/* tslint:disable */
/* eslint-disable */
/**
 * SpotSync.Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdminRevenueReport
 */
export interface AdminRevenueReport {
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'operatorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'facilityNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'operatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'paymentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'totalPaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'facilityFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'totalFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'reversed'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'remittedToFacility'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'stripeProcessing'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRevenueReport
     */
    'spotSyncNet'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'paidWhen'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'payoutDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'paymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'orderType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRevenueReport
     */
    'paymentIntentKey'?: string | null;
}
/**
 * 
 * @export
 * @interface AgingReport
 */
export interface AgingReport {
    /**
     * 
     * @type {number}
     * @memberof AgingReport
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgingReport
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgingReport
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgingReport
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgingReport
     */
    'balance30Days'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgingReport
     */
    'balance60Days'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgingReport
     */
    'balance90Days'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgingReport
     */
    'totalBalance'?: number;
}
/**
 * 
 * @export
 * @interface DataEntitiesAccessKey
 */
export interface DataEntitiesAccessKey {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKey
     */
    'accessKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKey
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesAccessKey
     */
    'accessKeyNumber': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesAccessKey
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKey
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesAccessKey
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKey
     */
    'removedByStaffId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesAccessKey
     */
    'note': string | null;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesAccessKey
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {Array<DataEntitiesAccessKeyLink>}
     * @memberof DataEntitiesAccessKey
     */
    'links'?: Array<DataEntitiesAccessKeyLink> | null;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesAccessKey
     */
    'createdByStaff'?: DataEntitiesStaff;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesAccessKey
     */
    'removedByStaff'?: DataEntitiesStaff;
}
/**
 * 
 * @export
 * @interface DataEntitiesAccessKeyLink
 */
export interface DataEntitiesAccessKeyLink {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKeyLink
     */
    'accessKeyLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKeyLink
     */
    'accessKeyId': number;
    /**
     * 
     * @type {DataEntitiesAccessKeyLinkType}
     * @memberof DataEntitiesAccessKeyLink
     */
    'type': DataEntitiesAccessKeyLinkType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesAccessKeyLink
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKeyLink
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesAccessKeyLink
     */
    'removedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessKeyLink
     */
    'removedByStaffId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesAccessKeyLink
     */
    'note': string | null;
    /**
     * 
     * @type {DataEntitiesAccessKey}
     * @memberof DataEntitiesAccessKeyLink
     */
    'accessKey'?: DataEntitiesAccessKey;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesAccessKeyLinkType = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30
} as const;

export type DataEntitiesAccessKeyLinkType = typeof DataEntitiesAccessKeyLinkType[keyof typeof DataEntitiesAccessKeyLinkType];


/**
 * 
 * @export
 * @interface DataEntitiesAccessPeriod
 */
export interface DataEntitiesAccessPeriod {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessPeriod
     */
    'accessPeriodId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessPeriod
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessPeriod
     */
    'orderId': number;
    /**
     * 
     * @type {DataEntitiesAccessPeriodType}
     * @memberof DataEntitiesAccessPeriod
     */
    'type': DataEntitiesAccessPeriodType;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessPeriod
     */
    'quantity': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesAccessPeriod
     */
    'start': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesAccessPeriod
     */
    'end': NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesAccessPeriod
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesAccessPeriod
     */
    'isDelivered': boolean;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesAccessPeriod
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {DataEntitiesOrderAccessPeriod}
     * @memberof DataEntitiesAccessPeriod
     */
    'order'?: DataEntitiesOrderAccessPeriod;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesAccessPeriodType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type DataEntitiesAccessPeriodType = typeof DataEntitiesAccessPeriodType[keyof typeof DataEntitiesAccessPeriodType];


/**
 * 
 * @export
 * @interface DataEntitiesApplyPayment
 */
export interface DataEntitiesApplyPayment {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'orderBalanceId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderBalanceType}
     * @memberof DataEntitiesApplyPayment
     */
    'type': DataEntitiesOrderBalanceType;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'orderId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'debt': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'paid': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'totalDebt': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'totalPaid': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesApplyPayment
     */
    'createdWhen': object;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesApplyPayment
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesOrder}
     * @memberof DataEntitiesApplyPayment
     */
    'order'?: DataEntitiesOrder;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesApplyPayment
     */
    'paymentId': number;
    /**
     * 
     * @type {DataEntitiesPayment}
     * @memberof DataEntitiesApplyPayment
     */
    'payment'?: DataEntitiesPayment;
}


/**
 * 
 * @export
 * @interface DataEntitiesCoordinates
 */
export interface DataEntitiesCoordinates {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesCoordinates
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesCoordinates
     */
    'lng'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesDaysOfWeek = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_4: 4,
    NUMBER_8: 8,
    NUMBER_16: 16,
    NUMBER_32: 32,
    NUMBER_62: 62,
    NUMBER_64: 64,
    NUMBER_65: 65,
    NUMBER_127: 127
} as const;

export type DataEntitiesDaysOfWeek = typeof DataEntitiesDaysOfWeek[keyof typeof DataEntitiesDaysOfWeek];


/**
 * 
 * @export
 * @interface DataEntitiesFacility
 */
export interface DataEntitiesFacility {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'operatorId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'timeZone': string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof DataEntitiesFacility
     */
    'address': DataEntitiesUsAddress;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof DataEntitiesFacility
     */
    'coordinates': NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'listImageId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'entryInstructions': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'physicalCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'enforcedCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'clearanceInches': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'website': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'invoicePrefix': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'invoiceOffset': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFacility
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFacility
     */
    'cancelledWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'processorAccountKey': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'applicationExpirationDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacility
     */
    'maxCreditCardAmountInCents'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFacility
     */
    'isWaitlistEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacility
     */
    'formattedTimeZone': string | null;
    /**
     * 
     * @type {DataEntitiesStoredImage}
     * @memberof DataEntitiesFacility
     */
    'listImage': DataEntitiesStoredImage;
    /**
     * 
     * @type {Array<DataEntitiesFacilityImage>}
     * @memberof DataEntitiesFacility
     */
    'images': Array<DataEntitiesFacilityImage> | null;
    /**
     * 
     * @type {DataEntitiesOperator}
     * @memberof DataEntitiesFacility
     */
    'operator': DataEntitiesOperator;
    /**
     * 
     * @type {Array<DataEntitiesRateProgram>}
     * @memberof DataEntitiesFacility
     */
    'rates': Array<DataEntitiesRateProgram> | null;
    /**
     * 
     * @type {Array<DataEntitiesPlan>}
     * @memberof DataEntitiesFacility
     */
    'plans': Array<DataEntitiesPlan> | null;
    /**
     * 
     * @type {Array<DataEntitiesAccessKey>}
     * @memberof DataEntitiesFacility
     */
    'accessKeys'?: Array<DataEntitiesAccessKey> | null;
    /**
     * 
     * @type {Array<DataEntitiesFacilityIntegrationParty>}
     * @memberof DataEntitiesFacility
     */
    'facilityIntegrationParties'?: Array<DataEntitiesFacilityIntegrationParty> | null;
    /**
     * 
     * @type {Array<DataEntitiesFinanceOperatorFee>}
     * @memberof DataEntitiesFacility
     */
    'operatorFees'?: Array<DataEntitiesFinanceOperatorFee> | null;
    /**
     * 
     * @type {Array<DataEntitiesStaff>}
     * @memberof DataEntitiesFacility
     */
    'staffs'?: Array<DataEntitiesStaff> | null;
    /**
     * 
     * @type {Array<DataEntitiesWaitlistEntry>}
     * @memberof DataEntitiesFacility
     */
    'waitlist'?: Array<DataEntitiesWaitlistEntry> | null;
    /**
     * 
     * @type {Array<DataEntitiesFinanceFacilityBillingPlan>}
     * @memberof DataEntitiesFacility
     */
    'facilityBillingPlans'?: Array<DataEntitiesFinanceFacilityBillingPlan> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesFacilityImage
 */
export interface DataEntitiesFacilityImage {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacilityImage
     */
    'facilityImageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacilityImage
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacilityImage
     */
    'storedImageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacilityImage
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacilityImage
     */
    'caption': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacilityImage
     */
    'altText': string | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesFacilityIntegrationParty
 */
export interface DataEntitiesFacilityIntegrationParty {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'facilityId'?: number;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'apiSecret'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {DataEntitiesIntegrationParty}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'integrationParty'?: DataEntitiesIntegrationParty;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFacilityIntegrationParty
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface DataEntitiesFinanceBillingPlan
 */
export interface DataEntitiesFinanceBillingPlan {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'billingPlanId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'description': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'canceledWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'createdByStaff'?: DataEntitiesStaff;
    /**
     * 
     * @type {Array<DataEntitiesFinanceBillingRule>}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'billingRules'?: Array<DataEntitiesFinanceBillingRule> | null;
    /**
     * 
     * @type {Array<DataEntitiesFinanceFacilityBillingPlan>}
     * @memberof DataEntitiesFinanceBillingPlan
     */
    'facilityBillingPlans'?: Array<DataEntitiesFinanceFacilityBillingPlan> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesFinanceBillingRule
 */
export interface DataEntitiesFinanceBillingRule {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'billingRuleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'billingPlanId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'name': string | null;
    /**
     * 
     * @type {DataEntitiesFinanceBillingRuleType}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'ruleType': DataEntitiesFinanceBillingRuleType;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'customProcedureName'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'canceledWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {DataEntitiesFinanceBillingPlan}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'billingPlan'?: DataEntitiesFinanceBillingPlan;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesFinanceBillingRule
     */
    'createdByStaff'?: DataEntitiesStaff;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinanceBillingRuleType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type DataEntitiesFinanceBillingRuleType = typeof DataEntitiesFinanceBillingRuleType[keyof typeof DataEntitiesFinanceBillingRuleType];


/**
 * 
 * @export
 * @interface DataEntitiesFinanceFacilityBillingPlan
 */
export interface DataEntitiesFinanceFacilityBillingPlan {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'facilityBillingPlanId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'billingPlanId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesFinanceBillingPlan}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'billingPlan'?: DataEntitiesFinanceBillingPlan;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesFinanceFacilityBillingPlan
     */
    'createdByStaff'?: DataEntitiesStaff;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinanceInvoiceStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type DataEntitiesFinanceInvoiceStatus = typeof DataEntitiesFinanceInvoiceStatus[keyof typeof DataEntitiesFinanceInvoiceStatus];


/**
 * 
 * @export
 * @interface DataEntitiesFinanceOperatorFee
 */
export interface DataEntitiesFinanceOperatorFee {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'feeName': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'amount'?: number;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeCalc}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'feeCalc'?: DataEntitiesFinanceOperatorFeeCalc;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'feeScope'?: DataEntitiesFinanceOperatorFeeScope;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'isAppliedToParker'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'canceledWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'createdByStaffId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'facilityId'?: number | null;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'paymentType'?: DataEntitiesFinanceOperatorFeePaymentType;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'receiptDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'isOptIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'isDefaultOptIn'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'partnerFee'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'isPerSpace'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'isFullyRemittedToOperator'?: boolean;
    /**
     * 
     * @type {DataEntitiesFinancePartner}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'partner'?: DataEntitiesFinancePartner;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesOperator}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'operator'?: DataEntitiesOperator;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesFinanceOperatorFee
     */
    'createdByStaff'?: DataEntitiesStaff;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinanceOperatorFeeCalc = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DataEntitiesFinanceOperatorFeeCalc = typeof DataEntitiesFinanceOperatorFeeCalc[keyof typeof DataEntitiesFinanceOperatorFeeCalc];


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinanceOperatorFeePaymentType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesFinanceOperatorFeePaymentType = typeof DataEntitiesFinanceOperatorFeePaymentType[keyof typeof DataEntitiesFinanceOperatorFeePaymentType];


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinanceOperatorFeeScope = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DataEntitiesFinanceOperatorFeeScope = typeof DataEntitiesFinanceOperatorFeeScope[keyof typeof DataEntitiesFinanceOperatorFeeScope];


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinanceOptInFeePartnerStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type DataEntitiesFinanceOptInFeePartnerStatus = typeof DataEntitiesFinanceOptInFeePartnerStatus[keyof typeof DataEntitiesFinanceOptInFeePartnerStatus];


/**
 * 
 * @export
 * @interface DataEntitiesFinanceParkerOptInOperatorFee
 */
export interface DataEntitiesFinanceParkerOptInOperatorFee {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'parkerOptInOperatorFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'reservationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'receiptNum': string | null;
    /**
     * 
     * @type {DataEntitiesFinanceOptInFeePartnerStatus}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'serviceStatus': DataEntitiesFinanceOptInFeePartnerStatus;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFee}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'operatorFee'?: DataEntitiesFinanceOperatorFee;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {DataEntitiesReservation}
     * @memberof DataEntitiesFinanceParkerOptInOperatorFee
     */
    'reservation'?: DataEntitiesReservation;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesFinancePartner = {
    NUMBER_0: 0
} as const;

export type DataEntitiesFinancePartner = typeof DataEntitiesFinancePartner[keyof typeof DataEntitiesFinancePartner];


/**
 * 
 * @export
 * @interface DataEntitiesIntegrationParty
 */
export interface DataEntitiesIntegrationParty {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesIntegrationParty
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesIntegrationParty
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesIntegrationParty
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesIntegrationParty
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesIntegrationParty
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<DataEntitiesFacilityIntegrationParty>}
     * @memberof DataEntitiesIntegrationParty
     */
    'facilityIntegrationParties'?: Array<DataEntitiesFacilityIntegrationParty> | null;
    /**
     * 
     * @type {Array<DataEntitiesParkerIntegrationParty>}
     * @memberof DataEntitiesIntegrationParty
     */
    'parkerIntegrationParties'?: Array<DataEntitiesParkerIntegrationParty> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesInvoice
 */
export interface DataEntitiesInvoice {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'invoiceNumber': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesInvoice
     */
    'createdWhen': object;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesInvoice
     */
    'dueWhen': NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'openingBalance': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'amountDue': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'endingBalance': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesInvoice
     */
    'emailSentWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoice
     */
    'parkerId': number;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesInvoice
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesInvoice
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {Array<DataEntitiesInvoiceOrder>}
     * @memberof DataEntitiesInvoice
     */
    'invoiceOrders'?: Array<DataEntitiesInvoiceOrder> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesInvoiceOrder
 */
export interface DataEntitiesInvoiceOrder {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoiceOrder
     */
    'invoiceOrderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoiceOrder
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesInvoiceOrder
     */
    'orderId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesInvoiceOrder
     */
    'createdWhen': object;
    /**
     * 
     * @type {DataEntitiesInvoice}
     * @memberof DataEntitiesInvoiceOrder
     */
    'invoice'?: DataEntitiesInvoice;
    /**
     * 
     * @type {DataEntitiesOrder}
     * @memberof DataEntitiesInvoiceOrder
     */
    'order'?: DataEntitiesOrder;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesNotificationType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11
} as const;

export type DataEntitiesNotificationType = typeof DataEntitiesNotificationType[keyof typeof DataEntitiesNotificationType];


/**
 * 
 * @export
 * @interface DataEntitiesOperator
 */
export interface DataEntitiesOperator {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOperator
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'hostName': string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof DataEntitiesOperator
     */
    'address': DataEntitiesUsAddress;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'website': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'topTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'bottomLeftTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'bottomRightTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'topText': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'bottomLeftText': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOperator
     */
    'bottomRightText': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesOperator
     */
    'isBilledSeparatePerFacility'?: boolean;
    /**
     * 
     * @type {Array<DataEntitiesFacility>}
     * @memberof DataEntitiesOperator
     */
    'facilities'?: Array<DataEntitiesFacility> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesOrder
 */
export interface DataEntitiesOrder {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'orderId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderInitiator}
     * @memberof DataEntitiesOrder
     */
    'initiator': DataEntitiesOrderInitiator;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'initiatedByStaffId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'facilityId': number;
    /**
     * 
     * @type {DataEntitiesOrderType}
     * @memberof DataEntitiesOrder
     */
    'type': DataEntitiesOrderType;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrder
     */
    'processorPaymentIntentKey': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrder
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrder
     */
    'submittedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'operatorFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'basePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrder
     */
    'feeCalculations'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'parkGuardFee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'remittedToOperatorFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrder
     */
    'referenceOrderId'?: number | null;
    /**
     * 
     * @type {Array<DataEntitiesOrderBalance>}
     * @memberof DataEntitiesOrder
     */
    'changes'?: Array<DataEntitiesOrderBalance> | null;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesOrder
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesOrder
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {Array<DataEntitiesInvoiceOrder>}
     * @memberof DataEntitiesOrder
     */
    'invoiceOrders'?: Array<DataEntitiesInvoiceOrder> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionGroupOrder>}
     * @memberof DataEntitiesOrder
     */
    'subscriptionGroupOrders'?: Array<DataEntitiesSubscriptionGroupOrder> | null;
}


/**
 * 
 * @export
 * @interface DataEntitiesOrderAccessPeriod
 */
export interface DataEntitiesOrderAccessPeriod {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'orderId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderInitiator}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'initiator': DataEntitiesOrderInitiator;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'initiatedByStaffId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'facilityId': number;
    /**
     * 
     * @type {DataEntitiesOrderType}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'type': DataEntitiesOrderType;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'processorPaymentIntentKey': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'submittedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'operatorFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'basePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'feeCalculations'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'parkGuardFee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'remittedToOperatorFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'referenceOrderId'?: number | null;
    /**
     * 
     * @type {Array<DataEntitiesOrderBalance>}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'changes'?: Array<DataEntitiesOrderBalance> | null;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {Array<DataEntitiesInvoiceOrder>}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'invoiceOrders'?: Array<DataEntitiesInvoiceOrder> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionGroupOrder>}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'subscriptionGroupOrders'?: Array<DataEntitiesSubscriptionGroupOrder> | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'subscriptionId': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'startDate': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'endDate': NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'price': number;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {DataEntitiesAccessPeriod}
     * @memberof DataEntitiesOrderAccessPeriod
     */
    'accessPeriod'?: DataEntitiesAccessPeriod;
}


/**
 * 
 * @export
 * @interface DataEntitiesOrderBalance
 */
export interface DataEntitiesOrderBalance {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'orderBalanceId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderBalanceType}
     * @memberof DataEntitiesOrderBalance
     */
    'type': DataEntitiesOrderBalanceType;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'orderId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'debt': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'paid': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'totalDebt': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderBalance
     */
    'totalPaid': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrderBalance
     */
    'createdWhen': object;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesOrderBalance
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesOrder}
     * @memberof DataEntitiesOrderBalance
     */
    'order'?: DataEntitiesOrder;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesOrderBalanceType = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60
} as const;

export type DataEntitiesOrderBalanceType = typeof DataEntitiesOrderBalanceType[keyof typeof DataEntitiesOrderBalanceType];


/**
 * 
 * @export
 * @interface DataEntitiesOrderDebt
 */
export interface DataEntitiesOrderDebt {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderDebt
     */
    'orderId'?: number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrderDebt
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderDebt
     */
    'orderTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderDebt
     */
    'paid'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderDebt
     */
    'unpaid'?: number;
}
/**
 * 
 * @export
 * @interface DataEntitiesOrderFeeCalculation
 */
export interface DataEntitiesOrderFeeCalculation {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderFeeCalculation
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrderFeeCalculation
     */
    'name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesOrderFeeCalculation
     */
    'isPaidByParker'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderFeeCalculation
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesOrderFeeCalculation
     */
    'isFullyRemittedToOperator'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesOrderInitiator = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesOrderInitiator = typeof DataEntitiesOrderInitiator[keyof typeof DataEntitiesOrderInitiator];


/**
 * 
 * @export
 * @interface DataEntitiesOrderSubscribe
 */
export interface DataEntitiesOrderSubscribe {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'orderId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderInitiator}
     * @memberof DataEntitiesOrderSubscribe
     */
    'initiator': DataEntitiesOrderInitiator;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'initiatedByStaffId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'facilityId': number;
    /**
     * 
     * @type {DataEntitiesOrderType}
     * @memberof DataEntitiesOrderSubscribe
     */
    'type': DataEntitiesOrderType;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrderSubscribe
     */
    'processorPaymentIntentKey': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrderSubscribe
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesOrderSubscribe
     */
    'submittedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'operatorFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'basePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesOrderSubscribe
     */
    'feeCalculations'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'parkGuardFee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'remittedToOperatorFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'referenceOrderId'?: number | null;
    /**
     * 
     * @type {Array<DataEntitiesOrderBalance>}
     * @memberof DataEntitiesOrderSubscribe
     */
    'changes'?: Array<DataEntitiesOrderBalance> | null;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesOrderSubscribe
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesOrderSubscribe
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {Array<DataEntitiesInvoiceOrder>}
     * @memberof DataEntitiesOrderSubscribe
     */
    'invoiceOrders'?: Array<DataEntitiesInvoiceOrder> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionGroupOrder>}
     * @memberof DataEntitiesOrderSubscribe
     */
    'subscriptionGroupOrders'?: Array<DataEntitiesSubscriptionGroupOrder> | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     * @deprecated
     */
    'planEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     * @deprecated
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'planPriceId': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesOrderSubscribe
     */
    'start': NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'parkerPlanInviteId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesOrderSubscribe
     */
    'price': number;
    /**
     * 
     * @type {DataEntitiesPlanEntry}
     * @memberof DataEntitiesOrderSubscribe
     */
    'planEntry': DataEntitiesPlanEntry;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesOrderSubscribe
     */
    'subscription': DataEntitiesSubscription;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesOrderType = {
    NUMBER_5: 5,
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80
} as const;

export type DataEntitiesOrderType = typeof DataEntitiesOrderType[keyof typeof DataEntitiesOrderType];


/**
 * 
 * @export
 * @interface DataEntitiesParker
 */
export interface DataEntitiesParker {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParker
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParker
     */
    'actorParkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParker
     */
    'operatorId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'passwordHash': string | null;
    /**
     * 
     * @type {DataEntitiesResetPasswordType}
     * @memberof DataEntitiesParker
     */
    'resetPasswordType'?: DataEntitiesResetPasswordType;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'resetPasswordCode'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParker
     */
    'resetPasswordCodeValidUntil'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'processorCustomerKey': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParker
     */
    'createdWhen': object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParker
     */
    'isGuest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParker
     */
    'isLoginEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParker
     */
    'isAutoGeneratedEmail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParker
     */
    'invoiceTxtBlock'?: string | null;
    /**
     * 
     * @type {DataEntitiesParkerInvoiceType}
     * @memberof DataEntitiesParker
     */
    'invoiceType'?: DataEntitiesParkerInvoiceType;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParker
     */
    'hasRegistered'?: boolean;
    /**
     * 
     * @type {DataEntitiesOperator}
     * @memberof DataEntitiesParker
     */
    'operator'?: DataEntitiesOperator;
    /**
     * 
     * @type {Array<DataEntitiesOrder>}
     * @memberof DataEntitiesParker
     */
    'orders'?: Array<DataEntitiesOrder> | null;
    /**
     * 
     * @type {Array<DataEntitiesPayment>}
     * @memberof DataEntitiesParker
     */
    'payments'?: Array<DataEntitiesPayment> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscription>}
     * @memberof DataEntitiesParker
     */
    'subscriptions'?: Array<DataEntitiesSubscription> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionParker>}
     * @memberof DataEntitiesParker
     */
    'guestSubscriptions'?: Array<DataEntitiesSubscriptionParker> | null;
    /**
     * 
     * @type {Array<DataEntitiesReservation>}
     * @memberof DataEntitiesParker
     */
    'reservations'?: Array<DataEntitiesReservation> | null;
    /**
     * 
     * @type {Array<DataEntitiesVehicle>}
     * @memberof DataEntitiesParker
     */
    'vehicles'?: Array<DataEntitiesVehicle> | null;
    /**
     * 
     * @type {Array<DataEntitiesParkerIntegrationParty>}
     * @memberof DataEntitiesParker
     */
    'parkerIntegrationParties'?: Array<DataEntitiesParkerIntegrationParty> | null;
    /**
     * 
     * @type {Array<DataEntitiesParkerBalance>}
     * @memberof DataEntitiesParker
     */
    'balances'?: Array<DataEntitiesParkerBalance> | null;
    /**
     * 
     * @type {Array<DataEntitiesFinanceParkerOptInOperatorFee>}
     * @memberof DataEntitiesParker
     */
    'optedInFees'?: Array<DataEntitiesFinanceParkerOptInOperatorFee> | null;
    /**
     * 
     * @type {Array<DataEntitiesParkerDelegate>}
     * @memberof DataEntitiesParker
     */
    'ownedDelegates'?: Array<DataEntitiesParkerDelegate> | null;
    /**
     * 
     * @type {Array<DataEntitiesParkerDelegate>}
     * @memberof DataEntitiesParker
     */
    'delegateAccesses'?: Array<DataEntitiesParkerDelegate> | null;
}


/**
 * 
 * @export
 * @interface DataEntitiesParkerBalance
 */
export interface DataEntitiesParkerBalance {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerBalance
     */
    'parkerBalanceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerBalance
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerBalance
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerBalance
     */
    'totalDebt'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerBalance
     */
    'totalPayments'?: number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkerBalance
     */
    'updatedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesParkerBalance
     */
    'parker'?: DataEntitiesParker;
}
/**
 * 
 * @export
 * @interface DataEntitiesParkerDelegate
 */
export interface DataEntitiesParkerDelegate {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerDelegate
     */
    'parkerDelegateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerDelegate
     */
    'ownerParkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerDelegate
     */
    'delegateParkerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerDelegate
     */
    'inviteEmail': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerDelegate
     */
    'inviteCode': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkerDelegate
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkerDelegate
     */
    'acceptedWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkerDelegate
     */
    'revokedWhen'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParkerDelegate
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParkerDelegate
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesParkerDelegate
     */
    'ownerParker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesParkerDelegate
     */
    'delegateParker'?: DataEntitiesParker;
}
/**
 * 
 * @export
 * @interface DataEntitiesParkerIntegrationParty
 */
export interface DataEntitiesParkerIntegrationParty {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'parkerIntegrationPartyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {DataEntitiesIntegrationParty}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'integrationParty'?: DataEntitiesIntegrationParty;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'lastOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'modified'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'metaFlashUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'parentUid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'metaFlashRFIDNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'vehicleLinkId'?: number | null;
    /**
     * 
     * @type {DataEntitiesVehicleLink}
     * @memberof DataEntitiesParkerIntegrationParty
     */
    'vehicleLink'?: DataEntitiesVehicleLink;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesParkerInvoiceType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DataEntitiesParkerInvoiceType = typeof DataEntitiesParkerInvoiceType[keyof typeof DataEntitiesParkerInvoiceType];


/**
 * 
 * @export
 * @interface DataEntitiesParkerPlanInvite
 */
export interface DataEntitiesParkerPlanInvite {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'parkerPlanInviteId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'planPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'waitlistEntryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'message': string | null;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'startDate'?: NodaTimeLocalDate;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'pendingIntegrationCredential'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {DataEntitiesPlan}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'plan'?: DataEntitiesPlan;
    /**
     * 
     * @type {DataEntitiesPlanPrice}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'planPrice'?: DataEntitiesPlanPrice;
    /**
     * 
     * @type {DataEntitiesWaitlistEntry}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'waitlistEntry'?: DataEntitiesWaitlistEntry;
    /**
     * 
     * @type {Array<DataEntitiesParkerPlanInviteFee>}
     * @memberof DataEntitiesParkerPlanInvite
     */
    'fees'?: Array<DataEntitiesParkerPlanInviteFee> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesParkerPlanInviteFee
 */
export interface DataEntitiesParkerPlanInviteFee {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInviteFee
     */
    'parkerPlanInviteFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInviteFee
     */
    'parkerPlanInviteId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkerPlanInviteFee
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkerPlanInviteFee
     */
    'amountCents': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionFeeCadence}
     * @memberof DataEntitiesParkerPlanInviteFee
     */
    'cadence': DataEntitiesSubscriptionFeeCadence;
    /**
     * 
     * @type {DataEntitiesParkerPlanInvite}
     * @memberof DataEntitiesParkerPlanInviteFee
     */
    'parkerPlanInvite'?: DataEntitiesParkerPlanInvite;
}


/**
 * 
 * @export
 * @interface DataEntitiesParkingValidationRequest
 */
export interface DataEntitiesParkingValidationRequest {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'parkingValidationRequestId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'parkerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'parkerName': string;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'parkerEmail': string;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'rateProgramId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'startDateTime': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'endDateTime': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'numberOfSpaces': number;
    /**
     * 
     * @type {DataEntitiesValidationRequestStatus}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'status': DataEntitiesValidationRequestStatus;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'updatedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesRateProgram}
     * @memberof DataEntitiesParkingValidationRequest
     */
    'rateProgram'?: DataEntitiesRateProgram;
}


/**
 * 
 * @export
 * @interface DataEntitiesPayment
 */
export interface DataEntitiesPayment {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'paymentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'parentPaymentId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'parkerId': number;
    /**
     * 
     * @type {DataEntitiesPaymentType}
     * @memberof DataEntitiesPayment
     */
    'type': DataEntitiesPaymentType;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'balance': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPayment
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPayment
     */
    'paidWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPayment
     */
    'clearedWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPayment
     */
    'achStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPayment
     */
    'achReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'staffId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPayment
     */
    'gross': number;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesPayment
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesPayment}
     * @memberof DataEntitiesPayment
     */
    'parent'?: DataEntitiesPayment;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesPayment
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesPayment
     */
    'staff'?: DataEntitiesStaff;
    /**
     * 
     * @type {Array<DataEntitiesPayment>}
     * @memberof DataEntitiesPayment
     */
    'changes'?: Array<DataEntitiesPayment> | null;
    /**
     * 
     * @type {Array<DataEntitiesApplyPayment>}
     * @memberof DataEntitiesPayment
     */
    'applications'?: Array<DataEntitiesApplyPayment> | null;
}


/**
 * 
 * @export
 * @interface DataEntitiesPaymentMethod
 */
export interface DataEntitiesPaymentMethod {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPaymentMethod
     */
    'paymentMethodId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPaymentMethod
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPaymentMethod
     */
    'paymentMethodKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPaymentMethod
     */
    'typeProvider': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPaymentMethod
     */
    'type': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPaymentMethod
     */
    'description': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPaymentMethod
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPaymentMethod
     */
    'paymentExpiredWhen': object;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesPaymentMethod
     */
    'parker'?: DataEntitiesParker;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesPaymentType = {
    NUMBER_20: 20,
    NUMBER_40: 40,
    NUMBER_60: 60,
    NUMBER_80: 80,
    NUMBER_100: 100,
    NUMBER_120: 120,
    NUMBER_140: 140,
    NUMBER_160: 160,
    NUMBER_180: 180,
    NUMBER_200: 200,
    NUMBER_220: 220,
    NUMBER_230: 230
} as const;

export type DataEntitiesPaymentType = typeof DataEntitiesPaymentType[keyof typeof DataEntitiesPaymentType];


/**
 * 
 * @export
 * @interface DataEntitiesPlan
 */
export interface DataEntitiesPlan {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlan
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlan
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlan
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPlan
     */
    'createdWhen': object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesPlan
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesPlan
     */
    'isOneTermPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesPlan
     */
    'isUsageBasedBilling'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlan
     */
    'renewalFailureDeactivateAfterDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlan
     */
    'cancellationWindowDays'?: number;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesPlan
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {Array<DataEntitiesPlanEntry>}
     * @memberof DataEntitiesPlan
     */
    'entries'?: Array<DataEntitiesPlanEntry> | null;
    /**
     * 
     * @type {Array<DataEntitiesPlanPrice>}
     * @memberof DataEntitiesPlan
     */
    'prices'?: Array<DataEntitiesPlanPrice> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesPlanEntry
 */
export interface DataEntitiesPlanEntry {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'planEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'planId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'accessHours': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'dayOfMonthInvoice': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'dayOfMonthDue': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'dayOfMonthLate': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'planPriceId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'formId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'prorate'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPlanEntry
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanEntry
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'terms': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanEntry
     */
    'approvalEmailText'?: string | null;
    /**
     * 
     * @type {DataEntitiesPlan}
     * @memberof DataEntitiesPlanEntry
     */
    'plan': DataEntitiesPlan;
    /**
     * 
     * @type {DataEntitiesPlanPrice}
     * @memberof DataEntitiesPlanEntry
     */
    'planPrice': DataEntitiesPlanPrice;
}
/**
 * 
 * @export
 * @interface DataEntitiesPlanPrice
 */
export interface DataEntitiesPlanPrice {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanPrice
     */
    'planPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanPrice
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanPrice
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanPrice
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesPlanPrice
     */
    'couponCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesPlanPrice
     */
    'createdByStaffId'?: number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesPlanPrice
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesPlanPrice
     */
    'isComplimentary'?: boolean;
    /**
     * 
     * @type {Array<DataEntitiesPlanEntry>}
     * @memberof DataEntitiesPlanPrice
     */
    'planEntries'?: Array<DataEntitiesPlanEntry> | null;
    /**
     * 
     * @type {DataEntitiesPlan}
     * @memberof DataEntitiesPlanPrice
     */
    'plan'?: DataEntitiesPlan;
    /**
     * 
     * @type {Array<DataEntitiesSubscription>}
     * @memberof DataEntitiesPlanPrice
     */
    'subscriptions'?: Array<DataEntitiesSubscription> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesRateEntry
 */
export interface DataEntitiesRateEntry {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesRateEntry
     */
    'rateEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesRateEntry
     */
    'rateProgramId'?: number;
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof DataEntitiesRateEntry
     */
    'upTo': NodaTimeDuration;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesRateEntry
     */
    'rate': number;
    /**
     * 
     * @type {DataEntitiesRateEntryDiscountType}
     * @memberof DataEntitiesRateEntry
     */
    'discountType'?: DataEntitiesRateEntryDiscountType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesRateEntryDiscountType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesRateEntryDiscountType = typeof DataEntitiesRateEntryDiscountType[keyof typeof DataEntitiesRateEntryDiscountType];


/**
 * 
 * @export
 * @interface DataEntitiesRateProgram
 */
export interface DataEntitiesRateProgram {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesRateProgram
     */
    'rateProgramId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesRateProgram
     */
    'parentRateProgramId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesRateProgram
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesRateProgram
     */
    'name': string | null;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof DataEntitiesRateProgram
     */
    'start': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof DataEntitiesRateProgram
     */
    'end': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof DataEntitiesRateProgram
     */
    'inAfter'?: NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof DataEntitiesRateProgram
     */
    'inBefore'?: NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof DataEntitiesRateProgram
     */
    'outAfter'?: NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof DataEntitiesRateProgram
     */
    'outBefore'?: NodaTimeLocalTime;
    /**
     * 
     * @type {DataEntitiesDaysOfWeek}
     * @memberof DataEntitiesRateProgram
     */
    'applicableDays'?: DataEntitiesDaysOfWeek;
    /**
     * 
     * @type {Array<DataEntitiesRateEntry>}
     * @memberof DataEntitiesRateProgram
     */
    'entries': Array<DataEntitiesRateEntry> | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesRateProgram
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesRateProgram
     */
    'cancelledWhen': object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesRateProgram
     */
    'isEvent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesRateProgram
     */
    'isValidation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesRateProgram
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesRateProgram
     */
    'canBeValidated'?: boolean;
    /**
     * 
     * @type {DataEntitiesValidationType}
     * @memberof DataEntitiesRateProgram
     */
    'validationType'?: DataEntitiesValidationType;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesRateProgram
     */
    'isSpecialRate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesRateProgram
     */
    'code'?: string | null;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesRateProgram
     */
    'facility'?: DataEntitiesFacility;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesReportsFrequency = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesReportsFrequency = typeof DataEntitiesReportsFrequency[keyof typeof DataEntitiesReportsFrequency];


/**
 * 
 * @export
 * @interface DataEntitiesReportsRedeemedValidationReport
 */
export interface DataEntitiesReportsRedeemedValidationReport {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReportsRedeemedValidationReport
     */
    'validationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesReportsRedeemedValidationReport
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesReportsRedeemedValidationReport
     */
    'endedWhen'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReportsRedeemedValidationReport
     */
    'originalPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReportsRedeemedValidationReport
     */
    'validatedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReportsRedeemedValidationReport
     */
    'facilityId'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesReportsReportType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type DataEntitiesReportsReportType = typeof DataEntitiesReportsReportType[keyof typeof DataEntitiesReportsReportType];


/**
 * 
 * @export
 * @interface DataEntitiesReservation
 */
export interface DataEntitiesReservation {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'reservationId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'orderId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'rateProgramId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'parkerId': number;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof DataEntitiesReservation
     */
    'start': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof DataEntitiesReservation
     */
    'end': NodaTimeLocalDateTime;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesReservation
     */
    'actualStart': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesReservation
     */
    'actualEnd': object;
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof DataEntitiesReservation
     */
    'chargeDuration': NodaTimeDuration;
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof DataEntitiesReservation
     */
    'stayDuration': NodaTimeDuration;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesReservation
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'validationRequestId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesReservation
     */
    'confirmationNum': string | null;
    /**
     * 
     * @type {DataEntitiesReserveCaptureStatus}
     * @memberof DataEntitiesReservation
     */
    'captureStatus': DataEntitiesReserveCaptureStatus;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesReservation
     */
    'apiId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'sourceIntegrationPartyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesReservation
     */
    'sourceExternalReservationId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesReservation
     */
    'validationRedeemRateId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesReservation
     */
    'receivedExtensionEmail'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesReservation
     */
    'entryConfirmedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesReservation
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesReservation
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesRateProgram}
     * @memberof DataEntitiesReservation
     */
    'rateProgram'?: DataEntitiesRateProgram;
    /**
     * 
     * @type {DataEntitiesIntegrationParty}
     * @memberof DataEntitiesReservation
     */
    'sourceIntegrationParty'?: DataEntitiesIntegrationParty;
    /**
     * 
     * @type {DataEntitiesParkingValidationRequest}
     * @memberof DataEntitiesReservation
     */
    'parkingValidationRequest'?: DataEntitiesParkingValidationRequest;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesReserveCaptureStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesReserveCaptureStatus = typeof DataEntitiesReserveCaptureStatus[keyof typeof DataEntitiesReserveCaptureStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesResetPasswordType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DataEntitiesResetPasswordType = typeof DataEntitiesResetPasswordType[keyof typeof DataEntitiesResetPasswordType];


/**
 * 
 * @export
 * @interface DataEntitiesStaff
 */
export interface DataEntitiesStaff {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesStaff
     */
    'staffId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesStaff
     */
    'operatorId'?: number;
    /**
     * 
     * @type {DataStaffRole}
     * @memberof DataEntitiesStaff
     */
    'role'?: DataStaffRole;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataEntitiesStaff
     */
    'roles'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'passwordHash'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesStaff
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesStaff
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'forgotPasswordCode'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesStaff
     */
    'forgotPasswordCodeValidUntil'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStaff
     */
    'aspNetUserId': string | null;
    /**
     * 
     * @type {DataEntitiesOperator}
     * @memberof DataEntitiesStaff
     */
    'operator'?: DataEntitiesOperator;
    /**
     * 
     * @type {Array<DataEntitiesStaffNotification>}
     * @memberof DataEntitiesStaff
     */
    'notifications'?: Array<DataEntitiesStaffNotification> | null;
    /**
     * 
     * @type {Array<DataEntitiesAccessKey>}
     * @memberof DataEntitiesStaff
     */
    'createdAccessKeys'?: Array<DataEntitiesAccessKey> | null;
    /**
     * 
     * @type {Array<DataEntitiesAccessKey>}
     * @memberof DataEntitiesStaff
     */
    'removedAccessKeys'?: Array<DataEntitiesAccessKey> | null;
    /**
     * 
     * @type {Array<DataEntitiesFacility>}
     * @memberof DataEntitiesStaff
     */
    'facilities'?: Array<DataEntitiesFacility> | null;
}


/**
 * 
 * @export
 * @interface DataEntitiesStaffNotification
 */
export interface DataEntitiesStaffNotification {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesStaffNotification
     */
    'staffNotificationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesStaffNotification
     */
    'staffId': number;
    /**
     * 
     * @type {DataEntitiesNotificationType}
     * @memberof DataEntitiesStaffNotification
     */
    'notificationType': DataEntitiesNotificationType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesStaffNotification
     */
    'createdWhen': object;
    /**
     * 
     * @type {DataEntitiesStaff}
     * @memberof DataEntitiesStaffNotification
     */
    'staff'?: DataEntitiesStaff;
}


/**
 * 
 * @export
 * @interface DataEntitiesStoredImage
 */
export interface DataEntitiesStoredImage {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesStoredImage
     */
    'storedImageId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStoredImage
     */
    'mimeType': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStoredImage
     */
    'bytes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesStoredImage
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesSubscription
 */
export interface DataEntitiesSubscription {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'orderId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'paymentMethodId'?: number | null;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesSubscription
     */
    'start': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof DataEntitiesSubscription
     */
    'end': NodaTimeLocalDate;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscription
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscription
     */
    'updatedWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesSubscription
     */
    'processorPaymentMethodKey': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'planId': number;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'isAccountsReceivable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'isLateFeeEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'planPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'planEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'quantity': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof DataEntitiesSubscription
     */
    'status': DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'isEnhancedGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'isGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'usesCalculatedGroupBilling'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'isPendingConversionToAutoPay'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscription
     */
    'convertedToAutoPayDate'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'isPendingPaymentMethodVerification'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscription
     */
    'staffInitiatedCancellation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscription
     */
    'cachedMrr'?: number;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesSubscription
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesSubscription
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesOrderSubscribe}
     * @memberof DataEntitiesSubscription
     */
    'order'?: DataEntitiesOrderSubscribe;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionParker>}
     * @memberof DataEntitiesSubscription
     */
    'guests'?: Array<DataEntitiesSubscriptionParker> | null;
    /**
     * 
     * @type {Array<DataEntitiesVehicleSubscription>}
     * @memberof DataEntitiesSubscription
     */
    'vehicles'?: Array<DataEntitiesVehicleSubscription> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionAccessKeyLink>}
     * @memberof DataEntitiesSubscription
     */
    'accessKeys'?: Array<DataEntitiesSubscriptionAccessKeyLink> | null;
    /**
     * 
     * @type {DataEntitiesPlan}
     * @memberof DataEntitiesSubscription
     */
    'plan'?: DataEntitiesPlan;
    /**
     * 
     * @type {DataEntitiesPlanEntry}
     * @memberof DataEntitiesSubscription
     */
    'planEntry'?: DataEntitiesPlanEntry;
    /**
     * 
     * @type {DataEntitiesPlanPrice}
     * @memberof DataEntitiesSubscription
     */
    'planPrice'?: DataEntitiesPlanPrice;
    /**
     * 
     * @type {Array<DataEntitiesAccessPeriod>}
     * @memberof DataEntitiesSubscription
     */
    'accessPeriods'?: Array<DataEntitiesAccessPeriod> | null;
    /**
     * 
     * @type {DataEntitiesPaymentMethod}
     * @memberof DataEntitiesSubscription
     */
    'paymentMethod'?: DataEntitiesPaymentMethod;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionGroup>}
     * @memberof DataEntitiesSubscription
     */
    'subscriptionGroups'?: Array<DataEntitiesSubscriptionGroup> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionFee>}
     * @memberof DataEntitiesSubscription
     */
    'fees'?: Array<DataEntitiesSubscriptionFee> | null;
}


/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionAccessKeyLink
 */
export interface DataEntitiesSubscriptionAccessKeyLink {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'accessKeyLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'accessKeyId': number;
    /**
     * 
     * @type {DataEntitiesAccessKeyLinkType}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'type': DataEntitiesAccessKeyLinkType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'removedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'removedByStaffId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'note': string | null;
    /**
     * 
     * @type {DataEntitiesAccessKey}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'accessKey'?: DataEntitiesAccessKey;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'subscriptionId': number;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesSubscriptionAccessKeyLink
     */
    'subscription'?: DataEntitiesSubscription;
}


/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionFee
 */
export interface DataEntitiesSubscriptionFee {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'subscriptionFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'subscriptionParkerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesSubscriptionFee
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'amountCents': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionFeeCadence}
     * @memberof DataEntitiesSubscriptionFee
     */
    'cadence': DataEntitiesSubscriptionFeeCadence;
    /**
     * 
     * @type {DataEntitiesSubscriptionFeeStatus}
     * @memberof DataEntitiesSubscriptionFee
     */
    'status': DataEntitiesSubscriptionFeeStatus;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'appliedOrderId'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionFee
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionFee
     */
    'revokedWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionFee
     */
    'revokedByStaffId'?: number | null;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesSubscriptionFee
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {DataEntitiesSubscriptionParker}
     * @memberof DataEntitiesSubscriptionFee
     */
    'subscriptionParker'?: DataEntitiesSubscriptionParker;
    /**
     * 
     * @type {DataEntitiesOrder}
     * @memberof DataEntitiesSubscriptionFee
     */
    'appliedOrder'?: DataEntitiesOrder;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesSubscriptionFeeCadence = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DataEntitiesSubscriptionFeeCadence = typeof DataEntitiesSubscriptionFeeCadence[keyof typeof DataEntitiesSubscriptionFeeCadence];


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesSubscriptionFeeStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type DataEntitiesSubscriptionFeeStatus = typeof DataEntitiesSubscriptionFeeStatus[keyof typeof DataEntitiesSubscriptionFeeStatus];


/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionGroup
 */
export interface DataEntitiesSubscriptionGroup {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'subscriptionGroupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionGroupContractRule>}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'contractRules'?: Array<DataEntitiesSubscriptionGroupContractRule> | null;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionParker>}
     * @memberof DataEntitiesSubscriptionGroup
     */
    'subscriptionParkers'?: Array<DataEntitiesSubscriptionParker> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionGroupContractRule
 */
export interface DataEntitiesSubscriptionGroupContractRule {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'subscriptionGroupContractRuleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'subscriptionGroupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'updatedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesSubscriptionGroup}
     * @memberof DataEntitiesSubscriptionGroupContractRule
     */
    'subscriptionGroup'?: DataEntitiesSubscriptionGroup;
}
/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionGroupOrder
 */
export interface DataEntitiesSubscriptionGroupOrder {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscriptionGroupOrderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscriptionGroupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscriptionGroupContractRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'numberOfParkers'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'baseUnitPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'baseTotalPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'unitAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'totalAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'finalPrice'?: number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'isArchived'?: boolean;
    /**
     * 
     * @type {DataEntitiesOrder}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'order'?: DataEntitiesOrder;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {DataEntitiesSubscriptionGroup}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscriptionGroup'?: DataEntitiesSubscriptionGroup;
    /**
     * 
     * @type {DataEntitiesSubscriptionGroupContractRule}
     * @memberof DataEntitiesSubscriptionGroupOrder
     */
    'subscriptionGroupContractRule'?: DataEntitiesSubscriptionGroupContractRule;
}
/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionParker
 */
export interface DataEntitiesSubscriptionParker {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParker
     */
    'subscriptionParkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParker
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParker
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParker
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParker
     */
    'subscriptionGroupId'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionParker
     */
    'addedWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionParker
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionParker
     */
    'startDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesSubscriptionParker
     */
    'pendingIntegrationCredential'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionParker
     */
    'startDateExact'?: object;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesSubscriptionParker
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesSubscriptionParker
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {Array<DataEntitiesSubscriptionParkerAccessKeyLink>}
     * @memberof DataEntitiesSubscriptionParker
     */
    'accessKeys'?: Array<DataEntitiesSubscriptionParkerAccessKeyLink> | null;
    /**
     * 
     * @type {DataEntitiesSubscriptionGroup}
     * @memberof DataEntitiesSubscriptionParker
     */
    'subscriptionGroup'?: DataEntitiesSubscriptionGroup;
}
/**
 * 
 * @export
 * @interface DataEntitiesSubscriptionParkerAccessKeyLink
 */
export interface DataEntitiesSubscriptionParkerAccessKeyLink {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'accessKeyLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'accessKeyId': number;
    /**
     * 
     * @type {DataEntitiesAccessKeyLinkType}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'type': DataEntitiesAccessKeyLinkType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'removedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'removedByStaffId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'note': string | null;
    /**
     * 
     * @type {DataEntitiesAccessKey}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'accessKey'?: DataEntitiesAccessKey;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'subscriptionParkerId': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionParker}
     * @memberof DataEntitiesSubscriptionParkerAccessKeyLink
     */
    'subscriptionParker'?: DataEntitiesSubscriptionParker;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesSubscriptionStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9
} as const;

export type DataEntitiesSubscriptionStatus = typeof DataEntitiesSubscriptionStatus[keyof typeof DataEntitiesSubscriptionStatus];


/**
 * 
 * @export
 * @interface DataEntitiesUsAddress
 */
export interface DataEntitiesUsAddress {
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesUsAddress
     */
    'addressLine1': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesUsAddress
     */
    'addressLine2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesUsAddress
     */
    'city': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesUsAddress
     */
    'state': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesUsAddress
     */
    'zipCode': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesValidationRequestStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type DataEntitiesValidationRequestStatus = typeof DataEntitiesValidationRequestStatus[keyof typeof DataEntitiesValidationRequestStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesValidationType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesValidationType = typeof DataEntitiesValidationType[keyof typeof DataEntitiesValidationType];


/**
 * 
 * @export
 * @interface DataEntitiesVehicle
 */
export interface DataEntitiesVehicle {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicle
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicle
     */
    'parkerId': number;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesVehicle
     */
    'make': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesVehicle
     */
    'model': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesVehicle
     */
    'color': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesVehicle
     */
    'stateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesVehicle
     */
    'licensePlateNumber': string | null;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicle
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicle
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesVehicle
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {Array<DataEntitiesVehicleLink>}
     * @memberof DataEntitiesVehicle
     */
    'links'?: Array<DataEntitiesVehicleLink> | null;
    /**
     * 
     * @type {Array<DataEntitiesAccessKey>}
     * @memberof DataEntitiesVehicle
     */
    'accessKeys'?: Array<DataEntitiesAccessKey> | null;
}
/**
 * 
 * @export
 * @interface DataEntitiesVehicleLink
 */
export interface DataEntitiesVehicleLink {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleLink
     */
    'vehicleLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleLink
     */
    'vehicleId': number;
    /**
     * 
     * @type {DataEntitiesVehicleLinkType}
     * @memberof DataEntitiesVehicleLink
     */
    'type'?: DataEntitiesVehicleLinkType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicleLink
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicleLink
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesVehicle}
     * @memberof DataEntitiesVehicleLink
     */
    'vehicle'?: DataEntitiesVehicle;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesVehicleLinkType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DataEntitiesVehicleLinkType = typeof DataEntitiesVehicleLinkType[keyof typeof DataEntitiesVehicleLinkType];


/**
 * 
 * @export
 * @interface DataEntitiesVehicleSubscription
 */
export interface DataEntitiesVehicleSubscription {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscription
     */
    'vehicleLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscription
     */
    'vehicleId': number;
    /**
     * 
     * @type {DataEntitiesVehicleLinkType}
     * @memberof DataEntitiesVehicleSubscription
     */
    'type'?: DataEntitiesVehicleLinkType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicleSubscription
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicleSubscription
     */
    'removedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesVehicle}
     * @memberof DataEntitiesVehicleSubscription
     */
    'vehicle'?: DataEntitiesVehicle;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscription
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesVehicleSubscription
     */
    'subscription'?: DataEntitiesSubscription;
    /**
     * 
     * @type {Array<DataEntitiesVehicleSubscriptionAccessKeyLink>}
     * @memberof DataEntitiesVehicleSubscription
     */
    'accessKeys'?: Array<DataEntitiesVehicleSubscriptionAccessKeyLink> | null;
}


/**
 * 
 * @export
 * @interface DataEntitiesVehicleSubscriptionAccessKeyLink
 */
export interface DataEntitiesVehicleSubscriptionAccessKeyLink {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'accessKeyLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'accessKeyId': number;
    /**
     * 
     * @type {DataEntitiesAccessKeyLinkType}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'type': DataEntitiesAccessKeyLinkType;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'createdByStaffId': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'removedWhen': object;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'removedByStaffId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'note': string | null;
    /**
     * 
     * @type {DataEntitiesAccessKey}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'accessKey'?: DataEntitiesAccessKey;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'vehicleSubscriptionId': number;
    /**
     * 
     * @type {DataEntitiesVehicleSubscription}
     * @memberof DataEntitiesVehicleSubscriptionAccessKeyLink
     */
    'vehicleSubscription'?: DataEntitiesVehicleSubscription;
}


/**
 * 
 * @export
 * @interface DataEntitiesWaitlistEntry
 */
export interface DataEntitiesWaitlistEntry {
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'waitlistEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'planEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'spacesRequested': number;
    /**
     * 
     * @type {DataEntitiesWaitlistStatus}
     * @memberof DataEntitiesWaitlistEntry
     */
    'status': DataEntitiesWaitlistStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DataEntitiesWaitlistEntry
     */
    'isAddingToExistingParker': boolean;
    /**
     * 
     * @type {number}
     * @memberof DataEntitiesWaitlistEntry
     */
    'order': number;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesWaitlistEntry
     */
    'holdUntil'?: object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesWaitlistEntry
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof DataEntitiesWaitlistEntry
     */
    'updatedWhen'?: object;
    /**
     * 
     * @type {DataEntitiesFacility}
     * @memberof DataEntitiesWaitlistEntry
     */
    'facility'?: DataEntitiesFacility;
    /**
     * 
     * @type {DataEntitiesParker}
     * @memberof DataEntitiesWaitlistEntry
     */
    'parker'?: DataEntitiesParker;
    /**
     * 
     * @type {DataEntitiesPlanEntry}
     * @memberof DataEntitiesWaitlistEntry
     */
    'planEntry'?: DataEntitiesPlanEntry;
    /**
     * 
     * @type {DataEntitiesParkerPlanInvite}
     * @memberof DataEntitiesWaitlistEntry
     */
    'parkerPlanInvite'?: DataEntitiesParkerPlanInvite;
    /**
     * 
     * @type {DataEntitiesSubscription}
     * @memberof DataEntitiesWaitlistEntry
     */
    'subscription'?: DataEntitiesSubscription;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataEntitiesWaitlistStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataEntitiesWaitlistStatus = typeof DataEntitiesWaitlistStatus[keyof typeof DataEntitiesWaitlistStatus];


/**
 * 
 * @export
 * @interface DataRepositoryFeeCalculationResult
 */
export interface DataRepositoryFeeCalculationResult {
    /**
     * 
     * @type {number}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'operatorFees'?: number;
    /**
     * 
     * @type {Array<DataEntitiesOrderFeeCalculation>}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'feeCalculations'?: Array<DataEntitiesOrderFeeCalculation> | null;
    /**
     * 
     * @type {Array<DataEntitiesOrderFeeCalculation>}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'parkerPaidFeeCalculations'?: Array<DataEntitiesOrderFeeCalculation> | null;
    /**
     * 
     * @type {number}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'totalApplicationFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'fullyRemittedToOperatorFees'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataRepositoryFeeCalculationResult
     */
    'serializedFeeCalculation'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataStaffRole = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type DataStaffRole = typeof DataStaffRole[keyof typeof DataStaffRole];


/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcProblemDetails
 */
export interface MicrosoftAspNetCoreMvcProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesCoordinate
 */
export interface NetTopologySuiteGeometriesCoordinate {
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinate
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinate
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinate
     */
    'z'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinate
     */
    'm'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinate}
     * @memberof NetTopologySuiteGeometriesCoordinate
     */
    'coordinateValue'?: NetTopologySuiteGeometriesCoordinate;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesCoordinate
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesCoordinateSequence
 */
export interface NetTopologySuiteGeometriesCoordinateSequence {
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'dimension'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'measures'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'spatial'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesOrdinates}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'ordinates'?: NetTopologySuiteGeometriesOrdinates;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'hasZ'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'hasM'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'zOrdinateIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'mOrdinateIndex'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinate}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'first'?: NetTopologySuiteGeometriesCoordinate;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinate}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'last'?: NetTopologySuiteGeometriesCoordinate;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesCoordinateSequence
     */
    'count'?: number;
}


/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesCoordinateSequenceFactory
 */
export interface NetTopologySuiteGeometriesCoordinateSequenceFactory {
    /**
     * 
     * @type {NetTopologySuiteGeometriesOrdinates}
     * @memberof NetTopologySuiteGeometriesCoordinateSequenceFactory
     */
    'ordinates'?: NetTopologySuiteGeometriesOrdinates;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NetTopologySuiteGeometriesDimension = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_MINUS_3: -3,
    NUMBER_MINUS_2: -2,
    NUMBER_MINUS_1: -1
} as const;

export type NetTopologySuiteGeometriesDimension = typeof NetTopologySuiteGeometriesDimension[keyof typeof NetTopologySuiteGeometriesDimension];


/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesEnvelope
 */
export interface NetTopologySuiteGeometriesEnvelope {
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'isNull'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'diameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'minX'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'maxX'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'minY'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'maxY'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'minExtent'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'maxExtent'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinate}
     * @memberof NetTopologySuiteGeometriesEnvelope
     */
    'centre'?: NetTopologySuiteGeometriesCoordinate;
}
/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesGeometry
 */
export interface NetTopologySuiteGeometriesGeometry {
    /**
     * 
     * @type {NetTopologySuiteGeometriesGeometryFactory}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'factory'?: NetTopologySuiteGeometriesGeometryFactory;
    /**
     * 
     * @type {any}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'userData'?: any | null;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'srid'?: number;
    /**
     * 
     * @type {string}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'geometryType'?: string | null;
    /**
     * 
     * @type {NetTopologySuiteGeometriesOgcGeometryType}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'ogcGeometryType'?: NetTopologySuiteGeometriesOgcGeometryType;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPrecisionModel}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'precisionModel'?: NetTopologySuiteGeometriesPrecisionModel;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinate}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'coordinate'?: NetTopologySuiteGeometriesCoordinate;
    /**
     * 
     * @type {Array<NetTopologySuiteGeometriesCoordinate>}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'coordinates'?: Array<NetTopologySuiteGeometriesCoordinate> | null;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'numPoints'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'numGeometries'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'isSimple'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'isEmpty'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'length'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'centroid'?: NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'interiorPoint'?: NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'pointOnSurface'?: NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {NetTopologySuiteGeometriesDimension}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'dimension'?: NetTopologySuiteGeometriesDimension;
    /**
     * 
     * @type {NetTopologySuiteGeometriesGeometry}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'boundary'?: NetTopologySuiteGeometriesGeometry;
    /**
     * 
     * @type {NetTopologySuiteGeometriesDimension}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'boundaryDimension'?: NetTopologySuiteGeometriesDimension;
    /**
     * 
     * @type {NetTopologySuiteGeometriesGeometry}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'envelope'?: NetTopologySuiteGeometriesGeometry;
    /**
     * 
     * @type {NetTopologySuiteGeometriesEnvelope}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'envelopeInternal'?: NetTopologySuiteGeometriesEnvelope;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesGeometry
     */
    'isRectangle'?: boolean;
}


/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesGeometryFactory
 */
export interface NetTopologySuiteGeometriesGeometryFactory {
    /**
     * 
     * @type {NetTopologySuiteGeometriesPrecisionModel}
     * @memberof NetTopologySuiteGeometriesGeometryFactory
     */
    'precisionModel'?: NetTopologySuiteGeometriesPrecisionModel;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinateSequenceFactory}
     * @memberof NetTopologySuiteGeometriesGeometryFactory
     */
    'coordinateSequenceFactory'?: NetTopologySuiteGeometriesCoordinateSequenceFactory;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesGeometryFactory
     */
    'srid'?: number;
    /**
     * 
     * @type {NetTopologySuiteNtsGeometryServices}
     * @memberof NetTopologySuiteGeometriesGeometryFactory
     */
    'geometryServices'?: NetTopologySuiteNtsGeometryServices;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NetTopologySuiteGeometriesOgcGeometryType = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
    NUMBER_15: 15,
    NUMBER_16: 16
} as const;

export type NetTopologySuiteGeometriesOgcGeometryType = typeof NetTopologySuiteGeometriesOgcGeometryType[keyof typeof NetTopologySuiteGeometriesOgcGeometryType];


/**
 * 
 * @export
 * @enum {string}
 */

export const NetTopologySuiteGeometriesOrdinates = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_16: 16,
    NUMBER_32: 32,
    NUMBER_64: 64,
    NUMBER_128: 128,
    NUMBER_256: 256,
    NUMBER_512: 512,
    NUMBER_1024: 1024,
    NUMBER_2048: 2048,
    NUMBER_4096: 4096,
    NUMBER_8192: 8192,
    NUMBER_16384: 16384,
    NUMBER_32768: 32768,
    NUMBER_65535: 65535,
    NUMBER_65536: 65536,
    NUMBER_65539: 65539,
    NUMBER_65543: 65543,
    NUMBER_131072: 131072,
    NUMBER_262144: 262144,
    NUMBER_524288: 524288,
    NUMBER_1048576: 1048576,
    NUMBER_2097152: 2097152,
    NUMBER_4194304: 4194304,
    NUMBER_8388608: 8388608,
    NUMBER_16777216: 16777216,
    NUMBER_33554432: 33554432,
    NUMBER_67108864: 67108864,
    NUMBER_134217728: 134217728,
    NUMBER_268435456: 268435456,
    NUMBER_536870912: 536870912,
    NUMBER_1073741824: 1073741824,
    NUMBER_MINUS_2147483648: -2147483648,
    NUMBER_MINUS_65536: -65536,
    NUMBER_MINUS_1: -1
} as const;

export type NetTopologySuiteGeometriesOrdinates = typeof NetTopologySuiteGeometriesOrdinates[keyof typeof NetTopologySuiteGeometriesOrdinates];


/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesPoint
 */
export interface NetTopologySuiteGeometriesPoint {
    /**
     * 
     * @type {NetTopologySuiteGeometriesGeometryFactory}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'factory'?: NetTopologySuiteGeometriesGeometryFactory;
    /**
     * 
     * @type {any}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'userData'?: any | null;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'srid'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPrecisionModel}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'precisionModel'?: NetTopologySuiteGeometriesPrecisionModel;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'numGeometries'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'isSimple'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'length'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'centroid'?: NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'interiorPoint'?: NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPoint}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'pointOnSurface'?: NetTopologySuiteGeometriesPoint;
    /**
     * 
     * @type {NetTopologySuiteGeometriesGeometry}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'envelope'?: NetTopologySuiteGeometriesGeometry;
    /**
     * 
     * @type {NetTopologySuiteGeometriesEnvelope}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'envelopeInternal'?: NetTopologySuiteGeometriesEnvelope;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'isRectangle'?: boolean;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinateSequence}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'coordinateSequence'?: NetTopologySuiteGeometriesCoordinateSequence;
    /**
     * 
     * @type {Array<NetTopologySuiteGeometriesCoordinate>}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'coordinates'?: Array<NetTopologySuiteGeometriesCoordinate> | null;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'numPoints'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'isEmpty'?: boolean;
    /**
     * 
     * @type {NetTopologySuiteGeometriesDimension}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'dimension'?: NetTopologySuiteGeometriesDimension;
    /**
     * 
     * @type {NetTopologySuiteGeometriesDimension}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'boundaryDimension'?: NetTopologySuiteGeometriesDimension;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'y'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinate}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'coordinate'?: NetTopologySuiteGeometriesCoordinate;
    /**
     * 
     * @type {string}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'geometryType'?: string | null;
    /**
     * 
     * @type {NetTopologySuiteGeometriesOgcGeometryType}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'ogcGeometryType'?: NetTopologySuiteGeometriesOgcGeometryType;
    /**
     * 
     * @type {NetTopologySuiteGeometriesGeometry}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'boundary'?: NetTopologySuiteGeometriesGeometry;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'z'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPoint
     */
    'm'?: number;
}


/**
 * 
 * @export
 * @interface NetTopologySuiteGeometriesPrecisionModel
 */
export interface NetTopologySuiteGeometriesPrecisionModel {
    /**
     * 
     * @type {boolean}
     * @memberof NetTopologySuiteGeometriesPrecisionModel
     */
    'isFloating'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPrecisionModel
     */
    'maximumSignificantDigits'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPrecisionModel
     */
    'scale'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteGeometriesPrecisionModel
     */
    'gridSize'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPrecisionModels}
     * @memberof NetTopologySuiteGeometriesPrecisionModel
     */
    'precisionModelType'?: NetTopologySuiteGeometriesPrecisionModels;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NetTopologySuiteGeometriesPrecisionModels = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type NetTopologySuiteGeometriesPrecisionModels = typeof NetTopologySuiteGeometriesPrecisionModels[keyof typeof NetTopologySuiteGeometriesPrecisionModels];


/**
 * 
 * @export
 * @interface NetTopologySuiteNtsGeometryServices
 */
export interface NetTopologySuiteNtsGeometryServices {
    /**
     * 
     * @type {object}
     * @memberof NetTopologySuiteNtsGeometryServices
     */
    'geometryOverlay'?: object;
    /**
     * 
     * @type {object}
     * @memberof NetTopologySuiteNtsGeometryServices
     */
    'coordinateEqualityComparer'?: object;
    /**
     * 
     * @type {number}
     * @memberof NetTopologySuiteNtsGeometryServices
     */
    'defaultSRID'?: number;
    /**
     * 
     * @type {NetTopologySuiteGeometriesCoordinateSequenceFactory}
     * @memberof NetTopologySuiteNtsGeometryServices
     */
    'defaultCoordinateSequenceFactory'?: NetTopologySuiteGeometriesCoordinateSequenceFactory;
    /**
     * 
     * @type {NetTopologySuiteGeometriesPrecisionModel}
     * @memberof NetTopologySuiteNtsGeometryServices
     */
    'defaultPrecisionModel'?: NetTopologySuiteGeometriesPrecisionModel;
}
/**
 * 
 * @export
 * @interface NodaTimeCalendarSystem
 */
export interface NodaTimeCalendarSystem {
    /**
     * 
     * @type {string}
     * @memberof NodaTimeCalendarSystem
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NodaTimeCalendarSystem
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeCalendarSystem
     */
    'minYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeCalendarSystem
     */
    'maxYear'?: number;
    /**
     * 
     * @type {Array<NodaTimeCalendarsEra>}
     * @memberof NodaTimeCalendarSystem
     */
    'eras'?: Array<NodaTimeCalendarsEra> | null;
}
/**
 * 
 * @export
 * @interface NodaTimeCalendarsEra
 */
export interface NodaTimeCalendarsEra {
    /**
     * 
     * @type {string}
     * @memberof NodaTimeCalendarsEra
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface NodaTimeDuration
 */
export interface NodaTimeDuration {
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'days'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'nanosecondOfDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'minutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'milliseconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'subsecondTicks'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'subsecondNanoseconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'bclCompatibleTicks'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalMilliseconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalTicks'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeDuration
     */
    'totalNanoseconds'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NodaTimeIsoDayOfWeek = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7
} as const;

export type NodaTimeIsoDayOfWeek = typeof NodaTimeIsoDayOfWeek[keyof typeof NodaTimeIsoDayOfWeek];


/**
 * 
 * @export
 * @interface NodaTimeLocalDate
 */
export interface NodaTimeLocalDate {
    /**
     * 
     * @type {NodaTimeCalendarSystem}
     * @memberof NodaTimeLocalDate
     */
    'calendar'?: NodaTimeCalendarSystem;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDate
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDate
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDate
     */
    'day'?: number;
    /**
     * 
     * @type {NodaTimeIsoDayOfWeek}
     * @memberof NodaTimeLocalDate
     */
    'dayOfWeek'?: NodaTimeIsoDayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDate
     */
    'yearOfEra'?: number;
    /**
     * 
     * @type {NodaTimeCalendarsEra}
     * @memberof NodaTimeLocalDate
     */
    'era'?: NodaTimeCalendarsEra;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDate
     */
    'dayOfYear'?: number;
}


/**
 * 
 * @export
 * @interface NodaTimeLocalDateTime
 */
export interface NodaTimeLocalDateTime {
    /**
     * 
     * @type {NodaTimeCalendarSystem}
     * @memberof NodaTimeLocalDateTime
     */
    'calendar'?: NodaTimeCalendarSystem;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'yearOfEra'?: number;
    /**
     * 
     * @type {NodaTimeCalendarsEra}
     * @memberof NodaTimeLocalDateTime
     */
    'era'?: NodaTimeCalendarsEra;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'dayOfYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'day'?: number;
    /**
     * 
     * @type {NodaTimeIsoDayOfWeek}
     * @memberof NodaTimeLocalDateTime
     */
    'dayOfWeek'?: NodaTimeIsoDayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'clockHourOfHalfDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'second'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'millisecond'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'tickOfSecond'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'tickOfDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'nanosecondOfSecond'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalDateTime
     */
    'nanosecondOfDay'?: number;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof NodaTimeLocalDateTime
     */
    'timeOfDay'?: NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof NodaTimeLocalDateTime
     */
    'date'?: NodaTimeLocalDate;
}


/**
 * 
 * @export
 * @interface NodaTimeLocalTime
 */
export interface NodaTimeLocalTime {
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'clockHourOfHalfDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'second'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'millisecond'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'tickOfSecond'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'tickOfDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'nanosecondOfSecond'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodaTimeLocalTime
     */
    'nanosecondOfDay'?: number;
}
/**
 * 
 * @export
 * @interface PaymentReport
 */
export interface PaymentReport {
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'operatorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'paymentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'totalPaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'facilityFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'reversed'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReport
     */
    'remittedToFacility'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'paidWhen'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'payoutWhen'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'paymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'orderType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'reversedReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'reversedWhen'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReport
     */
    'paymentIntentKey'?: string | null;
}
/**
 * 
 * @export
 * @interface PayoutSummaryReport
 */
export interface PayoutSummaryReport {
    /**
     * 
     * @type {number}
     * @memberof PayoutSummaryReport
     */
    'operatorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayoutSummaryReport
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PayoutSummaryReport
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutSummaryReport
     */
    'payoutKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayoutSummaryReport
     */
    'payoutDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PayoutSummaryReport
     */
    'totalAmount'?: number;
}
/**
 * 
 * @export
 * @interface ServerCommonEmailArgsInvoiceArgs
 */
export interface ServerCommonEmailArgsInvoiceArgs {
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'facilityName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'parkerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'invoiceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'invoiceDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'openingBalance': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'totalDue': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'staffName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'staffEmail': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'link': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'linkText': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'isInvitation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'isModified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'isLiveReprint'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'managePlanLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'invoiceTxtBlock'?: string | null;
    /**
     * 
     * @type {DataEntitiesParkerInvoiceType}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'invoiceType'?: DataEntitiesParkerInvoiceType;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'facilityLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'remitToName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'remitToAddressHtml'?: string | null;
    /**
     * 
     * @type {DataEntitiesOperator}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'operator'?: DataEntitiesOperator;
    /**
     * 
     * @type {Array<ServerCommonEmailArgsInvoiceOrderDetail>}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'orderDetails'?: Array<ServerCommonEmailArgsInvoiceOrderDetail> | null;
    /**
     * 
     * @type {Array<ServerCommonEmailArgsInvoiceFeeDetail>}
     * @memberof ServerCommonEmailArgsInvoiceArgs
     */
    'fees'?: Array<ServerCommonEmailArgsInvoiceFeeDetail> | null;
}


/**
 * 
 * @export
 * @interface ServerCommonEmailArgsInvoiceFeeDetail
 */
export interface ServerCommonEmailArgsInvoiceFeeDetail {
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceFeeDetail
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceFeeDetail
     */
    'amount': string | null;
}
/**
 * 
 * @export
 * @interface ServerCommonEmailArgsInvoiceGroupDetail
 */
export interface ServerCommonEmailArgsInvoiceGroupDetail {
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'groupName': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'numberOfParkers'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'baseUnitPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'baseTotalPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'unitAdjustment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'totalAdjustment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'finalPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'ruleDescription'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'parkers'?: Array<string> | null;
    /**
     * 
     * @type {Array<ServerCommonEmailArgsInvoiceParkerCost>}
     * @memberof ServerCommonEmailArgsInvoiceGroupDetail
     */
    'parkerCosts'?: Array<ServerCommonEmailArgsInvoiceParkerCost> | null;
}
/**
 * 
 * @export
 * @interface ServerCommonEmailArgsInvoiceOrderDetail
 */
export interface ServerCommonEmailArgsInvoiceOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'desc': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'additionalDesc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'price'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'end'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'parkers'?: Array<string> | null;
    /**
     * 
     * @type {Array<ServerCommonEmailArgsInvoiceGroupDetail>}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'groupDetails'?: Array<ServerCommonEmailArgsInvoiceGroupDetail> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'isPreviousPeriodActivity'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'orderIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'paymentAmount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceOrderDetail
     */
    'balanceAmount'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerCommonEmailArgsInvoiceParkerCost
 */
export interface ServerCommonEmailArgsInvoiceParkerCost {
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceParkerCost
     */
    'parkerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceParkerCost
     */
    'basePrice': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceParkerCost
     */
    'adjustment': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceParkerCost
     */
    'finalPrice': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCommonEmailArgsInvoiceParkerCost
     */
    'startDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerCommonEmailArgsInvoiceParkerCost
     */
    'wasProrated'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerCommonEmpty
 */
export interface ServerCommonEmpty {
    /**
     * 
     * @type {boolean}
     * @memberof ServerCommonEmpty
     */
    'isOk': boolean;
}
/**
 * 
 * @export
 * @interface ServerControllersGridResultAdminRevenueReport
 */
export interface ServerControllersGridResultAdminRevenueReport {
    /**
     * 
     * @type {Array<AdminRevenueReport>}
     * @memberof ServerControllersGridResultAdminRevenueReport
     */
    'items'?: Array<AdminRevenueReport> | null;
}
/**
 * 
 * @export
 * @interface ServerControllersGridResultAgingReport
 */
export interface ServerControllersGridResultAgingReport {
    /**
     * 
     * @type {Array<AgingReport>}
     * @memberof ServerControllersGridResultAgingReport
     */
    'items'?: Array<AgingReport> | null;
}
/**
 * 
 * @export
 * @interface ServerControllersGridResultPaymentReport
 */
export interface ServerControllersGridResultPaymentReport {
    /**
     * 
     * @type {Array<PaymentReport>}
     * @memberof ServerControllersGridResultPaymentReport
     */
    'items'?: Array<PaymentReport> | null;
}
/**
 * 
 * @export
 * @interface ServerControllersGridResultPayoutSummaryReport
 */
export interface ServerControllersGridResultPayoutSummaryReport {
    /**
     * 
     * @type {Array<PayoutSummaryReport>}
     * @memberof ServerControllersGridResultPayoutSummaryReport
     */
    'items'?: Array<PayoutSummaryReport> | null;
}
/**
 * 
 * @export
 * @interface ServerControllersGridResultRedeemedValidationReport
 */
export interface ServerControllersGridResultRedeemedValidationReport {
    /**
     * 
     * @type {Array<DataEntitiesReportsRedeemedValidationReport>}
     * @memberof ServerControllersGridResultRedeemedValidationReport
     */
    'items'?: Array<DataEntitiesReportsRedeemedValidationReport> | null;
}
/**
 * 
 * @export
 * @interface ServerControllersGridResultSubscriptionReport
 */
export interface ServerControllersGridResultSubscriptionReport {
    /**
     * 
     * @type {Array<SubscriptionReport>}
     * @memberof ServerControllersGridResultSubscriptionReport
     */
    'items'?: Array<SubscriptionReport> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsAcceptDelegateRequest
 */
export interface ServerRequestsAcceptDelegateRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsAcceptDelegateRequest
     */
    'inviteCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsAcceptDelegateResponse
 */
export interface ServerRequestsAcceptDelegateResponse {
    /**
     * 
     * @type {ServerTransferDelegateItem}
     * @memberof ServerRequestsAcceptDelegateResponse
     */
    'item'?: ServerTransferDelegateItem;
}
/**
 * 
 * @export
 * @interface ServerRequestsAddToWaitlistRequest
 */
export interface ServerRequestsAddToWaitlistRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAddToWaitlistRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAddToWaitlistRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAddToWaitlistRequest
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAddToWaitlistRequest
     */
    'planEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAddToWaitlistRequest
     */
    'spacesRequested'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsAddToWaitlistRequest
     */
    'isAddingToExistingParker'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsAnalyticsOverviewResponse
 */
export interface ServerRequestsAnalyticsOverviewResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAnalyticsOverviewResponse
     */
    'operatorsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAnalyticsOverviewResponse
     */
    'facilitiesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAnalyticsOverviewResponse
     */
    'usersCounts'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsAssignBillingPlanToFacilitiesResponse
 */
export interface ServerRequestsAssignBillingPlanToFacilitiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsAssignBillingPlanToFacilitiesResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsAssignBillingPlanToFacilitiesResponse
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<ServerRequestsFacilityBillingPlanDto>}
     * @memberof ServerRequestsAssignBillingPlanToFacilitiesResponse
     */
    'assignedPlans'?: Array<ServerRequestsFacilityBillingPlanDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsAuditTableResponse
 */
export interface ServerRequestsAuditTableResponse {
    /**
     * 
     * @type {Array<ServerServicesIntegrationsAuditEntity>}
     * @memberof ServerRequestsAuditTableResponse
     */
    'auditEntities'?: Array<ServerServicesIntegrationsAuditEntity> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsAvailableOptInFee
 */
export interface ServerRequestsAvailableOptInFee {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'isDefaultOptIn'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'amount'?: number;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeCalc}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'operatorFeeCalc'?: DataEntitiesFinanceOperatorFeeCalc;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'receiptDescription'?: string | null;
    /**
     * 
     * @type {DataEntitiesFinancePartner}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'partner'?: DataEntitiesFinancePartner;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsAvailableOptInFee
     */
    'isPerSpace'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerRequestsBillingPlanDetailDto
 */
export interface ServerRequestsBillingPlanDetailDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'billingPlanId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'description': string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'canceledWhen'?: object;
    /**
     * 
     * @type {Array<ServerRequestsBillingRuleDto>}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'billingRules'?: Array<ServerRequestsBillingRuleDto> | null;
    /**
     * 
     * @type {Array<ServerRequestsFacilityBillingPlanDto>}
     * @memberof ServerRequestsBillingPlanDetailDto
     */
    'facilityAssignments'?: Array<ServerRequestsFacilityBillingPlanDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsBillingPlanDto
 */
export interface ServerRequestsBillingPlanDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDto
     */
    'billingPlanId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDto
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsBillingPlanDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsBillingPlanDto
     */
    'description': string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsBillingPlanDto
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsBillingPlanDto
     */
    'canceledWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDto
     */
    'ruleCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDto
     */
    'operatorFacilityCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingPlanDto
     */
    'totalFacilityCount'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsBillingRuleDto
 */
export interface ServerRequestsBillingRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingRuleDto
     */
    'billingRuleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingRuleDto
     */
    'billingPlanId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsBillingRuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {DataEntitiesFinanceBillingRuleType}
     * @memberof ServerRequestsBillingRuleDto
     */
    'ruleType': DataEntitiesFinanceBillingRuleType;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsBillingRuleDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsBillingRuleDto
     */
    'customProcedureName'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsBillingRuleDto
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsBillingRuleDto
     */
    'canceledWhen'?: object;
}


/**
 * 
 * @export
 * @interface ServerRequestsCancelBillingPlanResponse
 */
export interface ServerRequestsCancelBillingPlanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCancelBillingPlanResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCancelBillingPlanResponse
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCancelFeeResponse
 */
export interface ServerRequestsCancelFeeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCancelFeeResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServerRequestsCancelFeeResponse
     */
    'errors'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsChangeOptInFeeRequest
 */
export interface ServerRequestsChangeOptInFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsChangeOptInFeeRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsChangeOptInFeeRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsChangeOptInFeeRequest
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsChangeOptInFeeRequest
     */
    'isOptIn'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsCheckParkerIntegrationSyncResponse
 */
export interface ServerRequestsCheckParkerIntegrationSyncResponse {
    /**
     * 
     * @type {Array<ServerRequestsParkerIntegrationSyncStatusDto>}
     * @memberof ServerRequestsCheckParkerIntegrationSyncResponse
     */
    'items'?: Array<ServerRequestsParkerIntegrationSyncStatusDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCompleteParkingValidationResponse
 */
export interface ServerRequestsCompleteParkingValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCompleteParkingValidationResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsContractRulesResponse
 */
export interface ServerRequestsContractRulesResponse {
    /**
     * 
     * @type {Array<ServerRequestsSubscriptionGroupContractRuleDto>}
     * @memberof ServerRequestsContractRulesResponse
     */
    'rules'?: Array<ServerRequestsSubscriptionGroupContractRuleDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsContractRulesResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsContractsRuleSaveRequest
 */
export interface ServerRequestsContractsRuleSaveRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsContractsRuleSaveRequest
     */
    'subscriptionGroupId'?: number;
    /**
     * 
     * @type {Array<ServerRequestsSubscriptionGroupContractRuleDto>}
     * @memberof ServerRequestsContractsRuleSaveRequest
     */
    'rules'?: Array<ServerRequestsSubscriptionGroupContractRuleDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCostProjectionDto
 */
export interface ServerRequestsCostProjectionDto {
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsCostProjectionDto
     */
    'periodStartDate'?: NodaTimeLocalDate;
    /**
     * 
     * @type {ServerRequestsMoneyDto}
     * @memberof ServerRequestsCostProjectionDto
     */
    'total'?: ServerRequestsMoneyDto;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCostProjectionDto
     */
    'hasPreviousPeriodActivity'?: boolean;
    /**
     * 
     * @type {Array<ServerRequestsCostProjectionGroupDto>}
     * @memberof ServerRequestsCostProjectionDto
     */
    'groups'?: Array<ServerRequestsCostProjectionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCostProjectionGroupDto
 */
export interface ServerRequestsCostProjectionGroupDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCostProjectionGroupDto
     */
    'groupId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCostProjectionGroupDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCostProjectionGroupDto
     */
    'parkerCount'?: number;
    /**
     * 
     * @type {ServerRequestsMoneyDto}
     * @memberof ServerRequestsCostProjectionGroupDto
     */
    'subtotal'?: ServerRequestsMoneyDto;
    /**
     * 
     * @type {Array<ServerRequestsCostProjectionLineItemDto>}
     * @memberof ServerRequestsCostProjectionGroupDto
     */
    'lineItems'?: Array<ServerRequestsCostProjectionLineItemDto> | null;
    /**
     * 
     * @type {Array<ServerRequestsParkerCostDto>}
     * @memberof ServerRequestsCostProjectionGroupDto
     */
    'parkerCosts'?: Array<ServerRequestsParkerCostDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCostProjectionLineItemDto
 */
export interface ServerRequestsCostProjectionLineItemDto {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCostProjectionLineItemDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCostProjectionLineItemDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {ServerRequestsMoneyDto}
     * @memberof ServerRequestsCostProjectionLineItemDto
     */
    'unitPrice'?: ServerRequestsMoneyDto;
    /**
     * 
     * @type {ServerRequestsMoneyDto}
     * @memberof ServerRequestsCostProjectionLineItemDto
     */
    'total'?: ServerRequestsMoneyDto;
}
/**
 * 
 * @export
 * @interface ServerRequestsCostProjectionResponse
 */
export interface ServerRequestsCostProjectionResponse {
    /**
     * 
     * @type {ServerRequestsCostProjectionDto}
     * @memberof ServerRequestsCostProjectionResponse
     */
    'currentPeriod'?: ServerRequestsCostProjectionDto;
    /**
     * 
     * @type {ServerRequestsCostProjectionDto}
     * @memberof ServerRequestsCostProjectionResponse
     */
    'nextPeriod'?: ServerRequestsCostProjectionDto;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateAdminStaffRequest
 */
export interface ServerRequestsCreateAdminStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateAdminStaffRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateAdminStaffRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateAdminStaffRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateAdminStaffRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateAdminStaffRequest
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateAdminStaffRequest
     */
    'role'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateBillingPlanRequest
 */
export interface ServerRequestsCreateBillingPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateBillingPlanRequest
     */
    'operatorId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateBillingPlanRequest
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateBillingPlanRequest
     */
    'description': string | null;
    /**
     * 
     * @type {Array<ServerRequestsCreateBillingRuleDto>}
     * @memberof ServerRequestsCreateBillingPlanRequest
     */
    'billingRules'?: Array<ServerRequestsCreateBillingRuleDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateBillingPlanRequest
     */
    'staffId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateBillingPlanResponse
 */
export interface ServerRequestsCreateBillingPlanResponse {
    /**
     * 
     * @type {ServerRequestsBillingPlanDetailDto}
     * @memberof ServerRequestsCreateBillingPlanResponse
     */
    'billingPlan'?: ServerRequestsBillingPlanDetailDto;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateBillingPlanResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateBillingPlanResponse
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateBillingRuleDto
 */
export interface ServerRequestsCreateBillingRuleDto {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateBillingRuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {DataEntitiesFinanceBillingRuleType}
     * @memberof ServerRequestsCreateBillingRuleDto
     */
    'ruleType': DataEntitiesFinanceBillingRuleType;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateBillingRuleDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateBillingRuleDto
     */
    'customProcedureName'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerRequestsCreateFeeRequest
 */
export interface ServerRequestsCreateFeeRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'feeName': string;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'amount': number;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeCalc}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'feeCalc': DataEntitiesFinanceOperatorFeeCalc;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'feeScope': DataEntitiesFinanceOperatorFeeScope;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'operatorId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'isAppliedToParker': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'facilityId'?: number | null;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'paymentType'?: DataEntitiesFinanceOperatorFeePaymentType;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'receiptDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'isOptIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'isPerSpace'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'isFullyRemittedToOperator'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'isDefaultOptIn'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'partnerFee'?: number;
    /**
     * 
     * @type {DataEntitiesFinancePartner}
     * @memberof ServerRequestsCreateFeeRequest
     */
    'partner'?: DataEntitiesFinancePartner;
}


/**
 * 
 * @export
 * @interface ServerRequestsCreateFeeResponse
 */
export interface ServerRequestsCreateFeeResponse {
    /**
     * 
     * @type {ServerRequestsFeeInfo}
     * @memberof ServerRequestsCreateFeeResponse
     */
    'item'?: ServerRequestsFeeInfo;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServerRequestsCreateFeeResponse
     */
    'errors'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateIntegrationPartyRequest
 */
export interface ServerRequestsCreateIntegrationPartyRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateIntegrationPartyRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateIntegrationPartyRequest
     */
    'origin'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateOperatorRequest
 */
export interface ServerRequestsCreateOperatorRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'hostName'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'logoUrlBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'topTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'bottomLeftTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'bottomRightTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'topText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'bottomLeftText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateOperatorRequest
     */
    'bottomRightText'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateParkerNoteRequest
 */
export interface ServerRequestsCreateParkerNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateParkerNoteRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateParkerNoteRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateParkerNoteRequest
     */
    'noteText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateParkerNoteRequest
     */
    'staffId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateParkerNoteResponse
 */
export interface ServerRequestsCreateParkerNoteResponse {
    /**
     * 
     * @type {ServerRequestsParkerNoteDto}
     * @memberof ServerRequestsCreateParkerNoteResponse
     */
    'note'?: ServerRequestsParkerNoteDto;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateStaffRequest
 */
export interface ServerRequestsCreateStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'role'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServerRequestsCreateStaffRequest
     */
    'facilities'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsCreateUsageChargeResponse
 */
export interface ServerRequestsCreateUsageChargeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsCreateUsageChargeResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateUsageChargeResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateUsageChargeResponse
     */
    'orderId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateUsageChargeResponse
     */
    'paymentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsCreateUsageChargeResponse
     */
    'totalCharged'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsCreateUsageChargeResponse
     */
    'paymentIntentKey'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsDeleteParkerFromWaitlistResponse
 */
export interface ServerRequestsDeleteParkerFromWaitlistResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsDeleteParkerFromWaitlistResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsEnrollIntegrationPartyRequest
 */
export interface ServerRequestsEnrollIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollIntegrationPartyRequest
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollIntegrationPartyRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsEnrollIntegrationPartyRequest
     */
    'isActive'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsEnrollIntegrationPartyRequest
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsEnrollIntegrationPartyRequest
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsEnrollIntegrationPartyRequest
     */
    'apiSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsEnrollSubscriptionIntegrationPartiesRequest
 */
export interface ServerRequestsEnrollSubscriptionIntegrationPartiesRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollSubscriptionIntegrationPartiesRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollSubscriptionIntegrationPartiesRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollSubscriptionIntegrationPartiesRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollSubscriptionIntegrationPartiesRequest
     */
    'integrationPartyId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsEnrollVehicleIntegrationPartiesRequest
 */
export interface ServerRequestsEnrollVehicleIntegrationPartiesRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollVehicleIntegrationPartiesRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollVehicleIntegrationPartiesRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollVehicleIntegrationPartiesRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollVehicleIntegrationPartiesRequest
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsEnrollVehicleIntegrationPartiesRequest
     */
    'vehicleId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsFacilityBillingPlanDto
 */
export interface ServerRequestsFacilityBillingPlanDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'facilityBillingPlanId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'billingPlanId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'facilityName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'billingPlanName': string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsFacilityBillingPlanDto
     */
    'removedWhen'?: object;
}
/**
 * 
 * @export
 * @interface ServerRequestsFeeCalculationTest
 */
export interface ServerRequestsFeeCalculationTest {
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof ServerRequestsFeeCalculationTest
     */
    'feeScope'?: DataEntitiesFinanceOperatorFeeScope;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof ServerRequestsFeeCalculationTest
     */
    'feePaymentType'?: DataEntitiesFinanceOperatorFeePaymentType;
    /**
     * 
     * @type {DataRepositoryFeeCalculationResult}
     * @memberof ServerRequestsFeeCalculationTest
     */
    'feeCalculations'?: DataRepositoryFeeCalculationResult;
}


/**
 * 
 * @export
 * @interface ServerRequestsFeeCalculationTestResponse
 */
export interface ServerRequestsFeeCalculationTestResponse {
    /**
     * 
     * @type {Array<ServerRequestsFeeCalculationTest>}
     * @memberof ServerRequestsFeeCalculationTestResponse
     */
    'feeCalculations'?: Array<ServerRequestsFeeCalculationTest> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsFeeInfo
 */
export interface ServerRequestsFeeInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFeeInfo
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFeeInfo
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'feeName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFeeInfo
     */
    'amount'?: number;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeCalc}
     * @memberof ServerRequestsFeeInfo
     */
    'feeCalc'?: DataEntitiesFinanceOperatorFeeCalc;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof ServerRequestsFeeInfo
     */
    'feeScope'?: DataEntitiesFinanceOperatorFeeScope;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsFeeInfo
     */
    'isAppliedToParker'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'createdWhen'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'canceledWhen'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFeeInfo
     */
    'createdByStaffId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFeeInfo
     */
    'facilityId'?: number | null;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof ServerRequestsFeeInfo
     */
    'paymentType'?: DataEntitiesFinanceOperatorFeePaymentType;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'createdByStaffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'operatorName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsFeeInfo
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsFeeInfo
     */
    'receiptDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsFeeInfo
     */
    'isOptIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsFeeInfo
     */
    'isPerSpace'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsFeeInfo
     */
    'isFullyRemittedToOperator'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsFeeInfo
     */
    'isDefaultOptIn'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsFeeInfo
     */
    'partnerFee'?: number;
    /**
     * 
     * @type {DataEntitiesFinancePartner}
     * @memberof ServerRequestsFeeInfo
     */
    'partner'?: DataEntitiesFinancePartner;
}


/**
 * 
 * @export
 * @interface ServerRequestsGenerateIntegrationPartyTokenResponse
 */
export interface ServerRequestsGenerateIntegrationPartyTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGenerateIntegrationPartyTokenResponse
     */
    'token': string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGenerateOperatorInvoicesRequest
 */
export interface ServerRequestsGenerateOperatorInvoicesRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGenerateOperatorInvoicesRequest
     */
    'operatorId': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGenerateOperatorInvoicesRequest
     */
    'billingPeriodStart': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGenerateOperatorInvoicesRequest
     */
    'billingPeriodEnd': NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGenerateOperatorInvoicesRequest
     */
    'staffId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGenerateOperatorInvoicesResponse
 */
export interface ServerRequestsGenerateOperatorInvoicesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGenerateOperatorInvoicesResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGenerateOperatorInvoicesResponse
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<ServerRequestsOperatorInvoiceDto>}
     * @memberof ServerRequestsGenerateOperatorInvoicesResponse
     */
    'generatedInvoices'?: Array<ServerRequestsOperatorInvoiceDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetBillingPlanResponse
 */
export interface ServerRequestsGetBillingPlanResponse {
    /**
     * 
     * @type {ServerRequestsBillingPlanDetailDto}
     * @memberof ServerRequestsGetBillingPlanResponse
     */
    'billingPlan'?: ServerRequestsBillingPlanDetailDto;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetBillingPlansResponse
 */
export interface ServerRequestsGetBillingPlansResponse {
    /**
     * 
     * @type {Array<ServerRequestsBillingPlanDto>}
     * @memberof ServerRequestsGetBillingPlansResponse
     */
    'billingPlans'?: Array<ServerRequestsBillingPlanDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetBillingPlansResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetCompletedTutorialResponse
 */
export interface ServerRequestsGetCompletedTutorialResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerRequestsGetCompletedTutorialResponse
     */
    'completedTutorials'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetEnrolledIntegrationPartiesResponse
 */
export interface ServerRequestsGetEnrolledIntegrationPartiesResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetEnrolledIntegrationPartiesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ServerTransferEnrolledIntegrationParty>}
     * @memberof ServerRequestsGetEnrolledIntegrationPartiesResponse
     */
    'items'?: Array<ServerTransferEnrolledIntegrationParty> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetEnrolledIntegrationPartyResponse
 */
export interface ServerRequestsGetEnrolledIntegrationPartyResponse {
    /**
     * 
     * @type {ServerTransferEnrolledIntegrationParty}
     * @memberof ServerRequestsGetEnrolledIntegrationPartyResponse
     */
    'item'?: ServerTransferEnrolledIntegrationParty;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetFacilitiesLiteResponse
 */
export interface ServerRequestsGetFacilitiesLiteResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetFacilitiesLiteResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ServerTransferFacilityLite>}
     * @memberof ServerRequestsGetFacilitiesLiteResponse
     */
    'items'?: Array<ServerTransferFacilityLite> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetFacilitiesResponse
 */
export interface ServerRequestsGetFacilitiesResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetFacilitiesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ServerTransferMonitorFacility>}
     * @memberof ServerRequestsGetFacilitiesResponse
     */
    'items'?: Array<ServerTransferMonitorFacility> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetFacilityBillingPlansResponse
 */
export interface ServerRequestsGetFacilityBillingPlansResponse {
    /**
     * 
     * @type {Array<ServerRequestsFacilityBillingPlanDto>}
     * @memberof ServerRequestsGetFacilityBillingPlansResponse
     */
    'billingPlans'?: Array<ServerRequestsFacilityBillingPlanDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetFacilityWaitlistToggleResponse
 */
export interface ServerRequestsGetFacilityWaitlistToggleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGetFacilityWaitlistToggleResponse
     */
    'isWaitlistEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGetFacilityWaitlistToggleResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetFeeResponse
 */
export interface ServerRequestsGetFeeResponse {
    /**
     * 
     * @type {ServerRequestsFeeInfo}
     * @memberof ServerRequestsGetFeeResponse
     */
    'item'?: ServerRequestsFeeInfo;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServerRequestsGetFeeResponse
     */
    'errors'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetFeesResponse
 */
export interface ServerRequestsGetFeesResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetFeesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ServerRequestsFeeInfo>}
     * @memberof ServerRequestsGetFeesResponse
     */
    'items'?: Array<ServerRequestsFeeInfo> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetIntegrationPartiesResponse
 */
export interface ServerRequestsGetIntegrationPartiesResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetIntegrationPartiesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ServerTransferIntegrationParty>}
     * @memberof ServerRequestsGetIntegrationPartiesResponse
     */
    'items'?: Array<ServerTransferIntegrationParty> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetIntegrationPartyResponse
 */
export interface ServerRequestsGetIntegrationPartyResponse {
    /**
     * 
     * @type {ServerTransferIntegrationParty}
     * @memberof ServerRequestsGetIntegrationPartyResponse
     */
    'item'?: ServerTransferIntegrationParty;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServerRequestsGetIntegrationPartyResponse
     */
    'errors'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetMyDelegatesResponse
 */
export interface ServerRequestsGetMyDelegatesResponse {
    /**
     * 
     * @type {Array<ServerTransferDelegateItem>}
     * @memberof ServerRequestsGetMyDelegatesResponse
     */
    'items'?: Array<ServerTransferDelegateItem> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetMyDelegationsResponse
 */
export interface ServerRequestsGetMyDelegationsResponse {
    /**
     * 
     * @type {Array<ServerTransferDelegateItem>}
     * @memberof ServerRequestsGetMyDelegationsResponse
     */
    'items'?: Array<ServerTransferDelegateItem> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetOperatorFacilityBillingPlansResponse
 */
export interface ServerRequestsGetOperatorFacilityBillingPlansResponse {
    /**
     * 
     * @type {Array<ServerRequestsFacilityBillingPlanDto>}
     * @memberof ServerRequestsGetOperatorFacilityBillingPlansResponse
     */
    'billingPlans'?: Array<ServerRequestsFacilityBillingPlanDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetOperatorFacilityBillingPlansResponse
     */
    'totalFacilities'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetOperatorFacilityBillingPlansResponse
     */
    'facilitiesWithBillingPlans'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetOperatorResponse
 */
export interface ServerRequestsGetOperatorResponse {
    /**
     * 
     * @type {ServerTransferOperator}
     * @memberof ServerRequestsGetOperatorResponse
     */
    'item'?: ServerTransferOperator;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServerRequestsGetOperatorResponse
     */
    'errors'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetOperatorsResponse
 */
export interface ServerRequestsGetOperatorsResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetOperatorsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DataEntitiesOperator>}
     * @memberof ServerRequestsGetOperatorsResponse
     */
    'items'?: Array<DataEntitiesOperator> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetOptInFeesResponse
 */
export interface ServerRequestsGetOptInFeesResponse {
    /**
     * 
     * @type {Array<ServerRequestsAvailableOptInFee>}
     * @memberof ServerRequestsGetOptInFeesResponse
     */
    'availableOptInFees'?: Array<ServerRequestsAvailableOptInFee> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetParkerDashboardStatsResponse
 */
export interface ServerRequestsGetParkerDashboardStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetParkerDashboardStatsResponse
     */
    'activeSubscriptionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetParkerDashboardStatsResponse
     */
    'activeOrUpcomingReservationCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetParkerDashboardStatsResponse
     */
    'activeAccessPassCount'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetParkerDelegatesResponse
 */
export interface ServerRequestsGetParkerDelegatesResponse {
    /**
     * 
     * @type {Array<ServerTransferDelegateItem>}
     * @memberof ServerRequestsGetParkerDelegatesResponse
     */
    'items'?: Array<ServerTransferDelegateItem> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetParkerOptInFeeResponse
 */
export interface ServerRequestsGetParkerOptInFeeResponse {
    /**
     * 
     * @type {Array<ServerRequestsParkerOptInFee>}
     * @memberof ServerRequestsGetParkerOptInFeeResponse
     */
    'parkerOptInFees'?: Array<ServerRequestsParkerOptInFee> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetParkerOptInFeesRequest
 */
export interface ServerRequestsGetParkerOptInFeesRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetParkerOptInFeesRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetParkerOptInFeesRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetParkerOptInFeesRequest
     */
    'facilityId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetParkerResponse
 */
export interface ServerRequestsGetParkerResponse {
    /**
     * 
     * @type {ServerTransferConnectParker}
     * @memberof ServerRequestsGetParkerResponse
     */
    'item'?: ServerTransferConnectParker;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetParkingValidationRequestsResponse
 */
export interface ServerRequestsGetParkingValidationRequestsResponse {
    /**
     * 
     * @type {Array<ServerRequestsParkingValidationData>}
     * @memberof ServerRequestsGetParkingValidationRequestsResponse
     */
    'items'?: Array<ServerRequestsParkingValidationData> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetStaffPermissionsCatalogResponse
 */
export interface ServerRequestsGetStaffPermissionsCatalogResponse {
    /**
     * 
     * @type {Array<ServerTransferMonitorMonitorPermissionDto>}
     * @memberof ServerRequestsGetStaffPermissionsCatalogResponse
     */
    'items'?: Array<ServerTransferMonitorMonitorPermissionDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetStaffResponse
 */
export interface ServerRequestsGetStaffResponse {
    /**
     * 
     * @type {ServerTransferMonitorStaff}
     * @memberof ServerRequestsGetStaffResponse
     */
    'item'?: ServerTransferMonitorStaff;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetStaffsResponse
 */
export interface ServerRequestsGetStaffsResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetStaffsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ServerTransferMonitorStaff>}
     * @memberof ServerRequestsGetStaffsResponse
     */
    'items'?: Array<ServerTransferMonitorStaff> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetSubBillingFailedResponse
 */
export interface ServerRequestsGetSubBillingFailedResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGetSubBillingFailedResponse
     */
    'failedMsg'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetWaitlistByParkerIdResponse
 */
export interface ServerRequestsGetWaitlistByParkerIdResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGetWaitlistByParkerIdResponse
     */
    'waitlistEntryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGetWaitlistByParkerIdResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGetWaitlistResponse
 */
export interface ServerRequestsGetWaitlistResponse {
    /**
     * 
     * @type {Array<ServerRequestsWaitlistData>}
     * @memberof ServerRequestsGetWaitlistResponse
     */
    'items'?: Array<ServerRequestsWaitlistData> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGetWaitlistResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerCheckoutParkerItem
 */
export interface ServerRequestsGroupParkerCheckoutParkerItem {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'startDate'?: NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'subscriptionGroupId'?: number | null;
    /**
     * 
     * @type {Array<ServerRequestsGroupParkerFeeItem>}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'fees'?: Array<ServerRequestsGroupParkerFeeItem> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerCheckoutParkerItem
     */
    'pendingIntegrationCredential'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerCheckoutRequest
 */
export interface ServerRequestsGroupParkerCheckoutRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerCheckoutRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {Array<ServerRequestsGroupParkerCheckoutParkerItem>}
     * @memberof ServerRequestsGroupParkerCheckoutRequest
     */
    'parkers'?: Array<ServerRequestsGroupParkerCheckoutParkerItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerCheckoutRequest
     */
    'isAch'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerCheckoutResponse
 */
export interface ServerRequestsGroupParkerCheckoutResponse {
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'parkers'?: Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'orderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'paymentIntentClientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerCheckoutResponse
     */
    'customerSessionClientSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerFeeItem
 */
export interface ServerRequestsGroupParkerFeeItem {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerFeeItem
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFeeItem
     */
    'amountCents'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionFeeCadence}
     * @memberof ServerRequestsGroupParkerFeeItem
     */
    'cadence'?: DataEntitiesSubscriptionFeeCadence;
}


/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerFinalizeQuoteRequest
 */
export interface ServerRequestsGroupParkerFinalizeQuoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {Array<ServerRequestsGroupParkerCheckoutParkerItem>}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteRequest
     */
    'parkers'?: Array<ServerRequestsGroupParkerCheckoutParkerItem> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerFinalizeQuoteResponse
 */
export interface ServerRequestsGroupParkerFinalizeQuoteResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteResponse
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteResponse
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeQuoteResponse
     */
    'goodsFees'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerFinalizeRequest
 */
export interface ServerRequestsGroupParkerFinalizeRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'staffId'?: number;
    /**
     * 
     * @type {Array<ServerRequestsGroupParkerCheckoutParkerItem>}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'parkers'?: Array<ServerRequestsGroupParkerCheckoutParkerItem> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'ipAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'userAgent'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerFinalizeRequest
     */
    'canChargeSubscription'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerFinalizeResponse
 */
export interface ServerRequestsGroupParkerFinalizeResponse {
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerRequestsGroupParkerFinalizeResponse
     */
    'parkers': Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeResponse
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeResponse
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerFinalizeResponse
     */
    'orderId'?: number | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerFulfillCheckoutResponse
 */
export interface ServerRequestsGroupParkerFulfillCheckoutResponse {
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerRequestsGroupParkerFulfillCheckoutResponse
     */
    'parkers': Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerFulfillCheckoutResponse
     */
    'alreadyFulfilled'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerInviteInitRequest
 */
export interface ServerRequestsGroupParkerInviteInitRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerInviteInitRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerInviteInitRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerInviteInitRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerInviteInitRequest
     */
    'isLoginEnabled'?: boolean;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGroupParkerInviteInitRequest
     */
    'startDate'?: NodaTimeLocalDate;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerInviteInitResponse
 */
export interface ServerRequestsGroupParkerInviteInitResponse {
    /**
     * 
     * @type {ServerTransferSubscriptionParker}
     * @memberof ServerRequestsGroupParkerInviteInitResponse
     */
    'parker': ServerTransferSubscriptionParker;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerInviteInitResponse
     */
    'isCurrentPeriod'?: boolean;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGroupParkerInviteInitResponse
     */
    'billingStartsOn'?: NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerInviteInitResponse
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerPreviewRequest
 */
export interface ServerRequestsGroupParkerPreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGroupParkerPreviewRequest
     */
    'startDate'?: NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewRequest
     */
    'pendingAssignCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewRequest
     */
    'pendingSameGroupAssignCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewRequest
     */
    'subscriptionGroupId'?: number | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerPreviewResponse
 */
export interface ServerRequestsGroupParkerPreviewResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewResponse
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerPreviewResponse
     */
    'parkerFees'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerPreviewResponse
     */
    'isCurrentPeriod'?: boolean;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsGroupParkerPreviewResponse
     */
    'billingStartsOn'?: NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsGroupParkerPreviewResponse
     */
    'willAmendOpenInvoice'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerUpdateRequest
 */
export interface ServerRequestsGroupParkerUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerUpdateRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsGroupParkerUpdateRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerUpdateRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerUpdateRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsGroupParkerUpdateRequest
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsGroupParkerUpdateResponse
 */
export interface ServerRequestsGroupParkerUpdateResponse {
    /**
     * 
     * @type {ServerTransferSubscriptionParker}
     * @memberof ServerRequestsGroupParkerUpdateResponse
     */
    'parker': ServerTransferSubscriptionParker;
}
/**
 * 
 * @export
 * @interface ServerRequestsInviteDelegateRequest
 */
export interface ServerRequestsInviteDelegateRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsInviteDelegateRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsInviteDelegateResponse
 */
export interface ServerRequestsInviteDelegateResponse {
    /**
     * 
     * @type {ServerTransferDelegateItem}
     * @memberof ServerRequestsInviteDelegateResponse
     */
    'item'?: ServerTransferDelegateItem;
}
/**
 * 
 * @export
 * @interface ServerRequestsInviteInfoResponse
 */
export interface ServerRequestsInviteInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsInviteInfoResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsInviteInfoResponse
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsInviteInfoResponse
     */
    'ownerParkerId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsInviteParkerToClaimSpotRequest
 */
export interface ServerRequestsInviteParkerToClaimSpotRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsInviteParkerToClaimSpotRequest
     */
    'waitlistEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsInviteParkerToClaimSpotRequest
     */
    'holdPeriodHours'?: number | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsListParkerIntegrationPartiesResponse
 */
export interface ServerRequestsListParkerIntegrationPartiesResponse {
    /**
     * 
     * @type {Array<ServerRequestsParkerIntegrationPartyDto>}
     * @memberof ServerRequestsListParkerIntegrationPartiesResponse
     */
    'items'?: Array<ServerRequestsParkerIntegrationPartyDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsListParkerNotesResponse
 */
export interface ServerRequestsListParkerNotesResponse {
    /**
     * 
     * @type {Array<ServerRequestsParkerNoteDto>}
     * @memberof ServerRequestsListParkerNotesResponse
     */
    'notes'?: Array<ServerRequestsParkerNoteDto> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsMoneyDto
 */
export interface ServerRequestsMoneyDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsMoneyDto
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsMoneyDto
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsOperatorInvoiceDto
 */
export interface ServerRequestsOperatorInvoiceDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'operatorInvoiceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'operatorName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'invoiceNumber': string | null;
    /**
     * 
     * @type {DataEntitiesFinanceInvoiceStatus}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'status': DataEntitiesFinanceInvoiceStatus;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'billingPeriodStart': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'billingPeriodEnd': NodaTimeLocalDate;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'sentWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'paidWhen'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'dueDate'?: object;
    /**
     * 
     * @type {Array<ServerRequestsOperatorInvoiceLineItemDto>}
     * @memberof ServerRequestsOperatorInvoiceDto
     */
    'lineItems'?: Array<ServerRequestsOperatorInvoiceLineItemDto> | null;
}


/**
 * 
 * @export
 * @interface ServerRequestsOperatorInvoiceLineItemDto
 */
export interface ServerRequestsOperatorInvoiceLineItemDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'operatorInvoiceLineItemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'operatorInvoiceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'billingRuleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'facilityName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'rate': number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'amount': number;
    /**
     * 
     * @type {DataEntitiesFinanceBillingRuleType}
     * @memberof ServerRequestsOperatorInvoiceLineItemDto
     */
    'ruleType': DataEntitiesFinanceBillingRuleType;
}


/**
 * 
 * @export
 * @interface ServerRequestsParkerCostDto
 */
export interface ServerRequestsParkerCostDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerCostDto
     */
    'subscriptionParkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerCostDto
     */
    'parkerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerCostDto
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerCostDto
     */
    'basePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerCostDto
     */
    'adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerCostDto
     */
    'finalPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerCostDto
     */
    'wasProrated'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkerGroupChangeRequest
 */
export interface ServerRequestsParkerGroupChangeRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerGroupChangeRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerGroupChangeRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerGroupChangeRequest
     */
    'subscriptionGroupId'?: number | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkerGroupChangeResponse
 */
export interface ServerRequestsParkerGroupChangeResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerGroupChangeResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkerIntegrationPartyDto
 */
export interface ServerRequestsParkerIntegrationPartyDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'integrationName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'lastOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'metaFlashUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'parentUid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'metaFlashRFIDNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'modified'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'capabilities'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'rfidValidationPattern'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationPartyDto
     */
    'rfidValidationMaxLength'?: number | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkerIntegrationSyncStatusDto
 */
export interface ServerRequestsParkerIntegrationSyncStatusDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationSyncStatusDto
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationSyncStatusDto
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerIntegrationSyncStatusDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerIntegrationSyncStatusDto
     */
    'isSynced'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerIntegrationSyncStatusDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerIntegrationSyncStatusDto
     */
    'canResync'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkerNoteDto
 */
export interface ServerRequestsParkerNoteDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerNoteDto
     */
    'parkerNoteId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerNoteDto
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerNoteDto
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerNoteDto
     */
    'staffId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerNoteDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerNoteDto
     */
    'noteText'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsParkerNoteDto
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerNoteDto
     */
    'previousNoteId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerNoteDto
     */
    'isEdited'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkerOptInFee
 */
export interface ServerRequestsParkerOptInFee {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerOptInFee
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkerOptInFee
     */
    'amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerOptInFee
     */
    'isOptedIn'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerOptInFee
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerOptInFee
     */
    'receiptDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerOptInFee
     */
    'receiptNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkerOptInFee
     */
    'status'?: string | null;
    /**
     * 
     * @type {DataEntitiesFinancePartner}
     * @memberof ServerRequestsParkerOptInFee
     */
    'partner'?: DataEntitiesFinancePartner;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsParkerOptInFee
     */
    'isPerSpace'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerRequestsParkersByGroupListResponse
 */
export interface ServerRequestsParkersByGroupListResponse {
    /**
     * 
     * @type {Array<ServerRequestsParkersByGroupResponse>}
     * @memberof ServerRequestsParkersByGroupListResponse
     */
    'parkers'?: Array<ServerRequestsParkersByGroupResponse> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkersByGroupResponse
 */
export interface ServerRequestsParkersByGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkersByGroupResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkersByGroupResponse
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkingValidationByIdData
 */
export interface ServerRequestsParkingValidationByIdData {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationByIdData
     */
    'rateProgramId'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsParkingValidationByIdData
     */
    'startDateTime'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsParkingValidationByIdData
     */
    'endDateTime'?: object;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationByIdData
     */
    'numberOfSpaces'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationByIdData
     */
    'ratePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkingValidationByIdData
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsParkingValidationData
 */
export interface ServerRequestsParkingValidationData {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationData
     */
    'validationRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkingValidationData
     */
    'parkerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkingValidationData
     */
    'parkerEmail'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsParkingValidationData
     */
    'startDateTime'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsParkingValidationData
     */
    'endDateTime'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsParkingValidationData
     */
    'requestedDate'?: object;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationData
     */
    'numberOfSpaces'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationData
     */
    'operatorId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsParkingValidationData
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkingValidationData
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsParkingValidationData
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsPartnerReservationCreateRequest
 */
export interface ServerRequestsPartnerReservationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'licensePlateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'licensePlateState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'startTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'endTimeUtc'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'priceCents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateRequest
     */
    'externalReservationId'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsPartnerReservationCreateResponse
 */
export interface ServerRequestsPartnerReservationCreateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsPartnerReservationCreateResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateResponse
     */
    'apiId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationCreateResponse
     */
    'confirmationNumber': string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsPartnerReservationListItem
 */
export interface ServerRequestsPartnerReservationListItem {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'apiId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'confirmationNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'locationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'licensePlateNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'startTimeUtc': string;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'endTimeUtc': string;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'priceCents'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'externalReservationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPartnerReservationListItem
     */
    'createdAtUtc': string;
}
/**
 * 
 * @export
 * @interface ServerRequestsPartnerReservationListResponse
 */
export interface ServerRequestsPartnerReservationListResponse {
    /**
     * 
     * @type {Array<ServerRequestsPartnerReservationListItem>}
     * @memberof ServerRequestsPartnerReservationListResponse
     */
    'items'?: Array<ServerRequestsPartnerReservationListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPartnerReservationListResponse
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsPatchFacilityWaitlistToggleRequest
 */
export interface ServerRequestsPatchFacilityWaitlistToggleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsPatchFacilityWaitlistToggleRequest
     */
    'isWaitlistEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPatchFacilityWaitlistToggleRequest
     */
    'facilityId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsPatchIntegrationPartyRequest
 */
export interface ServerRequestsPatchIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPatchIntegrationPartyRequest
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchIntegrationPartyRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsPatchIntegrationPartyRequest
     */
    'isActive'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchIntegrationPartyRequest
     */
    'origin'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsPatchOperatorRequest
 */
export interface ServerRequestsPatchOperatorRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'hostName'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'logoUrlBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'topTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'bottomLeftTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'bottomRightTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'topText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'bottomLeftText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchOperatorRequest
     */
    'bottomRightText'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsPatchParkerIntegrationPartiesResponse
 */
export interface ServerRequestsPatchParkerIntegrationPartiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsPatchParkerIntegrationPartiesResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {ServerRequestsParkerIntegrationPartyDto}
     * @memberof ServerRequestsPatchParkerIntegrationPartiesResponse
     */
    'parkerIntegrationParty'?: ServerRequestsParkerIntegrationPartyDto;
}
/**
 * 
 * @export
 * @interface ServerRequestsPatchStaffRequest
 */
export interface ServerRequestsPatchStaffRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'staffId'?: number;
    /**
     * 
     * @type {DataStaffRole}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'role'?: DataStaffRole;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'roles'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'facilities'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'passwordHash'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerRequestsPatchStaffRequest
     */
    'permissions'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface ServerRequestsPlateCandidate
 */
export interface ServerRequestsPlateCandidate {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateCandidate
     */
    'plate': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPlateCandidate
     */
    'confidence'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsPlateScanRequest
 */
export interface ServerRequestsPlateScanRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateScanRequest
     */
    'image': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateScanRequest
     */
    'regionHint'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsPlateScanResponse
 */
export interface ServerRequestsPlateScanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsPlateScanResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateScanResponse
     */
    'plate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPlateScanResponse
     */
    'confidence'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateScanResponse
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateScanResponse
     */
    'regionName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsPlateScanResponse
     */
    'vehicleType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsPlateScanResponse
     */
    'processingTimeMs'?: number;
    /**
     * 
     * @type {Array<ServerRequestsPlateCandidate>}
     * @memberof ServerRequestsPlateScanResponse
     */
    'candidates'?: Array<ServerRequestsPlateCandidate> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsProcessBillingForAllOperatorsRequest
 */
export interface ServerRequestsProcessBillingForAllOperatorsRequest {
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsProcessBillingForAllOperatorsRequest
     */
    'billingPeriodStart': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerRequestsProcessBillingForAllOperatorsRequest
     */
    'billingPeriodEnd': NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsProcessBillingForAllOperatorsRequest
     */
    'staffId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsProcessBillingForAllOperatorsResponse
 */
export interface ServerRequestsProcessBillingForAllOperatorsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsProcessBillingForAllOperatorsResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsProcessBillingForAllOperatorsResponse
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsProcessBillingForAllOperatorsResponse
     */
    'processedOperatorCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsProcessBillingForAllOperatorsResponse
     */
    'generatedInvoiceCount'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsRateProgramByIdReponse
 */
export interface ServerRequestsRateProgramByIdReponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsRateProgramByIdReponse
     */
    'exists'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsRemoveBillingPlanFromFacilitiesResponse
 */
export interface ServerRequestsRemoveBillingPlanFromFacilitiesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsRemoveBillingPlanFromFacilitiesResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsRemoveBillingPlanFromFacilitiesResponse
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsReorderWaitlistRequest
 */
export interface ServerRequestsReorderWaitlistRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReorderWaitlistRequest
     */
    'waitlistEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReorderWaitlistRequest
     */
    'newIndex'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsReservationEntryConfirmBody
 */
export interface ServerRequestsReservationEntryConfirmBody {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReservationEntryConfirmBody
     */
    'reservationId': number;
}
/**
 * 
 * @export
 * @interface ServerRequestsReservationEntryConfirmResponse
 */
export interface ServerRequestsReservationEntryConfirmResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsReservationEntryConfirmResponse
     */
    'wasSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsReservationEntryConfirmResponse
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsReservationEntryConfirmedTodayCountResponse
 */
export interface ServerRequestsReservationEntryConfirmedTodayCountResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReservationEntryConfirmedTodayCountResponse
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsReservationValidateRequest
 */
export interface ServerRequestsReservationValidateRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsReservationValidateRequest
     */
    'validationRateId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsReservationValidateRequest
     */
    'confirmationNum': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReservationValidateRequest
     */
    'facilityId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsReservationValidateResponse
 */
export interface ServerRequestsReservationValidateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsReservationValidateResponse
     */
    'wasSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsReservationValidateResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReservationValidateResponse
     */
    'newPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsReservationValidateResponse
     */
    'discount'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServerRequestsRuleType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type ServerRequestsRuleType = typeof ServerRequestsRuleType[keyof typeof ServerRequestsRuleType];


/**
 * 
 * @export
 * @interface ServerRequestsSaveTutorialProgressRequest
 */
export interface ServerRequestsSaveTutorialProgressRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSaveTutorialProgressRequest
     */
    'staffId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSaveTutorialProgressRequest
     */
    'tutorialKey'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsSaveTutorialProgressResponse
 */
export interface ServerRequestsSaveTutorialProgressResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSaveTutorialProgressResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsStaffAddDelegateRequest
 */
export interface ServerRequestsStaffAddDelegateRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsStaffAddDelegateRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsStaffAddDelegateRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsStaffAddDelegateResponse
 */
export interface ServerRequestsStaffAddDelegateResponse {
    /**
     * 
     * @type {ServerTransferDelegateItem}
     * @memberof ServerRequestsStaffAddDelegateResponse
     */
    'item'?: ServerTransferDelegateItem;
}
/**
 * 
 * @export
 * @interface ServerRequestsSubmitParkingValidationRequest
 */
export interface ServerRequestsSubmitParkingValidationRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'parkerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'parkerEmail'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'startDateTime'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'endDateTime'?: object;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'numberOfSpaces'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubmitParkingValidationRequest
     */
    'rateProgramId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsSubscriptionGroupAddRequest
 */
export interface ServerRequestsSubscriptionGroupAddRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupAddRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSubscriptionGroupAddRequest
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsSubscriptionGroupContractRuleDto
 */
export interface ServerRequestsSubscriptionGroupContractRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupContractRuleDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupContractRuleDto
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupContractRuleDto
     */
    'max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupContractRuleDto
     */
    'price'?: number;
    /**
     * 
     * @type {ServerRequestsRuleType}
     * @memberof ServerRequestsSubscriptionGroupContractRuleDto
     */
    'type'?: ServerRequestsRuleType;
}


/**
 * 
 * @export
 * @interface ServerRequestsSubscriptionGroupsListResponse
 */
export interface ServerRequestsSubscriptionGroupsListResponse {
    /**
     * 
     * @type {Array<ServerRequestsSubscriptionGroupsResponse>}
     * @memberof ServerRequestsSubscriptionGroupsListResponse
     */
    'groups'?: Array<ServerRequestsSubscriptionGroupsResponse> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsSubscriptionGroupsResponse
 */
export interface ServerRequestsSubscriptionGroupsResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupsResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSubscriptionGroupsResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsSubscriptionGroupsResponse
     */
    'parkerCount'?: number;
    /**
     * 
     * @type {Array<ServerRequestsSubscriptionGroupContractRuleDto>}
     * @memberof ServerRequestsSubscriptionGroupsResponse
     */
    'contractRules'?: Array<ServerRequestsSubscriptionGroupContractRuleDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsSubscriptionGroupsResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsUnrollSubscriptionIntegrationPartiesRequest
 */
export interface ServerRequestsUnrollSubscriptionIntegrationPartiesRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollSubscriptionIntegrationPartiesRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollSubscriptionIntegrationPartiesRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollSubscriptionIntegrationPartiesRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollSubscriptionIntegrationPartiesRequest
     */
    'integrationPartyId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsUnrollVehicleIntegrationPartiesRequest
 */
export interface ServerRequestsUnrollVehicleIntegrationPartiesRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollVehicleIntegrationPartiesRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollVehicleIntegrationPartiesRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollVehicleIntegrationPartiesRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollVehicleIntegrationPartiesRequest
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUnrollVehicleIntegrationPartiesRequest
     */
    'vehicleId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsUpdateBillingPlanRequest
 */
export interface ServerRequestsUpdateBillingPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateBillingPlanRequest
     */
    'billingPlanId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateBillingPlanRequest
     */
    'operatorId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateBillingPlanRequest
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateBillingPlanRequest
     */
    'description': string | null;
    /**
     * 
     * @type {Array<ServerRequestsUpdateBillingRuleDto>}
     * @memberof ServerRequestsUpdateBillingPlanRequest
     */
    'billingRules'?: Array<ServerRequestsUpdateBillingRuleDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateBillingPlanRequest
     */
    'staffId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsUpdateBillingPlanResponse
 */
export interface ServerRequestsUpdateBillingPlanResponse {
    /**
     * 
     * @type {ServerRequestsBillingPlanDetailDto}
     * @memberof ServerRequestsUpdateBillingPlanResponse
     */
    'billingPlan'?: ServerRequestsBillingPlanDetailDto;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUpdateBillingPlanResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateBillingPlanResponse
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsUpdateBillingRuleDto
 */
export interface ServerRequestsUpdateBillingRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateBillingRuleDto
     */
    'billingRuleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateBillingRuleDto
     */
    'name': string | null;
    /**
     * 
     * @type {DataEntitiesFinanceBillingRuleType}
     * @memberof ServerRequestsUpdateBillingRuleDto
     */
    'ruleType': DataEntitiesFinanceBillingRuleType;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateBillingRuleDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateBillingRuleDto
     */
    'customProcedureName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUpdateBillingRuleDto
     */
    'isDeleted'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerRequestsUpdateCredentialRequest
 */
export interface ServerRequestsUpdateCredentialRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateCredentialRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateCredentialRequest
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateCredentialRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateCredentialRequest
     */
    'staffId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateCredentialRequest
     */
    'integrationPartyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateCredentialRequest
     */
    'updatedCredential'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsUpdateFeeRequest
 */
export interface ServerRequestsUpdateFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'operatorFeeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'feeName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'amount'?: number | null;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeCalc}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'feeCalc'?: DataEntitiesFinanceOperatorFeeCalc;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'feeScope'?: DataEntitiesFinanceOperatorFeeScope;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'isAppliedToParker'?: boolean | null;
    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'paymentType'?: DataEntitiesFinanceOperatorFeePaymentType;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'receiptDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'isOptIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'isPerSpace'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'isDefaultOptIn'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'partnerFee'?: number | null;
    /**
     * 
     * @type {DataEntitiesFinancePartner}
     * @memberof ServerRequestsUpdateFeeRequest
     */
    'partner'?: DataEntitiesFinancePartner;
}


/**
 * 
 * @export
 * @interface ServerRequestsUpdateFeeResponse
 */
export interface ServerRequestsUpdateFeeResponse {
    /**
     * 
     * @type {ServerRequestsFeeInfo}
     * @memberof ServerRequestsUpdateFeeResponse
     */
    'item'?: ServerRequestsFeeInfo;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServerRequestsUpdateFeeResponse
     */
    'errors'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsUpdateParkerNoteRequest
 */
export interface ServerRequestsUpdateParkerNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateParkerNoteRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateParkerNoteRequest
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateParkerNoteRequest
     */
    'parkerNoteId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUpdateParkerNoteRequest
     */
    'noteText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUpdateParkerNoteRequest
     */
    'staffId'?: number;
}
/**
 * 
 * @export
 * @interface ServerRequestsUpdateParkerNoteResponse
 */
export interface ServerRequestsUpdateParkerNoteResponse {
    /**
     * 
     * @type {ServerRequestsParkerNoteDto}
     * @memberof ServerRequestsUpdateParkerNoteResponse
     */
    'note'?: ServerRequestsParkerNoteDto;
}
/**
 * 
 * @export
 * @interface ServerRequestsUsageBillingPageDto
 */
export interface ServerRequestsUsageBillingPageDto {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'parkerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'parkerEmail': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'planName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'subscriptionStatus': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'paymentMethodDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'hasPaymentMethod'?: boolean;
    /**
     * 
     * @type {Array<ServerRequestsUsageChargeHistoryItem>}
     * @memberof ServerRequestsUsageBillingPageDto
     */
    'recentCharges'?: Array<ServerRequestsUsageChargeHistoryItem> | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsUsageChargeHistoryItem
 */
export interface ServerRequestsUsageChargeHistoryItem {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUsageChargeHistoryItem
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageChargeHistoryItem
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUsageChargeHistoryItem
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsUsageChargeHistoryItem
     */
    'totalCharged'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageChargeHistoryItem
     */
    'createdWhen': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerRequestsUsageChargeHistoryItem
     */
    'hasReceipt'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerRequestsUsageReceiptDownloadDto
 */
export interface ServerRequestsUsageReceiptDownloadDto {
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageReceiptDownloadDto
     */
    'url': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageReceiptDownloadDto
     */
    'fileName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsUsageReceiptDownloadDto
     */
    'expiresAt': string | null;
}
/**
 * 
 * @export
 * @interface ServerRequestsWaitlistData
 */
export interface ServerRequestsWaitlistData {
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsWaitlistData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsWaitlistData
     */
    'parkerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsWaitlistData
     */
    'parkerEmail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsWaitlistData
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsWaitlistData
     */
    'planName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsWaitlistData
     */
    'spacesRequested'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerRequestsWaitlistData
     */
    'order'?: number;
    /**
     * 
     * @type {DataEntitiesWaitlistStatus}
     * @memberof ServerRequestsWaitlistData
     */
    'status'?: DataEntitiesWaitlistStatus;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsWaitlistData
     */
    'dateRequested'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerRequestsWaitlistData
     */
    'holdUntil'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerRequestsWaitlistData
     */
    'error'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerServicesChangeSubscriptionStatusBody
 */
export interface ServerServicesChangeSubscriptionStatusBody {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesChangeSubscriptionStatusBody
     */
    'cancellationReason'?: string | null;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerServicesChangeSubscriptionStatusBody
     */
    'cancellationDate'?: NodaTimeLocalDate;
}
/**
 * 
 * @export
 * @interface ServerServicesIntegrationsAccountImpersonateRequestModel
 */
export interface ServerServicesIntegrationsAccountImpersonateRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAccountImpersonateRequestModel
     */
    'userName'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerServicesIntegrationsAccountLoginRequestModel
 */
export interface ServerServicesIntegrationsAccountLoginRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAccountLoginRequestModel
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAccountLoginRequestModel
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAccountLoginRequestModel
     */
    'deviceId'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerServicesIntegrationsAccountLoginResponseModel
 */
export interface ServerServicesIntegrationsAccountLoginResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAccountLoginResponseModel
     */
    'accessToken'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ServerServicesIntegrationsAccountLoginResponseModel
     */
    'expire'?: any | null;
    /**
     * 
     * @type {number}
     * @memberof ServerServicesIntegrationsAccountLoginResponseModel
     */
    'spotSyncUserId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerServicesIntegrationsAccountLoginResponseModel
     */
    'userNotFound'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerServicesIntegrationsAuditEntity
 */
export interface ServerServicesIntegrationsAuditEntity {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'partitionKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'rowKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'timestamp'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'eTag'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'changeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'changedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'oldValues'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsAuditEntity
     */
    'newValues'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerServicesIntegrationsRefreshTokenRequestModel
 */
export interface ServerServicesIntegrationsRefreshTokenRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsRefreshTokenRequestModel
     */
    'accessToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsRefreshTokenRequestModel
     */
    'refreshToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesIntegrationsRefreshTokenRequestModel
     */
    'deviceId'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerServicesOperatorCreateReq
 */
export interface ServerServicesOperatorCreateReq {
    /**
     * 
     * @type {string}
     * @memberof ServerServicesOperatorCreateReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesOperatorCreateReq
     */
    'hostName': string;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesOperatorCreateReq
     */
    'emailAddress': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServerServicesSearchEntityType = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80,
    NUMBER_90: 90
} as const;

export type ServerServicesSearchEntityType = typeof ServerServicesSearchEntityType[keyof typeof ServerServicesSearchEntityType];


/**
 * 
 * @export
 * @interface ServerServicesSearchResult
 */
export interface ServerServicesSearchResult {
    /**
     * 
     * @type {ServerServicesSearchEntityType}
     * @memberof ServerServicesSearchResult
     */
    'type'?: ServerServicesSearchEntityType;
    /**
     * 
     * @type {number}
     * @memberof ServerServicesSearchResult
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesSearchResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerServicesSearchResult
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesSearchResult
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerServicesSearchResult
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerServicesSearchResult
     */
    'searchResultId'?: number;
}


/**
 * 
 * @export
 * @interface ServerServicesStripeLinkResp
 */
export interface ServerServicesStripeLinkResp {
    /**
     * 
     * @type {boolean}
     * @memberof ServerServicesStripeLinkResp
     */
    'isOnboarded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesStripeLinkResp
     */
    'connectLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerServicesStripeLinkResp
     */
    'expiresAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferAccessPeriodInfo
 */
export interface ServerTransferAccessPeriodInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'accessPeriodId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'quantity': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'start': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'end': NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'isDelivered': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferAccessPeriodInfo
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface ServerTransferAddSavedReportRequest
 */
export interface ServerTransferAddSavedReportRequest {
    /**
     * 
     * @type {DataEntitiesReportsReportType}
     * @memberof ServerTransferAddSavedReportRequest
     */
    'reportType'?: DataEntitiesReportsReportType;
    /**
     * 
     * @type {ServerTransferSavedReportRequest}
     * @memberof ServerTransferAddSavedReportRequest
     */
    'request'?: ServerTransferSavedReportRequest;
}


/**
 * 
 * @export
 * @interface ServerTransferApplyPayment
 */
export interface ServerTransferApplyPayment {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'orderBalanceId': number;
    /**
     * 
     * @type {DataEntitiesOrderBalanceType}
     * @memberof ServerTransferApplyPayment
     */
    'type': DataEntitiesOrderBalanceType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'orderId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'debt': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'paid': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'totalDebt': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'totalPaid': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferApplyPayment
     */
    'createdWhen': object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferApplyPayment
     */
    'invoiceNum'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferApplyPayment
     */
    'invoiceId'?: number;
}


/**
 * 
 * @export
 * @interface ServerTransferBalanceChange
 */
export interface ServerTransferBalanceChange {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferBalanceChange
     */
    'number'?: number;
    /**
     * 
     * @type {ServerTransferBalanceChangeType}
     * @memberof ServerTransferBalanceChange
     */
    'type'?: ServerTransferBalanceChangeType;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferBalanceChange
     */
    'paidWhen'?: object;
    /**
     * 
     * @type {ServerTransferPayment}
     * @memberof ServerTransferBalanceChange
     */
    'payment'?: ServerTransferPayment;
    /**
     * 
     * @type {ServerTransferOrderBalance}
     * @memberof ServerTransferBalanceChange
     */
    'orderBalance'?: ServerTransferOrderBalance;
    /**
     * 
     * @type {ServerTransferMonitorInvoiceInfo}
     * @memberof ServerTransferBalanceChange
     */
    'invoice'?: ServerTransferMonitorInvoiceInfo;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferBalanceChange
     */
    'rank'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferBalanceChange
     */
    'balance'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ServerTransferBalanceChangeType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type ServerTransferBalanceChangeType = typeof ServerTransferBalanceChangeType[keyof typeof ServerTransferBalanceChangeType];


/**
 * 
 * @export
 * @interface ServerTransferConnectChangeEmailReq
 */
export interface ServerTransferConnectChangeEmailReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangeEmailReq
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangeEmailReq
     */
    'newEmailAddress': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectChangeNameReq
 */
export interface ServerTransferConnectChangeNameReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangeNameReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangeNameReq
     */
    'emailAddress'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectChangePasswordReq
 */
export interface ServerTransferConnectChangePasswordReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangePasswordReq
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangePasswordReq
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectChangePhoneReq
 */
export interface ServerTransferConnectChangePhoneReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectChangePhoneReq
     */
    'phoneNumber': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectForgotPasswordReq
 */
export interface ServerTransferConnectForgotPasswordReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectForgotPasswordReq
     */
    'emailAddress': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectParker
 */
export interface ServerTransferConnectParker {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectParker
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectParker
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectParker
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectParker
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectParker
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferConnectParker
     */
    'createdWhen'?: object;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectReservation
 */
export interface ServerTransferConnectReservation {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectReservation
     */
    'reservationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectReservation
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectReservation
     */
    'parkerId'?: number;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferConnectReservation
     */
    'start'?: NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferConnectReservation
     */
    'end'?: NodaTimeLocalDateTime;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferConnectReservation
     */
    'actualStart'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferConnectReservation
     */
    'actualEnd'?: object;
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof ServerTransferConnectReservation
     */
    'duration'?: NodaTimeDuration;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectReservation
     */
    'rateProgramId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectReservation
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferConnectReservation
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectReservation
     */
    'confirmationNum'?: string | null;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferConnectReservation
     */
    'facility'?: ServerTransferFacilityInfo;
    /**
     * 
     * @type {ServerTransferRateProgram}
     * @memberof ServerTransferConnectReservation
     */
    'rateProgram'?: ServerTransferRateProgram;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectReservePreviewResp
 */
export interface ServerTransferConnectReservePreviewResp {
    /**
     * 
     * @type {Array<DataEntitiesOrderFeeCalculation>}
     * @memberof ServerTransferConnectReservePreviewResp
     */
    'fees'?: Array<DataEntitiesOrderFeeCalculation> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectReservePreviewResp
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectResetCodeCheckReq
 */
export interface ServerTransferConnectResetCodeCheckReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectResetCodeCheckReq
     */
    'resetPasswordCode': string;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectResetPasswordReq
 */
export interface ServerTransferConnectResetPasswordReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectResetPasswordReq
     */
    'resetPasswordCode': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectResetPasswordReq
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectSignUpReq
 */
export interface ServerTransferConnectSignUpReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectSignUpReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectSignUpReq
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectSignUpReq
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectSignUpReq
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectSignUpReq
     */
    'passwordConfirm': string;
}
/**
 * 
 * @export
 * @interface ServerTransferConnectSubListEntry
 */
export interface ServerTransferConnectSubListEntry {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectSubListEntry
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectSubListEntry
     */
    'parkerId'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferConnectSubListEntry
     */
    'status'?: DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectSubListEntry
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectSubListEntry
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectSubListEntry
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferConnectSubListEntry
     */
    'cachedMrr'?: number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferConnectSubListEntry
     */
    'start'?: NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferConnectSubListEntry
     */
    'isUsageBasedBilling'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferConnectSubListEntry
     */
    'isPendingPaymentMethodVerification'?: boolean;
    /**
     * 
     * @type {ServerTransferPlanInfoBasic}
     * @memberof ServerTransferConnectSubListEntry
     */
    'plan'?: ServerTransferPlanInfoBasic;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferConnectSubListEntry
     */
    'facility'?: ServerTransferFacilityInfo;
}


/**
 * 
 * @export
 * @interface ServerTransferConnectedAccountDropdown
 */
export interface ServerTransferConnectedAccountDropdown {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectedAccountDropdown
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferConnectedAccountDropdown
     */
    'label'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferConnectedAccountDropdown
     */
    'isAccountOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerTransferCustomReportDefinitionResponse
 */
export interface ServerTransferCustomReportDefinitionResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferCustomReportDefinitionResponse
     */
    'customReportDefinitionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportDefinitionResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportDefinitionResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportDefinitionResponse
     */
    'outputFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportDefinitionResponse
     */
    'dataSource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportDefinitionResponse
     */
    'filterType'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferCustomReportGenerateRequest
 */
export interface ServerTransferCustomReportGenerateRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferCustomReportGenerateRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServerTransferCustomReportGenerateRequest
     */
    'facilityIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportGenerateRequest
     */
    'from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferCustomReportGenerateRequest
     */
    'to'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferCustomReportGenerateRequest
     */
    'fileLines'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferDashboardMonthlyStat
 */
export interface ServerTransferDashboardMonthlyStat {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferDashboardMonthlyStat
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferDashboardMonthlyStat
     */
    'revenue'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferDashboardStats
 */
export interface ServerTransferDashboardStats {
    /**
     * 
     * @type {Array<ServerTransferFacilityDashboardStats>}
     * @memberof ServerTransferDashboardStats
     */
    'facilityDashboardStats'?: Array<ServerTransferFacilityDashboardStats> | null;
    /**
     * 
     * @type {Array<ServerTransferDashboardMonthlyStat>}
     * @memberof ServerTransferDashboardStats
     */
    'subscriptionRevTrend'?: Array<ServerTransferDashboardMonthlyStat> | null;
    /**
     * 
     * @type {Array<ServerTransferDashboardMonthlyStat>}
     * @memberof ServerTransferDashboardStats
     */
    'transientRevTrend'?: Array<ServerTransferDashboardMonthlyStat> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferDelegateItem
 */
export interface ServerTransferDelegateItem {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferDelegateItem
     */
    'parkerDelegateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferDelegateItem
     */
    'ownerParkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferDelegateItem
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferDelegateItem
     */
    'delegateParkerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferDelegateItem
     */
    'delegateEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferDelegateItem
     */
    'delegateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferDelegateItem
     */
    'inviteCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferDelegateItem
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferDelegateItem
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferDelegateItem
     */
    'createdWhen'?: object;
}
/**
 * 
 * @export
 * @interface ServerTransferEnrolledIntegrationParty
 */
export interface ServerTransferEnrolledIntegrationParty {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'facilityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'integrationPartyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'apiSecret'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferEnrolledIntegrationParty
     */
    'isActive'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ServerTransferFacility
 */
export interface ServerTransferFacility {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacility
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'timeZone'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferFacility
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {DataEntitiesCoordinates}
     * @memberof ServerTransferFacility
     */
    'coordinates'?: DataEntitiesCoordinates;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacility
     */
    'listImageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'entryInstructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacility
     */
    'physicalCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacility
     */
    'enforcedCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacility
     */
    'clearanceInches'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacility
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferFacility
     */
    'isWaitlistEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferFacility
     */
    'hasCodeValidations'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacility
     */
    'maxCreditCardAmountInCents'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferFacility
     */
    'features'?: Array<string> | null;
    /**
     * 
     * @type {Array<ServerTransferFacilityImage>}
     * @memberof ServerTransferFacility
     */
    'images'?: Array<ServerTransferFacilityImage> | null;
    /**
     * 
     * @type {Array<ServerTransferRateProgram>}
     * @memberof ServerTransferFacility
     */
    'hourlyRates'?: Array<ServerTransferRateProgram> | null;
    /**
     * 
     * @type {Array<ServerTransferListedPlan>}
     * @memberof ServerTransferFacility
     */
    'listedPlans'?: Array<ServerTransferListedPlan> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityDashboardStats
 */
export interface ServerTransferFacilityDashboardStats {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'subscriptionRevenue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'transientRevenue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'subscriptionParkerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'totalUnpaidBalance'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityDashboardStats
     */
    'transientCount'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityImage
 */
export interface ServerTransferFacilityImage {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityImage
     */
    'facilityImageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityImage
     */
    'storedImageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityImage
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityImage
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityImage
     */
    'altText'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityInfo
 */
export interface ServerTransferFacilityInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInfo
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInfo
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInfo
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInfo
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInfo
     */
    'timeZone'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferFacilityInfo
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {DataEntitiesCoordinates}
     * @memberof ServerTransferFacilityInfo
     */
    'coordinates'?: DataEntitiesCoordinates;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInfo
     */
    'listImageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInfo
     */
    'entryInstructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInfo
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInfo
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInfo
     */
    'clearanceInches'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferFacilityInfo
     */
    'isWaitlistEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInfo
     */
    'maxCreditCardAmountInCents'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferFacilityInfo
     */
    'hasWaitlistEntries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferFacilityInfo
     */
    'hasIntegrationsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferFacilityInfo
     */
    'hasSubscriptionIntegrationsEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityInvoice
 */
export interface ServerTransferFacilityInvoice {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInvoice
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityInvoice
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferFacilityInvoice
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferFacilityInvoice
     */
    'dueWhen'?: NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInvoice
     */
    'openingBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInvoice
     */
    'amountDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityInvoice
     */
    'endingBalance'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferFacilityInvoice
     */
    'emailSentWhen'?: object;
    /**
     * 
     * @type {Array<ServerTransferOrderInfo>}
     * @memberof ServerTransferFacilityInvoice
     */
    'orders'?: Array<ServerTransferOrderInfo> | null;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferFacilityInvoice
     */
    'parker'?: ServerTransferParkerInfo;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityLite
 */
export interface ServerTransferFacilityLite {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityLite
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'timeZone'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferFacilityLite
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {DataEntitiesCoordinates}
     * @memberof ServerTransferFacilityLite
     */
    'coordinates'?: DataEntitiesCoordinates;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityLite
     */
    'listImageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'entryInstructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityLite
     */
    'physicalCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityLite
     */
    'enforcedCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityLite
     */
    'clearanceInches'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityLite
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityReportsIndexResponse
 */
export interface ServerTransferFacilityReportsIndexResponse {
    /**
     * 
     * @type {Array<ServerTransferSavedReportResponse>}
     * @memberof ServerTransferFacilityReportsIndexResponse
     */
    'savedReports'?: Array<ServerTransferSavedReportResponse> | null;
    /**
     * 
     * @type {Array<ServerTransferRecurringReportScheduleResponse>}
     * @memberof ServerTransferFacilityReportsIndexResponse
     */
    'recurringReports'?: Array<ServerTransferRecurringReportScheduleResponse> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferFacilityStats
 */
export interface ServerTransferFacilityStats {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'totalMonthlyParkerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'pendingParkers'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'activeReservations'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'upcomingReservations'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'monthlyRecurringRevenue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'currentMonthTransientRevenue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'totalUnpaidBalance'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityStats
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityStats
     */
    'streetAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityStats
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityStats
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferFacilityStats
     */
    'zip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferFacilityStats
     */
    'facilityId'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferIntegrationParty
 */
export interface ServerTransferIntegrationParty {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferIntegrationParty
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferIntegrationParty
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferIntegrationParty
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferIntegrationParty
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferIntegrationParty
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferInvoice
 */
export interface ServerTransferInvoice {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferInvoice
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferInvoice
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferInvoice
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferInvoice
     */
    'dueWhen'?: NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferInvoice
     */
    'openingBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferInvoice
     */
    'currentOpeningBalance'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferInvoice
     */
    'amountDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferInvoice
     */
    'endingBalance'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferInvoice
     */
    'emailSentWhen'?: object;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferInvoice
     */
    'facility'?: ServerTransferFacilityInfo;
    /**
     * 
     * @type {Array<ServerTransferOrderInfo>}
     * @memberof ServerTransferInvoice
     */
    'orders'?: Array<ServerTransferOrderInfo> | null;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferInvoice
     */
    'parker'?: ServerTransferParkerInfo;
}
/**
 * 
 * @export
 * @interface ServerTransferListedPlan
 */
export interface ServerTransferListedPlan {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferListedPlan
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferListedPlan
     */
    'planEntryId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferListedPlan
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferListedPlan
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferListedPlan
     */
    'accessHours': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferListedPlan
     */
    'dayOfMonthInvoice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferListedPlan
     */
    'dayOfMonthDue': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferListedPlan
     */
    'dayOfMonthLate': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferListedPlan
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferListedPlan
     */
    'isOneTermPlan': boolean;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorAccessKey
 */
export interface ServerTransferMonitorAccessKey {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKey
     */
    'accessKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKey
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKey
     */
    'accessKeyNumber'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorAccessKey
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {ServerTransferMonitorStaff}
     * @memberof ServerTransferMonitorAccessKey
     */
    'createdByStaff'?: ServerTransferMonitorStaff;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKey
     */
    'note'?: string | null;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferMonitorAccessKey
     */
    'facility'?: ServerTransferFacilityInfo;
    /**
     * 
     * @type {Array<ServerTransferMonitorAccessKeyLinkInfo>}
     * @memberof ServerTransferMonitorAccessKey
     */
    'links'?: Array<ServerTransferMonitorAccessKeyLinkInfo> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorAccessKeyAssignSub
 */
export interface ServerTransferMonitorAccessKeyAssignSub {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyAssignSub
     */
    'accessKeyId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyAssignSub
     */
    'subscriptionId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKeyAssignSub
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorAccessKeyLinkInfo
 */
export interface ServerTransferMonitorAccessKeyLinkInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'accessKeyLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'accessKeyId'?: number;
    /**
     * 
     * @type {DataEntitiesAccessKeyLinkType}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'type'?: DataEntitiesAccessKeyLinkType;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'note'?: string | null;
    /**
     * 
     * @type {ServerTransferMonitorSubscriptionInfo}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'subscription'?: ServerTransferMonitorSubscriptionInfo;
    /**
     * 
     * @type {ServerTransferMonitorSubscriptionParkerAccessKey}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'guest'?: ServerTransferMonitorSubscriptionParkerAccessKey;
    /**
     * 
     * @type {ServerTransferMonitorSubscriptionParkerVehicleAccessKey}
     * @memberof ServerTransferMonitorAccessKeyLinkInfo
     */
    'vehicle'?: ServerTransferMonitorSubscriptionParkerVehicleAccessKey;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorAccessKeyParkerAssignReq
 */
export interface ServerTransferMonitorAccessKeyParkerAssignReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyParkerAssignReq
     */
    'accessKeyId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyParkerAssignReq
     */
    'subscriptionParkerId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKeyParkerAssignReq
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorAccessKeyReq
 */
export interface ServerTransferMonitorAccessKeyReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKeyReq
     */
    'accessKeyNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKeyReq
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorAccessKeyVehicleSubAssignReq
 */
export interface ServerTransferMonitorAccessKeyVehicleSubAssignReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyVehicleSubAssignReq
     */
    'accessKeyId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorAccessKeyVehicleSubAssignReq
     */
    'vehicleSubscriptionId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorAccessKeyVehicleSubAssignReq
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorCheckCreateReq
 */
export interface ServerTransferMonitorCheckCreateReq {
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorCheckCreateReq
     */
    'checkDate': NodaTimeLocalDate;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorCheckCreateReq
     */
    'checkNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorCheckCreateReq
     */
    'checkMemo': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorCheckCreateReq
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorFacility
 */
export interface ServerTransferMonitorFacility {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacility
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'timeZone'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferMonitorFacility
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {DataEntitiesCoordinates}
     * @memberof ServerTransferMonitorFacility
     */
    'coordinates'?: DataEntitiesCoordinates;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacility
     */
    'listImageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'entryInstructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacility
     */
    'physicalCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacility
     */
    'enforcedCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacility
     */
    'clearanceInches'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacility
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorFacility
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {Array<ServerTransferFacilityImage>}
     * @memberof ServerTransferMonitorFacility
     */
    'images'?: Array<ServerTransferFacilityImage> | null;
    /**
     * 
     * @type {Array<ServerTransferRateProgram>}
     * @memberof ServerTransferMonitorFacility
     */
    'hourlyRates'?: Array<ServerTransferRateProgram> | null;
    /**
     * 
     * @type {Array<ServerTransferListedPlan>}
     * @memberof ServerTransferMonitorFacility
     */
    'listedPlans'?: Array<ServerTransferListedPlan> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorFacilityCreateReq
 */
export interface ServerTransferMonitorFacilityCreateReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'name': string;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'address': DataEntitiesUsAddress;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'instructions': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'postedCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'enforcedCapacity': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'website': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'phoneNumber': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'clearanceInches': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'imageThumb': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'bannerImage': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'timezone': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityCreateReq
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorFacilityInviteCredentialCapabilityResp
 */
export interface ServerTransferMonitorFacilityInviteCredentialCapabilityResp {
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorFacilityInviteCredentialCapabilityResp
     */
    'hasCredentialUpdateIntegration'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityInviteCredentialCapabilityResp
     */
    'rfidValidationPattern'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityInviteCredentialCapabilityResp
     */
    'rfidValidationMaxLength'?: number | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorFacilityPayout
 */
export interface ServerTransferMonitorFacilityPayout {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'payoutId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'payoutKey': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'amount'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'processorCreatedWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'arrivalWhen': object;
    /**
     * 
     * @type {Array<ServerTransferMonitorPayoutTransaction>}
     * @memberof ServerTransferMonitorFacilityPayout
     */
    'transactions': Array<ServerTransferMonitorPayoutTransaction> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorFacilityPayoutAccountUpdateReq
 */
export interface ServerTransferMonitorFacilityPayoutAccountUpdateReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityPayoutAccountUpdateReq
     */
    'payoutAccount': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityPayoutAccountUpdateReq
     */
    'facilityId': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorFacilitySub
 */
export interface ServerTransferMonitorFacilitySub {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'parkerId'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'status'?: DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'unitPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'parker'?: ServerTransferParkerInfo;
    /**
     * 
     * @type {ServerTransferPlanInfoBasic}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'plan'?: ServerTransferPlanInfoBasic;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferMonitorFacilitySub
     */
    'facility'?: ServerTransferFacilityInfo;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorFacilityUpdateReq
 */
export interface ServerTransferMonitorFacilityUpdateReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'name': string;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'address': DataEntitiesUsAddress;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'instructions': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'postedCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'enforcedCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'clearanceInches': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'website': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'timezone': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorFacilityUpdateReq
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorImportPaymentReq
 */
export interface ServerTransferMonitorImportPaymentReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorImportPaymentReq
     */
    'note': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorImportPaymentReq
     */
    'amount': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorImportPaymentReq
     */
    'paymentDate': NodaTimeLocalDate;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorImportPaymentReq
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorInviteParkerFeeReq
 */
export interface ServerTransferMonitorInviteParkerFeeReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInviteParkerFeeReq
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInviteParkerFeeReq
     */
    'amountCents': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionFeeCadence}
     * @memberof ServerTransferMonitorInviteParkerFeeReq
     */
    'cadence': DataEntitiesSubscriptionFeeCadence;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorInviteParkerReq
 */
export interface ServerTransferMonitorInviteParkerReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'planPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'requirePayment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'isEnhancedGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'isGroup': boolean;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'startDate': NodaTimeLocalDate;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'pendingIntegrationCredential'?: string | null;
    /**
     * 
     * @type {Array<ServerTransferMonitorInviteParkerFeeReq>}
     * @memberof ServerTransferMonitorInviteParkerReq
     */
    'fees'?: Array<ServerTransferMonitorInviteParkerFeeReq> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorInviteParkerResp
 */
export interface ServerTransferMonitorInviteParkerResp {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInviteParkerResp
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInviteParkerResp
     */
    'subscriptionId'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorInvoiceInfo
 */
export interface ServerTransferMonitorInvoiceInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'invoiceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'dueWhen'?: NodaTimeLocalDate;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'openingBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'amountDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'endingBalance'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'emailSentWhen'?: object;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferMonitorInvoiceInfo
     */
    'parker'?: ServerTransferParkerInfo;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorMonitorPermissionDto
 */
export interface ServerTransferMonitorMonitorPermissionDto {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorMonitorPermissionDto
     */
    'key': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorMonitorPermissionDto
     */
    'displayName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorMonitorPermissionDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorMonitorPermissionDto
     */
    'category': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorMonitorPermissionDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorOrderAdjustReq
 */
export interface ServerTransferMonitorOrderAdjustReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorOrderAdjustReq
     */
    'orderId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorOrderAdjustReq
     */
    'currentTotalDebt': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorOrderAdjustReq
     */
    'newTotalDebt': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderAdjustReq
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorOrderCustomItemReq
 */
export interface ServerTransferMonitorOrderCustomItemReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderCustomItemReq
     */
    'category': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderCustomItemReq
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorOrderCustomItemReq
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorOrderCustomItemReq
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorOrderCustomReq
 */
export interface ServerTransferMonitorOrderCustomReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderCustomReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderCustomReq
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderCustomReq
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorOrderCustomReq
     */
    'description': string;
    /**
     * 
     * @type {Array<ServerTransferMonitorOrderCustomItemReq>}
     * @memberof ServerTransferMonitorOrderCustomReq
     */
    'items': Array<ServerTransferMonitorOrderCustomItemReq>;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorOrderCustomReq
     */
    'dueDate': NodaTimeLocalDate;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorParkerDetails
 */
export interface ServerTransferMonitorParkerDetails {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'parkerId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'balance': number;
    /**
     * 
     * @type {Array<ServerTransferMonitorParkerSubInfo>}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'subscriptions': Array<ServerTransferMonitorParkerSubInfo> | null;
    /**
     * 
     * @type {Array<ServerTransferMonitorReservation>}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'reservations': Array<ServerTransferMonitorReservation> | null;
    /**
     * 
     * @type {Array<ServerTransferVehicle>}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'vehicles': Array<ServerTransferVehicle> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'isManaged': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'nonRenewedSubscriptionIds'?: Array<number> | null;
    /**
     * 
     * @type {DataStaffRole}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'staffRole'?: DataStaffRole;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetails
     */
    'subscriptionParkerId'?: number | null;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorParkerDetailsGrid
 */
export interface ServerTransferMonitorParkerDetailsGrid {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'parkerId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'balance': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'status': DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'mrr': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'guestCount': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'spotCount': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'planCount': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'planName': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'inviteId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'hasAutoPay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerDetailsGrid
     */
    'hasNonRenewedPeriod'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorParkerDetailsGridResult
 */
export interface ServerTransferMonitorParkerDetailsGridResult {
    /**
     * 
     * @type {Array<ServerTransferMonitorParkerDetailsGrid>}
     * @memberof ServerTransferMonitorParkerDetailsGridResult
     */
    'parkerDetailsGrid': Array<ServerTransferMonitorParkerDetailsGrid> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorParkerDetailsGridResult
     */
    'timeZone': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorParkerSubInfo
 */
export interface ServerTransferMonitorParkerSubInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'parkerId': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'status': DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'createdWhen': object;
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'guests': Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {ServerTransferPlanInfoBasic}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'plan': ServerTransferPlanInfoBasic;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'facilityHasIntegrationsEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'hasAutoBillingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorParkerSubInfo
     */
    'isUsageBasedBilling'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorPaymentAdjustReq
 */
export interface ServerTransferMonitorPaymentAdjustReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPaymentAdjustReq
     */
    'paymentId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPaymentAdjustReq
     */
    'currentAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPaymentAdjustReq
     */
    'newAmount': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPaymentAdjustReq
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPayoutTransaction
 */
export interface ServerTransferMonitorPayoutTransaction {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'payoutTransactionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'payoutId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'balanceTransactionKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'type': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'key': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'paymentIntentKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'chargeKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'refundKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'disputeKey': string | null;
    /**
     * 
     * @type {ServerTransferPayoutTransactionPayment}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'payment': ServerTransferPayoutTransactionPayment;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'gross': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'fee': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'net': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'processorCreatedWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorPayoutTransaction
     */
    'availableWhen': object;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlan
 */
export interface ServerTransferMonitorPlan {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'planEntryId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlan
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlan
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlan
     */
    'accessHours': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'dayOfMonthInvoice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'dayOfMonthDue': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'dayOfMonthLate': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'planPriceId': number | null;
    /**
     * 
     * @type {ServerTransferMonitorPlanPriceInfo}
     * @memberof ServerTransferMonitorPlan
     */
    'planPrice': ServerTransferMonitorPlanPriceInfo;
    /**
     * 
     * @type {Array<ServerTransferMonitorPlanPriceDetails>}
     * @memberof ServerTransferMonitorPlan
     */
    'prices': Array<ServerTransferMonitorPlanPriceDetails> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlan
     */
    'note': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlan
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlan
     */
    'isOneTermPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlan
     */
    'isUsageBasedBilling': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlan
     */
    'cancellationWindowDays': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanChange
 */
export interface ServerTransferMonitorPlanChange {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'planEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanChange
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanChange
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanChange
     */
    'accessHours'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'dayOfMonthInvoice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'dayOfMonthDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'dayOfMonthLate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'planPriceId'?: number | null;
    /**
     * 
     * @type {ServerTransferMonitorPlanPriceInfo}
     * @memberof ServerTransferMonitorPlanChange
     */
    'planPrice'?: ServerTransferMonitorPlanPriceInfo;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorPlanChange
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanChange
     */
    'createdByStaffId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanChange
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanCreateReq
 */
export interface ServerTransferMonitorPlanCreateReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'accessHours': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'dayOfMonthInvoice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'dayOfMonthDue': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'dayOfMonthLate': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'initialPrice': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'terms': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'prorate': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'isOneTermPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'isUsageBasedBilling': boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'couponCode': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'approvalEmailText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'renewalFailureDeactivateAfterDays': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanCreateReq
     */
    'cancellationWindowDays'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanDetails
 */
export interface ServerTransferMonitorPlanDetails {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'planId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'planEntryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'accessHours'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'dayOfMonthInvoice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'dayOfMonthDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'dayOfMonthLate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'planPriceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'approvalEmailText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'isUsageBasedBilling'?: boolean;
    /**
     * 
     * @type {ServerTransferMonitorPlanPriceInfo}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'planPrice'?: ServerTransferMonitorPlanPriceInfo;
    /**
     * 
     * @type {Array<ServerTransferMonitorPlanPriceDetails>}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'prices'?: Array<ServerTransferMonitorPlanPriceDetails> | null;
    /**
     * 
     * @type {Array<ServerTransferMonitorPlanChange>}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'history'?: Array<ServerTransferMonitorPlanChange> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'prorate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'renewalFailureDeactivateAfterDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanDetails
     */
    'cancellationWindowDays'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanInvoiceReq
 */
export interface ServerTransferMonitorPlanInvoiceReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanInvoiceReq
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanInvoiceReq
     */
    'month': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanInvoiceResp
 */
export interface ServerTransferMonitorPlanInvoiceResp {
    /**
     * 
     * @type {ServerTransferMonitorInvoiceInfo}
     * @memberof ServerTransferMonitorPlanInvoiceResp
     */
    'invoice'?: ServerTransferMonitorInvoiceInfo;
    /**
     * 
     * @type {ServerCommonEmailArgsInvoiceArgs}
     * @memberof ServerTransferMonitorPlanInvoiceResp
     */
    'emailArgs'?: ServerCommonEmailArgsInvoiceArgs;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanPriceAddReq
 */
export interface ServerTransferMonitorPlanPriceAddReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceAddReq
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceAddReq
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceAddReq
     */
    'couponCode': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanPriceDetails
 */
export interface ServerTransferMonitorPlanPriceDetails {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'planPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'couponCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'createdByStaffId'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {Array<ServerTransferMonitorSubscriberInfo>}
     * @memberof ServerTransferMonitorPlanPriceDetails
     */
    'subscribers'?: Array<ServerTransferMonitorSubscriberInfo> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanPriceInfo
 */
export interface ServerTransferMonitorPlanPriceInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceInfo
     */
    'planPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceInfo
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceInfo
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceInfo
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceInfo
     */
    'createdByStaffId'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorPlanPriceInfo
     */
    'createdWhen'?: object;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanPriceListResp
 */
export interface ServerTransferMonitorPlanPriceListResp {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceListResp
     */
    'planPriceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceListResp
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanPriceListResp
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanPriceListResp
     */
    'couponCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorPlanUpdateReq
 */
export interface ServerTransferMonitorPlanUpdateReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'planEntryId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'accessHours': string;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'planPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'dayOfMonthInvoice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'dayOfMonthDue': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'dayOfMonthLate': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'terms': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'prorate': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'approvalEmailText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'renewalFailureDeactivateAfterDays': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorPlanUpdateReq
     */
    'cancellationWindowDays'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorRatePreviewReq
 */
export interface ServerTransferMonitorRatePreviewReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorRatePreviewReq
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorRatePreviewReq
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorReservation
 */
export interface ServerTransferMonitorReservation {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'reservationId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'parkerId': number;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferMonitorReservation
     */
    'start': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferMonitorReservation
     */
    'end': NodaTimeLocalDateTime;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorReservation
     */
    'actualStart': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorReservation
     */
    'actualEnd': object;
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof ServerTransferMonitorReservation
     */
    'duration': NodaTimeDuration;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'rateProgramId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorReservation
     */
    'createdWhen': object;
    /**
     * 
     * @type {ServerTransferRateProgramInfo}
     * @memberof ServerTransferMonitorReservation
     */
    'rateProgram': ServerTransferRateProgramInfo;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'validationRequestId': number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorReservation
     */
    'confirmationNum': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorReservation
     */
    'spaces': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSession
 */
export interface ServerTransferMonitorSession {
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferMonitorSession
     */
    'parker': ServerTransferParkerInfo;
    /**
     * 
     * @type {ServerTransferSessionType}
     * @memberof ServerTransferMonitorSession
     */
    'type': ServerTransferSessionType;
    /**
     * 
     * @type {ServerTransferMonitorSessionSubscription}
     * @memberof ServerTransferMonitorSession
     */
    'subscription': ServerTransferMonitorSessionSubscription;
    /**
     * 
     * @type {ServerTransferMonitorSessionSubscription}
     * @memberof ServerTransferMonitorSession
     */
    'subscriptionGuest': ServerTransferMonitorSessionSubscription;
    /**
     * 
     * @type {ServerTransferMonitorReservation}
     * @memberof ServerTransferMonitorSession
     */
    'reservation': ServerTransferMonitorReservation;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSession
     */
    'vehicles': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSession
     */
    'source'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorSessionAccessPeriod
 */
export interface ServerTransferMonitorSessionAccessPeriod {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'createdWhen': object;
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'guests': Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {ServerTransferPlanInfoBasic}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'plan': ServerTransferPlanInfoBasic;
    /**
     * 
     * @type {ServerTransferOrderBalance}
     * @memberof ServerTransferMonitorSessionAccessPeriod
     */
    'orderBalance': ServerTransferOrderBalance;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSessionSubscription
 */
export interface ServerTransferMonitorSessionSubscription {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSessionSubscription
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSessionSubscription
     */
    'parkerId': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorSessionSubscription
     */
    'status': DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerTransferMonitorSessionSubscription
     */
    'guests': Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {ServerTransferPlanInfoBasic}
     * @memberof ServerTransferMonitorSessionSubscription
     */
    'plan': ServerTransferPlanInfoBasic;
    /**
     * 
     * @type {Array<ServerTransferMonitorSessionAccessPeriod>}
     * @memberof ServerTransferMonitorSessionSubscription
     */
    'accessPeriods': Array<ServerTransferMonitorSessionAccessPeriod> | null;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorStaff
 */
export interface ServerTransferMonitorStaff {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorStaff
     */
    'staffId': number;
    /**
     * 
     * @type {DataStaffRole}
     * @memberof ServerTransferMonitorStaff
     */
    'role': DataStaffRole;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorStaff
     */
    'operatorId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorStaff
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorStaff
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorStaff
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorStaff
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorStaff
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorStaff
     */
    'removedWhen': object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferMonitorStaff
     */
    'roles'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferMonitorStaff
     */
    'permissions'?: Array<string> | null;
    /**
     * 
     * @type {Array<ServerTransferMonitorFacility>}
     * @memberof ServerTransferMonitorStaff
     */
    'facilities'?: Array<ServerTransferMonitorFacility> | null;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorSubEntry
 */
export interface ServerTransferMonitorSubEntry {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubEntry
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubEntry
     */
    'planId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubEntry
     */
    'planEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubEntry
     */
    'planPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubEntry
     */
    'quantity'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorSubEntry
     */
    'status'?: DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubEntry
     */
    'start'?: NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubEntry
     */
    'end'?: NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubEntry
     */
    'isAccountsReceivable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubEntry
     */
    'isLateFeeEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubEntry
     */
    'staffInitiatedCancellation'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorSubEntry
     */
    'createdWhen'?: object;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorSubForEdit
 */
export interface ServerTransferMonitorSubForEdit {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'planId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'planEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'planPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'quantity'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'status'?: DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'start'?: NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'end'?: NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'isAccountsReceivable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'isLateFeeEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'staffInitiatedCancellation'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {Array<ServerTransferMonitorPlanPriceInfo>}
     * @memberof ServerTransferMonitorSubForEdit
     */
    'prices'?: Array<ServerTransferMonitorPlanPriceInfo> | null;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriberInfo
 */
export interface ServerTransferMonitorSubscriberInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriberInfo
     */
    'parkerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriberInfo
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriberInfo
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriberInfo
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriberInfo
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriberInfo
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionInfo
 */
export interface ServerTransferMonitorSubscriptionInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionInfo
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorSubscriptionInfo
     */
    'status'?: DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubscriptionInfo
     */
    'start'?: NodaTimeLocalDate;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferMonitorSubscriptionInfo
     */
    'parker'?: ServerTransferParkerInfo;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionParkerAccessKey
 */
export interface ServerTransferMonitorSubscriptionParkerAccessKey {
    /**
     * 
     * @type {ServerTransferMonitorSubscriptionInfo}
     * @memberof ServerTransferMonitorSubscriptionParkerAccessKey
     */
    'subscription'?: ServerTransferMonitorSubscriptionInfo;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferMonitorSubscriptionParkerAccessKey
     */
    'parker'?: ServerTransferParkerInfo;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionParkerChangeReq
 */
export interface ServerTransferMonitorSubscriptionParkerChangeReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionParkerChangeReq
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionParkerChangeReq
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionParkerInviteReq
 */
export interface ServerTransferMonitorSubscriptionParkerInviteReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'isLoginEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'subscriptionGroupId'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'startDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferMonitorSubscriptionParkerInviteReq
     */
    'pendingIntegrationCredential'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionParkerRemoveReq
 */
export interface ServerTransferMonitorSubscriptionParkerRemoveReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionParkerRemoveReq
     */
    'parkerId': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferMonitorSubscriptionParkerRemoveReq
     */
    'removedWhen'?: object;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionParkerVehicleAccessKey
 */
export interface ServerTransferMonitorSubscriptionParkerVehicleAccessKey {
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubscriptionParkerVehicleAccessKey
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {ServerTransferMonitorSubscriptionInfo}
     * @memberof ServerTransferMonitorSubscriptionParkerVehicleAccessKey
     */
    'subscription'?: ServerTransferMonitorSubscriptionInfo;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferMonitorSubscriptionParkerVehicleAccessKey
     */
    'parker'?: ServerTransferParkerInfo;
    /**
     * 
     * @type {ServerTransferVehicle}
     * @memberof ServerTransferMonitorSubscriptionParkerVehicleAccessKey
     */
    'vehicle'?: ServerTransferVehicle;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorSubscriptionUpdateReq
 */
export interface ServerTransferMonitorSubscriptionUpdateReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'subscriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'planPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'quantity': number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'status': DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'start': NodaTimeLocalDate;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'end': NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'isAccountsReceivable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'isLateFeeEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferMonitorSubscriptionUpdateReq
     */
    'applyQuantityChangeNow': boolean;
}


/**
 * 
 * @export
 * @interface ServerTransferMonitorVehicleAddReq
 */
export interface ServerTransferMonitorVehicleAddReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorVehicleAddReq
     */
    'vehicleId': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorVehicleDeleteReq
 */
export interface ServerTransferMonitorVehicleDeleteReq {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorVehicleDeleteReq
     */
    'vehicleId': number;
}
/**
 * 
 * @export
 * @interface ServerTransferMonitorVehicleLinkResp
 */
export interface ServerTransferMonitorVehicleLinkResp {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorVehicleLinkResp
     */
    'vehicleLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorVehicleLinkResp
     */
    'vehicleId': number;
    /**
     * 
     * @type {DataEntitiesVehicleLinkType}
     * @memberof ServerTransferMonitorVehicleLinkResp
     */
    'type'?: DataEntitiesVehicleLinkType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferMonitorVehicleLinkResp
     */
    'subscriptionId'?: number;
}


/**
 * 
 * @export
 * @interface ServerTransferNewPayoutAccountResult
 */
export interface ServerTransferNewPayoutAccountResult {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferNewPayoutAccountResult
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferNewPayoutAccountResult
     */
    'linkUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferNewPayoutAccountResult
     */
    'linkExpiry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferNewPayoutAccountResult
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferOperator
 */
export interface ServerTransferOperator {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOperator
     */
    'operatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'name'?: string | null;
    /**
     * 
     * @type {DataEntitiesUsAddress}
     * @memberof ServerTransferOperator
     */
    'address'?: DataEntitiesUsAddress;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'topTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'topText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'bottomLeftTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'bottomLeftText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'bottomRightTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'bottomRightText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperator
     */
    'hostName'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferOperatorInvoiceApiResponse
 */
export interface ServerTransferOperatorInvoiceApiResponse {
    /**
     * 
     * @type {Array<ServerTransferOperatorInvoiceResponse>}
     * @memberof ServerTransferOperatorInvoiceApiResponse
     */
    'items'?: Array<ServerTransferOperatorInvoiceResponse> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferOperatorInvoiceResponse
 */
export interface ServerTransferOperatorInvoiceResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'amountDue'?: number;
    /**
     * 
     * @type {DataEntitiesFinanceInvoiceStatus}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'status'?: DataEntitiesFinanceInvoiceStatus;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'dueDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'createdDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'paymentUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOperatorInvoiceResponse
     */
    'operatorInvoiceId'?: number;
}


/**
 * 
 * @export
 * @interface ServerTransferOrder
 */
export interface ServerTransferOrder {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrder
     */
    'orderId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderInitiator}
     * @memberof ServerTransferOrder
     */
    'initiator'?: DataEntitiesOrderInitiator;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrder
     */
    'initiatedByStaffId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrder
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrder
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrder
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOrder
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOrder
     */
    'processorPaymentIntentKey'?: string | null;
    /**
     * 
     * @type {DataEntitiesOrderType}
     * @memberof ServerTransferOrder
     */
    'type'?: DataEntitiesOrderType;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferOrder
     */
    'facility'?: ServerTransferFacilityInfo;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOrder
     */
    'submittedWhen'?: object;
    /**
     * 
     * @type {ServerTransferOrderBalance}
     * @memberof ServerTransferOrder
     */
    'balance'?: ServerTransferOrderBalance;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOrder
     */
    'summary'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferOrder
     */
    'hasReceipt'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerTransferOrderBalance
 */
export interface ServerTransferOrderBalance {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'orderBalanceId': number;
    /**
     * 
     * @type {DataEntitiesOrderBalanceType}
     * @memberof ServerTransferOrderBalance
     */
    'type': DataEntitiesOrderBalanceType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'orderId': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOrderBalance
     */
    'createdWhen': object;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'debt': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'paid': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'totalDebt': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'totalPaid': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOrderBalance
     */
    'reason': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderBalance
     */
    'paymentId': number | null;
}


/**
 * 
 * @export
 * @interface ServerTransferOrderDetails
 */
export interface ServerTransferOrderDetails {
    /**
     * 
     * @type {ServerTransferOrder}
     * @memberof ServerTransferOrderDetails
     */
    'order': ServerTransferOrder;
    /**
     * 
     * @type {Array<ServerTransferOrderBalance>}
     * @memberof ServerTransferOrderDetails
     */
    'balanceChanges': Array<ServerTransferOrderBalance> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOrderDetails
     */
    'summary': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferOrderInfo
 */
export interface ServerTransferOrderInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderInfo
     */
    'orderId'?: number;
    /**
     * 
     * @type {DataEntitiesOrderInitiator}
     * @memberof ServerTransferOrderInfo
     */
    'initiator'?: DataEntitiesOrderInitiator;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderInfo
     */
    'initiatedByStaffId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderInfo
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderInfo
     */
    'facilityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferOrderInfo
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOrderInfo
     */
    'createdWhen'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOrderInfo
     */
    'processorPaymentIntentKey'?: string | null;
    /**
     * 
     * @type {DataEntitiesOrderType}
     * @memberof ServerTransferOrderInfo
     */
    'orderType'?: DataEntitiesOrderType;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferOrderInfo
     */
    'submittedWhen'?: object;
    /**
     * 
     * @type {ServerTransferOrderBalance}
     * @memberof ServerTransferOrderInfo
     */
    'balance'?: ServerTransferOrderBalance;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferOrderInfo
     */
    'summary'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerTransferParkerInfo
 */
export interface ServerTransferParkerInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferParkerInfo
     */
    'parkerId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferParkerInfo
     */
    'operatorId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferParkerInfo
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferParkerInfo
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferParkerInfo
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferParkerInfo
     */
    'createdWhen': object;
    /**
     * 
     * @type {Array<DataEntitiesVehicle>}
     * @memberof ServerTransferParkerInfo
     */
    'vehicles': Array<DataEntitiesVehicle> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferParkerInfo
     */
    'isManaged': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferParkerInfo
     */
    'isAutoGeneratedEmail': boolean;
}
/**
 * 
 * @export
 * @interface ServerTransferPayment
 */
export interface ServerTransferPayment {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayment
     */
    'paymentId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayment
     */
    'parentPaymentId': number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayment
     */
    'facilityId': number;
    /**
     * 
     * @type {ServerTransferFacilityLite}
     * @memberof ServerTransferPayment
     */
    'facility': ServerTransferFacilityLite;
    /**
     * 
     * @type {DataEntitiesPaymentType}
     * @memberof ServerTransferPayment
     */
    'type': DataEntitiesPaymentType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayment
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayment
     */
    'remaining': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayment
     */
    'unapplied'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'paymentMethod': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'paymentIntentKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'chargeKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'paymentKey': string | null;
    /**
     * 
     * @type {Array<ServerTransferPaymentChange>}
     * @memberof ServerTransferPayment
     */
    'changes': Array<ServerTransferPaymentChange> | null;
    /**
     * 
     * @type {Array<ServerTransferApplyPayment>}
     * @memberof ServerTransferPayment
     */
    'applications': Array<ServerTransferApplyPayment> | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferPayment
     */
    'createdWhen': object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferPayment
     */
    'paidWhen': object;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'status': string | null;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferPayment
     */
    'checkDate'?: NodaTimeLocalDate;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'checkNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'checkMemo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'creditNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayment
     */
    'staffName'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerTransferPaymentChange
 */
export interface ServerTransferPaymentChange {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPaymentChange
     */
    'paymentId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPaymentChange
     */
    'parentPaymentId': number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPaymentChange
     */
    'facilityId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPaymentChange
     */
    'parkerId': number;
    /**
     * 
     * @type {DataEntitiesPaymentType}
     * @memberof ServerTransferPaymentChange
     */
    'type': DataEntitiesPaymentType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPaymentChange
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPaymentChange
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPaymentChange
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPaymentChange
     */
    'note'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferPaymentChange
     */
    'createdWhen'?: object;
}


/**
 * 
 * @export
 * @interface ServerTransferPayoutOnboardingInviteStatusResp
 */
export interface ServerTransferPayoutOnboardingInviteStatusResp {
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferPayoutOnboardingInviteStatusResp
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferPayoutOnboardingInviteStatusResp
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferPayoutOnboardingInviteStatusResp
     */
    'isAlreadyOnboarded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayoutOnboardingInviteStatusResp
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayoutOnboardingInviteStatusResp
     */
    'accountLabel'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferPayoutOnboardingShareReq
 */
export interface ServerTransferPayoutOnboardingShareReq {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayoutOnboardingShareReq
     */
    'processorAccountKey': string;
}
/**
 * 
 * @export
 * @interface ServerTransferPayoutOnboardingShareResp
 */
export interface ServerTransferPayoutOnboardingShareResp {
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayoutOnboardingShareResp
     */
    'inviteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPayoutOnboardingShareResp
     */
    'shareLink'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferPayoutTransactionPayment
 */
export interface ServerTransferPayoutTransactionPayment {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'paymentId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'parentPaymentId': number | null;
    /**
     * 
     * @type {DataEntitiesPaymentType}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'type': DataEntitiesPaymentType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'balance': number;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'createdWhen': object;
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'parker': ServerTransferParkerInfo;
    /**
     * 
     * @type {Array<ServerTransferApplyPayment>}
     * @memberof ServerTransferPayoutTransactionPayment
     */
    'applications': Array<ServerTransferApplyPayment> | null;
}


/**
 * 
 * @export
 * @interface ServerTransferPlanInfo
 */
export interface ServerTransferPlanInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPlanInfo
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPlanInfo
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPlanInfo
     */
    'accessHours': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'dayOfMonthInvoice': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'dayOfMonthDue': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'dayOfMonthLate': number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferPlanInfo
     */
    'isOneTermParking': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'renewalFailureDeactivateAfterDays': number;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferPlanInfo
     */
    'isUsageBasedBilling': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfo
     */
    'cancellationWindowDays': number;
}
/**
 * 
 * @export
 * @interface ServerTransferPlanInfoBasic
 */
export interface ServerTransferPlanInfoBasic {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfoBasic
     */
    'planId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfoBasic
     */
    'planEntryId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPlanInfoBasic
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferPlanInfoBasic
     */
    'accessHours': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferPlanInfoBasic
     */
    'cancellationWindowDays'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferRateEntry
 */
export interface ServerTransferRateEntry {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateEntry
     */
    'rateEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateEntry
     */
    'rateProgramId': number;
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof ServerTransferRateEntry
     */
    'upTo': NodaTimeDuration;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateEntry
     */
    'rate': number;
    /**
     * 
     * @type {DataEntitiesRateEntryDiscountType}
     * @memberof ServerTransferRateEntry
     */
    'discountType'?: DataEntitiesRateEntryDiscountType;
}


/**
 * 
 * @export
 * @interface ServerTransferRateEntryData
 */
export interface ServerTransferRateEntryData {
    /**
     * 
     * @type {NodaTimeDuration}
     * @memberof ServerTransferRateEntryData
     */
    'upTo': NodaTimeDuration;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateEntryData
     */
    'rate': number;
    /**
     * 
     * @type {DataEntitiesRateEntryDiscountType}
     * @memberof ServerTransferRateEntryData
     */
    'discountType'?: DataEntitiesRateEntryDiscountType;
}


/**
 * 
 * @export
 * @interface ServerTransferRateProgram
 */
export interface ServerTransferRateProgram {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateProgram
     */
    'rateProgramId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgram
     */
    'encodedRateProgramId': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateProgram
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgram
     */
    'name': string | null;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferRateProgram
     */
    'start': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferRateProgram
     */
    'end': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgram
     */
    'inAfter': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgram
     */
    'inBefore': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgram
     */
    'outAfter': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgram
     */
    'outBefore': NodaTimeLocalTime;
    /**
     * 
     * @type {DataEntitiesDaysOfWeek}
     * @memberof ServerTransferRateProgram
     */
    'applicableDays': DataEntitiesDaysOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgram
     */
    'isEvent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgram
     */
    'isValidation': boolean;
    /**
     * 
     * @type {Array<ServerTransferRateEntry>}
     * @memberof ServerTransferRateProgram
     */
    'entries': Array<ServerTransferRateEntry> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgram
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgram
     */
    'canBeValidated': boolean;
    /**
     * 
     * @type {DataEntitiesValidationType}
     * @memberof ServerTransferRateProgram
     */
    'validationType': DataEntitiesValidationType;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgram
     */
    'isSpecialRate': boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgram
     */
    'code'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerTransferRateProgramData
 */
export interface ServerTransferRateProgramData {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateProgramData
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgramData
     */
    'name': string;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferRateProgramData
     */
    'start': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferRateProgramData
     */
    'end': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramData
     */
    'inAfter': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramData
     */
    'inBefore': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramData
     */
    'outAfter': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramData
     */
    'outBefore': NodaTimeLocalTime;
    /**
     * 
     * @type {DataEntitiesDaysOfWeek}
     * @memberof ServerTransferRateProgramData
     */
    'applicableDays': DataEntitiesDaysOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgramData
     */
    'isEvent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgramData
     */
    'isValidation': boolean;
    /**
     * 
     * @type {Array<ServerTransferRateEntryData>}
     * @memberof ServerTransferRateProgramData
     */
    'entries': Array<ServerTransferRateEntryData>;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgramData
     */
    'canBeValidated': boolean;
    /**
     * 
     * @type {DataEntitiesValidationType}
     * @memberof ServerTransferRateProgramData
     */
    'validationType': DataEntitiesValidationType;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgramData
     */
    'isSpecialRate': boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgramData
     */
    'code'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerTransferRateProgramDropdown
 */
export interface ServerTransferRateProgramDropdown {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateProgramDropdown
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgramDropdown
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferRateProgramInfo
 */
export interface ServerTransferRateProgramInfo {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateProgramInfo
     */
    'rateProgramId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRateProgramInfo
     */
    'facilityId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRateProgramInfo
     */
    'name': string | null;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferRateProgramInfo
     */
    'start': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalDateTime}
     * @memberof ServerTransferRateProgramInfo
     */
    'end': NodaTimeLocalDateTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramInfo
     */
    'inAfter': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramInfo
     */
    'inBefore': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramInfo
     */
    'outAfter': NodaTimeLocalTime;
    /**
     * 
     * @type {NodaTimeLocalTime}
     * @memberof ServerTransferRateProgramInfo
     */
    'outBefore': NodaTimeLocalTime;
    /**
     * 
     * @type {DataEntitiesDaysOfWeek}
     * @memberof ServerTransferRateProgramInfo
     */
    'applicableDays': DataEntitiesDaysOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgramInfo
     */
    'isEvent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferRateProgramInfo
     */
    'isSpecialRate': boolean;
}


/**
 * 
 * @export
 * @interface ServerTransferRecurringReportScheduleRequest
 */
export interface ServerTransferRecurringReportScheduleRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRecurringReportScheduleRequest
     */
    'savedReportId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferRecurringReportScheduleRequest
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {DataEntitiesReportsFrequency}
     * @memberof ServerTransferRecurringReportScheduleRequest
     */
    'frequency'?: DataEntitiesReportsFrequency;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferRecurringReportScheduleRequest
     */
    'days'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRecurringReportScheduleRequest
     */
    'time'?: string | null;
}


/**
 * 
 * @export
 * @interface ServerTransferRecurringReportScheduleResponse
 */
export interface ServerTransferRecurringReportScheduleResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'recurringReportScheduleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'savedReportId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {DataEntitiesReportsFrequency}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'frequency'?: DataEntitiesReportsFrequency;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'days'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'time'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferRecurringReportScheduleResponse
     */
    'lastRunTime'?: object;
}


/**
 * 
 * @export
 * @interface ServerTransferSavedReportRequest
 */
export interface ServerTransferSavedReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSavedReportRequest
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferSavedReportRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferSavedReportRequest
     */
    'filterJson'?: string | null;
}
/**
 * 
 * @export
 * @interface ServerTransferSavedReportResponse
 */
export interface ServerTransferSavedReportResponse {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSavedReportResponse
     */
    'savedReportId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferSavedReportResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {DataEntitiesReportsReportType}
     * @memberof ServerTransferSavedReportResponse
     */
    'type'?: DataEntitiesReportsReportType;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferSavedReportResponse
     */
    'filterJson'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferSavedReportResponse
     */
    'isRecurring'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ServerTransferSessionType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type ServerTransferSessionType = typeof ServerTransferSessionType[keyof typeof ServerTransferSessionType];


/**
 * 
 * @export
 * @interface ServerTransferSubscription
 */
export interface ServerTransferSubscription {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscription
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscription
     */
    'parkerId'?: number;
    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof ServerTransferSubscription
     */
    'status'?: DataEntitiesSubscriptionStatus;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferSubscription
     */
    'start'?: NodaTimeLocalDate;
    /**
     * 
     * @type {ServerTransferFacilityInfo}
     * @memberof ServerTransferSubscription
     */
    'facility'?: ServerTransferFacilityInfo;
    /**
     * 
     * @type {Array<ServerTransferAccessPeriodInfo>}
     * @memberof ServerTransferSubscription
     */
    'accessPeriods'?: Array<ServerTransferAccessPeriodInfo> | null;
    /**
     * 
     * @type {Array<ServerTransferSubscriptionParker>}
     * @memberof ServerTransferSubscription
     */
    'parkers'?: Array<ServerTransferSubscriptionParker> | null;
    /**
     * 
     * @type {Array<ServerTransferVehicle>}
     * @memberof ServerTransferSubscription
     */
    'vehicles'?: Array<ServerTransferVehicle> | null;
    /**
     * 
     * @type {Array<ServerTransferMonitorPlanPriceInfo>}
     * @memberof ServerTransferSubscription
     */
    'prices'?: Array<ServerTransferMonitorPlanPriceInfo> | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferSubscription
     */
    'paymentMethod'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscription
     */
    'planEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscription
     */
    'planPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscription
     */
    'quantity': number;
    /**
     * 
     * @type {NodaTimeLocalDate}
     * @memberof ServerTransferSubscription
     */
    'end': NodaTimeLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferSubscription
     */
    'isAccountsReceivable': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscription
     */
    'price': number;
    /**
     * 
     * @type {ServerTransferPlanInfo}
     * @memberof ServerTransferSubscription
     */
    'plan': ServerTransferPlanInfo;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferSubscription
     */
    'isEnhancedGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferSubscription
     */
    'isGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferSubscription
     */
    'staffInitiatedCancellation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServerTransferSubscription
     */
    'isPendingPaymentMethodVerification'?: boolean;
}


/**
 * 
 * @export
 * @interface ServerTransferSubscriptionParker
 */
export interface ServerTransferSubscriptionParker {
    /**
     * 
     * @type {ServerTransferParkerInfo}
     * @memberof ServerTransferSubscriptionParker
     */
    'parker'?: ServerTransferParkerInfo;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscriptionParker
     */
    'quantity'?: number;
    /**
     * 
     * @type {Array<ServerTransferVehicle>}
     * @memberof ServerTransferSubscriptionParker
     */
    'vehicles'?: Array<ServerTransferVehicle> | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferSubscriptionParker
     */
    'subscriptionGroupId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferSubscriptionParker
     */
    'subscriptionGroupName'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferSubscriptionParker
     */
    'startDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServerTransferSubscriptionParker
     */
    'removedWhen'?: object;
}
/**
 * 
 * @export
 * @interface ServerTransferVehicle
 */
export interface ServerTransferVehicle {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferVehicle
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicle
     */
    'make': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicle
     */
    'model': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicle
     */
    'color': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicle
     */
    'stateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicle
     */
    'licensePlateNumber': string | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferVehicle
     */
    'parkerId'?: number;
}
/**
 * 
 * @export
 * @interface ServerTransferVehicleDetails
 */
export interface ServerTransferVehicleDetails {
    /**
     * 
     * @type {number}
     * @memberof ServerTransferVehicleDetails
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicleDetails
     */
    'make': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicleDetails
     */
    'model': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicleDetails
     */
    'color': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicleDetails
     */
    'stateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerTransferVehicleDetails
     */
    'licensePlateNumber': string | null;
    /**
     * 
     * @type {Array<ServerTransferVehicleLink>}
     * @memberof ServerTransferVehicleDetails
     */
    'links': Array<ServerTransferVehicleLink> | null;
}
/**
 * 
 * @export
 * @interface ServerTransferVehicleLink
 */
export interface ServerTransferVehicleLink {
    /**
     * 
     * @type {DataEntitiesVehicleLinkType}
     * @memberof ServerTransferVehicleLink
     */
    'type': DataEntitiesVehicleLinkType;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferVehicleLink
     */
    'reservationId': number | null;
    /**
     * 
     * @type {number}
     * @memberof ServerTransferVehicleLink
     */
    'subscriptionId': number | null;
    /**
     * 
     * @type {ServerTransferConnectReservation}
     * @memberof ServerTransferVehicleLink
     */
    'reservation': ServerTransferConnectReservation;
    /**
     * 
     * @type {ServerTransferConnectSubListEntry}
     * @memberof ServerTransferVehicleLink
     */
    'subscription': ServerTransferConnectSubListEntry;
}


/**
 * 
 * @export
 * @interface SubscriptionReport
 */
export interface SubscriptionReport {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'parkerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'operatorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'facilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'facilityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'latestPeriodEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'plan'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'planId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'planEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionReport
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'allLps'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'linkedLps'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionReport
     */
    'isInvoiced'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReport
     */
    'price'?: string | null;
}

/**
 * AuditApi - axios parameter creator
 * @export
 */
export const AuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {number} [entityId] 
         * @param {number} [operatorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditEntriesAsync: async (entityType?: string, entityId?: number, operatorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/audit/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditApi - functional programming interface
 * @export
 */
export const AuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {number} [entityId] 
         * @param {number} [operatorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditEntriesAsync(entityType?: string, entityId?: number, operatorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsAuditTableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditEntriesAsync(entityType, entityId, operatorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.getAuditEntriesAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditApi - factory interface
 * @export
 */
export const AuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditApiGetAuditEntriesAsyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditEntriesAsync(requestParameters: AuditApiGetAuditEntriesAsyncRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsAuditTableResponse> {
            return localVarFp.getAuditEntriesAsync(requestParameters.entityType, requestParameters.entityId, requestParameters.operatorId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAuditEntriesAsync operation in AuditApi.
 * @export
 * @interface AuditApiGetAuditEntriesAsyncRequest
 */
export interface AuditApiGetAuditEntriesAsyncRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditApiGetAuditEntriesAsync
     */
    readonly entityType?: string

    /**
     * 
     * @type {number}
     * @memberof AuditApiGetAuditEntriesAsync
     */
    readonly entityId?: number

    /**
     * 
     * @type {number}
     * @memberof AuditApiGetAuditEntriesAsync
     */
    readonly operatorId?: number
}

/**
 * AuditApi - object-oriented interface
 * @export
 * @class AuditApi
 * @extends {BaseAPI}
 */
export class AuditApi extends BaseAPI {
    /**
     * 
     * @param {AuditApiGetAuditEntriesAsyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public getAuditEntriesAsync(requestParameters: AuditApiGetAuditEntriesAsyncRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).getAuditEntriesAsync(requestParameters.entityType, requestParameters.entityId, requestParameters.operatorId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerServicesIntegrationsAccountImpersonateRequestModel} [serverServicesIntegrationsAccountImpersonateRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate: async (serverServicesIntegrationsAccountImpersonateRequestModel?: ServerServicesIntegrationsAccountImpersonateRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/impersonate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverServicesIntegrationsAccountImpersonateRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerServicesIntegrationsAccountLoginRequestModel} [serverServicesIntegrationsAccountLoginRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (serverServicesIntegrationsAccountLoginRequestModel?: ServerServicesIntegrationsAccountLoginRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverServicesIntegrationsAccountLoginRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerServicesIntegrationsRefreshTokenRequestModel} [serverServicesIntegrationsRefreshTokenRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (serverServicesIntegrationsRefreshTokenRequestModel?: ServerServicesIntegrationsRefreshTokenRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverServicesIntegrationsRefreshTokenRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerServicesIntegrationsAccountImpersonateRequestModel} [serverServicesIntegrationsAccountImpersonateRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonate(serverServicesIntegrationsAccountImpersonateRequestModel?: ServerServicesIntegrationsAccountImpersonateRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerServicesIntegrationsAccountLoginResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonate(serverServicesIntegrationsAccountImpersonateRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.impersonate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerServicesIntegrationsAccountLoginRequestModel} [serverServicesIntegrationsAccountLoginRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(serverServicesIntegrationsAccountLoginRequestModel?: ServerServicesIntegrationsAccountLoginRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerServicesIntegrationsAccountLoginResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(serverServicesIntegrationsAccountLoginRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerServicesIntegrationsRefreshTokenRequestModel} [serverServicesIntegrationsRefreshTokenRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(serverServicesIntegrationsRefreshTokenRequestModel?: ServerServicesIntegrationsRefreshTokenRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(serverServicesIntegrationsRefreshTokenRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {AuthApiImpersonateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate(requestParameters: AuthApiImpersonateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerServicesIntegrationsAccountLoginResponseModel> {
            return localVarFp.impersonate(requestParameters.serverServicesIntegrationsAccountImpersonateRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthApiLoginRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerServicesIntegrationsAccountLoginResponseModel> {
            return localVarFp.login(requestParameters.serverServicesIntegrationsAccountLoginRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiRefreshTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(requestParameters: AuthApiRefreshTokenRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refreshToken(requestParameters.serverServicesIntegrationsRefreshTokenRequestModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for impersonate operation in AuthApi.
 * @export
 * @interface AuthApiImpersonateRequest
 */
export interface AuthApiImpersonateRequest {
    /**
     * 
     * @type {ServerServicesIntegrationsAccountImpersonateRequestModel}
     * @memberof AuthApiImpersonate
     */
    readonly serverServicesIntegrationsAccountImpersonateRequestModel?: ServerServicesIntegrationsAccountImpersonateRequestModel
}

/**
 * Request parameters for login operation in AuthApi.
 * @export
 * @interface AuthApiLoginRequest
 */
export interface AuthApiLoginRequest {
    /**
     * 
     * @type {ServerServicesIntegrationsAccountLoginRequestModel}
     * @memberof AuthApiLogin
     */
    readonly serverServicesIntegrationsAccountLoginRequestModel?: ServerServicesIntegrationsAccountLoginRequestModel
}

/**
 * Request parameters for refreshToken operation in AuthApi.
 * @export
 * @interface AuthApiRefreshTokenRequest
 */
export interface AuthApiRefreshTokenRequest {
    /**
     * 
     * @type {ServerServicesIntegrationsRefreshTokenRequestModel}
     * @memberof AuthApiRefreshToken
     */
    readonly serverServicesIntegrationsRefreshTokenRequestModel?: ServerServicesIntegrationsRefreshTokenRequestModel
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {AuthApiImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public impersonate(requestParameters: AuthApiImpersonateRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).impersonate(requestParameters.serverServicesIntegrationsAccountImpersonateRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(requestParameters: AuthApiLoginRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(requestParameters.serverServicesIntegrationsAccountLoginRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiRefreshTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshToken(requestParameters: AuthApiRefreshTokenRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshToken(requestParameters.serverServicesIntegrationsRefreshTokenRequestModel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} planId 
         * @param {number} [operatorId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBillingPlanToFacilities: async (planId: number, operatorId?: number, requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('assignBillingPlanToFacilities', 'planId', planId)
            const localVarPath = `/billing/plans/{planId}/facilities`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['operatorId'] = operatorId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [operatorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBillingPlan: async (id: number, operatorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelBillingPlan', 'id', id)
            const localVarPath = `/billing/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['operatorId'] = operatorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsCreateBillingPlanRequest} [serverRequestsCreateBillingPlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingPlan: async (serverRequestsCreateBillingPlanRequest?: ServerRequestsCreateBillingPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateBillingPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} operatorId 
         * @param {ServerRequestsGenerateOperatorInvoicesRequest} [serverRequestsGenerateOperatorInvoicesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOperatorInvoices: async (operatorId: number, serverRequestsGenerateOperatorInvoicesRequest?: ServerRequestsGenerateOperatorInvoicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operatorId' is not null or undefined
            assertParamExists('generateOperatorInvoices', 'operatorId', operatorId)
            const localVarPath = `/billing/operators/{operatorId}/generate-invoices`
                .replace(`{${"operatorId"}}`, encodeURIComponent(String(operatorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGenerateOperatorInvoicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [operatorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingPlan: async (id: number, operatorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillingPlan', 'id', id)
            const localVarPath = `/billing/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['operatorId'] = operatorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} operatorId 
         * @param {boolean} [includeCanceled] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingPlans: async (operatorId: number, includeCanceled?: boolean, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operatorId' is not null or undefined
            assertParamExists('getBillingPlans', 'operatorId', operatorId)
            const localVarPath = `/billing/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }

            if (includeCanceled !== undefined) {
                localVarQueryParameter['IncludeCanceled'] = includeCanceled;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityBillingPlans: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacilityBillingPlans', 'facilityId', facilityId)
            const localVarPath = `/billing/facilities/{facilityId}/plans`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} operatorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorFacilityBillingPlans: async (operatorId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operatorId' is not null or undefined
            assertParamExists('getOperatorFacilityBillingPlans', 'operatorId', operatorId)
            const localVarPath = `/billing/operators/{operatorId}/facility-plans`
                .replace(`{${"operatorId"}}`, encodeURIComponent(String(operatorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsProcessBillingForAllOperatorsRequest} [serverRequestsProcessBillingForAllOperatorsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processBillingForAllOperators: async (serverRequestsProcessBillingForAllOperatorsRequest?: ServerRequestsProcessBillingForAllOperatorsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/process-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsProcessBillingForAllOperatorsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} planId 
         * @param {number} [operatorId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBillingPlanFromFacilities: async (planId: number, operatorId?: number, requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('removeBillingPlanFromFacilities', 'planId', planId)
            const localVarPath = `/billing/plans/{planId}/facilities`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['operatorId'] = operatorId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsUpdateBillingPlanRequest} [serverRequestsUpdateBillingPlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingPlan: async (id: number, serverRequestsUpdateBillingPlanRequest?: ServerRequestsUpdateBillingPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBillingPlan', 'id', id)
            const localVarPath = `/billing/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsUpdateBillingPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} planId 
         * @param {number} [operatorId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignBillingPlanToFacilities(planId: number, operatorId?: number, requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsAssignBillingPlanToFacilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignBillingPlanToFacilities(planId, operatorId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.assignBillingPlanToFacilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [operatorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBillingPlan(id: number, operatorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCancelBillingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBillingPlan(id, operatorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.cancelBillingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsCreateBillingPlanRequest} [serverRequestsCreateBillingPlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillingPlan(serverRequestsCreateBillingPlanRequest?: ServerRequestsCreateBillingPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCreateBillingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillingPlan(serverRequestsCreateBillingPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.createBillingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} operatorId 
         * @param {ServerRequestsGenerateOperatorInvoicesRequest} [serverRequestsGenerateOperatorInvoicesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOperatorInvoices(operatorId: number, serverRequestsGenerateOperatorInvoicesRequest?: ServerRequestsGenerateOperatorInvoicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGenerateOperatorInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOperatorInvoices(operatorId, serverRequestsGenerateOperatorInvoicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.generateOperatorInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [operatorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingPlan(id: number, operatorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetBillingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingPlan(id, operatorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getBillingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} operatorId 
         * @param {boolean} [includeCanceled] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingPlans(operatorId: number, includeCanceled?: boolean, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetBillingPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingPlans(operatorId, includeCanceled, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getBillingPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilityBillingPlans(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFacilityBillingPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilityBillingPlans(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getFacilityBillingPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} operatorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorFacilityBillingPlans(operatorId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetOperatorFacilityBillingPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorFacilityBillingPlans(operatorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getOperatorFacilityBillingPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsProcessBillingForAllOperatorsRequest} [serverRequestsProcessBillingForAllOperatorsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processBillingForAllOperators(serverRequestsProcessBillingForAllOperatorsRequest?: ServerRequestsProcessBillingForAllOperatorsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsProcessBillingForAllOperatorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processBillingForAllOperators(serverRequestsProcessBillingForAllOperatorsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.processBillingForAllOperators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} planId 
         * @param {number} [operatorId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeBillingPlanFromFacilities(planId: number, operatorId?: number, requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsRemoveBillingPlanFromFacilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeBillingPlanFromFacilities(planId, operatorId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.removeBillingPlanFromFacilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsUpdateBillingPlanRequest} [serverRequestsUpdateBillingPlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBillingPlan(id: number, serverRequestsUpdateBillingPlanRequest?: ServerRequestsUpdateBillingPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUpdateBillingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBillingPlan(id, serverRequestsUpdateBillingPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.updateBillingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * 
         * @param {BillingApiAssignBillingPlanToFacilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBillingPlanToFacilities(requestParameters: BillingApiAssignBillingPlanToFacilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsAssignBillingPlanToFacilitiesResponse> {
            return localVarFp.assignBillingPlanToFacilities(requestParameters.planId, requestParameters.operatorId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiCancelBillingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBillingPlan(requestParameters: BillingApiCancelBillingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCancelBillingPlanResponse> {
            return localVarFp.cancelBillingPlan(requestParameters.id, requestParameters.operatorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiCreateBillingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingPlan(requestParameters: BillingApiCreateBillingPlanRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCreateBillingPlanResponse> {
            return localVarFp.createBillingPlan(requestParameters.serverRequestsCreateBillingPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiGenerateOperatorInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOperatorInvoices(requestParameters: BillingApiGenerateOperatorInvoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGenerateOperatorInvoicesResponse> {
            return localVarFp.generateOperatorInvoices(requestParameters.operatorId, requestParameters.serverRequestsGenerateOperatorInvoicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiGetBillingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingPlan(requestParameters: BillingApiGetBillingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetBillingPlanResponse> {
            return localVarFp.getBillingPlan(requestParameters.id, requestParameters.operatorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiGetBillingPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingPlans(requestParameters: BillingApiGetBillingPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetBillingPlansResponse> {
            return localVarFp.getBillingPlans(requestParameters.operatorId, requestParameters.includeCanceled, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiGetFacilityBillingPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityBillingPlans(requestParameters: BillingApiGetFacilityBillingPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFacilityBillingPlansResponse> {
            return localVarFp.getFacilityBillingPlans(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiGetOperatorFacilityBillingPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorFacilityBillingPlans(requestParameters: BillingApiGetOperatorFacilityBillingPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetOperatorFacilityBillingPlansResponse> {
            return localVarFp.getOperatorFacilityBillingPlans(requestParameters.operatorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiProcessBillingForAllOperatorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processBillingForAllOperators(requestParameters: BillingApiProcessBillingForAllOperatorsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsProcessBillingForAllOperatorsResponse> {
            return localVarFp.processBillingForAllOperators(requestParameters.serverRequestsProcessBillingForAllOperatorsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiRemoveBillingPlanFromFacilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBillingPlanFromFacilities(requestParameters: BillingApiRemoveBillingPlanFromFacilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsRemoveBillingPlanFromFacilitiesResponse> {
            return localVarFp.removeBillingPlanFromFacilities(requestParameters.planId, requestParameters.operatorId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BillingApiUpdateBillingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingPlan(requestParameters: BillingApiUpdateBillingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUpdateBillingPlanResponse> {
            return localVarFp.updateBillingPlan(requestParameters.id, requestParameters.serverRequestsUpdateBillingPlanRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignBillingPlanToFacilities operation in BillingApi.
 * @export
 * @interface BillingApiAssignBillingPlanToFacilitiesRequest
 */
export interface BillingApiAssignBillingPlanToFacilitiesRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiAssignBillingPlanToFacilities
     */
    readonly planId: number

    /**
     * 
     * @type {number}
     * @memberof BillingApiAssignBillingPlanToFacilities
     */
    readonly operatorId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof BillingApiAssignBillingPlanToFacilities
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for cancelBillingPlan operation in BillingApi.
 * @export
 * @interface BillingApiCancelBillingPlanRequest
 */
export interface BillingApiCancelBillingPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiCancelBillingPlan
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof BillingApiCancelBillingPlan
     */
    readonly operatorId?: number
}

/**
 * Request parameters for createBillingPlan operation in BillingApi.
 * @export
 * @interface BillingApiCreateBillingPlanRequest
 */
export interface BillingApiCreateBillingPlanRequest {
    /**
     * 
     * @type {ServerRequestsCreateBillingPlanRequest}
     * @memberof BillingApiCreateBillingPlan
     */
    readonly serverRequestsCreateBillingPlanRequest?: ServerRequestsCreateBillingPlanRequest
}

/**
 * Request parameters for generateOperatorInvoices operation in BillingApi.
 * @export
 * @interface BillingApiGenerateOperatorInvoicesRequest
 */
export interface BillingApiGenerateOperatorInvoicesRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiGenerateOperatorInvoices
     */
    readonly operatorId: number

    /**
     * 
     * @type {ServerRequestsGenerateOperatorInvoicesRequest}
     * @memberof BillingApiGenerateOperatorInvoices
     */
    readonly serverRequestsGenerateOperatorInvoicesRequest?: ServerRequestsGenerateOperatorInvoicesRequest
}

/**
 * Request parameters for getBillingPlan operation in BillingApi.
 * @export
 * @interface BillingApiGetBillingPlanRequest
 */
export interface BillingApiGetBillingPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiGetBillingPlan
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof BillingApiGetBillingPlan
     */
    readonly operatorId?: number
}

/**
 * Request parameters for getBillingPlans operation in BillingApi.
 * @export
 * @interface BillingApiGetBillingPlansRequest
 */
export interface BillingApiGetBillingPlansRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiGetBillingPlans
     */
    readonly operatorId: number

    /**
     * 
     * @type {boolean}
     * @memberof BillingApiGetBillingPlans
     */
    readonly includeCanceled?: boolean

    /**
     * 
     * @type {number}
     * @memberof BillingApiGetBillingPlans
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BillingApiGetBillingPlans
     */
    readonly take?: number
}

/**
 * Request parameters for getFacilityBillingPlans operation in BillingApi.
 * @export
 * @interface BillingApiGetFacilityBillingPlansRequest
 */
export interface BillingApiGetFacilityBillingPlansRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiGetFacilityBillingPlans
     */
    readonly facilityId: number
}

/**
 * Request parameters for getOperatorFacilityBillingPlans operation in BillingApi.
 * @export
 * @interface BillingApiGetOperatorFacilityBillingPlansRequest
 */
export interface BillingApiGetOperatorFacilityBillingPlansRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiGetOperatorFacilityBillingPlans
     */
    readonly operatorId: number
}

/**
 * Request parameters for processBillingForAllOperators operation in BillingApi.
 * @export
 * @interface BillingApiProcessBillingForAllOperatorsRequest
 */
export interface BillingApiProcessBillingForAllOperatorsRequest {
    /**
     * 
     * @type {ServerRequestsProcessBillingForAllOperatorsRequest}
     * @memberof BillingApiProcessBillingForAllOperators
     */
    readonly serverRequestsProcessBillingForAllOperatorsRequest?: ServerRequestsProcessBillingForAllOperatorsRequest
}

/**
 * Request parameters for removeBillingPlanFromFacilities operation in BillingApi.
 * @export
 * @interface BillingApiRemoveBillingPlanFromFacilitiesRequest
 */
export interface BillingApiRemoveBillingPlanFromFacilitiesRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiRemoveBillingPlanFromFacilities
     */
    readonly planId: number

    /**
     * 
     * @type {number}
     * @memberof BillingApiRemoveBillingPlanFromFacilities
     */
    readonly operatorId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof BillingApiRemoveBillingPlanFromFacilities
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for updateBillingPlan operation in BillingApi.
 * @export
 * @interface BillingApiUpdateBillingPlanRequest
 */
export interface BillingApiUpdateBillingPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof BillingApiUpdateBillingPlan
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsUpdateBillingPlanRequest}
     * @memberof BillingApiUpdateBillingPlan
     */
    readonly serverRequestsUpdateBillingPlanRequest?: ServerRequestsUpdateBillingPlanRequest
}

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * 
     * @param {BillingApiAssignBillingPlanToFacilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public assignBillingPlanToFacilities(requestParameters: BillingApiAssignBillingPlanToFacilitiesRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).assignBillingPlanToFacilities(requestParameters.planId, requestParameters.operatorId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiCancelBillingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public cancelBillingPlan(requestParameters: BillingApiCancelBillingPlanRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).cancelBillingPlan(requestParameters.id, requestParameters.operatorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiCreateBillingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public createBillingPlan(requestParameters: BillingApiCreateBillingPlanRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).createBillingPlan(requestParameters.serverRequestsCreateBillingPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiGenerateOperatorInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public generateOperatorInvoices(requestParameters: BillingApiGenerateOperatorInvoicesRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).generateOperatorInvoices(requestParameters.operatorId, requestParameters.serverRequestsGenerateOperatorInvoicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiGetBillingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getBillingPlan(requestParameters: BillingApiGetBillingPlanRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getBillingPlan(requestParameters.id, requestParameters.operatorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiGetBillingPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getBillingPlans(requestParameters: BillingApiGetBillingPlansRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getBillingPlans(requestParameters.operatorId, requestParameters.includeCanceled, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiGetFacilityBillingPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getFacilityBillingPlans(requestParameters: BillingApiGetFacilityBillingPlansRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getFacilityBillingPlans(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiGetOperatorFacilityBillingPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getOperatorFacilityBillingPlans(requestParameters: BillingApiGetOperatorFacilityBillingPlansRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getOperatorFacilityBillingPlans(requestParameters.operatorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiProcessBillingForAllOperatorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public processBillingForAllOperators(requestParameters: BillingApiProcessBillingForAllOperatorsRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).processBillingForAllOperators(requestParameters.serverRequestsProcessBillingForAllOperatorsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiRemoveBillingPlanFromFacilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public removeBillingPlanFromFacilities(requestParameters: BillingApiRemoveBillingPlanFromFacilitiesRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).removeBillingPlanFromFacilities(requestParameters.planId, requestParameters.operatorId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BillingApiUpdateBillingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public updateBillingPlan(requestParameters: BillingApiUpdateBillingPlanRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).updateBillingPlan(requestParameters.id, requestParameters.serverRequestsUpdateBillingPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConnectAuthApi - axios parameter creator
 * @export
 */
export const ConnectAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerTransferConnectResetCodeCheckReq} [serverTransferConnectResetCodeCheckReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthCheckPost: async (serverTransferConnectResetCodeCheckReq?: ServerTransferConnectResetCodeCheckReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectResetCodeCheckReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthDeleteConfirmPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/delete-confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthDeletePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectChangeEmailReq} [serverTransferConnectChangeEmailReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthEmailPost: async (serverTransferConnectChangeEmailReq?: ServerTransferConnectChangeEmailReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectChangeEmailReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectForgotPasswordReq} [serverTransferConnectForgotPasswordReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthForgotPost: async (serverTransferConnectForgotPasswordReq?: ServerTransferConnectForgotPasswordReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectForgotPasswordReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectChangeNameReq} [serverTransferConnectChangeNameReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthNamePost: async (serverTransferConnectChangeNameReq?: ServerTransferConnectChangeNameReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectChangeNameReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectChangePasswordReq} [serverTransferConnectChangePasswordReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthPasswordPost: async (serverTransferConnectChangePasswordReq?: ServerTransferConnectChangePasswordReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectChangePasswordReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectChangePhoneReq} [serverTransferConnectChangePhoneReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthPhonePost: async (serverTransferConnectChangePhoneReq?: ServerTransferConnectChangePhoneReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectChangePhoneReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectResetPasswordReq} [serverTransferConnectResetPasswordReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthResetPost: async (serverTransferConnectResetPasswordReq?: ServerTransferConnectResetPasswordReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectResetPasswordReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferConnectSignUpReq} [serverTransferConnectSignUpReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthSignupPost: async (serverTransferConnectSignUpReq?: ServerTransferConnectSignUpReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/auth/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferConnectSignUpReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectAuthApi - functional programming interface
 * @export
 */
export const ConnectAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerTransferConnectResetCodeCheckReq} [serverTransferConnectResetCodeCheckReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthCheckPost(serverTransferConnectResetCodeCheckReq?: ServerTransferConnectResetCodeCheckReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthCheckPost(serverTransferConnectResetCodeCheckReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthCheckPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthDeleteConfirmPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthDeleteConfirmPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthDeleteConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthDeletePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthDeletePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectChangeEmailReq} [serverTransferConnectChangeEmailReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthEmailPost(serverTransferConnectChangeEmailReq?: ServerTransferConnectChangeEmailReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthEmailPost(serverTransferConnectChangeEmailReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectForgotPasswordReq} [serverTransferConnectForgotPasswordReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthForgotPost(serverTransferConnectForgotPasswordReq?: ServerTransferConnectForgotPasswordReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthForgotPost(serverTransferConnectForgotPasswordReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthForgotPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectChangeNameReq} [serverTransferConnectChangeNameReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthNamePost(serverTransferConnectChangeNameReq?: ServerTransferConnectChangeNameReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthNamePost(serverTransferConnectChangeNameReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthNamePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectChangePasswordReq} [serverTransferConnectChangePasswordReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthPasswordPost(serverTransferConnectChangePasswordReq?: ServerTransferConnectChangePasswordReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthPasswordPost(serverTransferConnectChangePasswordReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectChangePhoneReq} [serverTransferConnectChangePhoneReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthPhonePost(serverTransferConnectChangePhoneReq?: ServerTransferConnectChangePhoneReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthPhonePost(serverTransferConnectChangePhoneReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthPhonePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectResetPasswordReq} [serverTransferConnectResetPasswordReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthResetPost(serverTransferConnectResetPasswordReq?: ServerTransferConnectResetPasswordReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthResetPost(serverTransferConnectResetPasswordReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferConnectSignUpReq} [serverTransferConnectSignUpReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectAuthSignupPost(serverTransferConnectSignUpReq?: ServerTransferConnectSignUpReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectAuthSignupPost(serverTransferConnectSignUpReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectAuthSignupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectAuthApi.connectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectAuthApi - factory interface
 * @export
 */
export const ConnectAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {ConnectAuthApiConnectAuthCheckPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthCheckPost(requestParameters: ConnectAuthApiConnectAuthCheckPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthCheckPost(requestParameters.serverTransferConnectResetCodeCheckReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthDeleteConfirmPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthDeleteConfirmPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthDeletePost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthDeletePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthEmailPost(requestParameters: ConnectAuthApiConnectAuthEmailPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthEmailPost(requestParameters.serverTransferConnectChangeEmailReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthForgotPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthForgotPost(requestParameters: ConnectAuthApiConnectAuthForgotPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthForgotPost(requestParameters.serverTransferConnectForgotPasswordReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthNamePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthNamePost(requestParameters: ConnectAuthApiConnectAuthNamePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthNamePost(requestParameters.serverTransferConnectChangeNameReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthPasswordPost(requestParameters: ConnectAuthApiConnectAuthPasswordPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthPasswordPost(requestParameters.serverTransferConnectChangePasswordReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthPhonePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthPhonePost(requestParameters: ConnectAuthApiConnectAuthPhonePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthPhonePost(requestParameters.serverTransferConnectChangePhoneReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthResetPost(requestParameters: ConnectAuthApiConnectAuthResetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthResetPost(requestParameters.serverTransferConnectResetPasswordReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectAuthApiConnectAuthSignupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectAuthSignupPost(requestParameters: ConnectAuthApiConnectAuthSignupPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectAuthSignupPost(requestParameters.serverTransferConnectSignUpReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for connectAuthCheckPost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthCheckPostRequest
 */
export interface ConnectAuthApiConnectAuthCheckPostRequest {
    /**
     * 
     * @type {ServerTransferConnectResetCodeCheckReq}
     * @memberof ConnectAuthApiConnectAuthCheckPost
     */
    readonly serverTransferConnectResetCodeCheckReq?: ServerTransferConnectResetCodeCheckReq
}

/**
 * Request parameters for connectAuthEmailPost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthEmailPostRequest
 */
export interface ConnectAuthApiConnectAuthEmailPostRequest {
    /**
     * 
     * @type {ServerTransferConnectChangeEmailReq}
     * @memberof ConnectAuthApiConnectAuthEmailPost
     */
    readonly serverTransferConnectChangeEmailReq?: ServerTransferConnectChangeEmailReq
}

/**
 * Request parameters for connectAuthForgotPost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthForgotPostRequest
 */
export interface ConnectAuthApiConnectAuthForgotPostRequest {
    /**
     * 
     * @type {ServerTransferConnectForgotPasswordReq}
     * @memberof ConnectAuthApiConnectAuthForgotPost
     */
    readonly serverTransferConnectForgotPasswordReq?: ServerTransferConnectForgotPasswordReq
}

/**
 * Request parameters for connectAuthNamePost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthNamePostRequest
 */
export interface ConnectAuthApiConnectAuthNamePostRequest {
    /**
     * 
     * @type {ServerTransferConnectChangeNameReq}
     * @memberof ConnectAuthApiConnectAuthNamePost
     */
    readonly serverTransferConnectChangeNameReq?: ServerTransferConnectChangeNameReq
}

/**
 * Request parameters for connectAuthPasswordPost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthPasswordPostRequest
 */
export interface ConnectAuthApiConnectAuthPasswordPostRequest {
    /**
     * 
     * @type {ServerTransferConnectChangePasswordReq}
     * @memberof ConnectAuthApiConnectAuthPasswordPost
     */
    readonly serverTransferConnectChangePasswordReq?: ServerTransferConnectChangePasswordReq
}

/**
 * Request parameters for connectAuthPhonePost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthPhonePostRequest
 */
export interface ConnectAuthApiConnectAuthPhonePostRequest {
    /**
     * 
     * @type {ServerTransferConnectChangePhoneReq}
     * @memberof ConnectAuthApiConnectAuthPhonePost
     */
    readonly serverTransferConnectChangePhoneReq?: ServerTransferConnectChangePhoneReq
}

/**
 * Request parameters for connectAuthResetPost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthResetPostRequest
 */
export interface ConnectAuthApiConnectAuthResetPostRequest {
    /**
     * 
     * @type {ServerTransferConnectResetPasswordReq}
     * @memberof ConnectAuthApiConnectAuthResetPost
     */
    readonly serverTransferConnectResetPasswordReq?: ServerTransferConnectResetPasswordReq
}

/**
 * Request parameters for connectAuthSignupPost operation in ConnectAuthApi.
 * @export
 * @interface ConnectAuthApiConnectAuthSignupPostRequest
 */
export interface ConnectAuthApiConnectAuthSignupPostRequest {
    /**
     * 
     * @type {ServerTransferConnectSignUpReq}
     * @memberof ConnectAuthApiConnectAuthSignupPost
     */
    readonly serverTransferConnectSignUpReq?: ServerTransferConnectSignUpReq
}

/**
 * ConnectAuthApi - object-oriented interface
 * @export
 * @class ConnectAuthApi
 * @extends {BaseAPI}
 */
export class ConnectAuthApi extends BaseAPI {
    /**
     * 
     * @param {ConnectAuthApiConnectAuthCheckPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthCheckPost(requestParameters: ConnectAuthApiConnectAuthCheckPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthCheckPost(requestParameters.serverTransferConnectResetCodeCheckReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthDeleteConfirmPost(options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthDeleteConfirmPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthDeletePost(options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthDeletePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthEmailPost(requestParameters: ConnectAuthApiConnectAuthEmailPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthEmailPost(requestParameters.serverTransferConnectChangeEmailReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthForgotPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthForgotPost(requestParameters: ConnectAuthApiConnectAuthForgotPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthForgotPost(requestParameters.serverTransferConnectForgotPasswordReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthGet(options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthLogoutPost(options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthNamePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthNamePost(requestParameters: ConnectAuthApiConnectAuthNamePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthNamePost(requestParameters.serverTransferConnectChangeNameReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthPasswordPost(requestParameters: ConnectAuthApiConnectAuthPasswordPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthPasswordPost(requestParameters.serverTransferConnectChangePasswordReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthPhonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthPhonePost(requestParameters: ConnectAuthApiConnectAuthPhonePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthPhonePost(requestParameters.serverTransferConnectChangePhoneReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthResetPost(requestParameters: ConnectAuthApiConnectAuthResetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthResetPost(requestParameters.serverTransferConnectResetPasswordReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectAuthApiConnectAuthSignupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectAuthSignupPost(requestParameters: ConnectAuthApiConnectAuthSignupPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectAuthSignupPost(requestParameters.serverTransferConnectSignUpReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectAuthApi
     */
    public connectGet(options?: RawAxiosRequestConfig) {
        return ConnectAuthApiFp(this.configuration).connectGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConnectDelegateApi - axios parameter creator
 * @export
 */
export const ConnectDelegateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsAcceptDelegateRequest} [serverRequestsAcceptDelegateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDelegate: async (serverRequestsAcceptDelegateRequest?: ServerRequestsAcceptDelegateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/delegate/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsAcceptDelegateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteInfo: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getInviteInfo', 'code', code)
            const localVarPath = `/connect/delegate/invite-info/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDelegates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/delegate/granted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDelegations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/delegate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsInviteDelegateRequest} [serverRequestsInviteDelegateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteDelegate: async (serverRequestsInviteDelegateRequest?: ServerRequestsInviteDelegateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connect/delegate/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsInviteDelegateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeDelegate: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeDelegate', 'id', id)
            const localVarPath = `/connect/delegate/revoke/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectDelegateApi - functional programming interface
 * @export
 */
export const ConnectDelegateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectDelegateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsAcceptDelegateRequest} [serverRequestsAcceptDelegateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptDelegate(serverRequestsAcceptDelegateRequest?: ServerRequestsAcceptDelegateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsAcceptDelegateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptDelegate(serverRequestsAcceptDelegateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectDelegateApi.acceptDelegate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInviteInfo(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsInviteInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInviteInfo(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectDelegateApi.getInviteInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyDelegates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetMyDelegatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyDelegates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectDelegateApi.getMyDelegates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyDelegations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetMyDelegationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyDelegations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectDelegateApi.getMyDelegations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsInviteDelegateRequest} [serverRequestsInviteDelegateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteDelegate(serverRequestsInviteDelegateRequest?: ServerRequestsInviteDelegateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsInviteDelegateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteDelegate(serverRequestsInviteDelegateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectDelegateApi.inviteDelegate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeDelegate(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeDelegate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectDelegateApi.revokeDelegate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectDelegateApi - factory interface
 * @export
 */
export const ConnectDelegateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectDelegateApiFp(configuration)
    return {
        /**
         * 
         * @param {ConnectDelegateApiAcceptDelegateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDelegate(requestParameters: ConnectDelegateApiAcceptDelegateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsAcceptDelegateResponse> {
            return localVarFp.acceptDelegate(requestParameters.serverRequestsAcceptDelegateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectDelegateApiGetInviteInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteInfo(requestParameters: ConnectDelegateApiGetInviteInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsInviteInfoResponse> {
            return localVarFp.getInviteInfo(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDelegates(options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetMyDelegatesResponse> {
            return localVarFp.getMyDelegates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDelegations(options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetMyDelegationsResponse> {
            return localVarFp.getMyDelegations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectDelegateApiInviteDelegateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteDelegate(requestParameters: ConnectDelegateApiInviteDelegateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsInviteDelegateResponse> {
            return localVarFp.inviteDelegate(requestParameters.serverRequestsInviteDelegateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConnectDelegateApiRevokeDelegateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeDelegate(requestParameters: ConnectDelegateApiRevokeDelegateRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.revokeDelegate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptDelegate operation in ConnectDelegateApi.
 * @export
 * @interface ConnectDelegateApiAcceptDelegateRequest
 */
export interface ConnectDelegateApiAcceptDelegateRequest {
    /**
     * 
     * @type {ServerRequestsAcceptDelegateRequest}
     * @memberof ConnectDelegateApiAcceptDelegate
     */
    readonly serverRequestsAcceptDelegateRequest?: ServerRequestsAcceptDelegateRequest
}

/**
 * Request parameters for getInviteInfo operation in ConnectDelegateApi.
 * @export
 * @interface ConnectDelegateApiGetInviteInfoRequest
 */
export interface ConnectDelegateApiGetInviteInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectDelegateApiGetInviteInfo
     */
    readonly code: string
}

/**
 * Request parameters for inviteDelegate operation in ConnectDelegateApi.
 * @export
 * @interface ConnectDelegateApiInviteDelegateRequest
 */
export interface ConnectDelegateApiInviteDelegateRequest {
    /**
     * 
     * @type {ServerRequestsInviteDelegateRequest}
     * @memberof ConnectDelegateApiInviteDelegate
     */
    readonly serverRequestsInviteDelegateRequest?: ServerRequestsInviteDelegateRequest
}

/**
 * Request parameters for revokeDelegate operation in ConnectDelegateApi.
 * @export
 * @interface ConnectDelegateApiRevokeDelegateRequest
 */
export interface ConnectDelegateApiRevokeDelegateRequest {
    /**
     * 
     * @type {number}
     * @memberof ConnectDelegateApiRevokeDelegate
     */
    readonly id: number
}

/**
 * ConnectDelegateApi - object-oriented interface
 * @export
 * @class ConnectDelegateApi
 * @extends {BaseAPI}
 */
export class ConnectDelegateApi extends BaseAPI {
    /**
     * 
     * @param {ConnectDelegateApiAcceptDelegateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectDelegateApi
     */
    public acceptDelegate(requestParameters: ConnectDelegateApiAcceptDelegateRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectDelegateApiFp(this.configuration).acceptDelegate(requestParameters.serverRequestsAcceptDelegateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectDelegateApiGetInviteInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectDelegateApi
     */
    public getInviteInfo(requestParameters: ConnectDelegateApiGetInviteInfoRequest, options?: RawAxiosRequestConfig) {
        return ConnectDelegateApiFp(this.configuration).getInviteInfo(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectDelegateApi
     */
    public getMyDelegates(options?: RawAxiosRequestConfig) {
        return ConnectDelegateApiFp(this.configuration).getMyDelegates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectDelegateApi
     */
    public getMyDelegations(options?: RawAxiosRequestConfig) {
        return ConnectDelegateApiFp(this.configuration).getMyDelegations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectDelegateApiInviteDelegateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectDelegateApi
     */
    public inviteDelegate(requestParameters: ConnectDelegateApiInviteDelegateRequest = {}, options?: RawAxiosRequestConfig) {
        return ConnectDelegateApiFp(this.configuration).inviteDelegate(requestParameters.serverRequestsInviteDelegateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConnectDelegateApiRevokeDelegateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectDelegateApi
     */
    public revokeDelegate(requestParameters: ConnectDelegateApiRevokeDelegateRequest, options?: RawAxiosRequestConfig) {
        return ConnectDelegateApiFp(this.configuration).revokeDelegate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractsRuleApi - axios parameter creator
 * @export
 */
export const ContractsRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsContractsRuleSaveRequest} [serverRequestsContractsRuleSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsRulePost: async (serverRequestsContractsRuleSaveRequest?: ServerRequestsContractsRuleSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contracts-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsContractsRuleSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsRuleSubscriptionGroupIdDelete: async (subscriptionGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionGroupId' is not null or undefined
            assertParamExists('contractsRuleSubscriptionGroupIdDelete', 'subscriptionGroupId', subscriptionGroupId)
            const localVarPath = `/contracts-rule/{subscriptionGroupId}`
                .replace(`{${"subscriptionGroupId"}}`, encodeURIComponent(String(subscriptionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsRuleSubscriptionGroupIdGet: async (subscriptionGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionGroupId' is not null or undefined
            assertParamExists('contractsRuleSubscriptionGroupIdGet', 'subscriptionGroupId', subscriptionGroupId)
            const localVarPath = `/contracts-rule/{subscriptionGroupId}`
                .replace(`{${"subscriptionGroupId"}}`, encodeURIComponent(String(subscriptionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsRuleApi - functional programming interface
 * @export
 */
export const ContractsRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsContractsRuleSaveRequest} [serverRequestsContractsRuleSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractsRulePost(serverRequestsContractsRuleSaveRequest?: ServerRequestsContractsRuleSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsContractRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractsRulePost(serverRequestsContractsRuleSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsRuleApi.contractsRulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractsRuleSubscriptionGroupIdDelete(subscriptionGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsContractRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractsRuleSubscriptionGroupIdDelete(subscriptionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsRuleApi.contractsRuleSubscriptionGroupIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractsRuleSubscriptionGroupIdGet(subscriptionGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsContractRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractsRuleSubscriptionGroupIdGet(subscriptionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsRuleApi.contractsRuleSubscriptionGroupIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractsRuleApi - factory interface
 * @export
 */
export const ContractsRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsRuleApiFp(configuration)
    return {
        /**
         * 
         * @param {ContractsRuleApiContractsRulePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsRulePost(requestParameters: ContractsRuleApiContractsRulePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsContractRulesResponse> {
            return localVarFp.contractsRulePost(requestParameters.serverRequestsContractsRuleSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsRuleApiContractsRuleSubscriptionGroupIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsRuleSubscriptionGroupIdDelete(requestParameters: ContractsRuleApiContractsRuleSubscriptionGroupIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsContractRulesResponse> {
            return localVarFp.contractsRuleSubscriptionGroupIdDelete(requestParameters.subscriptionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsRuleApiContractsRuleSubscriptionGroupIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsRuleSubscriptionGroupIdGet(requestParameters: ContractsRuleApiContractsRuleSubscriptionGroupIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsContractRulesResponse> {
            return localVarFp.contractsRuleSubscriptionGroupIdGet(requestParameters.subscriptionGroupId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for contractsRulePost operation in ContractsRuleApi.
 * @export
 * @interface ContractsRuleApiContractsRulePostRequest
 */
export interface ContractsRuleApiContractsRulePostRequest {
    /**
     * 
     * @type {ServerRequestsContractsRuleSaveRequest}
     * @memberof ContractsRuleApiContractsRulePost
     */
    readonly serverRequestsContractsRuleSaveRequest?: ServerRequestsContractsRuleSaveRequest
}

/**
 * Request parameters for contractsRuleSubscriptionGroupIdDelete operation in ContractsRuleApi.
 * @export
 * @interface ContractsRuleApiContractsRuleSubscriptionGroupIdDeleteRequest
 */
export interface ContractsRuleApiContractsRuleSubscriptionGroupIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractsRuleApiContractsRuleSubscriptionGroupIdDelete
     */
    readonly subscriptionGroupId: number
}

/**
 * Request parameters for contractsRuleSubscriptionGroupIdGet operation in ContractsRuleApi.
 * @export
 * @interface ContractsRuleApiContractsRuleSubscriptionGroupIdGetRequest
 */
export interface ContractsRuleApiContractsRuleSubscriptionGroupIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractsRuleApiContractsRuleSubscriptionGroupIdGet
     */
    readonly subscriptionGroupId: number
}

/**
 * ContractsRuleApi - object-oriented interface
 * @export
 * @class ContractsRuleApi
 * @extends {BaseAPI}
 */
export class ContractsRuleApi extends BaseAPI {
    /**
     * 
     * @param {ContractsRuleApiContractsRulePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsRuleApi
     */
    public contractsRulePost(requestParameters: ContractsRuleApiContractsRulePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ContractsRuleApiFp(this.configuration).contractsRulePost(requestParameters.serverRequestsContractsRuleSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsRuleApiContractsRuleSubscriptionGroupIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsRuleApi
     */
    public contractsRuleSubscriptionGroupIdDelete(requestParameters: ContractsRuleApiContractsRuleSubscriptionGroupIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ContractsRuleApiFp(this.configuration).contractsRuleSubscriptionGroupIdDelete(requestParameters.subscriptionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsRuleApiContractsRuleSubscriptionGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsRuleApi
     */
    public contractsRuleSubscriptionGroupIdGet(requestParameters: ContractsRuleApiContractsRuleSubscriptionGroupIdGetRequest, options?: RawAxiosRequestConfig) {
        return ContractsRuleApiFp(this.configuration).contractsRuleSubscriptionGroupIdGet(requestParameters.subscriptionGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomReportsApi - axios parameter creator
 * @export
 */
export const CustomReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerTransferAddSavedReportRequest} [serverTransferAddSavedReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsAddSavedReportPost: async (serverTransferAddSavedReportRequest?: ServerTransferAddSavedReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/custom-reports/add-saved-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferAddSavedReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} definitionId 
         * @param {ServerTransferCustomReportGenerateRequest} [serverTransferCustomReportGenerateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsDefinitionIdRequestEmailPost: async (definitionId: number, serverTransferCustomReportGenerateRequest?: ServerTransferCustomReportGenerateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('monitorCustomReportsDefinitionIdRequestEmailPost', 'definitionId', definitionId)
            const localVarPath = `/monitor/custom-reports/{definitionId}/request-email`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferCustomReportGenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsDefinitionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/custom-reports/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsHasCustomReportsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/custom-reports/has-custom-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} savedReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsSavedReportSavedReportIdDelete: async (savedReportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedReportId' is not null or undefined
            assertParamExists('monitorCustomReportsSavedReportSavedReportIdDelete', 'savedReportId', savedReportId)
            const localVarPath = `/monitor/custom-reports/saved-report/{savedReportId}`
                .replace(`{${"savedReportId"}}`, encodeURIComponent(String(savedReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsSavedReportsGet: async (facilityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/custom-reports/saved-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomReportsApi - functional programming interface
 * @export
 */
export const CustomReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerTransferAddSavedReportRequest} [serverTransferAddSavedReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorCustomReportsAddSavedReportPost(serverTransferAddSavedReportRequest?: ServerTransferAddSavedReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferSavedReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorCustomReportsAddSavedReportPost(serverTransferAddSavedReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomReportsApi.monitorCustomReportsAddSavedReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} definitionId 
         * @param {ServerTransferCustomReportGenerateRequest} [serverTransferCustomReportGenerateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorCustomReportsDefinitionIdRequestEmailPost(definitionId: number, serverTransferCustomReportGenerateRequest?: ServerTransferCustomReportGenerateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorCustomReportsDefinitionIdRequestEmailPost(definitionId, serverTransferCustomReportGenerateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomReportsApi.monitorCustomReportsDefinitionIdRequestEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorCustomReportsDefinitionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferCustomReportDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorCustomReportsDefinitionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomReportsApi.monitorCustomReportsDefinitionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorCustomReportsHasCustomReportsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorCustomReportsHasCustomReportsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomReportsApi.monitorCustomReportsHasCustomReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} savedReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorCustomReportsSavedReportSavedReportIdDelete(savedReportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorCustomReportsSavedReportSavedReportIdDelete(savedReportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomReportsApi.monitorCustomReportsSavedReportSavedReportIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorCustomReportsSavedReportsGet(facilityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferSavedReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorCustomReportsSavedReportsGet(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomReportsApi.monitorCustomReportsSavedReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomReportsApi - factory interface
 * @export
 */
export const CustomReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomReportsApiMonitorCustomReportsAddSavedReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsAddSavedReportPost(requestParameters: CustomReportsApiMonitorCustomReportsAddSavedReportPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferSavedReportResponse> {
            return localVarFp.monitorCustomReportsAddSavedReportPost(requestParameters.serverTransferAddSavedReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsDefinitionIdRequestEmailPost(requestParameters: CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.monitorCustomReportsDefinitionIdRequestEmailPost(requestParameters.definitionId, requestParameters.serverTransferCustomReportGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsDefinitionsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferCustomReportDefinitionResponse>> {
            return localVarFp.monitorCustomReportsDefinitionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsHasCustomReportsGet(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.monitorCustomReportsHasCustomReportsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsSavedReportSavedReportIdDelete(requestParameters: CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.monitorCustomReportsSavedReportSavedReportIdDelete(requestParameters.savedReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomReportsApiMonitorCustomReportsSavedReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCustomReportsSavedReportsGet(requestParameters: CustomReportsApiMonitorCustomReportsSavedReportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferSavedReportResponse>> {
            return localVarFp.monitorCustomReportsSavedReportsGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for monitorCustomReportsAddSavedReportPost operation in CustomReportsApi.
 * @export
 * @interface CustomReportsApiMonitorCustomReportsAddSavedReportPostRequest
 */
export interface CustomReportsApiMonitorCustomReportsAddSavedReportPostRequest {
    /**
     * 
     * @type {ServerTransferAddSavedReportRequest}
     * @memberof CustomReportsApiMonitorCustomReportsAddSavedReportPost
     */
    readonly serverTransferAddSavedReportRequest?: ServerTransferAddSavedReportRequest
}

/**
 * Request parameters for monitorCustomReportsDefinitionIdRequestEmailPost operation in CustomReportsApi.
 * @export
 * @interface CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPostRequest
 */
export interface CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPostRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPost
     */
    readonly definitionId: number

    /**
     * 
     * @type {ServerTransferCustomReportGenerateRequest}
     * @memberof CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPost
     */
    readonly serverTransferCustomReportGenerateRequest?: ServerTransferCustomReportGenerateRequest
}

/**
 * Request parameters for monitorCustomReportsSavedReportSavedReportIdDelete operation in CustomReportsApi.
 * @export
 * @interface CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDeleteRequest
 */
export interface CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDelete
     */
    readonly savedReportId: number
}

/**
 * Request parameters for monitorCustomReportsSavedReportsGet operation in CustomReportsApi.
 * @export
 * @interface CustomReportsApiMonitorCustomReportsSavedReportsGetRequest
 */
export interface CustomReportsApiMonitorCustomReportsSavedReportsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomReportsApiMonitorCustomReportsSavedReportsGet
     */
    readonly facilityId?: number
}

/**
 * CustomReportsApi - object-oriented interface
 * @export
 * @class CustomReportsApi
 * @extends {BaseAPI}
 */
export class CustomReportsApi extends BaseAPI {
    /**
     * 
     * @param {CustomReportsApiMonitorCustomReportsAddSavedReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomReportsApi
     */
    public monitorCustomReportsAddSavedReportPost(requestParameters: CustomReportsApiMonitorCustomReportsAddSavedReportPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomReportsApiFp(this.configuration).monitorCustomReportsAddSavedReportPost(requestParameters.serverTransferAddSavedReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomReportsApi
     */
    public monitorCustomReportsDefinitionIdRequestEmailPost(requestParameters: CustomReportsApiMonitorCustomReportsDefinitionIdRequestEmailPostRequest, options?: RawAxiosRequestConfig) {
        return CustomReportsApiFp(this.configuration).monitorCustomReportsDefinitionIdRequestEmailPost(requestParameters.definitionId, requestParameters.serverTransferCustomReportGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomReportsApi
     */
    public monitorCustomReportsDefinitionsGet(options?: RawAxiosRequestConfig) {
        return CustomReportsApiFp(this.configuration).monitorCustomReportsDefinitionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomReportsApi
     */
    public monitorCustomReportsHasCustomReportsGet(options?: RawAxiosRequestConfig) {
        return CustomReportsApiFp(this.configuration).monitorCustomReportsHasCustomReportsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomReportsApi
     */
    public monitorCustomReportsSavedReportSavedReportIdDelete(requestParameters: CustomReportsApiMonitorCustomReportsSavedReportSavedReportIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CustomReportsApiFp(this.configuration).monitorCustomReportsSavedReportSavedReportIdDelete(requestParameters.savedReportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomReportsApiMonitorCustomReportsSavedReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomReportsApi
     */
    public monitorCustomReportsSavedReportsGet(requestParameters: CustomReportsApiMonitorCustomReportsSavedReportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomReportsApiFp(this.configuration).monitorCustomReportsSavedReportsGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FacilityApi - axios parameter creator
 * @export
 */
export const FacilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateFacilityIntegration: async (facilityId: number, integrationPartyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('activateFacilityIntegration', 'facilityId', facilityId)
            // verify required parameter 'integrationPartyId' is not null or undefined
            assertParamExists('activateFacilityIntegration', 'integrationPartyId', integrationPartyId)
            const localVarPath = `/facility/{facilityId}/integrations/{integrationPartyId}/activate`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"integrationPartyId"}}`, encodeURIComponent(String(integrationPartyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacilityIntegration: async (facilityId: number, integrationPartyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('addFacilityIntegration', 'facilityId', facilityId)
            // verify required parameter 'integrationPartyId' is not null or undefined
            assertParamExists('addFacilityIntegration', 'integrationPartyId', integrationPartyId)
            const localVarPath = `/facility/{facilityId}/integrations/{integrationPartyId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"integrationPartyId"}}`, encodeURIComponent(String(integrationPartyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateFacilityIntegration: async (facilityId: number, integrationPartyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('deactivateFacilityIntegration', 'facilityId', facilityId)
            // verify required parameter 'integrationPartyId' is not null or undefined
            assertParamExists('deactivateFacilityIntegration', 'integrationPartyId', integrationPartyId)
            const localVarPath = `/facility/{facilityId}/integrations/{integrationPartyId}/deactivate`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"integrationPartyId"}}`, encodeURIComponent(String(integrationPartyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [daysBack] 
         * @param {boolean} [isInitialLoad] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitiesDashboard: async (daysBack?: number, isInitialLoad?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (daysBack !== undefined) {
                localVarQueryParameter['daysBack'] = daysBack;
            }

            if (isInitialLoad !== undefined) {
                localVarQueryParameter['isInitialLoad'] = isInitialLoad;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitiesStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacility: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacility', 'facilityId', facilityId)
            const localVarPath = `/facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityIntegrations: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacilityIntegrations', 'facilityId', facilityId)
            const localVarPath = `/facility/{facilityId}/integrations`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityPayoutAccountAsync: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacilityPayoutAccountAsync', 'facilityId', facilityId)
            const localVarPath = `/facility/{facilityId}/payout-account`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [operatorId] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilities: async (operatorId?: number, pageSize?: number, pageNumber?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['Pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [operatorId] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitiesLite: async (operatorId?: number, pageSize?: number, pageNumber?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility/lite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['Pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFacilityIntegration: async (facilityId: number, integrationPartyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('removeFacilityIntegration', 'facilityId', facilityId)
            // verify required parameter 'integrationPartyId' is not null or undefined
            assertParamExists('removeFacilityIntegration', 'integrationPartyId', integrationPartyId)
            const localVarPath = `/facility/{facilityId}/integrations/{integrationPartyId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"integrationPartyId"}}`, encodeURIComponent(String(integrationPartyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilityApi - functional programming interface
 * @export
 */
export const FacilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateFacilityIntegration(facilityId: number, integrationPartyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateFacilityIntegration(facilityId, integrationPartyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.activateFacilityIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFacilityIntegration(facilityId: number, integrationPartyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFacilityIntegration(facilityId, integrationPartyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.addFacilityIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateFacilityIntegration(facilityId: number, integrationPartyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateFacilityIntegration(facilityId, integrationPartyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.deactivateFacilityIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [daysBack] 
         * @param {boolean} [isInitialLoad] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitiesDashboard(daysBack?: number, isInitialLoad?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferDashboardStats>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitiesDashboard(daysBack, isInitialLoad, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.getFacilitiesDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitiesStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferFacilityStats>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitiesStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.getFacilitiesStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacility(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferFacility>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacility(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.getFacility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilityIntegrations(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataEntitiesFacilityIntegrationParty>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilityIntegrations(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.getFacilityIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilityPayoutAccountAsync(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferConnectedAccountDropdown>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilityPayoutAccountAsync(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.getFacilityPayoutAccountAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [operatorId] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFacilities(operatorId?: number, pageSize?: number, pageNumber?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFacilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFacilities(operatorId, pageSize, pageNumber, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.listFacilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [operatorId] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFacilitiesLite(operatorId?: number, pageSize?: number, pageNumber?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFacilitiesLiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFacilitiesLite(operatorId, pageSize, pageNumber, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.listFacilitiesLite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} integrationPartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFacilityIntegration(facilityId: number, integrationPartyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFacilityIntegration(facilityId, integrationPartyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilityApi.removeFacilityIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacilityApi - factory interface
 * @export
 */
export const FacilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilityApiFp(configuration)
    return {
        /**
         * 
         * @param {FacilityApiActivateFacilityIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateFacilityIntegration(requestParameters: FacilityApiActivateFacilityIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.activateFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiAddFacilityIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacilityIntegration(requestParameters: FacilityApiAddFacilityIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiDeactivateFacilityIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateFacilityIntegration(requestParameters: FacilityApiDeactivateFacilityIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiGetFacilitiesDashboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitiesDashboard(requestParameters: FacilityApiGetFacilitiesDashboardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferDashboardStats>> {
            return localVarFp.getFacilitiesDashboard(requestParameters.daysBack, requestParameters.isInitialLoad, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitiesStats(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferFacilityStats>> {
            return localVarFp.getFacilitiesStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiGetFacilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacility(requestParameters: FacilityApiGetFacilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferFacility> {
            return localVarFp.getFacility(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiGetFacilityIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityIntegrations(requestParameters: FacilityApiGetFacilityIntegrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataEntitiesFacilityIntegrationParty>> {
            return localVarFp.getFacilityIntegrations(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiGetFacilityPayoutAccountAsyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityPayoutAccountAsync(requestParameters: FacilityApiGetFacilityPayoutAccountAsyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferConnectedAccountDropdown> {
            return localVarFp.getFacilityPayoutAccountAsync(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiListFacilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilities(requestParameters: FacilityApiListFacilitiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFacilitiesResponse> {
            return localVarFp.listFacilities(requestParameters.operatorId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiListFacilitiesLiteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitiesLite(requestParameters: FacilityApiListFacilitiesLiteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFacilitiesLiteResponse> {
            return localVarFp.listFacilitiesLite(requestParameters.operatorId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityApiRemoveFacilityIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFacilityIntegration(requestParameters: FacilityApiRemoveFacilityIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateFacilityIntegration operation in FacilityApi.
 * @export
 * @interface FacilityApiActivateFacilityIntegrationRequest
 */
export interface FacilityApiActivateFacilityIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiActivateFacilityIntegration
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiActivateFacilityIntegration
     */
    readonly integrationPartyId: number
}

/**
 * Request parameters for addFacilityIntegration operation in FacilityApi.
 * @export
 * @interface FacilityApiAddFacilityIntegrationRequest
 */
export interface FacilityApiAddFacilityIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiAddFacilityIntegration
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiAddFacilityIntegration
     */
    readonly integrationPartyId: number
}

/**
 * Request parameters for deactivateFacilityIntegration operation in FacilityApi.
 * @export
 * @interface FacilityApiDeactivateFacilityIntegrationRequest
 */
export interface FacilityApiDeactivateFacilityIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiDeactivateFacilityIntegration
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiDeactivateFacilityIntegration
     */
    readonly integrationPartyId: number
}

/**
 * Request parameters for getFacilitiesDashboard operation in FacilityApi.
 * @export
 * @interface FacilityApiGetFacilitiesDashboardRequest
 */
export interface FacilityApiGetFacilitiesDashboardRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiGetFacilitiesDashboard
     */
    readonly daysBack?: number

    /**
     * 
     * @type {boolean}
     * @memberof FacilityApiGetFacilitiesDashboard
     */
    readonly isInitialLoad?: boolean
}

/**
 * Request parameters for getFacility operation in FacilityApi.
 * @export
 * @interface FacilityApiGetFacilityRequest
 */
export interface FacilityApiGetFacilityRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiGetFacility
     */
    readonly facilityId: number
}

/**
 * Request parameters for getFacilityIntegrations operation in FacilityApi.
 * @export
 * @interface FacilityApiGetFacilityIntegrationsRequest
 */
export interface FacilityApiGetFacilityIntegrationsRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiGetFacilityIntegrations
     */
    readonly facilityId: number
}

/**
 * Request parameters for getFacilityPayoutAccountAsync operation in FacilityApi.
 * @export
 * @interface FacilityApiGetFacilityPayoutAccountAsyncRequest
 */
export interface FacilityApiGetFacilityPayoutAccountAsyncRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiGetFacilityPayoutAccountAsync
     */
    readonly facilityId: number
}

/**
 * Request parameters for listFacilities operation in FacilityApi.
 * @export
 * @interface FacilityApiListFacilitiesRequest
 */
export interface FacilityApiListFacilitiesRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiListFacilities
     */
    readonly operatorId?: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiListFacilities
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiListFacilities
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof FacilityApiListFacilities
     */
    readonly pagination?: boolean
}

/**
 * Request parameters for listFacilitiesLite operation in FacilityApi.
 * @export
 * @interface FacilityApiListFacilitiesLiteRequest
 */
export interface FacilityApiListFacilitiesLiteRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiListFacilitiesLite
     */
    readonly operatorId?: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiListFacilitiesLite
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiListFacilitiesLite
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof FacilityApiListFacilitiesLite
     */
    readonly pagination?: boolean
}

/**
 * Request parameters for removeFacilityIntegration operation in FacilityApi.
 * @export
 * @interface FacilityApiRemoveFacilityIntegrationRequest
 */
export interface FacilityApiRemoveFacilityIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof FacilityApiRemoveFacilityIntegration
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof FacilityApiRemoveFacilityIntegration
     */
    readonly integrationPartyId: number
}

/**
 * FacilityApi - object-oriented interface
 * @export
 * @class FacilityApi
 * @extends {BaseAPI}
 */
export class FacilityApi extends BaseAPI {
    /**
     * 
     * @param {FacilityApiActivateFacilityIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public activateFacilityIntegration(requestParameters: FacilityApiActivateFacilityIntegrationRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).activateFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiAddFacilityIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public addFacilityIntegration(requestParameters: FacilityApiAddFacilityIntegrationRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).addFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiDeactivateFacilityIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public deactivateFacilityIntegration(requestParameters: FacilityApiDeactivateFacilityIntegrationRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).deactivateFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiGetFacilitiesDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public getFacilitiesDashboard(requestParameters: FacilityApiGetFacilitiesDashboardRequest = {}, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).getFacilitiesDashboard(requestParameters.daysBack, requestParameters.isInitialLoad, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public getFacilitiesStats(options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).getFacilitiesStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiGetFacilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public getFacility(requestParameters: FacilityApiGetFacilityRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).getFacility(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiGetFacilityIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public getFacilityIntegrations(requestParameters: FacilityApiGetFacilityIntegrationsRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).getFacilityIntegrations(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiGetFacilityPayoutAccountAsyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public getFacilityPayoutAccountAsync(requestParameters: FacilityApiGetFacilityPayoutAccountAsyncRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).getFacilityPayoutAccountAsync(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiListFacilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public listFacilities(requestParameters: FacilityApiListFacilitiesRequest = {}, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).listFacilities(requestParameters.operatorId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiListFacilitiesLiteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public listFacilitiesLite(requestParameters: FacilityApiListFacilitiesLiteRequest = {}, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).listFacilitiesLite(requestParameters.operatorId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityApiRemoveFacilityIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityApi
     */
    public removeFacilityIntegration(requestParameters: FacilityApiRemoveFacilityIntegrationRequest, options?: RawAxiosRequestConfig) {
        return FacilityApiFp(this.configuration).removeFacilityIntegration(requestParameters.facilityId, requestParameters.integrationPartyId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeesApi - axios parameter creator
 * @export
 */
export const FeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFee: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelFee', 'id', id)
            const localVarPath = `/fees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsCreateFeeRequest} [serverRequestsCreateFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFee: async (serverRequestsCreateFeeRequest?: ServerRequestsCreateFeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFee: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFee', 'id', id)
            const localVarPath = `/fees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {DataEntitiesFinanceOperatorFeeScope} [feeScope] 
         * @param {DataEntitiesFinanceOperatorFeePaymentType} [feePaymentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptInFees: async (facilityId?: number, feeScope?: DataEntitiesFinanceOperatorFeeScope, feePaymentType?: DataEntitiesFinanceOperatorFeePaymentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fees/optin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (feeScope !== undefined) {
                localVarQueryParameter['FeeScope'] = feeScope;
            }

            if (feePaymentType !== undefined) {
                localVarQueryParameter['FeePaymentType'] = feePaymentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [operatorId] 
         * @param {number} [facilityId] 
         * @param {DataEntitiesFinanceOperatorFeeScope} [feeScope] 
         * @param {DataEntitiesFinanceOperatorFeePaymentType} [paymentType] 
         * @param {boolean} [isAppliedToParker] 
         * @param {boolean} [isActive] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFees: async (operatorId?: number, facilityId?: number, feeScope?: DataEntitiesFinanceOperatorFeeScope, paymentType?: DataEntitiesFinanceOperatorFeePaymentType, isAppliedToParker?: boolean, isActive?: boolean, pageSize?: number, pageNumber?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (feeScope !== undefined) {
                localVarQueryParameter['FeeScope'] = feeScope;
            }

            if (paymentType !== undefined) {
                localVarQueryParameter['PaymentType'] = paymentType;
            }

            if (isAppliedToParker !== undefined) {
                localVarQueryParameter['IsAppliedToParker'] = isAppliedToParker;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['Pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCalculation: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('testCalculation', 'facilityId', facilityId)
            const localVarPath = `/fees/test-calculation/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsUpdateFeeRequest} [serverRequestsUpdateFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFee: async (id: number, serverRequestsUpdateFeeRequest?: ServerRequestsUpdateFeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFee', 'id', id)
            const localVarPath = `/fees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsUpdateFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeesApi - functional programming interface
 * @export
 */
export const FeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelFee(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCancelFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelFee(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.cancelFee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsCreateFeeRequest} [serverRequestsCreateFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFee(serverRequestsCreateFeeRequest?: ServerRequestsCreateFeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCreateFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFee(serverRequestsCreateFeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.createFee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFee(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFee(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.getFee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {DataEntitiesFinanceOperatorFeeScope} [feeScope] 
         * @param {DataEntitiesFinanceOperatorFeePaymentType} [feePaymentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptInFees(facilityId?: number, feeScope?: DataEntitiesFinanceOperatorFeeScope, feePaymentType?: DataEntitiesFinanceOperatorFeePaymentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetOptInFeesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptInFees(facilityId, feeScope, feePaymentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.getOptInFees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [operatorId] 
         * @param {number} [facilityId] 
         * @param {DataEntitiesFinanceOperatorFeeScope} [feeScope] 
         * @param {DataEntitiesFinanceOperatorFeePaymentType} [paymentType] 
         * @param {boolean} [isAppliedToParker] 
         * @param {boolean} [isActive] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFees(operatorId?: number, facilityId?: number, feeScope?: DataEntitiesFinanceOperatorFeeScope, paymentType?: DataEntitiesFinanceOperatorFeePaymentType, isAppliedToParker?: boolean, isActive?: boolean, pageSize?: number, pageNumber?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFeesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFees(operatorId, facilityId, feeScope, paymentType, isAppliedToParker, isActive, pageSize, pageNumber, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.listFees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCalculation(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsFeeCalculationTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCalculation(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.testCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsUpdateFeeRequest} [serverRequestsUpdateFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFee(id: number, serverRequestsUpdateFeeRequest?: ServerRequestsUpdateFeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUpdateFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFee(id, serverRequestsUpdateFeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeesApi.updateFee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeesApi - factory interface
 * @export
 */
export const FeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeesApiFp(configuration)
    return {
        /**
         * 
         * @param {FeesApiCancelFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFee(requestParameters: FeesApiCancelFeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCancelFeeResponse> {
            return localVarFp.cancelFee(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FeesApiCreateFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFee(requestParameters: FeesApiCreateFeeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCreateFeeResponse> {
            return localVarFp.createFee(requestParameters.serverRequestsCreateFeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FeesApiGetFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFee(requestParameters: FeesApiGetFeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFeeResponse> {
            return localVarFp.getFee(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FeesApiGetOptInFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptInFees(requestParameters: FeesApiGetOptInFeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetOptInFeesResponse> {
            return localVarFp.getOptInFees(requestParameters.facilityId, requestParameters.feeScope, requestParameters.feePaymentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FeesApiListFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFees(requestParameters: FeesApiListFeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFeesResponse> {
            return localVarFp.listFees(requestParameters.operatorId, requestParameters.facilityId, requestParameters.feeScope, requestParameters.paymentType, requestParameters.isAppliedToParker, requestParameters.isActive, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FeesApiTestCalculationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCalculation(requestParameters: FeesApiTestCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsFeeCalculationTestResponse> {
            return localVarFp.testCalculation(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FeesApiUpdateFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFee(requestParameters: FeesApiUpdateFeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUpdateFeeResponse> {
            return localVarFp.updateFee(requestParameters.id, requestParameters.serverRequestsUpdateFeeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelFee operation in FeesApi.
 * @export
 * @interface FeesApiCancelFeeRequest
 */
export interface FeesApiCancelFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof FeesApiCancelFee
     */
    readonly id: number
}

/**
 * Request parameters for createFee operation in FeesApi.
 * @export
 * @interface FeesApiCreateFeeRequest
 */
export interface FeesApiCreateFeeRequest {
    /**
     * 
     * @type {ServerRequestsCreateFeeRequest}
     * @memberof FeesApiCreateFee
     */
    readonly serverRequestsCreateFeeRequest?: ServerRequestsCreateFeeRequest
}

/**
 * Request parameters for getFee operation in FeesApi.
 * @export
 * @interface FeesApiGetFeeRequest
 */
export interface FeesApiGetFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof FeesApiGetFee
     */
    readonly id: number
}

/**
 * Request parameters for getOptInFees operation in FeesApi.
 * @export
 * @interface FeesApiGetOptInFeesRequest
 */
export interface FeesApiGetOptInFeesRequest {
    /**
     * 
     * @type {number}
     * @memberof FeesApiGetOptInFees
     */
    readonly facilityId?: number

    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof FeesApiGetOptInFees
     */
    readonly feeScope?: DataEntitiesFinanceOperatorFeeScope

    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof FeesApiGetOptInFees
     */
    readonly feePaymentType?: DataEntitiesFinanceOperatorFeePaymentType
}

/**
 * Request parameters for listFees operation in FeesApi.
 * @export
 * @interface FeesApiListFeesRequest
 */
export interface FeesApiListFeesRequest {
    /**
     * 
     * @type {number}
     * @memberof FeesApiListFees
     */
    readonly operatorId?: number

    /**
     * 
     * @type {number}
     * @memberof FeesApiListFees
     */
    readonly facilityId?: number

    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeeScope}
     * @memberof FeesApiListFees
     */
    readonly feeScope?: DataEntitiesFinanceOperatorFeeScope

    /**
     * 
     * @type {DataEntitiesFinanceOperatorFeePaymentType}
     * @memberof FeesApiListFees
     */
    readonly paymentType?: DataEntitiesFinanceOperatorFeePaymentType

    /**
     * 
     * @type {boolean}
     * @memberof FeesApiListFees
     */
    readonly isAppliedToParker?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof FeesApiListFees
     */
    readonly isActive?: boolean

    /**
     * 
     * @type {number}
     * @memberof FeesApiListFees
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof FeesApiListFees
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof FeesApiListFees
     */
    readonly pagination?: boolean
}

/**
 * Request parameters for testCalculation operation in FeesApi.
 * @export
 * @interface FeesApiTestCalculationRequest
 */
export interface FeesApiTestCalculationRequest {
    /**
     * 
     * @type {number}
     * @memberof FeesApiTestCalculation
     */
    readonly facilityId: number
}

/**
 * Request parameters for updateFee operation in FeesApi.
 * @export
 * @interface FeesApiUpdateFeeRequest
 */
export interface FeesApiUpdateFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof FeesApiUpdateFee
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsUpdateFeeRequest}
     * @memberof FeesApiUpdateFee
     */
    readonly serverRequestsUpdateFeeRequest?: ServerRequestsUpdateFeeRequest
}

/**
 * FeesApi - object-oriented interface
 * @export
 * @class FeesApi
 * @extends {BaseAPI}
 */
export class FeesApi extends BaseAPI {
    /**
     * 
     * @param {FeesApiCancelFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public cancelFee(requestParameters: FeesApiCancelFeeRequest, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).cancelFee(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FeesApiCreateFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public createFee(requestParameters: FeesApiCreateFeeRequest = {}, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).createFee(requestParameters.serverRequestsCreateFeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FeesApiGetFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public getFee(requestParameters: FeesApiGetFeeRequest, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).getFee(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FeesApiGetOptInFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public getOptInFees(requestParameters: FeesApiGetOptInFeesRequest = {}, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).getOptInFees(requestParameters.facilityId, requestParameters.feeScope, requestParameters.feePaymentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FeesApiListFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public listFees(requestParameters: FeesApiListFeesRequest = {}, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).listFees(requestParameters.operatorId, requestParameters.facilityId, requestParameters.feeScope, requestParameters.paymentType, requestParameters.isAppliedToParker, requestParameters.isActive, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FeesApiTestCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public testCalculation(requestParameters: FeesApiTestCalculationRequest, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).testCalculation(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FeesApiUpdateFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public updateFee(requestParameters: FeesApiUpdateFeeRequest, options?: RawAxiosRequestConfig) {
        return FeesApiFp(this.configuration).updateFee(requestParameters.id, requestParameters.serverRequestsUpdateFeeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileUploadApi - axios parameter creator
 * @export
 */
export const FileUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {string} [containerPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileUploadUploadMultiplePost: async (files?: Array<File>, containerPath?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FileUpload/upload-multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                  localVarFormParams.append('files', element as any);
                })
            }

    
            if (containerPath !== undefined) { 
                localVarFormParams.append('containerPath', containerPath as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [containerPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileUploadUploadPost: async (file?: File, containerPath?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FileUpload/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (containerPath !== undefined) { 
                localVarFormParams.append('containerPath', containerPath as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileUploadApi - functional programming interface
 * @export
 */
export const FileUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {string} [containerPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileUploadUploadMultiplePost(files?: Array<File>, containerPath?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileUploadUploadMultiplePost(files, containerPath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.apiFileUploadUploadMultiplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [containerPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileUploadUploadPost(file?: File, containerPath?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileUploadUploadPost(file, containerPath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.apiFileUploadUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileUploadApi - factory interface
 * @export
 */
export const FileUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileUploadApiFp(configuration)
    return {
        /**
         * 
         * @param {FileUploadApiApiFileUploadUploadMultiplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileUploadUploadMultiplePost(requestParameters: FileUploadApiApiFileUploadUploadMultiplePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFileUploadUploadMultiplePost(requestParameters.files, requestParameters.containerPath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileUploadApiApiFileUploadUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileUploadUploadPost(requestParameters: FileUploadApiApiFileUploadUploadPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFileUploadUploadPost(requestParameters.file, requestParameters.containerPath, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFileUploadUploadMultiplePost operation in FileUploadApi.
 * @export
 * @interface FileUploadApiApiFileUploadUploadMultiplePostRequest
 */
export interface FileUploadApiApiFileUploadUploadMultiplePostRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof FileUploadApiApiFileUploadUploadMultiplePost
     */
    readonly files?: Array<File>

    /**
     * 
     * @type {string}
     * @memberof FileUploadApiApiFileUploadUploadMultiplePost
     */
    readonly containerPath?: string
}

/**
 * Request parameters for apiFileUploadUploadPost operation in FileUploadApi.
 * @export
 * @interface FileUploadApiApiFileUploadUploadPostRequest
 */
export interface FileUploadApiApiFileUploadUploadPostRequest {
    /**
     * 
     * @type {File}
     * @memberof FileUploadApiApiFileUploadUploadPost
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof FileUploadApiApiFileUploadUploadPost
     */
    readonly containerPath?: string
}

/**
 * FileUploadApi - object-oriented interface
 * @export
 * @class FileUploadApi
 * @extends {BaseAPI}
 */
export class FileUploadApi extends BaseAPI {
    /**
     * 
     * @param {FileUploadApiApiFileUploadUploadMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public apiFileUploadUploadMultiplePost(requestParameters: FileUploadApiApiFileUploadUploadMultiplePostRequest = {}, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).apiFileUploadUploadMultiplePost(requestParameters.files, requestParameters.containerPath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileUploadApiApiFileUploadUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public apiFileUploadUploadPost(requestParameters: FileUploadApiApiFileUploadUploadPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).apiFileUploadUploadPost(requestParameters.file, requestParameters.containerPath, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GroupParkerApi - axios parameter creator
 * @export
 */
export const GroupParkerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerCheckoutRequest} [serverRequestsGroupParkerCheckoutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerCheckout: async (subscriptionId: number, serverRequestsGroupParkerCheckoutRequest?: ServerRequestsGroupParkerCheckoutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('groupParkerCheckout', 'subscriptionId', subscriptionId)
            const localVarPath = `/connect/group-parker/{subscriptionId}/checkout`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerCheckoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerFulfillCheckout: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('groupParkerFulfillCheckout', 'orderId', orderId)
            const localVarPath = `/connect/group-parker/checkout/{orderId}/fulfill`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerInviteInitRequest} [serverRequestsGroupParkerInviteInitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerInviteInit: async (subscriptionId: number, serverRequestsGroupParkerInviteInitRequest?: ServerRequestsGroupParkerInviteInitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('groupParkerInviteInit', 'subscriptionId', subscriptionId)
            const localVarPath = `/connect/group-parker/{subscriptionId}/invite-init`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerInviteInitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerPreviewRequest} [serverRequestsGroupParkerPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerPreview: async (subscriptionId: number, serverRequestsGroupParkerPreviewRequest?: ServerRequestsGroupParkerPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('groupParkerPreview', 'subscriptionId', subscriptionId)
            const localVarPath = `/connect/group-parker/{subscriptionId}/preview`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {ServerRequestsGroupParkerUpdateRequest} [serverRequestsGroupParkerUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerUpdate: async (subscriptionId: number, parkerId: number, serverRequestsGroupParkerUpdateRequest?: ServerRequestsGroupParkerUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('groupParkerUpdate', 'subscriptionId', subscriptionId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('groupParkerUpdate', 'parkerId', parkerId)
            const localVarPath = `/connect/group-parker/{subscriptionId}/parker/{parkerId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupParkerApi - functional programming interface
 * @export
 */
export const GroupParkerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupParkerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerCheckoutRequest} [serverRequestsGroupParkerCheckoutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupParkerCheckout(subscriptionId: number, serverRequestsGroupParkerCheckoutRequest?: ServerRequestsGroupParkerCheckoutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerCheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupParkerCheckout(subscriptionId, serverRequestsGroupParkerCheckoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupParkerApi.groupParkerCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupParkerFulfillCheckout(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerFulfillCheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupParkerFulfillCheckout(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupParkerApi.groupParkerFulfillCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerInviteInitRequest} [serverRequestsGroupParkerInviteInitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupParkerInviteInit(subscriptionId: number, serverRequestsGroupParkerInviteInitRequest?: ServerRequestsGroupParkerInviteInitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerInviteInitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupParkerInviteInit(subscriptionId, serverRequestsGroupParkerInviteInitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupParkerApi.groupParkerInviteInit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerPreviewRequest} [serverRequestsGroupParkerPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupParkerPreview(subscriptionId: number, serverRequestsGroupParkerPreviewRequest?: ServerRequestsGroupParkerPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupParkerPreview(subscriptionId, serverRequestsGroupParkerPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupParkerApi.groupParkerPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {ServerRequestsGroupParkerUpdateRequest} [serverRequestsGroupParkerUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupParkerUpdate(subscriptionId: number, parkerId: number, serverRequestsGroupParkerUpdateRequest?: ServerRequestsGroupParkerUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupParkerUpdate(subscriptionId, parkerId, serverRequestsGroupParkerUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupParkerApi.groupParkerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GroupParkerApi - factory interface
 * @export
 */
export const GroupParkerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupParkerApiFp(configuration)
    return {
        /**
         * 
         * @param {GroupParkerApiGroupParkerCheckoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerCheckout(requestParameters: GroupParkerApiGroupParkerCheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerCheckoutResponse> {
            return localVarFp.groupParkerCheckout(requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerCheckoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupParkerApiGroupParkerFulfillCheckoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerFulfillCheckout(requestParameters: GroupParkerApiGroupParkerFulfillCheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerFulfillCheckoutResponse> {
            return localVarFp.groupParkerFulfillCheckout(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupParkerApiGroupParkerInviteInitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerInviteInit(requestParameters: GroupParkerApiGroupParkerInviteInitRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerInviteInitResponse> {
            return localVarFp.groupParkerInviteInit(requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerInviteInitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupParkerApiGroupParkerPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerPreview(requestParameters: GroupParkerApiGroupParkerPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerPreviewResponse> {
            return localVarFp.groupParkerPreview(requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupParkerApiGroupParkerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParkerUpdate(requestParameters: GroupParkerApiGroupParkerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerUpdateResponse> {
            return localVarFp.groupParkerUpdate(requestParameters.subscriptionId, requestParameters.parkerId, requestParameters.serverRequestsGroupParkerUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for groupParkerCheckout operation in GroupParkerApi.
 * @export
 * @interface GroupParkerApiGroupParkerCheckoutRequest
 */
export interface GroupParkerApiGroupParkerCheckoutRequest {
    /**
     * 
     * @type {number}
     * @memberof GroupParkerApiGroupParkerCheckout
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerCheckoutRequest}
     * @memberof GroupParkerApiGroupParkerCheckout
     */
    readonly serverRequestsGroupParkerCheckoutRequest?: ServerRequestsGroupParkerCheckoutRequest
}

/**
 * Request parameters for groupParkerFulfillCheckout operation in GroupParkerApi.
 * @export
 * @interface GroupParkerApiGroupParkerFulfillCheckoutRequest
 */
export interface GroupParkerApiGroupParkerFulfillCheckoutRequest {
    /**
     * 
     * @type {number}
     * @memberof GroupParkerApiGroupParkerFulfillCheckout
     */
    readonly orderId: number
}

/**
 * Request parameters for groupParkerInviteInit operation in GroupParkerApi.
 * @export
 * @interface GroupParkerApiGroupParkerInviteInitRequest
 */
export interface GroupParkerApiGroupParkerInviteInitRequest {
    /**
     * 
     * @type {number}
     * @memberof GroupParkerApiGroupParkerInviteInit
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerInviteInitRequest}
     * @memberof GroupParkerApiGroupParkerInviteInit
     */
    readonly serverRequestsGroupParkerInviteInitRequest?: ServerRequestsGroupParkerInviteInitRequest
}

/**
 * Request parameters for groupParkerPreview operation in GroupParkerApi.
 * @export
 * @interface GroupParkerApiGroupParkerPreviewRequest
 */
export interface GroupParkerApiGroupParkerPreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof GroupParkerApiGroupParkerPreview
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerPreviewRequest}
     * @memberof GroupParkerApiGroupParkerPreview
     */
    readonly serverRequestsGroupParkerPreviewRequest?: ServerRequestsGroupParkerPreviewRequest
}

/**
 * Request parameters for groupParkerUpdate operation in GroupParkerApi.
 * @export
 * @interface GroupParkerApiGroupParkerUpdateRequest
 */
export interface GroupParkerApiGroupParkerUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof GroupParkerApiGroupParkerUpdate
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {number}
     * @memberof GroupParkerApiGroupParkerUpdate
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerUpdateRequest}
     * @memberof GroupParkerApiGroupParkerUpdate
     */
    readonly serverRequestsGroupParkerUpdateRequest?: ServerRequestsGroupParkerUpdateRequest
}

/**
 * GroupParkerApi - object-oriented interface
 * @export
 * @class GroupParkerApi
 * @extends {BaseAPI}
 */
export class GroupParkerApi extends BaseAPI {
    /**
     * 
     * @param {GroupParkerApiGroupParkerCheckoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupParkerApi
     */
    public groupParkerCheckout(requestParameters: GroupParkerApiGroupParkerCheckoutRequest, options?: RawAxiosRequestConfig) {
        return GroupParkerApiFp(this.configuration).groupParkerCheckout(requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerCheckoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupParkerApiGroupParkerFulfillCheckoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupParkerApi
     */
    public groupParkerFulfillCheckout(requestParameters: GroupParkerApiGroupParkerFulfillCheckoutRequest, options?: RawAxiosRequestConfig) {
        return GroupParkerApiFp(this.configuration).groupParkerFulfillCheckout(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupParkerApiGroupParkerInviteInitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupParkerApi
     */
    public groupParkerInviteInit(requestParameters: GroupParkerApiGroupParkerInviteInitRequest, options?: RawAxiosRequestConfig) {
        return GroupParkerApiFp(this.configuration).groupParkerInviteInit(requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerInviteInitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupParkerApiGroupParkerPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupParkerApi
     */
    public groupParkerPreview(requestParameters: GroupParkerApiGroupParkerPreviewRequest, options?: RawAxiosRequestConfig) {
        return GroupParkerApiFp(this.configuration).groupParkerPreview(requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupParkerApiGroupParkerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupParkerApi
     */
    public groupParkerUpdate(requestParameters: GroupParkerApiGroupParkerUpdateRequest, options?: RawAxiosRequestConfig) {
        return GroupParkerApiFp(this.configuration).groupParkerUpdate(requestParameters.subscriptionId, requestParameters.parkerId, requestParameters.serverRequestsGroupParkerUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImageApiApi - axios parameter creator
 * @export
 */
export const ImageApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} imgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectImgImgIdGet: async (imgId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imgId' is not null or undefined
            assertParamExists('connectImgImgIdGet', 'imgId', imgId)
            const localVarPath = `/connect/img/{imgId}`
                .replace(`{${"imgId"}}`, encodeURIComponent(String(imgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} imgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorImgImgIdGet: async (imgId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imgId' is not null or undefined
            assertParamExists('monitorImgImgIdGet', 'imgId', imgId)
            const localVarPath = `/monitor/img/{imgId}`
                .replace(`{${"imgId"}}`, encodeURIComponent(String(imgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageApiApi - functional programming interface
 * @export
 */
export const ImageApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} imgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectImgImgIdGet(imgId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectImgImgIdGet(imgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageApiApi.connectImgImgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} imgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorImgImgIdGet(imgId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorImgImgIdGet(imgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageApiApi.monitorImgImgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImageApiApi - factory interface
 * @export
 */
export const ImageApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ImageApiApiConnectImgImgIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectImgImgIdGet(requestParameters: ImageApiApiConnectImgImgIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectImgImgIdGet(requestParameters.imgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImageApiApiMonitorImgImgIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorImgImgIdGet(requestParameters: ImageApiApiMonitorImgImgIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.monitorImgImgIdGet(requestParameters.imgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for connectImgImgIdGet operation in ImageApiApi.
 * @export
 * @interface ImageApiApiConnectImgImgIdGetRequest
 */
export interface ImageApiApiConnectImgImgIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ImageApiApiConnectImgImgIdGet
     */
    readonly imgId: number
}

/**
 * Request parameters for monitorImgImgIdGet operation in ImageApiApi.
 * @export
 * @interface ImageApiApiMonitorImgImgIdGetRequest
 */
export interface ImageApiApiMonitorImgImgIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ImageApiApiMonitorImgImgIdGet
     */
    readonly imgId: number
}

/**
 * ImageApiApi - object-oriented interface
 * @export
 * @class ImageApiApi
 * @extends {BaseAPI}
 */
export class ImageApiApi extends BaseAPI {
    /**
     * 
     * @param {ImageApiApiConnectImgImgIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApiApi
     */
    public connectImgImgIdGet(requestParameters: ImageApiApiConnectImgImgIdGetRequest, options?: RawAxiosRequestConfig) {
        return ImageApiApiFp(this.configuration).connectImgImgIdGet(requestParameters.imgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImageApiApiMonitorImgImgIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApiApi
     */
    public monitorImgImgIdGet(requestParameters: ImageApiApiMonitorImgImgIdGetRequest, options?: RawAxiosRequestConfig) {
        return ImageApiApiFp(this.configuration).monitorImgImgIdGet(requestParameters.imgId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntegrationPartyApi - axios parameter creator
 * @export
 */
export const IntegrationPartyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsCreateIntegrationPartyRequest} [serverRequestsCreateIntegrationPartyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationParty: async (serverRequestsCreateIntegrationPartyRequest?: ServerRequestsCreateIntegrationPartyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integration-parties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateIntegrationPartyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegrationParty: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteIntegrationParty', 'id', id)
            const localVarPath = `/integration-parties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsEnrollIntegrationPartyRequest} [serverRequestsEnrollIntegrationPartyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollIntegrationParty: async (id: number, serverRequestsEnrollIntegrationPartyRequest?: ServerRequestsEnrollIntegrationPartyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enrollIntegrationParty', 'id', id)
            const localVarPath = `/integration-parties/{id}/enroll`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsEnrollIntegrationPartyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFacilityIntegrationToken: async (id: number, facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateFacilityIntegrationToken', 'id', id)
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('generateFacilityIntegrationToken', 'facilityId', facilityId)
            const localVarPath = `/integration-parties/{id}/facility/{facilityId}/generate-token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationParty: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIntegrationParty', 'id', id)
            const localVarPath = `/integration-parties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [integrationPartyId] 
         * @param {number} [operatorId] 
         * @param {number} [facilityId] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnrolledIntegrationParty: async (integrationPartyId?: number, operatorId?: number, facilityId?: number, pageSize?: number, pageNumber?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integration-parties/enrolleds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (integrationPartyId !== undefined) {
                localVarQueryParameter['IntegrationPartyId'] = integrationPartyId;
            }

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['Pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegrationParty: async (pageSize?: number, pageNumber?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integration-parties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['Pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsPatchIntegrationPartyRequest} [serverRequestsPatchIntegrationPartyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationParty: async (id: number, serverRequestsPatchIntegrationPartyRequest?: ServerRequestsPatchIntegrationPartyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIntegrationParty', 'id', id)
            const localVarPath = `/integration-parties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsPatchIntegrationPartyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationPartyApi - functional programming interface
 * @export
 */
export const IntegrationPartyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationPartyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsCreateIntegrationPartyRequest} [serverRequestsCreateIntegrationPartyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIntegrationParty(serverRequestsCreateIntegrationPartyRequest?: ServerRequestsCreateIntegrationPartyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetIntegrationPartyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIntegrationParty(serverRequestsCreateIntegrationPartyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.createIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIntegrationParty(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIntegrationParty(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.deleteIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsEnrollIntegrationPartyRequest} [serverRequestsEnrollIntegrationPartyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollIntegrationParty(id: number, serverRequestsEnrollIntegrationPartyRequest?: ServerRequestsEnrollIntegrationPartyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetEnrolledIntegrationPartyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollIntegrationParty(id, serverRequestsEnrollIntegrationPartyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.enrollIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateFacilityIntegrationToken(id: number, facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGenerateIntegrationPartyTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFacilityIntegrationToken(id, facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.generateFacilityIntegrationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntegrationParty(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetIntegrationPartyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationParty(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.getIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [integrationPartyId] 
         * @param {number} [operatorId] 
         * @param {number} [facilityId] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEnrolledIntegrationParty(integrationPartyId?: number, operatorId?: number, facilityId?: number, pageSize?: number, pageNumber?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetEnrolledIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEnrolledIntegrationParty(integrationPartyId, operatorId, facilityId, pageSize, pageNumber, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.listEnrolledIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIntegrationParty(pageSize?: number, pageNumber?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIntegrationParty(pageSize, pageNumber, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.listIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsPatchIntegrationPartyRequest} [serverRequestsPatchIntegrationPartyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIntegrationParty(id: number, serverRequestsPatchIntegrationPartyRequest?: ServerRequestsPatchIntegrationPartyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetIntegrationPartyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIntegrationParty(id, serverRequestsPatchIntegrationPartyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationPartyApi.updateIntegrationParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationPartyApi - factory interface
 * @export
 */
export const IntegrationPartyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationPartyApiFp(configuration)
    return {
        /**
         * 
         * @param {IntegrationPartyApiCreateIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationParty(requestParameters: IntegrationPartyApiCreateIntegrationPartyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetIntegrationPartyResponse> {
            return localVarFp.createIntegrationParty(requestParameters.serverRequestsCreateIntegrationPartyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiDeleteIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegrationParty(requestParameters: IntegrationPartyApiDeleteIntegrationPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteIntegrationParty(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiEnrollIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollIntegrationParty(requestParameters: IntegrationPartyApiEnrollIntegrationPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetEnrolledIntegrationPartyResponse> {
            return localVarFp.enrollIntegrationParty(requestParameters.id, requestParameters.serverRequestsEnrollIntegrationPartyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiGenerateFacilityIntegrationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFacilityIntegrationToken(requestParameters: IntegrationPartyApiGenerateFacilityIntegrationTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGenerateIntegrationPartyTokenResponse> {
            return localVarFp.generateFacilityIntegrationToken(requestParameters.id, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiGetIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationParty(requestParameters: IntegrationPartyApiGetIntegrationPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetIntegrationPartyResponse> {
            return localVarFp.getIntegrationParty(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiListEnrolledIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnrolledIntegrationParty(requestParameters: IntegrationPartyApiListEnrolledIntegrationPartyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetEnrolledIntegrationPartiesResponse> {
            return localVarFp.listEnrolledIntegrationParty(requestParameters.integrationPartyId, requestParameters.operatorId, requestParameters.facilityId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiListIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegrationParty(requestParameters: IntegrationPartyApiListIntegrationPartyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetIntegrationPartiesResponse> {
            return localVarFp.listIntegrationParty(requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationPartyApiUpdateIntegrationPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationParty(requestParameters: IntegrationPartyApiUpdateIntegrationPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetIntegrationPartyResponse> {
            return localVarFp.updateIntegrationParty(requestParameters.id, requestParameters.serverRequestsPatchIntegrationPartyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiCreateIntegrationPartyRequest
 */
export interface IntegrationPartyApiCreateIntegrationPartyRequest {
    /**
     * 
     * @type {ServerRequestsCreateIntegrationPartyRequest}
     * @memberof IntegrationPartyApiCreateIntegrationParty
     */
    readonly serverRequestsCreateIntegrationPartyRequest?: ServerRequestsCreateIntegrationPartyRequest
}

/**
 * Request parameters for deleteIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiDeleteIntegrationPartyRequest
 */
export interface IntegrationPartyApiDeleteIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiDeleteIntegrationParty
     */
    readonly id: number
}

/**
 * Request parameters for enrollIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiEnrollIntegrationPartyRequest
 */
export interface IntegrationPartyApiEnrollIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiEnrollIntegrationParty
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsEnrollIntegrationPartyRequest}
     * @memberof IntegrationPartyApiEnrollIntegrationParty
     */
    readonly serverRequestsEnrollIntegrationPartyRequest?: ServerRequestsEnrollIntegrationPartyRequest
}

/**
 * Request parameters for generateFacilityIntegrationToken operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiGenerateFacilityIntegrationTokenRequest
 */
export interface IntegrationPartyApiGenerateFacilityIntegrationTokenRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiGenerateFacilityIntegrationToken
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiGenerateFacilityIntegrationToken
     */
    readonly facilityId: number
}

/**
 * Request parameters for getIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiGetIntegrationPartyRequest
 */
export interface IntegrationPartyApiGetIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiGetIntegrationParty
     */
    readonly id: number
}

/**
 * Request parameters for listEnrolledIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiListEnrolledIntegrationPartyRequest
 */
export interface IntegrationPartyApiListEnrolledIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListEnrolledIntegrationParty
     */
    readonly integrationPartyId?: number

    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListEnrolledIntegrationParty
     */
    readonly operatorId?: number

    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListEnrolledIntegrationParty
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListEnrolledIntegrationParty
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListEnrolledIntegrationParty
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof IntegrationPartyApiListEnrolledIntegrationParty
     */
    readonly pagination?: boolean
}

/**
 * Request parameters for listIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiListIntegrationPartyRequest
 */
export interface IntegrationPartyApiListIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListIntegrationParty
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiListIntegrationParty
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof IntegrationPartyApiListIntegrationParty
     */
    readonly pagination?: boolean
}

/**
 * Request parameters for updateIntegrationParty operation in IntegrationPartyApi.
 * @export
 * @interface IntegrationPartyApiUpdateIntegrationPartyRequest
 */
export interface IntegrationPartyApiUpdateIntegrationPartyRequest {
    /**
     * 
     * @type {number}
     * @memberof IntegrationPartyApiUpdateIntegrationParty
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsPatchIntegrationPartyRequest}
     * @memberof IntegrationPartyApiUpdateIntegrationParty
     */
    readonly serverRequestsPatchIntegrationPartyRequest?: ServerRequestsPatchIntegrationPartyRequest
}

/**
 * IntegrationPartyApi - object-oriented interface
 * @export
 * @class IntegrationPartyApi
 * @extends {BaseAPI}
 */
export class IntegrationPartyApi extends BaseAPI {
    /**
     * 
     * @param {IntegrationPartyApiCreateIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public createIntegrationParty(requestParameters: IntegrationPartyApiCreateIntegrationPartyRequest = {}, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).createIntegrationParty(requestParameters.serverRequestsCreateIntegrationPartyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiDeleteIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public deleteIntegrationParty(requestParameters: IntegrationPartyApiDeleteIntegrationPartyRequest, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).deleteIntegrationParty(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiEnrollIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public enrollIntegrationParty(requestParameters: IntegrationPartyApiEnrollIntegrationPartyRequest, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).enrollIntegrationParty(requestParameters.id, requestParameters.serverRequestsEnrollIntegrationPartyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiGenerateFacilityIntegrationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public generateFacilityIntegrationToken(requestParameters: IntegrationPartyApiGenerateFacilityIntegrationTokenRequest, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).generateFacilityIntegrationToken(requestParameters.id, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiGetIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public getIntegrationParty(requestParameters: IntegrationPartyApiGetIntegrationPartyRequest, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).getIntegrationParty(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiListEnrolledIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public listEnrolledIntegrationParty(requestParameters: IntegrationPartyApiListEnrolledIntegrationPartyRequest = {}, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).listEnrolledIntegrationParty(requestParameters.integrationPartyId, requestParameters.operatorId, requestParameters.facilityId, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiListIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public listIntegrationParty(requestParameters: IntegrationPartyApiListIntegrationPartyRequest = {}, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).listIntegrationParty(requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationPartyApiUpdateIntegrationPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationPartyApi
     */
    public updateIntegrationParty(requestParameters: IntegrationPartyApiUpdateIntegrationPartyRequest, options?: RawAxiosRequestConfig) {
        return IntegrationPartyApiFp(this.configuration).updateIntegrationParty(requestParameters.id, requestParameters.serverRequestsPatchIntegrationPartyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MonitorDelegateApi - axios parameter creator
 * @export
 */
export const MonitorDelegateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerDelegates: async (parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerDelegates', 'parkerId', parkerId)
            const localVarPath = `/monitor/parker/{parkerId}/delegate`
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parkerId 
         * @param {ServerRequestsStaffAddDelegateRequest} [serverRequestsStaffAddDelegateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffAddDelegate: async (parkerId: number, serverRequestsStaffAddDelegateRequest?: ServerRequestsStaffAddDelegateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('staffAddDelegate', 'parkerId', parkerId)
            const localVarPath = `/monitor/parker/{parkerId}/delegate`
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsStaffAddDelegateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parkerId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffRevokeDelegate: async (parkerId: number, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('staffRevokeDelegate', 'parkerId', parkerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('staffRevokeDelegate', 'id', id)
            const localVarPath = `/monitor/parker/{parkerId}/delegate/{id}/revoke`
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitorDelegateApi - functional programming interface
 * @export
 */
export const MonitorDelegateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitorDelegateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerDelegates(parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetParkerDelegatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerDelegates(parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorDelegateApi.getParkerDelegates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parkerId 
         * @param {ServerRequestsStaffAddDelegateRequest} [serverRequestsStaffAddDelegateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffAddDelegate(parkerId: number, serverRequestsStaffAddDelegateRequest?: ServerRequestsStaffAddDelegateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsStaffAddDelegateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffAddDelegate(parkerId, serverRequestsStaffAddDelegateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorDelegateApi.staffAddDelegate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parkerId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staffRevokeDelegate(parkerId: number, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staffRevokeDelegate(parkerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorDelegateApi.staffRevokeDelegate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MonitorDelegateApi - factory interface
 * @export
 */
export const MonitorDelegateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitorDelegateApiFp(configuration)
    return {
        /**
         * 
         * @param {MonitorDelegateApiGetParkerDelegatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerDelegates(requestParameters: MonitorDelegateApiGetParkerDelegatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetParkerDelegatesResponse> {
            return localVarFp.getParkerDelegates(requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorDelegateApiStaffAddDelegateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffAddDelegate(requestParameters: MonitorDelegateApiStaffAddDelegateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsStaffAddDelegateResponse> {
            return localVarFp.staffAddDelegate(requestParameters.parkerId, requestParameters.serverRequestsStaffAddDelegateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorDelegateApiStaffRevokeDelegateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffRevokeDelegate(requestParameters: MonitorDelegateApiStaffRevokeDelegateRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.staffRevokeDelegate(requestParameters.parkerId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getParkerDelegates operation in MonitorDelegateApi.
 * @export
 * @interface MonitorDelegateApiGetParkerDelegatesRequest
 */
export interface MonitorDelegateApiGetParkerDelegatesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorDelegateApiGetParkerDelegates
     */
    readonly parkerId: number
}

/**
 * Request parameters for staffAddDelegate operation in MonitorDelegateApi.
 * @export
 * @interface MonitorDelegateApiStaffAddDelegateRequest
 */
export interface MonitorDelegateApiStaffAddDelegateRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorDelegateApiStaffAddDelegate
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerRequestsStaffAddDelegateRequest}
     * @memberof MonitorDelegateApiStaffAddDelegate
     */
    readonly serverRequestsStaffAddDelegateRequest?: ServerRequestsStaffAddDelegateRequest
}

/**
 * Request parameters for staffRevokeDelegate operation in MonitorDelegateApi.
 * @export
 * @interface MonitorDelegateApiStaffRevokeDelegateRequest
 */
export interface MonitorDelegateApiStaffRevokeDelegateRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorDelegateApiStaffRevokeDelegate
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorDelegateApiStaffRevokeDelegate
     */
    readonly id: number
}

/**
 * MonitorDelegateApi - object-oriented interface
 * @export
 * @class MonitorDelegateApi
 * @extends {BaseAPI}
 */
export class MonitorDelegateApi extends BaseAPI {
    /**
     * 
     * @param {MonitorDelegateApiGetParkerDelegatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorDelegateApi
     */
    public getParkerDelegates(requestParameters: MonitorDelegateApiGetParkerDelegatesRequest, options?: RawAxiosRequestConfig) {
        return MonitorDelegateApiFp(this.configuration).getParkerDelegates(requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorDelegateApiStaffAddDelegateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorDelegateApi
     */
    public staffAddDelegate(requestParameters: MonitorDelegateApiStaffAddDelegateRequest, options?: RawAxiosRequestConfig) {
        return MonitorDelegateApiFp(this.configuration).staffAddDelegate(requestParameters.parkerId, requestParameters.serverRequestsStaffAddDelegateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorDelegateApiStaffRevokeDelegateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorDelegateApi
     */
    public staffRevokeDelegate(requestParameters: MonitorDelegateApiStaffRevokeDelegateRequest, options?: RawAxiosRequestConfig) {
        return MonitorDelegateApiFp(this.configuration).staffRevokeDelegate(requestParameters.parkerId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MonitorFacilityApiApi - axios parameter creator
 * @export
 */
export const MonitorFacilityApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorVehicleAddReq} serverTransferMonitorVehicleAddReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubscriptionVehicle: async (facilityId: number, subscriptionId: number, serverTransferMonitorVehicleAddReq: ServerTransferMonitorVehicleAddReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('addSubscriptionVehicle', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('addSubscriptionVehicle', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorVehicleAddReq' is not null or undefined
            assertParamExists('addSubscriptionVehicle', 'serverTransferMonitorVehicleAddReq', serverTransferMonitorVehicleAddReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/vehicle/add`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorVehicleAddReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferVehicle} serverTransferVehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVehicle: async (facilityId: number, parkerId: number, serverTransferVehicle: ServerTransferVehicle, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('addVehicle', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('addVehicle', 'parkerId', parkerId)
            // verify required parameter 'serverTransferVehicle' is not null or undefined
            assertParamExists('addVehicle', 'serverTransferVehicle', serverTransferVehicle)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/vehicle`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferVehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorOrderAdjustReq} serverTransferMonitorOrderAdjustReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustParkerOrder: async (facilityId: number, parkerId: number, serverTransferMonitorOrderAdjustReq: ServerTransferMonitorOrderAdjustReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adjustParkerOrder', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('adjustParkerOrder', 'parkerId', parkerId)
            // verify required parameter 'serverTransferMonitorOrderAdjustReq' is not null or undefined
            assertParamExists('adjustParkerOrder', 'serverTransferMonitorOrderAdjustReq', serverTransferMonitorOrderAdjustReq)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/order/adjust`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorOrderAdjustReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorPaymentAdjustReq} serverTransferMonitorPaymentAdjustReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustParkerPayment: async (facilityId: number, parkerId: number, serverTransferMonitorPaymentAdjustReq: ServerTransferMonitorPaymentAdjustReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adjustParkerPayment', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('adjustParkerPayment', 'parkerId', parkerId)
            // verify required parameter 'serverTransferMonitorPaymentAdjustReq' is not null or undefined
            assertParamExists('adjustParkerPayment', 'serverTransferMonitorPaymentAdjustReq', serverTransferMonitorPaymentAdjustReq)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/payment/adjust`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorPaymentAdjustReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorAccessKeyParkerAssignReq} serverTransferMonitorAccessKeyParkerAssignReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAccessKeyToParker: async (facilityId: number, serverTransferMonitorAccessKeyParkerAssignReq: ServerTransferMonitorAccessKeyParkerAssignReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('assignAccessKeyToParker', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorAccessKeyParkerAssignReq' is not null or undefined
            assertParamExists('assignAccessKeyToParker', 'serverTransferMonitorAccessKeyParkerAssignReq', serverTransferMonitorAccessKeyParkerAssignReq)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}/link/parker`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorAccessKeyParkerAssignReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorAccessKeyAssignSub} serverTransferMonitorAccessKeyAssignSub 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAccessKeyToSubscription: async (facilityId: number, serverTransferMonitorAccessKeyAssignSub: ServerTransferMonitorAccessKeyAssignSub, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('assignAccessKeyToSubscription', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorAccessKeyAssignSub' is not null or undefined
            assertParamExists('assignAccessKeyToSubscription', 'serverTransferMonitorAccessKeyAssignSub', serverTransferMonitorAccessKeyAssignSub)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}/link/subscription`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorAccessKeyAssignSub, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {ServerTransferMonitorAccessKeyVehicleSubAssignReq} serverTransferMonitorAccessKeyVehicleSubAssignReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAccessKeyToVehicle: async (facilityId: number, accessKeyId: number, serverTransferMonitorAccessKeyVehicleSubAssignReq: ServerTransferMonitorAccessKeyVehicleSubAssignReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('assignAccessKeyToVehicle', 'facilityId', facilityId)
            // verify required parameter 'accessKeyId' is not null or undefined
            assertParamExists('assignAccessKeyToVehicle', 'accessKeyId', accessKeyId)
            // verify required parameter 'serverTransferMonitorAccessKeyVehicleSubAssignReq' is not null or undefined
            assertParamExists('assignAccessKeyToVehicle', 'serverTransferMonitorAccessKeyVehicleSubAssignReq', serverTransferMonitorAccessKeyVehicleSubAssignReq)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}/link/vehicle`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"accessKeyId"}}`, encodeURIComponent(String(accessKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorAccessKeyVehicleSubAssignReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {DataEntitiesSubscriptionStatus} status 
         * @param {boolean} isAccountsReceivable 
         * @param {ServerServicesChangeSubscriptionStatusBody} [serverServicesChangeSubscriptionStatusBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionStatus: async (subscriptionId: number, status: DataEntitiesSubscriptionStatus, isAccountsReceivable: boolean, serverServicesChangeSubscriptionStatusBody?: ServerServicesChangeSubscriptionStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('changeSubscriptionStatus', 'subscriptionId', subscriptionId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changeSubscriptionStatus', 'status', status)
            // verify required parameter 'isAccountsReceivable' is not null or undefined
            assertParamExists('changeSubscriptionStatus', 'isAccountsReceivable', isAccountsReceivable)
            const localVarPath = `/monitor/facility/{subscriptionId}/status/{status}/isAccountsReceivable/{isAccountsReceivable}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)))
                .replace(`{${"isAccountsReceivable"}}`, encodeURIComponent(String(isAccountsReceivable)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverServicesChangeSubscriptionStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanInvoiceReq} serverTransferMonitorPlanInvoiceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPlanInvoice: async (facilityId: number, planId: number, serverTransferMonitorPlanInvoiceReq: ServerTransferMonitorPlanInvoiceReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('confirmPlanInvoice', 'facilityId', facilityId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('confirmPlanInvoice', 'planId', planId)
            // verify required parameter 'serverTransferMonitorPlanInvoiceReq' is not null or undefined
            assertParamExists('confirmPlanInvoice', 'serverTransferMonitorPlanInvoiceReq', serverTransferMonitorPlanInvoiceReq)
            const localVarPath = `/monitor/facility/{facilityId}/plan/{planId}/invoice/confirm`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorPlanInvoiceReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorAccessKeyReq} serverTransferMonitorAccessKeyReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessKey: async (facilityId: number, serverTransferMonitorAccessKeyReq: ServerTransferMonitorAccessKeyReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createAccessKey', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorAccessKeyReq' is not null or undefined
            assertParamExists('createAccessKey', 'serverTransferMonitorAccessKeyReq', serverTransferMonitorAccessKeyReq)
            const localVarPath = `/monitor/facility/{facilityId}/key`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorAccessKeyReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorOrderCustomReq} serverTransferMonitorOrderCustomReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomOrder: async (facilityId: number, serverTransferMonitorOrderCustomReq: ServerTransferMonitorOrderCustomReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createCustomOrder', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorOrderCustomReq' is not null or undefined
            assertParamExists('createCustomOrder', 'serverTransferMonitorOrderCustomReq', serverTransferMonitorOrderCustomReq)
            const localVarPath = `/monitor/facility/{facilityId}/order/custom`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorOrderCustomReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferMonitorFacilityCreateReq} serverTransferMonitorFacilityCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacility: async (serverTransferMonitorFacilityCreateReq: ServerTransferMonitorFacilityCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverTransferMonitorFacilityCreateReq' is not null or undefined
            assertParamExists('createFacility', 'serverTransferMonitorFacilityCreateReq', serverTransferMonitorFacilityCreateReq)
            const localVarPath = `/monitor/facility/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorFacilityCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorImportPaymentReq} serverTransferMonitorImportPaymentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createImportedParkerPayment: async (facilityId: number, parkerId: number, serverTransferMonitorImportPaymentReq: ServerTransferMonitorImportPaymentReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createImportedParkerPayment', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('createImportedParkerPayment', 'parkerId', parkerId)
            // verify required parameter 'serverTransferMonitorImportPaymentReq' is not null or undefined
            assertParamExists('createImportedParkerPayment', 'serverTransferMonitorImportPaymentReq', serverTransferMonitorImportPaymentReq)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/payment/import`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorImportPaymentReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorCheckCreateReq} serverTransferMonitorCheckCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParkerCheck: async (facilityId: number, parkerId: number, serverTransferMonitorCheckCreateReq: ServerTransferMonitorCheckCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createParkerCheck', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('createParkerCheck', 'parkerId', parkerId)
            // verify required parameter 'serverTransferMonitorCheckCreateReq' is not null or undefined
            assertParamExists('createParkerCheck', 'serverTransferMonitorCheckCreateReq', serverTransferMonitorCheckCreateReq)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/payment/check`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorCheckCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorPlanCreateReq} serverTransferMonitorPlanCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlan: async (facilityId: number, serverTransferMonitorPlanCreateReq: ServerTransferMonitorPlanCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createPlan', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorPlanCreateReq' is not null or undefined
            assertParamExists('createPlan', 'serverTransferMonitorPlanCreateReq', serverTransferMonitorPlanCreateReq)
            const localVarPath = `/monitor/facility/{facilityId}/plan`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorPlanCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanPriceAddReq} serverTransferMonitorPlanPriceAddReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanPrice: async (facilityId: number, planId: number, serverTransferMonitorPlanPriceAddReq: ServerTransferMonitorPlanPriceAddReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createPlanPrice', 'facilityId', facilityId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('createPlanPrice', 'planId', planId)
            // verify required parameter 'serverTransferMonitorPlanPriceAddReq' is not null or undefined
            assertParamExists('createPlanPrice', 'serverTransferMonitorPlanPriceAddReq', serverTransferMonitorPlanPriceAddReq)
            const localVarPath = `/monitor/facility/{facilityId}/plan/{planId}/price`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorPlanPriceAddReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferRateProgramData} serverTransferRateProgramData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateProgram: async (facilityId: number, serverTransferRateProgramData: ServerTransferRateProgramData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createRateProgram', 'facilityId', facilityId)
            // verify required parameter 'serverTransferRateProgramData' is not null or undefined
            assertParamExists('createRateProgram', 'serverTransferRateProgramData', serverTransferRateProgramData)
            const localVarPath = `/monitor/facility/{facilityId}/rate/create`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferRateProgramData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {number} vehicleId 
         * @param {ServerTransferMonitorVehicleDeleteReq} serverTransferMonitorVehicleDeleteReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionVehicle: async (facilityId: number, subscriptionId: number, vehicleId: number, serverTransferMonitorVehicleDeleteReq: ServerTransferMonitorVehicleDeleteReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('deleteSubscriptionVehicle', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deleteSubscriptionVehicle', 'subscriptionId', subscriptionId)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('deleteSubscriptionVehicle', 'vehicleId', vehicleId)
            // verify required parameter 'serverTransferMonitorVehicleDeleteReq' is not null or undefined
            assertParamExists('deleteSubscriptionVehicle', 'serverTransferMonitorVehicleDeleteReq', serverTransferMonitorVehicleDeleteReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/vehicle/{vehicleId}/delete`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorVehicleDeleteReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicle: async (facilityId: number, parkerId: number, vehicleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('deleteVehicle', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('deleteVehicle', 'parkerId', parkerId)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('deleteVehicle', 'vehicleId', vehicleId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/vehicle/{vehicleId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enhancedGroupFinalizeChanges: async (facilityId: number, subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('enhancedGroupFinalizeChanges', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('enhancedGroupFinalizeChanges', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/update/enhanced`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferMonitorFacilityPayoutAccountUpdateReq} serverTransferMonitorFacilityPayoutAccountUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityPayoutAccountUpdate: async (serverTransferMonitorFacilityPayoutAccountUpdateReq: ServerTransferMonitorFacilityPayoutAccountUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverTransferMonitorFacilityPayoutAccountUpdateReq' is not null or undefined
            assertParamExists('facilityPayoutAccountUpdate', 'serverTransferMonitorFacilityPayoutAccountUpdateReq', serverTransferMonitorFacilityPayoutAccountUpdateReq)
            const localVarPath = `/monitor/facility/{facilityId}/payout-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorFacilityPayoutAccountUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKey: async (facilityId: number, accessKeyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getAccessKey', 'facilityId', facilityId)
            // verify required parameter 'accessKeyId' is not null or undefined
            assertParamExists('getAccessKey', 'accessKeyId', accessKeyId)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"accessKeyId"}}`, encodeURIComponent(String(accessKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKeys: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getAccessKeys', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/key`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacility2: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacility2', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityStats: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacilityStats', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/stats`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getInvoices', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/invoice`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerBalanceHistory: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerBalanceHistory', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerBalanceHistory', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/balance/history`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerDetails: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerDetails', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerDetails', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerInviteCredentialCapability: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerInviteCredentialCapability', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/invite/credential-capability`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerInvoiceDetails: async (facilityId: number, parkerId: number, invoiceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerInvoiceDetails', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerInvoiceDetails', 'parkerId', parkerId)
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getParkerInvoiceDetails', 'invoiceId', invoiceId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/invoice/{invoiceId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerInvoices: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerInvoices', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerInvoices', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/invoice`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOpenOrders: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerOpenOrders', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerOpenOrders', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/order/open`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOrderDetails: async (facilityId: number, parkerId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerOrderDetails', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerOrderDetails', 'parkerId', parkerId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getParkerOrderDetails', 'orderId', orderId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/order/{orderId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOrders: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerOrders', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerOrders', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/order`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerPaymentDetails: async (facilityId: number, parkerId: number, paymentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerPaymentDetails', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerPaymentDetails', 'parkerId', parkerId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('getParkerPaymentDetails', 'paymentId', paymentId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/payment/{paymentId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerPayments: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkerPayments', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerPayments', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/payment`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkers: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getParkers', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/parker`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} payoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayout: async (facilityId: number, payoutId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPayout', 'facilityId', facilityId)
            // verify required parameter 'payoutId' is not null or undefined
            assertParamExists('getPayout', 'payoutId', payoutId)
            const localVarPath = `/monitor/facility/{facilityId}/payout/{payoutId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"payoutId"}}`, encodeURIComponent(String(payoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayouts: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPayouts', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/payout`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan: async (facilityId: number, planId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPlan', 'facilityId', facilityId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getPlan', 'planId', planId)
            const localVarPath = `/monitor/facility/{facilityId}/plan/{planId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanInvites: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPlanInvites', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/plan/invite`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanPrices: async (facilityId: number, planId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPlanPrices', 'facilityId', facilityId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getPlanPrices', 'planId', planId)
            const localVarPath = `/monitor/facility/{facilityId}/plan/{planId}/price`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPlans', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/plan`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} rateProgramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateProgram: async (facilityId: number, rateProgramId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getRateProgram', 'facilityId', facilityId)
            // verify required parameter 'rateProgramId' is not null or undefined
            assertParamExists('getRateProgram', 'rateProgramId', rateProgramId)
            const localVarPath = `/monitor/facility/{facilityId}/rate/{rateProgramId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"rateProgramId"}}`, encodeURIComponent(String(rateProgramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateProgramDiscounts: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getRateProgramDiscounts', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/rate/discounts`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatePrograms: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getRatePrograms', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/rate`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {string} [timezone] 
         * @param {string} [createdSince] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessions: async (facilityId: number, timezone?: string, createdSince?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getSessions', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/session`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (createdSince !== undefined) {
                localVarQueryParameter['createdSince'] = createdSince;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionDetails: async (subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscriptionDetails', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/detail/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionEdit: async (facilityId: number, subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getSubscriptionEdit', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscriptionEdit', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/edit`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionManagement: async (subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscriptionManagement', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getSubscriptions', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/subscription`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsByParker: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getSubscriptionsByParker', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getSubscriptionsByParker', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/subscription`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicles: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getVehicles', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getVehicles', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/vehicle`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {File | null} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importParkers: async (facilityId: number, file?: File | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('importParkers', 'facilityId', facilityId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/import`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanInvoiceReq} serverTransferMonitorPlanInvoiceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializePlanInvoice: async (facilityId: number, planId: number, serverTransferMonitorPlanInvoiceReq: ServerTransferMonitorPlanInvoiceReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('initializePlanInvoice', 'facilityId', facilityId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('initializePlanInvoice', 'planId', planId)
            // verify required parameter 'serverTransferMonitorPlanInvoiceReq' is not null or undefined
            assertParamExists('initializePlanInvoice', 'serverTransferMonitorPlanInvoiceReq', serverTransferMonitorPlanInvoiceReq)
            const localVarPath = `/monitor/facility/{facilityId}/plan/{planId}/invoice/init`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorPlanInvoiceReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorInviteParkerReq} serverTransferMonitorInviteParkerReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteParker: async (facilityId: number, serverTransferMonitorInviteParkerReq: ServerTransferMonitorInviteParkerReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('inviteParker', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorInviteParkerReq' is not null or undefined
            assertParamExists('inviteParker', 'serverTransferMonitorInviteParkerReq', serverTransferMonitorInviteParkerReq)
            const localVarPath = `/monitor/facility/{facilityId}/invite`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorInviteParkerReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerInviteReq} serverTransferMonitorSubscriptionParkerInviteReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteSubscriptionParker: async (facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerInviteReq: ServerTransferMonitorSubscriptionParkerInviteReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('inviteSubscriptionParker', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('inviteSubscriptionParker', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorSubscriptionParkerInviteReq' is not null or undefined
            assertParamExists('inviteSubscriptionParker', 'serverTransferMonitorSubscriptionParkerInviteReq', serverTransferMonitorSubscriptionParkerInviteReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/invite`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorSubscriptionParkerInviteReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {Array<ServerTransferMonitorSubscriptionParkerInviteReq>} serverTransferMonitorSubscriptionParkerInviteReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteSubscriptionParkerBatch: async (facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerInviteReq: Array<ServerTransferMonitorSubscriptionParkerInviteReq>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('inviteSubscriptionParkerBatch', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('inviteSubscriptionParkerBatch', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorSubscriptionParkerInviteReq' is not null or undefined
            assertParamExists('inviteSubscriptionParkerBatch', 'serverTransferMonitorSubscriptionParkerInviteReq', serverTransferMonitorSubscriptionParkerInviteReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/invite-batch`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorSubscriptionParkerInviteReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} inviteId 
         * @param {number} parkerId 
         * @param {string} action 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageParkerInvite: async (facilityId: number, inviteId: number, parkerId: number, action: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('manageParkerInvite', 'facilityId', facilityId)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('manageParkerInvite', 'inviteId', inviteId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('manageParkerInvite', 'parkerId', parkerId)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('manageParkerInvite', 'action', action)
            const localVarPath = `/monitor/facility/{facilityId}/invite/{parkerId}/invite/{inviteId}/{action}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorImportPaymentReq} serverTransferMonitorImportPaymentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerCreditAccountCreate: async (facilityId: number, parkerId: number, serverTransferMonitorImportPaymentReq: ServerTransferMonitorImportPaymentReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('parkerCreditAccountCreate', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('parkerCreditAccountCreate', 'parkerId', parkerId)
            // verify required parameter 'serverTransferMonitorImportPaymentReq' is not null or undefined
            assertParamExists('parkerCreditAccountCreate', 'serverTransferMonitorImportPaymentReq', serverTransferMonitorImportPaymentReq)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/payment/credit`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorImportPaymentReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorRatePreviewReq} serverTransferMonitorRatePreviewReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratePreview: async (facilityId: number, serverTransferMonitorRatePreviewReq: ServerTransferMonitorRatePreviewReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('ratePreview', 'facilityId', facilityId)
            // verify required parameter 'serverTransferMonitorRatePreviewReq' is not null or undefined
            assertParamExists('ratePreview', 'serverTransferMonitorRatePreviewReq', serverTransferMonitorRatePreviewReq)
            const localVarPath = `/monitor/facility/{facilityId}/rate/preview`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorRatePreviewReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccessKey: async (facilityId: number, accessKeyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('removeAccessKey', 'facilityId', facilityId)
            // verify required parameter 'accessKeyId' is not null or undefined
            assertParamExists('removeAccessKey', 'accessKeyId', accessKeyId)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}/{accessKeyLinkId}/remove`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"accessKeyId"}}`, encodeURIComponent(String(accessKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccessKeyLink: async (facilityId: number, accessKeyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('removeAccessKeyLink', 'facilityId', facilityId)
            // verify required parameter 'accessKeyId' is not null or undefined
            assertParamExists('removeAccessKeyLink', 'accessKeyId', accessKeyId)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}/remove`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"accessKeyId"}}`, encodeURIComponent(String(accessKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerRemoveReq} serverTransferMonitorSubscriptionParkerRemoveReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubscriptionParker: async (facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerRemoveReq: ServerTransferMonitorSubscriptionParkerRemoveReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('removeSubscriptionParker', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('removeSubscriptionParker', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorSubscriptionParkerRemoveReq' is not null or undefined
            assertParamExists('removeSubscriptionParker', 'serverTransferMonitorSubscriptionParkerRemoveReq', serverTransferMonitorSubscriptionParkerRemoveReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/parker/remove`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorSubscriptionParkerRemoveReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invoiceId 
         * @param {string} [recipientEmail] 
         * @param {boolean} [isAdjustmentReprint] 
         * @param {boolean} [isLiveReprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprintInvoice: async (invoiceId: number, recipientEmail?: string, isAdjustmentReprint?: boolean, isLiveReprint?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('reprintInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/invoice/{invoiceId}/reprint-invoice`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recipientEmail !== undefined) {
                localVarQueryParameter['recipientEmail'] = recipientEmail;
            }

            if (isAdjustmentReprint !== undefined) {
                localVarQueryParameter['isAdjustmentReprint'] = isAdjustmentReprint;
            }

            if (isLiveReprint !== undefined) {
                localVarQueryParameter['isLiveReprint'] = isLiveReprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} query 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFacility: async (query: string, facilityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchFacility', 'query', query)
            const localVarPath = `/monitor/facility/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerRemoveReq} serverTransferMonitorSubscriptionParkerRemoveReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCancelSubscriptionParker: async (facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerRemoveReq: ServerTransferMonitorSubscriptionParkerRemoveReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('undoCancelSubscriptionParker', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('undoCancelSubscriptionParker', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorSubscriptionParkerRemoveReq' is not null or undefined
            assertParamExists('undoCancelSubscriptionParker', 'serverTransferMonitorSubscriptionParkerRemoveReq', serverTransferMonitorSubscriptionParkerRemoveReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/parker/undo-cancel`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorSubscriptionParkerRemoveReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {ServerTransferMonitorAccessKeyReq} serverTransferMonitorAccessKeyReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessKey: async (facilityId: number, accessKeyId: number, serverTransferMonitorAccessKeyReq: ServerTransferMonitorAccessKeyReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updateAccessKey', 'facilityId', facilityId)
            // verify required parameter 'accessKeyId' is not null or undefined
            assertParamExists('updateAccessKey', 'accessKeyId', accessKeyId)
            // verify required parameter 'serverTransferMonitorAccessKeyReq' is not null or undefined
            assertParamExists('updateAccessKey', 'serverTransferMonitorAccessKeyReq', serverTransferMonitorAccessKeyReq)
            const localVarPath = `/monitor/facility/{facilityId}/key/{accessKeyId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"accessKeyId"}}`, encodeURIComponent(String(accessKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorAccessKeyReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferMonitorFacilityUpdateReq} serverTransferMonitorFacilityUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacility: async (serverTransferMonitorFacilityUpdateReq: ServerTransferMonitorFacilityUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverTransferMonitorFacilityUpdateReq' is not null or undefined
            assertParamExists('updateFacility', 'serverTransferMonitorFacilityUpdateReq', serverTransferMonitorFacilityUpdateReq)
            const localVarPath = `/monitor/facility/{facilityId}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorFacilityUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanUpdateReq} serverTransferMonitorPlanUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan: async (facilityId: number, planId: number, serverTransferMonitorPlanUpdateReq: ServerTransferMonitorPlanUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updatePlan', 'facilityId', facilityId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('updatePlan', 'planId', planId)
            // verify required parameter 'serverTransferMonitorPlanUpdateReq' is not null or undefined
            assertParamExists('updatePlan', 'serverTransferMonitorPlanUpdateReq', serverTransferMonitorPlanUpdateReq)
            const localVarPath = `/monitor/facility/{facilityId}/plan/{planId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorPlanUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} rateProgramId 
         * @param {ServerTransferRateProgramData} serverTransferRateProgramData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateProgram: async (facilityId: number, rateProgramId: number, serverTransferRateProgramData: ServerTransferRateProgramData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updateRateProgram', 'facilityId', facilityId)
            // verify required parameter 'rateProgramId' is not null or undefined
            assertParamExists('updateRateProgram', 'rateProgramId', rateProgramId)
            // verify required parameter 'serverTransferRateProgramData' is not null or undefined
            assertParamExists('updateRateProgram', 'serverTransferRateProgramData', serverTransferRateProgramData)
            const localVarPath = `/monitor/facility/{facilityId}/rate/{rateProgramId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"rateProgramId"}}`, encodeURIComponent(String(rateProgramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferRateProgramData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} rateProgramId 
         * @param {boolean} isActive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateProgramStatus: async (rateProgramId: number, isActive: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rateProgramId' is not null or undefined
            assertParamExists('updateRateProgramStatus', 'rateProgramId', rateProgramId)
            // verify required parameter 'isActive' is not null or undefined
            assertParamExists('updateRateProgramStatus', 'isActive', isActive)
            const localVarPath = `/monitor/facility/{facilityId}/rate/{rateProgramId}/isActive/{isActive}`
                .replace(`{${"rateProgramId"}}`, encodeURIComponent(String(rateProgramId)))
                .replace(`{${"isActive"}}`, encodeURIComponent(String(isActive)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionUpdateReq} serverTransferMonitorSubscriptionUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionEdit: async (facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionUpdateReq: ServerTransferMonitorSubscriptionUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updateSubscriptionEdit', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscriptionEdit', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorSubscriptionUpdateReq' is not null or undefined
            assertParamExists('updateSubscriptionEdit', 'serverTransferMonitorSubscriptionUpdateReq', serverTransferMonitorSubscriptionUpdateReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/edit`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorSubscriptionUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerChangeReq} serverTransferMonitorSubscriptionParkerChangeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionParker: async (facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerChangeReq: ServerTransferMonitorSubscriptionParkerChangeReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updateSubscriptionParker', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscriptionParker', 'subscriptionId', subscriptionId)
            // verify required parameter 'serverTransferMonitorSubscriptionParkerChangeReq' is not null or undefined
            assertParamExists('updateSubscriptionParker', 'serverTransferMonitorSubscriptionParkerChangeReq', serverTransferMonitorSubscriptionParkerChangeReq)
            const localVarPath = `/monitor/facility/{facilityId}/subscription/{subscriptionId}/parker`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferMonitorSubscriptionParkerChangeReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} vehicleId 
         * @param {ServerTransferVehicle} serverTransferVehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicle: async (facilityId: number, parkerId: number, vehicleId: number, serverTransferVehicle: ServerTransferVehicle, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updateVehicle', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('updateVehicle', 'parkerId', parkerId)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('updateVehicle', 'vehicleId', vehicleId)
            // verify required parameter 'serverTransferVehicle' is not null or undefined
            assertParamExists('updateVehicle', 'serverTransferVehicle', serverTransferVehicle)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/vehicle/{vehicleId}/update`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferVehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitorFacilityApiApi - functional programming interface
 * @export
 */
export const MonitorFacilityApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitorFacilityApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorVehicleAddReq} serverTransferMonitorVehicleAddReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSubscriptionVehicle(facilityId: number, subscriptionId: number, serverTransferMonitorVehicleAddReq: ServerTransferMonitorVehicleAddReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorVehicleLinkResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSubscriptionVehicle(facilityId, subscriptionId, serverTransferMonitorVehicleAddReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.addSubscriptionVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferVehicle} serverTransferVehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addVehicle(facilityId: number, parkerId: number, serverTransferVehicle: ServerTransferVehicle, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferVehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addVehicle(facilityId, parkerId, serverTransferVehicle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.addVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorOrderAdjustReq} serverTransferMonitorOrderAdjustReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustParkerOrder(facilityId: number, parkerId: number, serverTransferMonitorOrderAdjustReq: ServerTransferMonitorOrderAdjustReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferOrderBalance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustParkerOrder(facilityId, parkerId, serverTransferMonitorOrderAdjustReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.adjustParkerOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorPaymentAdjustReq} serverTransferMonitorPaymentAdjustReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustParkerPayment(facilityId: number, parkerId: number, serverTransferMonitorPaymentAdjustReq: ServerTransferMonitorPaymentAdjustReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPaymentChange>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustParkerPayment(facilityId, parkerId, serverTransferMonitorPaymentAdjustReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.adjustParkerPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorAccessKeyParkerAssignReq} serverTransferMonitorAccessKeyParkerAssignReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignAccessKeyToParker(facilityId: number, serverTransferMonitorAccessKeyParkerAssignReq: ServerTransferMonitorAccessKeyParkerAssignReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignAccessKeyToParker(facilityId, serverTransferMonitorAccessKeyParkerAssignReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.assignAccessKeyToParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorAccessKeyAssignSub} serverTransferMonitorAccessKeyAssignSub 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignAccessKeyToSubscription(facilityId: number, serverTransferMonitorAccessKeyAssignSub: ServerTransferMonitorAccessKeyAssignSub, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignAccessKeyToSubscription(facilityId, serverTransferMonitorAccessKeyAssignSub, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.assignAccessKeyToSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {ServerTransferMonitorAccessKeyVehicleSubAssignReq} serverTransferMonitorAccessKeyVehicleSubAssignReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignAccessKeyToVehicle(facilityId: number, accessKeyId: number, serverTransferMonitorAccessKeyVehicleSubAssignReq: ServerTransferMonitorAccessKeyVehicleSubAssignReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignAccessKeyToVehicle(facilityId, accessKeyId, serverTransferMonitorAccessKeyVehicleSubAssignReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.assignAccessKeyToVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {DataEntitiesSubscriptionStatus} status 
         * @param {boolean} isAccountsReceivable 
         * @param {ServerServicesChangeSubscriptionStatusBody} [serverServicesChangeSubscriptionStatusBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSubscriptionStatus(subscriptionId: number, status: DataEntitiesSubscriptionStatus, isAccountsReceivable: boolean, serverServicesChangeSubscriptionStatusBody?: ServerServicesChangeSubscriptionStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataEntitiesSubscriptionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSubscriptionStatus(subscriptionId, status, isAccountsReceivable, serverServicesChangeSubscriptionStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.changeSubscriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanInvoiceReq} serverTransferMonitorPlanInvoiceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPlanInvoice(facilityId: number, planId: number, serverTransferMonitorPlanInvoiceReq: ServerTransferMonitorPlanInvoiceReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorPlanInvoiceResp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPlanInvoice(facilityId, planId, serverTransferMonitorPlanInvoiceReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.confirmPlanInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorAccessKeyReq} serverTransferMonitorAccessKeyReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccessKey(facilityId: number, serverTransferMonitorAccessKeyReq: ServerTransferMonitorAccessKeyReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccessKey(facilityId, serverTransferMonitorAccessKeyReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createAccessKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorOrderCustomReq} serverTransferMonitorOrderCustomReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomOrder(facilityId: number, serverTransferMonitorOrderCustomReq: ServerTransferMonitorOrderCustomReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomOrder(facilityId, serverTransferMonitorOrderCustomReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createCustomOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferMonitorFacilityCreateReq} serverTransferMonitorFacilityCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFacility(serverTransferMonitorFacilityCreateReq: ServerTransferMonitorFacilityCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFacility(serverTransferMonitorFacilityCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createFacility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorImportPaymentReq} serverTransferMonitorImportPaymentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createImportedParkerPayment(facilityId: number, parkerId: number, serverTransferMonitorImportPaymentReq: ServerTransferMonitorImportPaymentReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createImportedParkerPayment(facilityId, parkerId, serverTransferMonitorImportPaymentReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createImportedParkerPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorCheckCreateReq} serverTransferMonitorCheckCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParkerCheck(facilityId: number, parkerId: number, serverTransferMonitorCheckCreateReq: ServerTransferMonitorCheckCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParkerCheck(facilityId, parkerId, serverTransferMonitorCheckCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createParkerCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorPlanCreateReq} serverTransferMonitorPlanCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlan(facilityId: number, serverTransferMonitorPlanCreateReq: ServerTransferMonitorPlanCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerCommonEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlan(facilityId, serverTransferMonitorPlanCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanPriceAddReq} serverTransferMonitorPlanPriceAddReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanPrice(facilityId: number, planId: number, serverTransferMonitorPlanPriceAddReq: ServerTransferMonitorPlanPriceAddReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorPlanPriceListResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanPrice(facilityId, planId, serverTransferMonitorPlanPriceAddReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createPlanPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferRateProgramData} serverTransferRateProgramData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRateProgram(facilityId: number, serverTransferRateProgramData: ServerTransferRateProgramData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferRateProgram>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRateProgram(facilityId, serverTransferRateProgramData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.createRateProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {number} vehicleId 
         * @param {ServerTransferMonitorVehicleDeleteReq} serverTransferMonitorVehicleDeleteReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscriptionVehicle(facilityId: number, subscriptionId: number, vehicleId: number, serverTransferMonitorVehicleDeleteReq: ServerTransferMonitorVehicleDeleteReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscriptionVehicle(facilityId, subscriptionId, vehicleId, serverTransferMonitorVehicleDeleteReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.deleteSubscriptionVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVehicle(facilityId: number, parkerId: number, vehicleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVehicle(facilityId, parkerId, vehicleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.deleteVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enhancedGroupFinalizeChanges(facilityId: number, subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enhancedGroupFinalizeChanges(facilityId, subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.enhancedGroupFinalizeChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferMonitorFacilityPayoutAccountUpdateReq} serverTransferMonitorFacilityPayoutAccountUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityPayoutAccountUpdate(serverTransferMonitorFacilityPayoutAccountUpdateReq: ServerTransferMonitorFacilityPayoutAccountUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityPayoutAccountUpdate(serverTransferMonitorFacilityPayoutAccountUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.facilityPayoutAccountUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessKey(facilityId: number, accessKeyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessKey(facilityId, accessKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getAccessKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessKeys(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorAccessKey>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessKeys(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getAccessKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferFacilityLite>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getFacilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacility2(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferFacility>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacility2(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getFacility2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilityStats(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferFacilityStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilityStats(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getFacilityStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferFacilityInvoice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerBalanceHistory(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferBalanceChange>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerBalanceHistory(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerBalanceHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerDetails(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorParkerDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerDetails(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerInviteCredentialCapability(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorFacilityInviteCredentialCapabilityResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerInviteCredentialCapability(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerInviteCredentialCapability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerInvoiceDetails(facilityId: number, parkerId: number, invoiceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferInvoice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerInvoiceDetails(facilityId, parkerId, invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerInvoiceDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerInvoices(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferInvoice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerInvoices(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerOpenOrders(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataEntitiesOrderDebt>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerOpenOrders(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerOpenOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerOrderDetails(facilityId: number, parkerId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferOrderDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerOrderDetails(facilityId, parkerId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerOrders(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferOrder>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerOrders(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerPaymentDetails(facilityId: number, parkerId: number, paymentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerPaymentDetails(facilityId, parkerId, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerPaymentDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerPayments(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferPayment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerPayments(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkerPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkers(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorParkerDetailsGridResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkers(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getParkers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} payoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayout(facilityId: number, payoutId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorFacilityPayout>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayout(facilityId, payoutId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getPayout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayouts(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorFacilityPayout>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayouts(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getPayouts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlan(facilityId: number, planId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorPlanDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlan(facilityId, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanInvites(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorPlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanInvites(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getPlanInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanPrices(facilityId: number, planId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorPlanPriceListResp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanPrices(facilityId, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getPlanPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlans(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorPlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlans(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} rateProgramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRateProgram(facilityId: number, rateProgramId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferRateProgram>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRateProgram(facilityId, rateProgramId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getRateProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRateProgramDiscounts(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferRateProgramDropdown>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRateProgramDiscounts(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getRateProgramDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatePrograms(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferRateProgram>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatePrograms(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getRatePrograms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {string} [timezone] 
         * @param {string} [createdSince] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessions(facilityId: number, timezone?: string, createdSince?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessions(facilityId, timezone, createdSince, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionDetails(subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferSubscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionDetails(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getSubscriptionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionEdit(facilityId: number, subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorSubForEdit>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionEdit(facilityId, subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getSubscriptionEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionManagement(subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferSubscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionManagement(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getSubscriptionManagement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptions(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorFacilitySub>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptions(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionsByParker(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorFacilitySub>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionsByParker(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getSubscriptionsByParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicles(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferVehicleDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVehicles(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.getVehicles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {File | null} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importParkers(facilityId: number, file?: File | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerCommonEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importParkers(facilityId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.importParkers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanInvoiceReq} serverTransferMonitorPlanInvoiceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializePlanInvoice(facilityId: number, planId: number, serverTransferMonitorPlanInvoiceReq: ServerTransferMonitorPlanInvoiceReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferMonitorPlanInvoiceResp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializePlanInvoice(facilityId, planId, serverTransferMonitorPlanInvoiceReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.initializePlanInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorInviteParkerReq} serverTransferMonitorInviteParkerReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteParker(facilityId: number, serverTransferMonitorInviteParkerReq: ServerTransferMonitorInviteParkerReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorInviteParkerResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteParker(facilityId, serverTransferMonitorInviteParkerReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.inviteParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerInviteReq} serverTransferMonitorSubscriptionParkerInviteReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteSubscriptionParker(facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerInviteReq: ServerTransferMonitorSubscriptionParkerInviteReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferSubscriptionParker>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteSubscriptionParker(facilityId, subscriptionId, serverTransferMonitorSubscriptionParkerInviteReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.inviteSubscriptionParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {Array<ServerTransferMonitorSubscriptionParkerInviteReq>} serverTransferMonitorSubscriptionParkerInviteReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteSubscriptionParkerBatch(facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerInviteReq: Array<ServerTransferMonitorSubscriptionParkerInviteReq>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferSubscriptionParker>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteSubscriptionParkerBatch(facilityId, subscriptionId, serverTransferMonitorSubscriptionParkerInviteReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.inviteSubscriptionParkerBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} inviteId 
         * @param {number} parkerId 
         * @param {string} action 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageParkerInvite(facilityId: number, inviteId: number, parkerId: number, action: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageParkerInvite(facilityId, inviteId, parkerId, action, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.manageParkerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerTransferMonitorImportPaymentReq} serverTransferMonitorImportPaymentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerCreditAccountCreate(facilityId: number, parkerId: number, serverTransferMonitorImportPaymentReq: ServerTransferMonitorImportPaymentReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerCreditAccountCreate(facilityId, parkerId, serverTransferMonitorImportPaymentReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.parkerCreditAccountCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferMonitorRatePreviewReq} serverTransferMonitorRatePreviewReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ratePreview(facilityId: number, serverTransferMonitorRatePreviewReq: ServerTransferMonitorRatePreviewReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferConnectReservePreviewResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ratePreview(facilityId, serverTransferMonitorRatePreviewReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.ratePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAccessKey(facilityId: number, accessKeyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAccessKey(facilityId, accessKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.removeAccessKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAccessKeyLink(facilityId: number, accessKeyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAccessKeyLink(facilityId, accessKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.removeAccessKeyLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerRemoveReq} serverTransferMonitorSubscriptionParkerRemoveReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSubscriptionParker(facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerRemoveReq: ServerTransferMonitorSubscriptionParkerRemoveReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSubscriptionParker(facilityId, subscriptionId, serverTransferMonitorSubscriptionParkerRemoveReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.removeSubscriptionParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} invoiceId 
         * @param {string} [recipientEmail] 
         * @param {boolean} [isAdjustmentReprint] 
         * @param {boolean} [isLiveReprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reprintInvoice(invoiceId: number, recipientEmail?: string, isAdjustmentReprint?: boolean, isLiveReprint?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerCommonEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reprintInvoice(invoiceId, recipientEmail, isAdjustmentReprint, isLiveReprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.reprintInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} query 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFacility(query: string, facilityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerServicesSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFacility(query, facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.searchFacility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerRemoveReq} serverTransferMonitorSubscriptionParkerRemoveReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoCancelSubscriptionParker(facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerRemoveReq: ServerTransferMonitorSubscriptionParkerRemoveReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoCancelSubscriptionParker(facilityId, subscriptionId, serverTransferMonitorSubscriptionParkerRemoveReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.undoCancelSubscriptionParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} accessKeyId 
         * @param {ServerTransferMonitorAccessKeyReq} serverTransferMonitorAccessKeyReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccessKey(facilityId: number, accessKeyId: number, serverTransferMonitorAccessKeyReq: ServerTransferMonitorAccessKeyReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorAccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccessKey(facilityId, accessKeyId, serverTransferMonitorAccessKeyReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateAccessKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferMonitorFacilityUpdateReq} serverTransferMonitorFacilityUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFacility(serverTransferMonitorFacilityUpdateReq: ServerTransferMonitorFacilityUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFacility(serverTransferMonitorFacilityUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateFacility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} planId 
         * @param {ServerTransferMonitorPlanUpdateReq} serverTransferMonitorPlanUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlan(facilityId: number, planId: number, serverTransferMonitorPlanUpdateReq: ServerTransferMonitorPlanUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerCommonEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlan(facilityId, planId, serverTransferMonitorPlanUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updatePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} rateProgramId 
         * @param {ServerTransferRateProgramData} serverTransferRateProgramData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRateProgram(facilityId: number, rateProgramId: number, serverTransferRateProgramData: ServerTransferRateProgramData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferRateProgram>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRateProgram(facilityId, rateProgramId, serverTransferRateProgramData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateRateProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} rateProgramId 
         * @param {boolean} isActive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRateProgramStatus(rateProgramId: number, isActive: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferRateProgram>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRateProgramStatus(rateProgramId, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateRateProgramStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionUpdateReq} serverTransferMonitorSubscriptionUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionEdit(facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionUpdateReq: ServerTransferMonitorSubscriptionUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferMonitorSubEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionEdit(facilityId, subscriptionId, serverTransferMonitorSubscriptionUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateSubscriptionEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerTransferMonitorSubscriptionParkerChangeReq} serverTransferMonitorSubscriptionParkerChangeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionParker(facilityId: number, subscriptionId: number, serverTransferMonitorSubscriptionParkerChangeReq: ServerTransferMonitorSubscriptionParkerChangeReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionParker(facilityId, subscriptionId, serverTransferMonitorSubscriptionParkerChangeReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateSubscriptionParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} vehicleId 
         * @param {ServerTransferVehicle} serverTransferVehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVehicle(facilityId: number, parkerId: number, vehicleId: number, serverTransferVehicle: ServerTransferVehicle, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferVehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVehicle(facilityId, parkerId, vehicleId, serverTransferVehicle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorFacilityApiApi.updateVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MonitorFacilityApiApi - factory interface
 * @export
 */
export const MonitorFacilityApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitorFacilityApiApiFp(configuration)
    return {
        /**
         * 
         * @param {MonitorFacilityApiApiAddSubscriptionVehicleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubscriptionVehicle(requestParameters: MonitorFacilityApiApiAddSubscriptionVehicleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorVehicleLinkResp> {
            return localVarFp.addSubscriptionVehicle(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorVehicleAddReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiAddVehicleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVehicle(requestParameters: MonitorFacilityApiApiAddVehicleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferVehicle> {
            return localVarFp.addVehicle(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferVehicle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiAdjustParkerOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustParkerOrder(requestParameters: MonitorFacilityApiApiAdjustParkerOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferOrderBalance> {
            return localVarFp.adjustParkerOrder(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorOrderAdjustReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiAdjustParkerPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustParkerPayment(requestParameters: MonitorFacilityApiApiAdjustParkerPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPaymentChange> {
            return localVarFp.adjustParkerPayment(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorPaymentAdjustReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiAssignAccessKeyToParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAccessKeyToParker(requestParameters: MonitorFacilityApiApiAssignAccessKeyToParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.assignAccessKeyToParker(requestParameters.facilityId, requestParameters.serverTransferMonitorAccessKeyParkerAssignReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiAssignAccessKeyToSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAccessKeyToSubscription(requestParameters: MonitorFacilityApiApiAssignAccessKeyToSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.assignAccessKeyToSubscription(requestParameters.facilityId, requestParameters.serverTransferMonitorAccessKeyAssignSub, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiAssignAccessKeyToVehicleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAccessKeyToVehicle(requestParameters: MonitorFacilityApiApiAssignAccessKeyToVehicleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.assignAccessKeyToVehicle(requestParameters.facilityId, requestParameters.accessKeyId, requestParameters.serverTransferMonitorAccessKeyVehicleSubAssignReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiChangeSubscriptionStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionStatus(requestParameters: MonitorFacilityApiApiChangeSubscriptionStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataEntitiesSubscriptionStatus> {
            return localVarFp.changeSubscriptionStatus(requestParameters.subscriptionId, requestParameters.status, requestParameters.isAccountsReceivable, requestParameters.serverServicesChangeSubscriptionStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiConfirmPlanInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPlanInvoice(requestParameters: MonitorFacilityApiApiConfirmPlanInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorPlanInvoiceResp>> {
            return localVarFp.confirmPlanInvoice(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanInvoiceReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreateAccessKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessKey(requestParameters: MonitorFacilityApiApiCreateAccessKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.createAccessKey(requestParameters.facilityId, requestParameters.serverTransferMonitorAccessKeyReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreateCustomOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomOrder(requestParameters: MonitorFacilityApiApiCreateCustomOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferOrder> {
            return localVarFp.createCustomOrder(requestParameters.facilityId, requestParameters.serverTransferMonitorOrderCustomReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreateFacilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacility(requestParameters: MonitorFacilityApiApiCreateFacilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createFacility(requestParameters.serverTransferMonitorFacilityCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreateImportedParkerPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createImportedParkerPayment(requestParameters: MonitorFacilityApiApiCreateImportedParkerPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPayment> {
            return localVarFp.createImportedParkerPayment(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorImportPaymentReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreateParkerCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParkerCheck(requestParameters: MonitorFacilityApiApiCreateParkerCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPayment> {
            return localVarFp.createParkerCheck(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorCheckCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreatePlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlan(requestParameters: MonitorFacilityApiApiCreatePlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerCommonEmpty> {
            return localVarFp.createPlan(requestParameters.facilityId, requestParameters.serverTransferMonitorPlanCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreatePlanPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanPrice(requestParameters: MonitorFacilityApiApiCreatePlanPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorPlanPriceListResp> {
            return localVarFp.createPlanPrice(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanPriceAddReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiCreateRateProgramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateProgram(requestParameters: MonitorFacilityApiApiCreateRateProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferRateProgram> {
            return localVarFp.createRateProgram(requestParameters.facilityId, requestParameters.serverTransferRateProgramData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiDeleteSubscriptionVehicleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionVehicle(requestParameters: MonitorFacilityApiApiDeleteSubscriptionVehicleRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteSubscriptionVehicle(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.vehicleId, requestParameters.serverTransferMonitorVehicleDeleteReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiDeleteVehicleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicle(requestParameters: MonitorFacilityApiApiDeleteVehicleRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteVehicle(requestParameters.facilityId, requestParameters.parkerId, requestParameters.vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiEnhancedGroupFinalizeChangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enhancedGroupFinalizeChanges(requestParameters: MonitorFacilityApiApiEnhancedGroupFinalizeChangesRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.enhancedGroupFinalizeChanges(requestParameters.facilityId, requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiFacilityPayoutAccountUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityPayoutAccountUpdate(requestParameters: MonitorFacilityApiApiFacilityPayoutAccountUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.facilityPayoutAccountUpdate(requestParameters.serverTransferMonitorFacilityPayoutAccountUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetAccessKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKey(requestParameters: MonitorFacilityApiApiGetAccessKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.getAccessKey(requestParameters.facilityId, requestParameters.accessKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetAccessKeysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKeys(requestParameters: MonitorFacilityApiApiGetAccessKeysRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorAccessKey>> {
            return localVarFp.getAccessKeys(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilities(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferFacilityLite>> {
            return localVarFp.getFacilities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetFacility2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacility2(requestParameters: MonitorFacilityApiApiGetFacility2Request, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferFacility> {
            return localVarFp.getFacility2(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetFacilityStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityStats(requestParameters: MonitorFacilityApiApiGetFacilityStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferFacilityStats> {
            return localVarFp.getFacilityStats(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(requestParameters: MonitorFacilityApiApiGetInvoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferFacilityInvoice>> {
            return localVarFp.getInvoices(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerBalanceHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerBalanceHistory(requestParameters: MonitorFacilityApiApiGetParkerBalanceHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferBalanceChange>> {
            return localVarFp.getParkerBalanceHistory(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerDetails(requestParameters: MonitorFacilityApiApiGetParkerDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorParkerDetails> {
            return localVarFp.getParkerDetails(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerInviteCredentialCapabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerInviteCredentialCapability(requestParameters: MonitorFacilityApiApiGetParkerInviteCredentialCapabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorFacilityInviteCredentialCapabilityResp> {
            return localVarFp.getParkerInviteCredentialCapability(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerInvoiceDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerInvoiceDetails(requestParameters: MonitorFacilityApiApiGetParkerInvoiceDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferInvoice> {
            return localVarFp.getParkerInvoiceDetails(requestParameters.facilityId, requestParameters.parkerId, requestParameters.invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerInvoices(requestParameters: MonitorFacilityApiApiGetParkerInvoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferInvoice>> {
            return localVarFp.getParkerInvoices(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerOpenOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOpenOrders(requestParameters: MonitorFacilityApiApiGetParkerOpenOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataEntitiesOrderDebt>> {
            return localVarFp.getParkerOpenOrders(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerOrderDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOrderDetails(requestParameters: MonitorFacilityApiApiGetParkerOrderDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferOrderDetails> {
            return localVarFp.getParkerOrderDetails(requestParameters.facilityId, requestParameters.parkerId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOrders(requestParameters: MonitorFacilityApiApiGetParkerOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferOrder>> {
            return localVarFp.getParkerOrders(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerPaymentDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerPaymentDetails(requestParameters: MonitorFacilityApiApiGetParkerPaymentDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPayment> {
            return localVarFp.getParkerPaymentDetails(requestParameters.facilityId, requestParameters.parkerId, requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkerPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerPayments(requestParameters: MonitorFacilityApiApiGetParkerPaymentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferPayment>> {
            return localVarFp.getParkerPayments(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetParkersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkers(requestParameters: MonitorFacilityApiApiGetParkersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorParkerDetailsGridResult> {
            return localVarFp.getParkers(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetPayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayout(requestParameters: MonitorFacilityApiApiGetPayoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorFacilityPayout> {
            return localVarFp.getPayout(requestParameters.facilityId, requestParameters.payoutId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetPayoutsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayouts(requestParameters: MonitorFacilityApiApiGetPayoutsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorFacilityPayout>> {
            return localVarFp.getPayouts(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan(requestParameters: MonitorFacilityApiApiGetPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorPlanDetails> {
            return localVarFp.getPlan(requestParameters.facilityId, requestParameters.planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetPlanInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanInvites(requestParameters: MonitorFacilityApiApiGetPlanInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorPlan>> {
            return localVarFp.getPlanInvites(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetPlanPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanPrices(requestParameters: MonitorFacilityApiApiGetPlanPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorPlanPriceListResp>> {
            return localVarFp.getPlanPrices(requestParameters.facilityId, requestParameters.planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans(requestParameters: MonitorFacilityApiApiGetPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorPlan>> {
            return localVarFp.getPlans(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetRateProgramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateProgram(requestParameters: MonitorFacilityApiApiGetRateProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferRateProgram> {
            return localVarFp.getRateProgram(requestParameters.facilityId, requestParameters.rateProgramId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetRateProgramDiscountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateProgramDiscounts(requestParameters: MonitorFacilityApiApiGetRateProgramDiscountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferRateProgramDropdown>> {
            return localVarFp.getRateProgramDiscounts(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetRateProgramsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatePrograms(requestParameters: MonitorFacilityApiApiGetRateProgramsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferRateProgram>> {
            return localVarFp.getRatePrograms(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessions(requestParameters: MonitorFacilityApiApiGetSessionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorSession>> {
            return localVarFp.getSessions(requestParameters.facilityId, requestParameters.timezone, requestParameters.createdSince, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetSubscriptionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionDetails(requestParameters: MonitorFacilityApiApiGetSubscriptionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferSubscription> {
            return localVarFp.getSubscriptionDetails(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetSubscriptionEditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionEdit(requestParameters: MonitorFacilityApiApiGetSubscriptionEditRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorSubForEdit> {
            return localVarFp.getSubscriptionEdit(requestParameters.facilityId, requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetSubscriptionManagementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionManagement(requestParameters: MonitorFacilityApiApiGetSubscriptionManagementRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferSubscription> {
            return localVarFp.getSubscriptionManagement(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(requestParameters: MonitorFacilityApiApiGetSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorFacilitySub>> {
            return localVarFp.getSubscriptions(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetSubscriptionsByParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsByParker(requestParameters: MonitorFacilityApiApiGetSubscriptionsByParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorFacilitySub>> {
            return localVarFp.getSubscriptionsByParker(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiGetVehiclesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicles(requestParameters: MonitorFacilityApiApiGetVehiclesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferVehicleDetails>> {
            return localVarFp.getVehicles(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiImportParkersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importParkers(requestParameters: MonitorFacilityApiApiImportParkersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerCommonEmpty> {
            return localVarFp.importParkers(requestParameters.facilityId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiInitializePlanInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializePlanInvoice(requestParameters: MonitorFacilityApiApiInitializePlanInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferMonitorPlanInvoiceResp>> {
            return localVarFp.initializePlanInvoice(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanInvoiceReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiInviteParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteParker(requestParameters: MonitorFacilityApiApiInviteParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorInviteParkerResp> {
            return localVarFp.inviteParker(requestParameters.facilityId, requestParameters.serverTransferMonitorInviteParkerReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiInviteSubscriptionParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteSubscriptionParker(requestParameters: MonitorFacilityApiApiInviteSubscriptionParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferSubscriptionParker> {
            return localVarFp.inviteSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerInviteReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiInviteSubscriptionParkerBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteSubscriptionParkerBatch(requestParameters: MonitorFacilityApiApiInviteSubscriptionParkerBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferSubscriptionParker>> {
            return localVarFp.inviteSubscriptionParkerBatch(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerInviteReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiManageParkerInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageParkerInvite(requestParameters: MonitorFacilityApiApiManageParkerInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.manageParkerInvite(requestParameters.facilityId, requestParameters.inviteId, requestParameters.parkerId, requestParameters.action, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiParkerCreditAccountCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerCreditAccountCreate(requestParameters: MonitorFacilityApiApiParkerCreditAccountCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPayment> {
            return localVarFp.parkerCreditAccountCreate(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorImportPaymentReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiRatePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ratePreview(requestParameters: MonitorFacilityApiApiRatePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferConnectReservePreviewResp> {
            return localVarFp.ratePreview(requestParameters.facilityId, requestParameters.serverTransferMonitorRatePreviewReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiRemoveAccessKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccessKey(requestParameters: MonitorFacilityApiApiRemoveAccessKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.removeAccessKey(requestParameters.facilityId, requestParameters.accessKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiRemoveAccessKeyLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccessKeyLink(requestParameters: MonitorFacilityApiApiRemoveAccessKeyLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.removeAccessKeyLink(requestParameters.facilityId, requestParameters.accessKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiRemoveSubscriptionParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubscriptionParker(requestParameters: MonitorFacilityApiApiRemoveSubscriptionParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.removeSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerRemoveReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiReprintInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprintInvoice(requestParameters: MonitorFacilityApiApiReprintInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerCommonEmpty> {
            return localVarFp.reprintInvoice(requestParameters.invoiceId, requestParameters.recipientEmail, requestParameters.isAdjustmentReprint, requestParameters.isLiveReprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiSearchFacilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFacility(requestParameters: MonitorFacilityApiApiSearchFacilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerServicesSearchResult>> {
            return localVarFp.searchFacility(requestParameters.query, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUndoCancelSubscriptionParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCancelSubscriptionParker(requestParameters: MonitorFacilityApiApiUndoCancelSubscriptionParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.undoCancelSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerRemoveReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateAccessKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessKey(requestParameters: MonitorFacilityApiApiUpdateAccessKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorAccessKey> {
            return localVarFp.updateAccessKey(requestParameters.facilityId, requestParameters.accessKeyId, requestParameters.serverTransferMonitorAccessKeyReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateFacilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacility(requestParameters: MonitorFacilityApiApiUpdateFacilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateFacility(requestParameters.serverTransferMonitorFacilityUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdatePlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan(requestParameters: MonitorFacilityApiApiUpdatePlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerCommonEmpty> {
            return localVarFp.updatePlan(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateRateProgramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateProgram(requestParameters: MonitorFacilityApiApiUpdateRateProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferRateProgram> {
            return localVarFp.updateRateProgram(requestParameters.facilityId, requestParameters.rateProgramId, requestParameters.serverTransferRateProgramData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateRateProgramStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateProgramStatus(requestParameters: MonitorFacilityApiApiUpdateRateProgramStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferRateProgram> {
            return localVarFp.updateRateProgramStatus(requestParameters.rateProgramId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateSubscriptionEditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionEdit(requestParameters: MonitorFacilityApiApiUpdateSubscriptionEditRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferMonitorSubEntry> {
            return localVarFp.updateSubscriptionEdit(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateSubscriptionParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionParker(requestParameters: MonitorFacilityApiApiUpdateSubscriptionParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerChangeReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorFacilityApiApiUpdateVehicleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicle(requestParameters: MonitorFacilityApiApiUpdateVehicleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferVehicle> {
            return localVarFp.updateVehicle(requestParameters.facilityId, requestParameters.parkerId, requestParameters.vehicleId, requestParameters.serverTransferVehicle, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addSubscriptionVehicle operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAddSubscriptionVehicleRequest
 */
export interface MonitorFacilityApiApiAddSubscriptionVehicleRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAddSubscriptionVehicle
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAddSubscriptionVehicle
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerTransferMonitorVehicleAddReq}
     * @memberof MonitorFacilityApiApiAddSubscriptionVehicle
     */
    readonly serverTransferMonitorVehicleAddReq: ServerTransferMonitorVehicleAddReq
}

/**
 * Request parameters for addVehicle operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAddVehicleRequest
 */
export interface MonitorFacilityApiApiAddVehicleRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAddVehicle
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAddVehicle
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerTransferVehicle}
     * @memberof MonitorFacilityApiApiAddVehicle
     */
    readonly serverTransferVehicle: ServerTransferVehicle
}

/**
 * Request parameters for adjustParkerOrder operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAdjustParkerOrderRequest
 */
export interface MonitorFacilityApiApiAdjustParkerOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAdjustParkerOrder
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAdjustParkerOrder
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerTransferMonitorOrderAdjustReq}
     * @memberof MonitorFacilityApiApiAdjustParkerOrder
     */
    readonly serverTransferMonitorOrderAdjustReq: ServerTransferMonitorOrderAdjustReq
}

/**
 * Request parameters for adjustParkerPayment operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAdjustParkerPaymentRequest
 */
export interface MonitorFacilityApiApiAdjustParkerPaymentRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAdjustParkerPayment
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAdjustParkerPayment
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerTransferMonitorPaymentAdjustReq}
     * @memberof MonitorFacilityApiApiAdjustParkerPayment
     */
    readonly serverTransferMonitorPaymentAdjustReq: ServerTransferMonitorPaymentAdjustReq
}

/**
 * Request parameters for assignAccessKeyToParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAssignAccessKeyToParkerRequest
 */
export interface MonitorFacilityApiApiAssignAccessKeyToParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorAccessKeyParkerAssignReq}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToParker
     */
    readonly serverTransferMonitorAccessKeyParkerAssignReq: ServerTransferMonitorAccessKeyParkerAssignReq
}

/**
 * Request parameters for assignAccessKeyToSubscription operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAssignAccessKeyToSubscriptionRequest
 */
export interface MonitorFacilityApiApiAssignAccessKeyToSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToSubscription
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorAccessKeyAssignSub}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToSubscription
     */
    readonly serverTransferMonitorAccessKeyAssignSub: ServerTransferMonitorAccessKeyAssignSub
}

/**
 * Request parameters for assignAccessKeyToVehicle operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiAssignAccessKeyToVehicleRequest
 */
export interface MonitorFacilityApiApiAssignAccessKeyToVehicleRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToVehicle
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToVehicle
     */
    readonly accessKeyId: number

    /**
     * 
     * @type {ServerTransferMonitorAccessKeyVehicleSubAssignReq}
     * @memberof MonitorFacilityApiApiAssignAccessKeyToVehicle
     */
    readonly serverTransferMonitorAccessKeyVehicleSubAssignReq: ServerTransferMonitorAccessKeyVehicleSubAssignReq
}

/**
 * Request parameters for changeSubscriptionStatus operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiChangeSubscriptionStatusRequest
 */
export interface MonitorFacilityApiApiChangeSubscriptionStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiChangeSubscriptionStatus
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {DataEntitiesSubscriptionStatus}
     * @memberof MonitorFacilityApiApiChangeSubscriptionStatus
     */
    readonly status: DataEntitiesSubscriptionStatus

    /**
     * 
     * @type {boolean}
     * @memberof MonitorFacilityApiApiChangeSubscriptionStatus
     */
    readonly isAccountsReceivable: boolean

    /**
     * 
     * @type {ServerServicesChangeSubscriptionStatusBody}
     * @memberof MonitorFacilityApiApiChangeSubscriptionStatus
     */
    readonly serverServicesChangeSubscriptionStatusBody?: ServerServicesChangeSubscriptionStatusBody
}

/**
 * Request parameters for confirmPlanInvoice operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiConfirmPlanInvoiceRequest
 */
export interface MonitorFacilityApiApiConfirmPlanInvoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiConfirmPlanInvoice
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiConfirmPlanInvoice
     */
    readonly planId: number

    /**
     * 
     * @type {ServerTransferMonitorPlanInvoiceReq}
     * @memberof MonitorFacilityApiApiConfirmPlanInvoice
     */
    readonly serverTransferMonitorPlanInvoiceReq: ServerTransferMonitorPlanInvoiceReq
}

/**
 * Request parameters for createAccessKey operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreateAccessKeyRequest
 */
export interface MonitorFacilityApiApiCreateAccessKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateAccessKey
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorAccessKeyReq}
     * @memberof MonitorFacilityApiApiCreateAccessKey
     */
    readonly serverTransferMonitorAccessKeyReq: ServerTransferMonitorAccessKeyReq
}

/**
 * Request parameters for createCustomOrder operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreateCustomOrderRequest
 */
export interface MonitorFacilityApiApiCreateCustomOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateCustomOrder
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorOrderCustomReq}
     * @memberof MonitorFacilityApiApiCreateCustomOrder
     */
    readonly serverTransferMonitorOrderCustomReq: ServerTransferMonitorOrderCustomReq
}

/**
 * Request parameters for createFacility operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreateFacilityRequest
 */
export interface MonitorFacilityApiApiCreateFacilityRequest {
    /**
     * 
     * @type {ServerTransferMonitorFacilityCreateReq}
     * @memberof MonitorFacilityApiApiCreateFacility
     */
    readonly serverTransferMonitorFacilityCreateReq: ServerTransferMonitorFacilityCreateReq
}

/**
 * Request parameters for createImportedParkerPayment operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreateImportedParkerPaymentRequest
 */
export interface MonitorFacilityApiApiCreateImportedParkerPaymentRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateImportedParkerPayment
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateImportedParkerPayment
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerTransferMonitorImportPaymentReq}
     * @memberof MonitorFacilityApiApiCreateImportedParkerPayment
     */
    readonly serverTransferMonitorImportPaymentReq: ServerTransferMonitorImportPaymentReq
}

/**
 * Request parameters for createParkerCheck operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreateParkerCheckRequest
 */
export interface MonitorFacilityApiApiCreateParkerCheckRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateParkerCheck
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateParkerCheck
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerTransferMonitorCheckCreateReq}
     * @memberof MonitorFacilityApiApiCreateParkerCheck
     */
    readonly serverTransferMonitorCheckCreateReq: ServerTransferMonitorCheckCreateReq
}

/**
 * Request parameters for createPlan operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreatePlanRequest
 */
export interface MonitorFacilityApiApiCreatePlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreatePlan
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorPlanCreateReq}
     * @memberof MonitorFacilityApiApiCreatePlan
     */
    readonly serverTransferMonitorPlanCreateReq: ServerTransferMonitorPlanCreateReq
}

/**
 * Request parameters for createPlanPrice operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreatePlanPriceRequest
 */
export interface MonitorFacilityApiApiCreatePlanPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreatePlanPrice
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreatePlanPrice
     */
    readonly planId: number

    /**
     * 
     * @type {ServerTransferMonitorPlanPriceAddReq}
     * @memberof MonitorFacilityApiApiCreatePlanPrice
     */
    readonly serverTransferMonitorPlanPriceAddReq: ServerTransferMonitorPlanPriceAddReq
}

/**
 * Request parameters for createRateProgram operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiCreateRateProgramRequest
 */
export interface MonitorFacilityApiApiCreateRateProgramRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiCreateRateProgram
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferRateProgramData}
     * @memberof MonitorFacilityApiApiCreateRateProgram
     */
    readonly serverTransferRateProgramData: ServerTransferRateProgramData
}

/**
 * Request parameters for deleteSubscriptionVehicle operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiDeleteSubscriptionVehicleRequest
 */
export interface MonitorFacilityApiApiDeleteSubscriptionVehicleRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiDeleteSubscriptionVehicle
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiDeleteSubscriptionVehicle
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiDeleteSubscriptionVehicle
     */
    readonly vehicleId: number

    /**
     * 
     * @type {ServerTransferMonitorVehicleDeleteReq}
     * @memberof MonitorFacilityApiApiDeleteSubscriptionVehicle
     */
    readonly serverTransferMonitorVehicleDeleteReq: ServerTransferMonitorVehicleDeleteReq
}

/**
 * Request parameters for deleteVehicle operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiDeleteVehicleRequest
 */
export interface MonitorFacilityApiApiDeleteVehicleRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiDeleteVehicle
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiDeleteVehicle
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiDeleteVehicle
     */
    readonly vehicleId: number
}

/**
 * Request parameters for enhancedGroupFinalizeChanges operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiEnhancedGroupFinalizeChangesRequest
 */
export interface MonitorFacilityApiApiEnhancedGroupFinalizeChangesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiEnhancedGroupFinalizeChanges
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiEnhancedGroupFinalizeChanges
     */
    readonly subscriptionId: number
}

/**
 * Request parameters for facilityPayoutAccountUpdate operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiFacilityPayoutAccountUpdateRequest
 */
export interface MonitorFacilityApiApiFacilityPayoutAccountUpdateRequest {
    /**
     * 
     * @type {ServerTransferMonitorFacilityPayoutAccountUpdateReq}
     * @memberof MonitorFacilityApiApiFacilityPayoutAccountUpdate
     */
    readonly serverTransferMonitorFacilityPayoutAccountUpdateReq: ServerTransferMonitorFacilityPayoutAccountUpdateReq
}

/**
 * Request parameters for getAccessKey operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetAccessKeyRequest
 */
export interface MonitorFacilityApiApiGetAccessKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetAccessKey
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetAccessKey
     */
    readonly accessKeyId: number
}

/**
 * Request parameters for getAccessKeys operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetAccessKeysRequest
 */
export interface MonitorFacilityApiApiGetAccessKeysRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetAccessKeys
     */
    readonly facilityId: number
}

/**
 * Request parameters for getFacility2 operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetFacility2Request
 */
export interface MonitorFacilityApiApiGetFacility2Request {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetFacility2
     */
    readonly facilityId: number
}

/**
 * Request parameters for getFacilityStats operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetFacilityStatsRequest
 */
export interface MonitorFacilityApiApiGetFacilityStatsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetFacilityStats
     */
    readonly facilityId: number
}

/**
 * Request parameters for getInvoices operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetInvoicesRequest
 */
export interface MonitorFacilityApiApiGetInvoicesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetInvoices
     */
    readonly facilityId: number
}

/**
 * Request parameters for getParkerBalanceHistory operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerBalanceHistoryRequest
 */
export interface MonitorFacilityApiApiGetParkerBalanceHistoryRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerBalanceHistory
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerBalanceHistory
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkerDetails operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerDetailsRequest
 */
export interface MonitorFacilityApiApiGetParkerDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerDetails
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerDetails
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkerInviteCredentialCapability operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerInviteCredentialCapabilityRequest
 */
export interface MonitorFacilityApiApiGetParkerInviteCredentialCapabilityRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerInviteCredentialCapability
     */
    readonly facilityId: number
}

/**
 * Request parameters for getParkerInvoiceDetails operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerInvoiceDetailsRequest
 */
export interface MonitorFacilityApiApiGetParkerInvoiceDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerInvoiceDetails
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerInvoiceDetails
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerInvoiceDetails
     */
    readonly invoiceId: number
}

/**
 * Request parameters for getParkerInvoices operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerInvoicesRequest
 */
export interface MonitorFacilityApiApiGetParkerInvoicesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerInvoices
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerInvoices
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkerOpenOrders operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerOpenOrdersRequest
 */
export interface MonitorFacilityApiApiGetParkerOpenOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOpenOrders
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOpenOrders
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkerOrderDetails operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerOrderDetailsRequest
 */
export interface MonitorFacilityApiApiGetParkerOrderDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOrderDetails
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOrderDetails
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOrderDetails
     */
    readonly orderId: number
}

/**
 * Request parameters for getParkerOrders operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerOrdersRequest
 */
export interface MonitorFacilityApiApiGetParkerOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOrders
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerOrders
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkerPaymentDetails operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerPaymentDetailsRequest
 */
export interface MonitorFacilityApiApiGetParkerPaymentDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerPaymentDetails
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerPaymentDetails
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerPaymentDetails
     */
    readonly paymentId: number
}

/**
 * Request parameters for getParkerPayments operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkerPaymentsRequest
 */
export interface MonitorFacilityApiApiGetParkerPaymentsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerPayments
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkerPayments
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkers operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetParkersRequest
 */
export interface MonitorFacilityApiApiGetParkersRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetParkers
     */
    readonly facilityId: number
}

/**
 * Request parameters for getPayout operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetPayoutRequest
 */
export interface MonitorFacilityApiApiGetPayoutRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPayout
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPayout
     */
    readonly payoutId: number
}

/**
 * Request parameters for getPayouts operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetPayoutsRequest
 */
export interface MonitorFacilityApiApiGetPayoutsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPayouts
     */
    readonly facilityId: number
}

/**
 * Request parameters for getPlan operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetPlanRequest
 */
export interface MonitorFacilityApiApiGetPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPlan
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPlan
     */
    readonly planId: number
}

/**
 * Request parameters for getPlanInvites operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetPlanInvitesRequest
 */
export interface MonitorFacilityApiApiGetPlanInvitesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPlanInvites
     */
    readonly facilityId: number
}

/**
 * Request parameters for getPlanPrices operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetPlanPricesRequest
 */
export interface MonitorFacilityApiApiGetPlanPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPlanPrices
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPlanPrices
     */
    readonly planId: number
}

/**
 * Request parameters for getPlans operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetPlansRequest
 */
export interface MonitorFacilityApiApiGetPlansRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetPlans
     */
    readonly facilityId: number
}

/**
 * Request parameters for getRateProgram operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetRateProgramRequest
 */
export interface MonitorFacilityApiApiGetRateProgramRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetRateProgram
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetRateProgram
     */
    readonly rateProgramId: number
}

/**
 * Request parameters for getRateProgramDiscounts operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetRateProgramDiscountsRequest
 */
export interface MonitorFacilityApiApiGetRateProgramDiscountsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetRateProgramDiscounts
     */
    readonly facilityId: number
}

/**
 * Request parameters for getRatePrograms operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetRateProgramsRequest
 */
export interface MonitorFacilityApiApiGetRateProgramsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetRatePrograms
     */
    readonly facilityId: number
}

/**
 * Request parameters for getSessions operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetSessionsRequest
 */
export interface MonitorFacilityApiApiGetSessionsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSessions
     */
    readonly facilityId: number

    /**
     * 
     * @type {string}
     * @memberof MonitorFacilityApiApiGetSessions
     */
    readonly timezone?: string

    /**
     * 
     * @type {string}
     * @memberof MonitorFacilityApiApiGetSessions
     */
    readonly createdSince?: string
}

/**
 * Request parameters for getSubscriptionDetails operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetSubscriptionDetailsRequest
 */
export interface MonitorFacilityApiApiGetSubscriptionDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptionDetails
     */
    readonly subscriptionId: number
}

/**
 * Request parameters for getSubscriptionEdit operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetSubscriptionEditRequest
 */
export interface MonitorFacilityApiApiGetSubscriptionEditRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptionEdit
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptionEdit
     */
    readonly subscriptionId: number
}

/**
 * Request parameters for getSubscriptionManagement operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetSubscriptionManagementRequest
 */
export interface MonitorFacilityApiApiGetSubscriptionManagementRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptionManagement
     */
    readonly subscriptionId: number
}

/**
 * Request parameters for getSubscriptions operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetSubscriptionsRequest
 */
export interface MonitorFacilityApiApiGetSubscriptionsRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptions
     */
    readonly facilityId: number
}

/**
 * Request parameters for getSubscriptionsByParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetSubscriptionsByParkerRequest
 */
export interface MonitorFacilityApiApiGetSubscriptionsByParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptionsByParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetSubscriptionsByParker
     */
    readonly parkerId: number
}

/**
 * Request parameters for getVehicles operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiGetVehiclesRequest
 */
export interface MonitorFacilityApiApiGetVehiclesRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetVehicles
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiGetVehicles
     */
    readonly parkerId: number
}

/**
 * Request parameters for importParkers operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiImportParkersRequest
 */
export interface MonitorFacilityApiApiImportParkersRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiImportParkers
     */
    readonly facilityId: number

    /**
     * 
     * @type {File}
     * @memberof MonitorFacilityApiApiImportParkers
     */
    readonly file?: File | null
}

/**
 * Request parameters for initializePlanInvoice operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiInitializePlanInvoiceRequest
 */
export interface MonitorFacilityApiApiInitializePlanInvoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInitializePlanInvoice
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInitializePlanInvoice
     */
    readonly planId: number

    /**
     * 
     * @type {ServerTransferMonitorPlanInvoiceReq}
     * @memberof MonitorFacilityApiApiInitializePlanInvoice
     */
    readonly serverTransferMonitorPlanInvoiceReq: ServerTransferMonitorPlanInvoiceReq
}

/**
 * Request parameters for inviteParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiInviteParkerRequest
 */
export interface MonitorFacilityApiApiInviteParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInviteParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorInviteParkerReq}
     * @memberof MonitorFacilityApiApiInviteParker
     */
    readonly serverTransferMonitorInviteParkerReq: ServerTransferMonitorInviteParkerReq
}

/**
 * Request parameters for inviteSubscriptionParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiInviteSubscriptionParkerRequest
 */
export interface MonitorFacilityApiApiInviteSubscriptionParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInviteSubscriptionParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInviteSubscriptionParker
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerTransferMonitorSubscriptionParkerInviteReq}
     * @memberof MonitorFacilityApiApiInviteSubscriptionParker
     */
    readonly serverTransferMonitorSubscriptionParkerInviteReq: ServerTransferMonitorSubscriptionParkerInviteReq
}

/**
 * Request parameters for inviteSubscriptionParkerBatch operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiInviteSubscriptionParkerBatchRequest
 */
export interface MonitorFacilityApiApiInviteSubscriptionParkerBatchRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInviteSubscriptionParkerBatch
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiInviteSubscriptionParkerBatch
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {Array<ServerTransferMonitorSubscriptionParkerInviteReq>}
     * @memberof MonitorFacilityApiApiInviteSubscriptionParkerBatch
     */
    readonly serverTransferMonitorSubscriptionParkerInviteReq: Array<ServerTransferMonitorSubscriptionParkerInviteReq>
}

/**
 * Request parameters for manageParkerInvite operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiManageParkerInviteRequest
 */
export interface MonitorFacilityApiApiManageParkerInviteRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiManageParkerInvite
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiManageParkerInvite
     */
    readonly inviteId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiManageParkerInvite
     */
    readonly parkerId: number

    /**
     * 
     * @type {string}
     * @memberof MonitorFacilityApiApiManageParkerInvite
     */
    readonly action: string
}

/**
 * Request parameters for parkerCreditAccountCreate operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiParkerCreditAccountCreateRequest
 */
export interface MonitorFacilityApiApiParkerCreditAccountCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiParkerCreditAccountCreate
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiParkerCreditAccountCreate
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerTransferMonitorImportPaymentReq}
     * @memberof MonitorFacilityApiApiParkerCreditAccountCreate
     */
    readonly serverTransferMonitorImportPaymentReq: ServerTransferMonitorImportPaymentReq
}

/**
 * Request parameters for ratePreview operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiRatePreviewRequest
 */
export interface MonitorFacilityApiApiRatePreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRatePreview
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferMonitorRatePreviewReq}
     * @memberof MonitorFacilityApiApiRatePreview
     */
    readonly serverTransferMonitorRatePreviewReq: ServerTransferMonitorRatePreviewReq
}

/**
 * Request parameters for removeAccessKey operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiRemoveAccessKeyRequest
 */
export interface MonitorFacilityApiApiRemoveAccessKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRemoveAccessKey
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRemoveAccessKey
     */
    readonly accessKeyId: number
}

/**
 * Request parameters for removeAccessKeyLink operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiRemoveAccessKeyLinkRequest
 */
export interface MonitorFacilityApiApiRemoveAccessKeyLinkRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRemoveAccessKeyLink
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRemoveAccessKeyLink
     */
    readonly accessKeyId: number
}

/**
 * Request parameters for removeSubscriptionParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiRemoveSubscriptionParkerRequest
 */
export interface MonitorFacilityApiApiRemoveSubscriptionParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRemoveSubscriptionParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiRemoveSubscriptionParker
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerTransferMonitorSubscriptionParkerRemoveReq}
     * @memberof MonitorFacilityApiApiRemoveSubscriptionParker
     */
    readonly serverTransferMonitorSubscriptionParkerRemoveReq: ServerTransferMonitorSubscriptionParkerRemoveReq
}

/**
 * Request parameters for reprintInvoice operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiReprintInvoiceRequest
 */
export interface MonitorFacilityApiApiReprintInvoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiReprintInvoice
     */
    readonly invoiceId: number

    /**
     * 
     * @type {string}
     * @memberof MonitorFacilityApiApiReprintInvoice
     */
    readonly recipientEmail?: string

    /**
     * 
     * @type {boolean}
     * @memberof MonitorFacilityApiApiReprintInvoice
     */
    readonly isAdjustmentReprint?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof MonitorFacilityApiApiReprintInvoice
     */
    readonly isLiveReprint?: boolean
}

/**
 * Request parameters for searchFacility operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiSearchFacilityRequest
 */
export interface MonitorFacilityApiApiSearchFacilityRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitorFacilityApiApiSearchFacility
     */
    readonly query: string

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiSearchFacility
     */
    readonly facilityId?: number
}

/**
 * Request parameters for undoCancelSubscriptionParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUndoCancelSubscriptionParkerRequest
 */
export interface MonitorFacilityApiApiUndoCancelSubscriptionParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUndoCancelSubscriptionParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUndoCancelSubscriptionParker
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerTransferMonitorSubscriptionParkerRemoveReq}
     * @memberof MonitorFacilityApiApiUndoCancelSubscriptionParker
     */
    readonly serverTransferMonitorSubscriptionParkerRemoveReq: ServerTransferMonitorSubscriptionParkerRemoveReq
}

/**
 * Request parameters for updateAccessKey operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateAccessKeyRequest
 */
export interface MonitorFacilityApiApiUpdateAccessKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateAccessKey
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateAccessKey
     */
    readonly accessKeyId: number

    /**
     * 
     * @type {ServerTransferMonitorAccessKeyReq}
     * @memberof MonitorFacilityApiApiUpdateAccessKey
     */
    readonly serverTransferMonitorAccessKeyReq: ServerTransferMonitorAccessKeyReq
}

/**
 * Request parameters for updateFacility operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateFacilityRequest
 */
export interface MonitorFacilityApiApiUpdateFacilityRequest {
    /**
     * 
     * @type {ServerTransferMonitorFacilityUpdateReq}
     * @memberof MonitorFacilityApiApiUpdateFacility
     */
    readonly serverTransferMonitorFacilityUpdateReq: ServerTransferMonitorFacilityUpdateReq
}

/**
 * Request parameters for updatePlan operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdatePlanRequest
 */
export interface MonitorFacilityApiApiUpdatePlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdatePlan
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdatePlan
     */
    readonly planId: number

    /**
     * 
     * @type {ServerTransferMonitorPlanUpdateReq}
     * @memberof MonitorFacilityApiApiUpdatePlan
     */
    readonly serverTransferMonitorPlanUpdateReq: ServerTransferMonitorPlanUpdateReq
}

/**
 * Request parameters for updateRateProgram operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateRateProgramRequest
 */
export interface MonitorFacilityApiApiUpdateRateProgramRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateRateProgram
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateRateProgram
     */
    readonly rateProgramId: number

    /**
     * 
     * @type {ServerTransferRateProgramData}
     * @memberof MonitorFacilityApiApiUpdateRateProgram
     */
    readonly serverTransferRateProgramData: ServerTransferRateProgramData
}

/**
 * Request parameters for updateRateProgramStatus operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateRateProgramStatusRequest
 */
export interface MonitorFacilityApiApiUpdateRateProgramStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateRateProgramStatus
     */
    readonly rateProgramId: number

    /**
     * 
     * @type {boolean}
     * @memberof MonitorFacilityApiApiUpdateRateProgramStatus
     */
    readonly isActive: boolean
}

/**
 * Request parameters for updateSubscriptionEdit operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateSubscriptionEditRequest
 */
export interface MonitorFacilityApiApiUpdateSubscriptionEditRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateSubscriptionEdit
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateSubscriptionEdit
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerTransferMonitorSubscriptionUpdateReq}
     * @memberof MonitorFacilityApiApiUpdateSubscriptionEdit
     */
    readonly serverTransferMonitorSubscriptionUpdateReq: ServerTransferMonitorSubscriptionUpdateReq
}

/**
 * Request parameters for updateSubscriptionParker operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateSubscriptionParkerRequest
 */
export interface MonitorFacilityApiApiUpdateSubscriptionParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateSubscriptionParker
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateSubscriptionParker
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerTransferMonitorSubscriptionParkerChangeReq}
     * @memberof MonitorFacilityApiApiUpdateSubscriptionParker
     */
    readonly serverTransferMonitorSubscriptionParkerChangeReq: ServerTransferMonitorSubscriptionParkerChangeReq
}

/**
 * Request parameters for updateVehicle operation in MonitorFacilityApiApi.
 * @export
 * @interface MonitorFacilityApiApiUpdateVehicleRequest
 */
export interface MonitorFacilityApiApiUpdateVehicleRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateVehicle
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateVehicle
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorFacilityApiApiUpdateVehicle
     */
    readonly vehicleId: number

    /**
     * 
     * @type {ServerTransferVehicle}
     * @memberof MonitorFacilityApiApiUpdateVehicle
     */
    readonly serverTransferVehicle: ServerTransferVehicle
}

/**
 * MonitorFacilityApiApi - object-oriented interface
 * @export
 * @class MonitorFacilityApiApi
 * @extends {BaseAPI}
 */
export class MonitorFacilityApiApi extends BaseAPI {
    /**
     * 
     * @param {MonitorFacilityApiApiAddSubscriptionVehicleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public addSubscriptionVehicle(requestParameters: MonitorFacilityApiApiAddSubscriptionVehicleRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).addSubscriptionVehicle(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorVehicleAddReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiAddVehicleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public addVehicle(requestParameters: MonitorFacilityApiApiAddVehicleRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).addVehicle(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferVehicle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiAdjustParkerOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public adjustParkerOrder(requestParameters: MonitorFacilityApiApiAdjustParkerOrderRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).adjustParkerOrder(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorOrderAdjustReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiAdjustParkerPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public adjustParkerPayment(requestParameters: MonitorFacilityApiApiAdjustParkerPaymentRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).adjustParkerPayment(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorPaymentAdjustReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiAssignAccessKeyToParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public assignAccessKeyToParker(requestParameters: MonitorFacilityApiApiAssignAccessKeyToParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).assignAccessKeyToParker(requestParameters.facilityId, requestParameters.serverTransferMonitorAccessKeyParkerAssignReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiAssignAccessKeyToSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public assignAccessKeyToSubscription(requestParameters: MonitorFacilityApiApiAssignAccessKeyToSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).assignAccessKeyToSubscription(requestParameters.facilityId, requestParameters.serverTransferMonitorAccessKeyAssignSub, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiAssignAccessKeyToVehicleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public assignAccessKeyToVehicle(requestParameters: MonitorFacilityApiApiAssignAccessKeyToVehicleRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).assignAccessKeyToVehicle(requestParameters.facilityId, requestParameters.accessKeyId, requestParameters.serverTransferMonitorAccessKeyVehicleSubAssignReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiChangeSubscriptionStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public changeSubscriptionStatus(requestParameters: MonitorFacilityApiApiChangeSubscriptionStatusRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).changeSubscriptionStatus(requestParameters.subscriptionId, requestParameters.status, requestParameters.isAccountsReceivable, requestParameters.serverServicesChangeSubscriptionStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiConfirmPlanInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public confirmPlanInvoice(requestParameters: MonitorFacilityApiApiConfirmPlanInvoiceRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).confirmPlanInvoice(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanInvoiceReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreateAccessKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createAccessKey(requestParameters: MonitorFacilityApiApiCreateAccessKeyRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createAccessKey(requestParameters.facilityId, requestParameters.serverTransferMonitorAccessKeyReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreateCustomOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createCustomOrder(requestParameters: MonitorFacilityApiApiCreateCustomOrderRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createCustomOrder(requestParameters.facilityId, requestParameters.serverTransferMonitorOrderCustomReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreateFacilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createFacility(requestParameters: MonitorFacilityApiApiCreateFacilityRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createFacility(requestParameters.serverTransferMonitorFacilityCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreateImportedParkerPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createImportedParkerPayment(requestParameters: MonitorFacilityApiApiCreateImportedParkerPaymentRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createImportedParkerPayment(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorImportPaymentReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreateParkerCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createParkerCheck(requestParameters: MonitorFacilityApiApiCreateParkerCheckRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createParkerCheck(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorCheckCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreatePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createPlan(requestParameters: MonitorFacilityApiApiCreatePlanRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createPlan(requestParameters.facilityId, requestParameters.serverTransferMonitorPlanCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreatePlanPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createPlanPrice(requestParameters: MonitorFacilityApiApiCreatePlanPriceRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createPlanPrice(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanPriceAddReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiCreateRateProgramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public createRateProgram(requestParameters: MonitorFacilityApiApiCreateRateProgramRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).createRateProgram(requestParameters.facilityId, requestParameters.serverTransferRateProgramData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiDeleteSubscriptionVehicleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public deleteSubscriptionVehicle(requestParameters: MonitorFacilityApiApiDeleteSubscriptionVehicleRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).deleteSubscriptionVehicle(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.vehicleId, requestParameters.serverTransferMonitorVehicleDeleteReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiDeleteVehicleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public deleteVehicle(requestParameters: MonitorFacilityApiApiDeleteVehicleRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).deleteVehicle(requestParameters.facilityId, requestParameters.parkerId, requestParameters.vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiEnhancedGroupFinalizeChangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public enhancedGroupFinalizeChanges(requestParameters: MonitorFacilityApiApiEnhancedGroupFinalizeChangesRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).enhancedGroupFinalizeChanges(requestParameters.facilityId, requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiFacilityPayoutAccountUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public facilityPayoutAccountUpdate(requestParameters: MonitorFacilityApiApiFacilityPayoutAccountUpdateRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).facilityPayoutAccountUpdate(requestParameters.serverTransferMonitorFacilityPayoutAccountUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetAccessKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getAccessKey(requestParameters: MonitorFacilityApiApiGetAccessKeyRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getAccessKey(requestParameters.facilityId, requestParameters.accessKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetAccessKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getAccessKeys(requestParameters: MonitorFacilityApiApiGetAccessKeysRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getAccessKeys(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getFacilities(options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getFacilities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetFacility2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getFacility2(requestParameters: MonitorFacilityApiApiGetFacility2Request, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getFacility2(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetFacilityStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getFacilityStats(requestParameters: MonitorFacilityApiApiGetFacilityStatsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getFacilityStats(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getInvoices(requestParameters: MonitorFacilityApiApiGetInvoicesRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getInvoices(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerBalanceHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerBalanceHistory(requestParameters: MonitorFacilityApiApiGetParkerBalanceHistoryRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerBalanceHistory(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerDetails(requestParameters: MonitorFacilityApiApiGetParkerDetailsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerDetails(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerInviteCredentialCapabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerInviteCredentialCapability(requestParameters: MonitorFacilityApiApiGetParkerInviteCredentialCapabilityRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerInviteCredentialCapability(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerInvoiceDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerInvoiceDetails(requestParameters: MonitorFacilityApiApiGetParkerInvoiceDetailsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerInvoiceDetails(requestParameters.facilityId, requestParameters.parkerId, requestParameters.invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerInvoices(requestParameters: MonitorFacilityApiApiGetParkerInvoicesRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerInvoices(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerOpenOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerOpenOrders(requestParameters: MonitorFacilityApiApiGetParkerOpenOrdersRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerOpenOrders(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerOrderDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerOrderDetails(requestParameters: MonitorFacilityApiApiGetParkerOrderDetailsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerOrderDetails(requestParameters.facilityId, requestParameters.parkerId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerOrders(requestParameters: MonitorFacilityApiApiGetParkerOrdersRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerOrders(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerPaymentDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerPaymentDetails(requestParameters: MonitorFacilityApiApiGetParkerPaymentDetailsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerPaymentDetails(requestParameters.facilityId, requestParameters.parkerId, requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkerPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkerPayments(requestParameters: MonitorFacilityApiApiGetParkerPaymentsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkerPayments(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetParkersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getParkers(requestParameters: MonitorFacilityApiApiGetParkersRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getParkers(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetPayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getPayout(requestParameters: MonitorFacilityApiApiGetPayoutRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getPayout(requestParameters.facilityId, requestParameters.payoutId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetPayoutsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getPayouts(requestParameters: MonitorFacilityApiApiGetPayoutsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getPayouts(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getPlan(requestParameters: MonitorFacilityApiApiGetPlanRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getPlan(requestParameters.facilityId, requestParameters.planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetPlanInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getPlanInvites(requestParameters: MonitorFacilityApiApiGetPlanInvitesRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getPlanInvites(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetPlanPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getPlanPrices(requestParameters: MonitorFacilityApiApiGetPlanPricesRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getPlanPrices(requestParameters.facilityId, requestParameters.planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getPlans(requestParameters: MonitorFacilityApiApiGetPlansRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getPlans(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetRateProgramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getRateProgram(requestParameters: MonitorFacilityApiApiGetRateProgramRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getRateProgram(requestParameters.facilityId, requestParameters.rateProgramId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetRateProgramDiscountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getRateProgramDiscounts(requestParameters: MonitorFacilityApiApiGetRateProgramDiscountsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getRateProgramDiscounts(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetRateProgramsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getRatePrograms(requestParameters: MonitorFacilityApiApiGetRateProgramsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getRatePrograms(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getSessions(requestParameters: MonitorFacilityApiApiGetSessionsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getSessions(requestParameters.facilityId, requestParameters.timezone, requestParameters.createdSince, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetSubscriptionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getSubscriptionDetails(requestParameters: MonitorFacilityApiApiGetSubscriptionDetailsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getSubscriptionDetails(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetSubscriptionEditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getSubscriptionEdit(requestParameters: MonitorFacilityApiApiGetSubscriptionEditRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getSubscriptionEdit(requestParameters.facilityId, requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetSubscriptionManagementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getSubscriptionManagement(requestParameters: MonitorFacilityApiApiGetSubscriptionManagementRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getSubscriptionManagement(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getSubscriptions(requestParameters: MonitorFacilityApiApiGetSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getSubscriptions(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetSubscriptionsByParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getSubscriptionsByParker(requestParameters: MonitorFacilityApiApiGetSubscriptionsByParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getSubscriptionsByParker(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiGetVehiclesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public getVehicles(requestParameters: MonitorFacilityApiApiGetVehiclesRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).getVehicles(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiImportParkersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public importParkers(requestParameters: MonitorFacilityApiApiImportParkersRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).importParkers(requestParameters.facilityId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiInitializePlanInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public initializePlanInvoice(requestParameters: MonitorFacilityApiApiInitializePlanInvoiceRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).initializePlanInvoice(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanInvoiceReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiInviteParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public inviteParker(requestParameters: MonitorFacilityApiApiInviteParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).inviteParker(requestParameters.facilityId, requestParameters.serverTransferMonitorInviteParkerReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiInviteSubscriptionParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public inviteSubscriptionParker(requestParameters: MonitorFacilityApiApiInviteSubscriptionParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).inviteSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerInviteReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiInviteSubscriptionParkerBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public inviteSubscriptionParkerBatch(requestParameters: MonitorFacilityApiApiInviteSubscriptionParkerBatchRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).inviteSubscriptionParkerBatch(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerInviteReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiManageParkerInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public manageParkerInvite(requestParameters: MonitorFacilityApiApiManageParkerInviteRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).manageParkerInvite(requestParameters.facilityId, requestParameters.inviteId, requestParameters.parkerId, requestParameters.action, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiParkerCreditAccountCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public parkerCreditAccountCreate(requestParameters: MonitorFacilityApiApiParkerCreditAccountCreateRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).parkerCreditAccountCreate(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverTransferMonitorImportPaymentReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiRatePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public ratePreview(requestParameters: MonitorFacilityApiApiRatePreviewRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).ratePreview(requestParameters.facilityId, requestParameters.serverTransferMonitorRatePreviewReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiRemoveAccessKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public removeAccessKey(requestParameters: MonitorFacilityApiApiRemoveAccessKeyRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).removeAccessKey(requestParameters.facilityId, requestParameters.accessKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiRemoveAccessKeyLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public removeAccessKeyLink(requestParameters: MonitorFacilityApiApiRemoveAccessKeyLinkRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).removeAccessKeyLink(requestParameters.facilityId, requestParameters.accessKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiRemoveSubscriptionParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public removeSubscriptionParker(requestParameters: MonitorFacilityApiApiRemoveSubscriptionParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).removeSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerRemoveReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiReprintInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public reprintInvoice(requestParameters: MonitorFacilityApiApiReprintInvoiceRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).reprintInvoice(requestParameters.invoiceId, requestParameters.recipientEmail, requestParameters.isAdjustmentReprint, requestParameters.isLiveReprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiSearchFacilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public searchFacility(requestParameters: MonitorFacilityApiApiSearchFacilityRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).searchFacility(requestParameters.query, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUndoCancelSubscriptionParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public undoCancelSubscriptionParker(requestParameters: MonitorFacilityApiApiUndoCancelSubscriptionParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).undoCancelSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerRemoveReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateAccessKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateAccessKey(requestParameters: MonitorFacilityApiApiUpdateAccessKeyRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateAccessKey(requestParameters.facilityId, requestParameters.accessKeyId, requestParameters.serverTransferMonitorAccessKeyReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateFacilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateFacility(requestParameters: MonitorFacilityApiApiUpdateFacilityRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateFacility(requestParameters.serverTransferMonitorFacilityUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdatePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updatePlan(requestParameters: MonitorFacilityApiApiUpdatePlanRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updatePlan(requestParameters.facilityId, requestParameters.planId, requestParameters.serverTransferMonitorPlanUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateRateProgramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateRateProgram(requestParameters: MonitorFacilityApiApiUpdateRateProgramRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateRateProgram(requestParameters.facilityId, requestParameters.rateProgramId, requestParameters.serverTransferRateProgramData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateRateProgramStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateRateProgramStatus(requestParameters: MonitorFacilityApiApiUpdateRateProgramStatusRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateRateProgramStatus(requestParameters.rateProgramId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateSubscriptionEditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateSubscriptionEdit(requestParameters: MonitorFacilityApiApiUpdateSubscriptionEditRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateSubscriptionEdit(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateSubscriptionParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateSubscriptionParker(requestParameters: MonitorFacilityApiApiUpdateSubscriptionParkerRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateSubscriptionParker(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverTransferMonitorSubscriptionParkerChangeReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorFacilityApiApiUpdateVehicleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorFacilityApiApi
     */
    public updateVehicle(requestParameters: MonitorFacilityApiApiUpdateVehicleRequest, options?: RawAxiosRequestConfig) {
        return MonitorFacilityApiApiFp(this.configuration).updateVehicle(requestParameters.facilityId, requestParameters.parkerId, requestParameters.vehicleId, requestParameters.serverTransferVehicle, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MonitorGroupParkerApi - axios parameter creator
 * @export
 */
export const MonitorGroupParkerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerFinalizeRequest} [serverRequestsGroupParkerFinalizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerFinalize: async (facilityId: number, subscriptionId: number, serverRequestsGroupParkerFinalizeRequest?: ServerRequestsGroupParkerFinalizeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorGroupParkerFinalize', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('monitorGroupParkerFinalize', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/{facilityId}/group-parker/{subscriptionId}/finalize`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerFinalizeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerFinalizeQuoteRequest} [serverRequestsGroupParkerFinalizeQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerFinalizeQuote: async (facilityId: number, subscriptionId: number, serverRequestsGroupParkerFinalizeQuoteRequest?: ServerRequestsGroupParkerFinalizeQuoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorGroupParkerFinalizeQuote', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('monitorGroupParkerFinalizeQuote', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/{facilityId}/group-parker/{subscriptionId}/finalize-quote`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerFinalizeQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerPreviewRequest} [serverRequestsGroupParkerPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerPreview: async (facilityId: number, subscriptionId: number, serverRequestsGroupParkerPreviewRequest?: ServerRequestsGroupParkerPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorGroupParkerPreview', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('monitorGroupParkerPreview', 'subscriptionId', subscriptionId)
            const localVarPath = `/monitor/facility/{facilityId}/group-parker/{subscriptionId}/preview`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {ServerRequestsGroupParkerUpdateRequest} [serverRequestsGroupParkerUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerUpdate: async (facilityId: number, subscriptionId: number, parkerId: number, serverRequestsGroupParkerUpdateRequest?: ServerRequestsGroupParkerUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorGroupParkerUpdate', 'facilityId', facilityId)
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('monitorGroupParkerUpdate', 'subscriptionId', subscriptionId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('monitorGroupParkerUpdate', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/group-parker/{subscriptionId}/parker/{parkerId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGroupParkerUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitorGroupParkerApi - functional programming interface
 * @export
 */
export const MonitorGroupParkerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitorGroupParkerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerFinalizeRequest} [serverRequestsGroupParkerFinalizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorGroupParkerFinalize(facilityId: number, subscriptionId: number, serverRequestsGroupParkerFinalizeRequest?: ServerRequestsGroupParkerFinalizeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerFinalizeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorGroupParkerFinalize(facilityId, subscriptionId, serverRequestsGroupParkerFinalizeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorGroupParkerApi.monitorGroupParkerFinalize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerFinalizeQuoteRequest} [serverRequestsGroupParkerFinalizeQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorGroupParkerFinalizeQuote(facilityId: number, subscriptionId: number, serverRequestsGroupParkerFinalizeQuoteRequest?: ServerRequestsGroupParkerFinalizeQuoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerFinalizeQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorGroupParkerFinalizeQuote(facilityId, subscriptionId, serverRequestsGroupParkerFinalizeQuoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorGroupParkerApi.monitorGroupParkerFinalizeQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {ServerRequestsGroupParkerPreviewRequest} [serverRequestsGroupParkerPreviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorGroupParkerPreview(facilityId: number, subscriptionId: number, serverRequestsGroupParkerPreviewRequest?: ServerRequestsGroupParkerPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorGroupParkerPreview(facilityId, subscriptionId, serverRequestsGroupParkerPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorGroupParkerApi.monitorGroupParkerPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {ServerRequestsGroupParkerUpdateRequest} [serverRequestsGroupParkerUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorGroupParkerUpdate(facilityId: number, subscriptionId: number, parkerId: number, serverRequestsGroupParkerUpdateRequest?: ServerRequestsGroupParkerUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGroupParkerUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorGroupParkerUpdate(facilityId, subscriptionId, parkerId, serverRequestsGroupParkerUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorGroupParkerApi.monitorGroupParkerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MonitorGroupParkerApi - factory interface
 * @export
 */
export const MonitorGroupParkerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitorGroupParkerApiFp(configuration)
    return {
        /**
         * 
         * @param {MonitorGroupParkerApiMonitorGroupParkerFinalizeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerFinalize(requestParameters: MonitorGroupParkerApiMonitorGroupParkerFinalizeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerFinalizeResponse> {
            return localVarFp.monitorGroupParkerFinalize(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerFinalizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorGroupParkerApiMonitorGroupParkerFinalizeQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerFinalizeQuote(requestParameters: MonitorGroupParkerApiMonitorGroupParkerFinalizeQuoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerFinalizeQuoteResponse> {
            return localVarFp.monitorGroupParkerFinalizeQuote(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerFinalizeQuoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorGroupParkerApiMonitorGroupParkerPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerPreview(requestParameters: MonitorGroupParkerApiMonitorGroupParkerPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerPreviewResponse> {
            return localVarFp.monitorGroupParkerPreview(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorGroupParkerApiMonitorGroupParkerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGroupParkerUpdate(requestParameters: MonitorGroupParkerApiMonitorGroupParkerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGroupParkerUpdateResponse> {
            return localVarFp.monitorGroupParkerUpdate(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.parkerId, requestParameters.serverRequestsGroupParkerUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for monitorGroupParkerFinalize operation in MonitorGroupParkerApi.
 * @export
 * @interface MonitorGroupParkerApiMonitorGroupParkerFinalizeRequest
 */
export interface MonitorGroupParkerApiMonitorGroupParkerFinalizeRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerFinalize
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerFinalize
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerFinalizeRequest}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerFinalize
     */
    readonly serverRequestsGroupParkerFinalizeRequest?: ServerRequestsGroupParkerFinalizeRequest
}

/**
 * Request parameters for monitorGroupParkerFinalizeQuote operation in MonitorGroupParkerApi.
 * @export
 * @interface MonitorGroupParkerApiMonitorGroupParkerFinalizeQuoteRequest
 */
export interface MonitorGroupParkerApiMonitorGroupParkerFinalizeQuoteRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerFinalizeQuote
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerFinalizeQuote
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerFinalizeQuoteRequest}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerFinalizeQuote
     */
    readonly serverRequestsGroupParkerFinalizeQuoteRequest?: ServerRequestsGroupParkerFinalizeQuoteRequest
}

/**
 * Request parameters for monitorGroupParkerPreview operation in MonitorGroupParkerApi.
 * @export
 * @interface MonitorGroupParkerApiMonitorGroupParkerPreviewRequest
 */
export interface MonitorGroupParkerApiMonitorGroupParkerPreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerPreview
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerPreview
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerPreviewRequest}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerPreview
     */
    readonly serverRequestsGroupParkerPreviewRequest?: ServerRequestsGroupParkerPreviewRequest
}

/**
 * Request parameters for monitorGroupParkerUpdate operation in MonitorGroupParkerApi.
 * @export
 * @interface MonitorGroupParkerApiMonitorGroupParkerUpdateRequest
 */
export interface MonitorGroupParkerApiMonitorGroupParkerUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerUpdate
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerUpdate
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {number}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerUpdate
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerRequestsGroupParkerUpdateRequest}
     * @memberof MonitorGroupParkerApiMonitorGroupParkerUpdate
     */
    readonly serverRequestsGroupParkerUpdateRequest?: ServerRequestsGroupParkerUpdateRequest
}

/**
 * MonitorGroupParkerApi - object-oriented interface
 * @export
 * @class MonitorGroupParkerApi
 * @extends {BaseAPI}
 */
export class MonitorGroupParkerApi extends BaseAPI {
    /**
     * 
     * @param {MonitorGroupParkerApiMonitorGroupParkerFinalizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorGroupParkerApi
     */
    public monitorGroupParkerFinalize(requestParameters: MonitorGroupParkerApiMonitorGroupParkerFinalizeRequest, options?: RawAxiosRequestConfig) {
        return MonitorGroupParkerApiFp(this.configuration).monitorGroupParkerFinalize(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerFinalizeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorGroupParkerApiMonitorGroupParkerFinalizeQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorGroupParkerApi
     */
    public monitorGroupParkerFinalizeQuote(requestParameters: MonitorGroupParkerApiMonitorGroupParkerFinalizeQuoteRequest, options?: RawAxiosRequestConfig) {
        return MonitorGroupParkerApiFp(this.configuration).monitorGroupParkerFinalizeQuote(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerFinalizeQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorGroupParkerApiMonitorGroupParkerPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorGroupParkerApi
     */
    public monitorGroupParkerPreview(requestParameters: MonitorGroupParkerApiMonitorGroupParkerPreviewRequest, options?: RawAxiosRequestConfig) {
        return MonitorGroupParkerApiFp(this.configuration).monitorGroupParkerPreview(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.serverRequestsGroupParkerPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorGroupParkerApiMonitorGroupParkerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorGroupParkerApi
     */
    public monitorGroupParkerUpdate(requestParameters: MonitorGroupParkerApiMonitorGroupParkerUpdateRequest, options?: RawAxiosRequestConfig) {
        return MonitorGroupParkerApiFp(this.configuration).monitorGroupParkerUpdate(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.parkerId, requestParameters.serverRequestsGroupParkerUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MonitorStripeApiApi - axios parameter creator
 * @export
 */
export const MonitorStripeApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripeAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/stripe/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityName 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripeCreateNewAccount: async (facilityName: string, facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityName' is not null or undefined
            assertParamExists('monitorStripeCreateNewAccount', 'facilityName', facilityName)
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorStripeCreateNewAccount', 'facilityId', facilityId)
            const localVarPath = `/monitor/stripe/accounts/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityName !== undefined) {
                localVarQueryParameter['facilityName'] = facilityName;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {boolean} [createAccount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripeFacilityIdLinkGet: async (facilityId: number, createAccount?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorStripeFacilityIdLinkGet', 'facilityId', facilityId)
            const localVarPath = `/monitor/stripe/{facilityId}/link`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (createAccount !== undefined) {
                localVarQueryParameter['createAccount'] = createAccount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripePayoutOnboardingInviteGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('monitorStripePayoutOnboardingInviteGet', 'token', token)
            const localVarPath = `/monitor/stripe/payout-onboarding/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripePayoutOnboardingInviteLinkPost: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('monitorStripePayoutOnboardingInviteLinkPost', 'token', token)
            const localVarPath = `/monitor/stripe/payout-onboarding/{token}/link`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferPayoutOnboardingShareReq} serverTransferPayoutOnboardingShareReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripePayoutOnboardingShare: async (facilityId: number, serverTransferPayoutOnboardingShareReq: ServerTransferPayoutOnboardingShareReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorStripePayoutOnboardingShare', 'facilityId', facilityId)
            // verify required parameter 'serverTransferPayoutOnboardingShareReq' is not null or undefined
            assertParamExists('monitorStripePayoutOnboardingShare', 'serverTransferPayoutOnboardingShareReq', serverTransferPayoutOnboardingShareReq)
            const localVarPath = `/monitor/stripe/{facilityId}/payout-onboarding/share`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferPayoutOnboardingShareReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitorStripeApiApi - functional programming interface
 * @export
 */
export const MonitorStripeApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitorStripeApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorStripeAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferConnectedAccountDropdown>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorStripeAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorStripeApiApi.monitorStripeAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} facilityName 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorStripeCreateNewAccount(facilityName: string, facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferNewPayoutAccountResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorStripeCreateNewAccount(facilityName, facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorStripeApiApi.monitorStripeCreateNewAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {boolean} [createAccount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorStripeFacilityIdLinkGet(facilityId: number, createAccount?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerServicesStripeLinkResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorStripeFacilityIdLinkGet(facilityId, createAccount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorStripeApiApi.monitorStripeFacilityIdLinkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorStripePayoutOnboardingInviteGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPayoutOnboardingInviteStatusResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorStripePayoutOnboardingInviteGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorStripeApiApi.monitorStripePayoutOnboardingInviteGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorStripePayoutOnboardingInviteLinkPost(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerServicesStripeLinkResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorStripePayoutOnboardingInviteLinkPost(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorStripeApiApi.monitorStripePayoutOnboardingInviteLinkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerTransferPayoutOnboardingShareReq} serverTransferPayoutOnboardingShareReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorStripePayoutOnboardingShare(facilityId: number, serverTransferPayoutOnboardingShareReq: ServerTransferPayoutOnboardingShareReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferPayoutOnboardingShareResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorStripePayoutOnboardingShare(facilityId, serverTransferPayoutOnboardingShareReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MonitorStripeApiApi.monitorStripePayoutOnboardingShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MonitorStripeApiApi - factory interface
 * @export
 */
export const MonitorStripeApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitorStripeApiApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripeAccounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferConnectedAccountDropdown>> {
            return localVarFp.monitorStripeAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorStripeApiApiMonitorStripeCreateNewAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripeCreateNewAccount(requestParameters: MonitorStripeApiApiMonitorStripeCreateNewAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferNewPayoutAccountResult> {
            return localVarFp.monitorStripeCreateNewAccount(requestParameters.facilityName, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorStripeApiApiMonitorStripeFacilityIdLinkGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripeFacilityIdLinkGet(requestParameters: MonitorStripeApiApiMonitorStripeFacilityIdLinkGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerServicesStripeLinkResp> {
            return localVarFp.monitorStripeFacilityIdLinkGet(requestParameters.facilityId, requestParameters.createAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripePayoutOnboardingInviteGet(requestParameters: MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPayoutOnboardingInviteStatusResp> {
            return localVarFp.monitorStripePayoutOnboardingInviteGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripePayoutOnboardingInviteLinkPost(requestParameters: MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerServicesStripeLinkResp> {
            return localVarFp.monitorStripePayoutOnboardingInviteLinkPost(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MonitorStripeApiApiMonitorStripePayoutOnboardingShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorStripePayoutOnboardingShare(requestParameters: MonitorStripeApiApiMonitorStripePayoutOnboardingShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferPayoutOnboardingShareResp> {
            return localVarFp.monitorStripePayoutOnboardingShare(requestParameters.facilityId, requestParameters.serverTransferPayoutOnboardingShareReq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for monitorStripeCreateNewAccount operation in MonitorStripeApiApi.
 * @export
 * @interface MonitorStripeApiApiMonitorStripeCreateNewAccountRequest
 */
export interface MonitorStripeApiApiMonitorStripeCreateNewAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitorStripeApiApiMonitorStripeCreateNewAccount
     */
    readonly facilityName: string

    /**
     * 
     * @type {number}
     * @memberof MonitorStripeApiApiMonitorStripeCreateNewAccount
     */
    readonly facilityId: number
}

/**
 * Request parameters for monitorStripeFacilityIdLinkGet operation in MonitorStripeApiApi.
 * @export
 * @interface MonitorStripeApiApiMonitorStripeFacilityIdLinkGetRequest
 */
export interface MonitorStripeApiApiMonitorStripeFacilityIdLinkGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorStripeApiApiMonitorStripeFacilityIdLinkGet
     */
    readonly facilityId: number

    /**
     * 
     * @type {boolean}
     * @memberof MonitorStripeApiApiMonitorStripeFacilityIdLinkGet
     */
    readonly createAccount?: boolean
}

/**
 * Request parameters for monitorStripePayoutOnboardingInviteGet operation in MonitorStripeApiApi.
 * @export
 * @interface MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGetRequest
 */
export interface MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGet
     */
    readonly token: string
}

/**
 * Request parameters for monitorStripePayoutOnboardingInviteLinkPost operation in MonitorStripeApiApi.
 * @export
 * @interface MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPostRequest
 */
export interface MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPostRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPost
     */
    readonly token: string
}

/**
 * Request parameters for monitorStripePayoutOnboardingShare operation in MonitorStripeApiApi.
 * @export
 * @interface MonitorStripeApiApiMonitorStripePayoutOnboardingShareRequest
 */
export interface MonitorStripeApiApiMonitorStripePayoutOnboardingShareRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitorStripeApiApiMonitorStripePayoutOnboardingShare
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerTransferPayoutOnboardingShareReq}
     * @memberof MonitorStripeApiApiMonitorStripePayoutOnboardingShare
     */
    readonly serverTransferPayoutOnboardingShareReq: ServerTransferPayoutOnboardingShareReq
}

/**
 * MonitorStripeApiApi - object-oriented interface
 * @export
 * @class MonitorStripeApiApi
 * @extends {BaseAPI}
 */
export class MonitorStripeApiApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorStripeApiApi
     */
    public monitorStripeAccounts(options?: RawAxiosRequestConfig) {
        return MonitorStripeApiApiFp(this.configuration).monitorStripeAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorStripeApiApiMonitorStripeCreateNewAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorStripeApiApi
     */
    public monitorStripeCreateNewAccount(requestParameters: MonitorStripeApiApiMonitorStripeCreateNewAccountRequest, options?: RawAxiosRequestConfig) {
        return MonitorStripeApiApiFp(this.configuration).monitorStripeCreateNewAccount(requestParameters.facilityName, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorStripeApiApiMonitorStripeFacilityIdLinkGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorStripeApiApi
     */
    public monitorStripeFacilityIdLinkGet(requestParameters: MonitorStripeApiApiMonitorStripeFacilityIdLinkGetRequest, options?: RawAxiosRequestConfig) {
        return MonitorStripeApiApiFp(this.configuration).monitorStripeFacilityIdLinkGet(requestParameters.facilityId, requestParameters.createAccount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorStripeApiApi
     */
    public monitorStripePayoutOnboardingInviteGet(requestParameters: MonitorStripeApiApiMonitorStripePayoutOnboardingInviteGetRequest, options?: RawAxiosRequestConfig) {
        return MonitorStripeApiApiFp(this.configuration).monitorStripePayoutOnboardingInviteGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorStripeApiApi
     */
    public monitorStripePayoutOnboardingInviteLinkPost(requestParameters: MonitorStripeApiApiMonitorStripePayoutOnboardingInviteLinkPostRequest, options?: RawAxiosRequestConfig) {
        return MonitorStripeApiApiFp(this.configuration).monitorStripePayoutOnboardingInviteLinkPost(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MonitorStripeApiApiMonitorStripePayoutOnboardingShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorStripeApiApi
     */
    public monitorStripePayoutOnboardingShare(requestParameters: MonitorStripeApiApiMonitorStripePayoutOnboardingShareRequest, options?: RawAxiosRequestConfig) {
        return MonitorStripeApiApiFp(this.configuration).monitorStripePayoutOnboardingShare(requestParameters.facilityId, requestParameters.serverTransferPayoutOnboardingShareReq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperatorApi - axios parameter creator
 * @export
 */
export const OperatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsOverview: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/operators/analytics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsCreateOperatorRequest} [serverRequestsCreateOperatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (serverRequestsCreateOperatorRequest?: ServerRequestsCreateOperatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/operators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateOperatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            const localVarPath = `/operators/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/operators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsPatchOperatorRequest} [serverRequestsPatchOperatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch: async (id: number, serverRequestsPatchOperatorRequest?: ServerRequestsPatchOperatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patch', 'id', id)
            const localVarPath = `/operators/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsPatchOperatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorApi - functional programming interface
 * @export
 */
export const OperatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsOverview(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsAnalyticsOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsOverview(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApi.analyticsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsCreateOperatorRequest} [serverRequestsCreateOperatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(serverRequestsCreateOperatorRequest?: ServerRequestsCreateOperatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetOperatorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(serverRequestsCreateOperatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetOperatorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetOperatorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsPatchOperatorRequest} [serverRequestsPatchOperatorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch(id: number, serverRequestsPatchOperatorRequest?: ServerRequestsPatchOperatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetOperatorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch(id, serverRequestsPatchOperatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApi.patch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperatorApi - factory interface
 * @export
 */
export const OperatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorApiFp(configuration)
    return {
        /**
         * 
         * @param {OperatorApiAnalyticsOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsOverview(requestParameters: OperatorApiAnalyticsOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsAnalyticsOverviewResponse> {
            return localVarFp.analyticsOverview(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OperatorApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: OperatorApiCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetOperatorResponse> {
            return localVarFp.create(requestParameters.serverRequestsCreateOperatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OperatorApiGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(requestParameters: OperatorApiGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetOperatorResponse> {
            return localVarFp.get(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetOperatorsResponse> {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OperatorApiPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch(requestParameters: OperatorApiPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetOperatorResponse> {
            return localVarFp.patch(requestParameters.id, requestParameters.serverRequestsPatchOperatorRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for analyticsOverview operation in OperatorApi.
 * @export
 * @interface OperatorApiAnalyticsOverviewRequest
 */
export interface OperatorApiAnalyticsOverviewRequest {
    /**
     * 
     * @type {object}
     * @memberof OperatorApiAnalyticsOverview
     */
    readonly body?: object
}

/**
 * Request parameters for create operation in OperatorApi.
 * @export
 * @interface OperatorApiCreateRequest
 */
export interface OperatorApiCreateRequest {
    /**
     * 
     * @type {ServerRequestsCreateOperatorRequest}
     * @memberof OperatorApiCreate
     */
    readonly serverRequestsCreateOperatorRequest?: ServerRequestsCreateOperatorRequest
}

/**
 * Request parameters for get operation in OperatorApi.
 * @export
 * @interface OperatorApiGetRequest
 */
export interface OperatorApiGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OperatorApiGet
     */
    readonly id: number
}

/**
 * Request parameters for patch operation in OperatorApi.
 * @export
 * @interface OperatorApiPatchRequest
 */
export interface OperatorApiPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof OperatorApiPatch
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsPatchOperatorRequest}
     * @memberof OperatorApiPatch
     */
    readonly serverRequestsPatchOperatorRequest?: ServerRequestsPatchOperatorRequest
}

/**
 * OperatorApi - object-oriented interface
 * @export
 * @class OperatorApi
 * @extends {BaseAPI}
 */
export class OperatorApi extends BaseAPI {
    /**
     * 
     * @param {OperatorApiAnalyticsOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApi
     */
    public analyticsOverview(requestParameters: OperatorApiAnalyticsOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorApiFp(this.configuration).analyticsOverview(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OperatorApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApi
     */
    public create(requestParameters: OperatorApiCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorApiFp(this.configuration).create(requestParameters.serverRequestsCreateOperatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OperatorApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApi
     */
    public get(requestParameters: OperatorApiGetRequest, options?: RawAxiosRequestConfig) {
        return OperatorApiFp(this.configuration).get(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApi
     */
    public list(options?: RawAxiosRequestConfig) {
        return OperatorApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OperatorApiPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApi
     */
    public patch(requestParameters: OperatorApiPatchRequest, options?: RawAxiosRequestConfig) {
        return OperatorApiFp(this.configuration).patch(requestParameters.id, requestParameters.serverRequestsPatchOperatorRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperatorApiApi - axios parameter creator
 * @export
 */
export const OperatorApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerServicesOperatorCreateReq} serverServicesOperatorCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operatorPost: async (serverServicesOperatorCreateReq: ServerServicesOperatorCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverServicesOperatorCreateReq' is not null or undefined
            assertParamExists('operatorPost', 'serverServicesOperatorCreateReq', serverServicesOperatorCreateReq)
            const localVarPath = `/Operator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverServicesOperatorCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorApiApi - functional programming interface
 * @export
 */
export const OperatorApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataEntitiesOperator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApiApi.monitorGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerServicesOperatorCreateReq} serverServicesOperatorCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operatorPost(serverServicesOperatorCreateReq: ServerServicesOperatorCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataEntitiesOperator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operatorPost(serverServicesOperatorCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorApiApi.operatorPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperatorApiApi - factory interface
 * @export
 */
export const OperatorApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorApiApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGet(options?: RawAxiosRequestConfig): AxiosPromise<DataEntitiesOperator> {
            return localVarFp.monitorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OperatorApiApiOperatorPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operatorPost(requestParameters: OperatorApiApiOperatorPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataEntitiesOperator> {
            return localVarFp.operatorPost(requestParameters.serverServicesOperatorCreateReq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for operatorPost operation in OperatorApiApi.
 * @export
 * @interface OperatorApiApiOperatorPostRequest
 */
export interface OperatorApiApiOperatorPostRequest {
    /**
     * 
     * @type {ServerServicesOperatorCreateReq}
     * @memberof OperatorApiApiOperatorPost
     */
    readonly serverServicesOperatorCreateReq: ServerServicesOperatorCreateReq
}

/**
 * OperatorApiApi - object-oriented interface
 * @export
 * @class OperatorApiApi
 * @extends {BaseAPI}
 */
export class OperatorApiApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApiApi
     */
    public monitorGet(options?: RawAxiosRequestConfig) {
        return OperatorApiApiFp(this.configuration).monitorGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OperatorApiApiOperatorPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorApiApi
     */
    public operatorPost(requestParameters: OperatorApiApiOperatorPostRequest, options?: RawAxiosRequestConfig) {
        return OperatorApiApiFp(this.configuration).operatorPost(requestParameters.serverServicesOperatorCreateReq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperatorInvoiceApi - axios parameter creator
 * @export
 */
export const OperatorInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorInvoices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/operator/invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorInvoiceApi - functional programming interface
 * @export
 */
export const OperatorInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorInvoices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferOperatorInvoiceApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorInvoices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorInvoiceApi.getOperatorInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperatorInvoiceApi - factory interface
 * @export
 */
export const OperatorInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorInvoices(options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferOperatorInvoiceApiResponse> {
            return localVarFp.getOperatorInvoices(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperatorInvoiceApi - object-oriented interface
 * @export
 * @class OperatorInvoiceApi
 * @extends {BaseAPI}
 */
export class OperatorInvoiceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorInvoiceApi
     */
    public getOperatorInvoices(options?: RawAxiosRequestConfig) {
        return OperatorInvoiceApiFp(this.configuration).getOperatorInvoices(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParkerApi - axios parameter creator
 * @export
 */
export const ParkerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParker: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getParker', 'id', id)
            const localVarPath = `/parkers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerDashboardStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parkers/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParkerApi - functional programming interface
 * @export
 */
export const ParkerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParkerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParker(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetParkerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParker(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerApi.getParker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerDashboardStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetParkerDashboardStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerDashboardStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerApi.getParkerDashboardStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParkerApi - factory interface
 * @export
 */
export const ParkerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParkerApiFp(configuration)
    return {
        /**
         * 
         * @param {ParkerApiGetParkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParker(requestParameters: ParkerApiGetParkerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetParkerResponse> {
            return localVarFp.getParker(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerDashboardStats(options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetParkerDashboardStatsResponse> {
            return localVarFp.getParkerDashboardStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getParker operation in ParkerApi.
 * @export
 * @interface ParkerApiGetParkerRequest
 */
export interface ParkerApiGetParkerRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerApiGetParker
     */
    readonly id: number
}

/**
 * ParkerApi - object-oriented interface
 * @export
 * @class ParkerApi
 * @extends {BaseAPI}
 */
export class ParkerApi extends BaseAPI {
    /**
     * 
     * @param {ParkerApiGetParkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerApi
     */
    public getParker(requestParameters: ParkerApiGetParkerRequest, options?: RawAxiosRequestConfig) {
        return ParkerApiFp(this.configuration).getParker(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerApi
     */
    public getParkerDashboardStats(options?: RawAxiosRequestConfig) {
        return ParkerApiFp(this.configuration).getParkerDashboardStats(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParkerIntegrationPartyApi - axios parameter creator
 * @export
 */
export const ParkerIntegrationPartyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [subscriptionId] 
         * @param {number} [parkerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParkerIntegrationParties: async (subscriptionId?: number, parkerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (subscriptionId !== undefined) {
                localVarQueryParameter['SubscriptionId'] = subscriptionId;
            }

            if (parkerId !== undefined) {
                localVarQueryParameter['parkerId'] = parkerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsUpdateCredentialRequest} [serverRequestsUpdateCredentialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesCredentialUpdatePatch: async (serverRequestsUpdateCredentialRequest?: ServerRequestsUpdateCredentialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties/credential-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsUpdateCredentialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsEnrollSubscriptionIntegrationPartiesRequest} [serverRequestsEnrollSubscriptionIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesSubscriptionEnrollPatch: async (serverRequestsEnrollSubscriptionIntegrationPartiesRequest?: ServerRequestsEnrollSubscriptionIntegrationPartiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties/subscription-enroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsEnrollSubscriptionIntegrationPartiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsUnrollSubscriptionIntegrationPartiesRequest} [serverRequestsUnrollSubscriptionIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesSubscriptionUnrollPatch: async (serverRequestsUnrollSubscriptionIntegrationPartiesRequest?: ServerRequestsUnrollSubscriptionIntegrationPartiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties/subscription-unroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsUnrollSubscriptionIntegrationPartiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [subscriptionId] 
         * @param {number} [parkerId] 
         * @param {number} [integrationPartyId] 
         * @param {number} [vehicleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesSyncStatusGet: async (facilityId?: number, subscriptionId?: number, parkerId?: number, integrationPartyId?: number, vehicleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties/sync-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (subscriptionId !== undefined) {
                localVarQueryParameter['SubscriptionId'] = subscriptionId;
            }

            if (parkerId !== undefined) {
                localVarQueryParameter['ParkerId'] = parkerId;
            }

            if (integrationPartyId !== undefined) {
                localVarQueryParameter['IntegrationPartyId'] = integrationPartyId;
            }

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsEnrollVehicleIntegrationPartiesRequest} [serverRequestsEnrollVehicleIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesVehicleEnrollPatch: async (serverRequestsEnrollVehicleIntegrationPartiesRequest?: ServerRequestsEnrollVehicleIntegrationPartiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties/vehicle-enroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsEnrollVehicleIntegrationPartiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsUnrollVehicleIntegrationPartiesRequest} [serverRequestsUnrollVehicleIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesVehicleUnrollPatch: async (serverRequestsUnrollVehicleIntegrationPartiesRequest?: ServerRequestsUnrollVehicleIntegrationPartiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parker-integration-parties/vehicle-unroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsUnrollVehicleIntegrationPartiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParkerIntegrationPartyApi - functional programming interface
 * @export
 */
export const ParkerIntegrationPartyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParkerIntegrationPartyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [subscriptionId] 
         * @param {number} [parkerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParkerIntegrationParties(subscriptionId?: number, parkerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsListParkerIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParkerIntegrationParties(subscriptionId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.listParkerIntegrationParties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsUpdateCredentialRequest} [serverRequestsUpdateCredentialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerIntegrationPartiesCredentialUpdatePatch(serverRequestsUpdateCredentialRequest?: ServerRequestsUpdateCredentialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerIntegrationPartiesCredentialUpdatePatch(serverRequestsUpdateCredentialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.parkerIntegrationPartiesCredentialUpdatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsEnrollSubscriptionIntegrationPartiesRequest} [serverRequestsEnrollSubscriptionIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerIntegrationPartiesSubscriptionEnrollPatch(serverRequestsEnrollSubscriptionIntegrationPartiesRequest?: ServerRequestsEnrollSubscriptionIntegrationPartiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerIntegrationPartiesSubscriptionEnrollPatch(serverRequestsEnrollSubscriptionIntegrationPartiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.parkerIntegrationPartiesSubscriptionEnrollPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsUnrollSubscriptionIntegrationPartiesRequest} [serverRequestsUnrollSubscriptionIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerIntegrationPartiesSubscriptionUnrollPatch(serverRequestsUnrollSubscriptionIntegrationPartiesRequest?: ServerRequestsUnrollSubscriptionIntegrationPartiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerIntegrationPartiesSubscriptionUnrollPatch(serverRequestsUnrollSubscriptionIntegrationPartiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.parkerIntegrationPartiesSubscriptionUnrollPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [subscriptionId] 
         * @param {number} [parkerId] 
         * @param {number} [integrationPartyId] 
         * @param {number} [vehicleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerIntegrationPartiesSyncStatusGet(facilityId?: number, subscriptionId?: number, parkerId?: number, integrationPartyId?: number, vehicleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCheckParkerIntegrationSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerIntegrationPartiesSyncStatusGet(facilityId, subscriptionId, parkerId, integrationPartyId, vehicleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.parkerIntegrationPartiesSyncStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsEnrollVehicleIntegrationPartiesRequest} [serverRequestsEnrollVehicleIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerIntegrationPartiesVehicleEnrollPatch(serverRequestsEnrollVehicleIntegrationPartiesRequest?: ServerRequestsEnrollVehicleIntegrationPartiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerIntegrationPartiesVehicleEnrollPatch(serverRequestsEnrollVehicleIntegrationPartiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.parkerIntegrationPartiesVehicleEnrollPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsUnrollVehicleIntegrationPartiesRequest} [serverRequestsUnrollVehicleIntegrationPartiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkerIntegrationPartiesVehicleUnrollPatch(serverRequestsUnrollVehicleIntegrationPartiesRequest?: ServerRequestsUnrollVehicleIntegrationPartiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkerIntegrationPartiesVehicleUnrollPatch(serverRequestsUnrollVehicleIntegrationPartiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerIntegrationPartyApi.parkerIntegrationPartiesVehicleUnrollPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParkerIntegrationPartyApi - factory interface
 * @export
 */
export const ParkerIntegrationPartyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParkerIntegrationPartyApiFp(configuration)
    return {
        /**
         * 
         * @param {ParkerIntegrationPartyApiListParkerIntegrationPartiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParkerIntegrationParties(requestParameters: ParkerIntegrationPartyApiListParkerIntegrationPartiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsListParkerIntegrationPartiesResponse> {
            return localVarFp.listParkerIntegrationParties(requestParameters.subscriptionId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesCredentialUpdatePatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse> {
            return localVarFp.parkerIntegrationPartiesCredentialUpdatePatch(requestParameters.serverRequestsUpdateCredentialRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesSubscriptionEnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse> {
            return localVarFp.parkerIntegrationPartiesSubscriptionEnrollPatch(requestParameters.serverRequestsEnrollSubscriptionIntegrationPartiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesSubscriptionUnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse> {
            return localVarFp.parkerIntegrationPartiesSubscriptionUnrollPatch(requestParameters.serverRequestsUnrollSubscriptionIntegrationPartiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesSyncStatusGet(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCheckParkerIntegrationSyncResponse> {
            return localVarFp.parkerIntegrationPartiesSyncStatusGet(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.parkerId, requestParameters.integrationPartyId, requestParameters.vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesVehicleEnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse> {
            return localVarFp.parkerIntegrationPartiesVehicleEnrollPatch(requestParameters.serverRequestsEnrollVehicleIntegrationPartiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkerIntegrationPartiesVehicleUnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPatchParkerIntegrationPartiesResponse> {
            return localVarFp.parkerIntegrationPartiesVehicleUnrollPatch(requestParameters.serverRequestsUnrollVehicleIntegrationPartiesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listParkerIntegrationParties operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiListParkerIntegrationPartiesRequest
 */
export interface ParkerIntegrationPartyApiListParkerIntegrationPartiesRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiListParkerIntegrationParties
     */
    readonly subscriptionId?: number

    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiListParkerIntegrationParties
     */
    readonly parkerId?: number
}

/**
 * Request parameters for parkerIntegrationPartiesCredentialUpdatePatch operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatchRequest
 */
export interface ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatchRequest {
    /**
     * 
     * @type {ServerRequestsUpdateCredentialRequest}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatch
     */
    readonly serverRequestsUpdateCredentialRequest?: ServerRequestsUpdateCredentialRequest
}

/**
 * Request parameters for parkerIntegrationPartiesSubscriptionEnrollPatch operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatchRequest
 */
export interface ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatchRequest {
    /**
     * 
     * @type {ServerRequestsEnrollSubscriptionIntegrationPartiesRequest}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatch
     */
    readonly serverRequestsEnrollSubscriptionIntegrationPartiesRequest?: ServerRequestsEnrollSubscriptionIntegrationPartiesRequest
}

/**
 * Request parameters for parkerIntegrationPartiesSubscriptionUnrollPatch operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatchRequest
 */
export interface ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatchRequest {
    /**
     * 
     * @type {ServerRequestsUnrollSubscriptionIntegrationPartiesRequest}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatch
     */
    readonly serverRequestsUnrollSubscriptionIntegrationPartiesRequest?: ServerRequestsUnrollSubscriptionIntegrationPartiesRequest
}

/**
 * Request parameters for parkerIntegrationPartiesSyncStatusGet operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGetRequest
 */
export interface ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGet
     */
    readonly subscriptionId?: number

    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGet
     */
    readonly parkerId?: number

    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGet
     */
    readonly integrationPartyId?: number

    /**
     * 
     * @type {number}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGet
     */
    readonly vehicleId?: number
}

/**
 * Request parameters for parkerIntegrationPartiesVehicleEnrollPatch operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatchRequest
 */
export interface ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatchRequest {
    /**
     * 
     * @type {ServerRequestsEnrollVehicleIntegrationPartiesRequest}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatch
     */
    readonly serverRequestsEnrollVehicleIntegrationPartiesRequest?: ServerRequestsEnrollVehicleIntegrationPartiesRequest
}

/**
 * Request parameters for parkerIntegrationPartiesVehicleUnrollPatch operation in ParkerIntegrationPartyApi.
 * @export
 * @interface ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatchRequest
 */
export interface ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatchRequest {
    /**
     * 
     * @type {ServerRequestsUnrollVehicleIntegrationPartiesRequest}
     * @memberof ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatch
     */
    readonly serverRequestsUnrollVehicleIntegrationPartiesRequest?: ServerRequestsUnrollVehicleIntegrationPartiesRequest
}

/**
 * ParkerIntegrationPartyApi - object-oriented interface
 * @export
 * @class ParkerIntegrationPartyApi
 * @extends {BaseAPI}
 */
export class ParkerIntegrationPartyApi extends BaseAPI {
    /**
     * 
     * @param {ParkerIntegrationPartyApiListParkerIntegrationPartiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public listParkerIntegrationParties(requestParameters: ParkerIntegrationPartyApiListParkerIntegrationPartiesRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).listParkerIntegrationParties(requestParameters.subscriptionId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public parkerIntegrationPartiesCredentialUpdatePatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesCredentialUpdatePatchRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).parkerIntegrationPartiesCredentialUpdatePatch(requestParameters.serverRequestsUpdateCredentialRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public parkerIntegrationPartiesSubscriptionEnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionEnrollPatchRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).parkerIntegrationPartiesSubscriptionEnrollPatch(requestParameters.serverRequestsEnrollSubscriptionIntegrationPartiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public parkerIntegrationPartiesSubscriptionUnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesSubscriptionUnrollPatchRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).parkerIntegrationPartiesSubscriptionUnrollPatch(requestParameters.serverRequestsUnrollSubscriptionIntegrationPartiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public parkerIntegrationPartiesSyncStatusGet(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesSyncStatusGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).parkerIntegrationPartiesSyncStatusGet(requestParameters.facilityId, requestParameters.subscriptionId, requestParameters.parkerId, requestParameters.integrationPartyId, requestParameters.vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public parkerIntegrationPartiesVehicleEnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleEnrollPatchRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).parkerIntegrationPartiesVehicleEnrollPatch(requestParameters.serverRequestsEnrollVehicleIntegrationPartiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerIntegrationPartyApi
     */
    public parkerIntegrationPartiesVehicleUnrollPatch(requestParameters: ParkerIntegrationPartyApiParkerIntegrationPartiesVehicleUnrollPatchRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkerIntegrationPartyApiFp(this.configuration).parkerIntegrationPartiesVehicleUnrollPatch(requestParameters.serverRequestsUnrollVehicleIntegrationPartiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParkerNoteApi - axios parameter creator
 * @export
 */
export const ParkerNoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerRequestsCreateParkerNoteRequest} [serverRequestsCreateParkerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParkerNote: async (facilityId: number, parkerId: number, serverRequestsCreateParkerNoteRequest?: ServerRequestsCreateParkerNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('createParkerNote', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('createParkerNote', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/note`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateParkerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParkerNote: async (facilityId: number, parkerId: number, noteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('deleteParkerNote', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('deleteParkerNote', 'parkerId', parkerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteParkerNote', 'noteId', noteId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/note/{noteId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParkerNotes: async (facilityId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('listParkerNotes', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('listParkerNotes', 'parkerId', parkerId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/note`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} noteId 
         * @param {ServerRequestsUpdateParkerNoteRequest} [serverRequestsUpdateParkerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParkerNote: async (facilityId: number, parkerId: number, noteId: number, serverRequestsUpdateParkerNoteRequest?: ServerRequestsUpdateParkerNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('updateParkerNote', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('updateParkerNote', 'parkerId', parkerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('updateParkerNote', 'noteId', noteId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/note/{noteId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsUpdateParkerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParkerNoteApi - functional programming interface
 * @export
 */
export const ParkerNoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParkerNoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {ServerRequestsCreateParkerNoteRequest} [serverRequestsCreateParkerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParkerNote(facilityId: number, parkerId: number, serverRequestsCreateParkerNoteRequest?: ServerRequestsCreateParkerNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCreateParkerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParkerNote(facilityId, parkerId, serverRequestsCreateParkerNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerNoteApi.createParkerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParkerNote(facilityId: number, parkerId: number, noteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParkerNote(facilityId, parkerId, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerNoteApi.deleteParkerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParkerNotes(facilityId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsListParkerNotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParkerNotes(facilityId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerNoteApi.listParkerNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} noteId 
         * @param {ServerRequestsUpdateParkerNoteRequest} [serverRequestsUpdateParkerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParkerNote(facilityId: number, parkerId: number, noteId: number, serverRequestsUpdateParkerNoteRequest?: ServerRequestsUpdateParkerNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUpdateParkerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParkerNote(facilityId, parkerId, noteId, serverRequestsUpdateParkerNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkerNoteApi.updateParkerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParkerNoteApi - factory interface
 * @export
 */
export const ParkerNoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParkerNoteApiFp(configuration)
    return {
        /**
         * 
         * @param {ParkerNoteApiCreateParkerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParkerNote(requestParameters: ParkerNoteApiCreateParkerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCreateParkerNoteResponse> {
            return localVarFp.createParkerNote(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverRequestsCreateParkerNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerNoteApiDeleteParkerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParkerNote(requestParameters: ParkerNoteApiDeleteParkerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteParkerNote(requestParameters.facilityId, requestParameters.parkerId, requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerNoteApiListParkerNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParkerNotes(requestParameters: ParkerNoteApiListParkerNotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsListParkerNotesResponse> {
            return localVarFp.listParkerNotes(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkerNoteApiUpdateParkerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParkerNote(requestParameters: ParkerNoteApiUpdateParkerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUpdateParkerNoteResponse> {
            return localVarFp.updateParkerNote(requestParameters.facilityId, requestParameters.parkerId, requestParameters.noteId, requestParameters.serverRequestsUpdateParkerNoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createParkerNote operation in ParkerNoteApi.
 * @export
 * @interface ParkerNoteApiCreateParkerNoteRequest
 */
export interface ParkerNoteApiCreateParkerNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiCreateParkerNote
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiCreateParkerNote
     */
    readonly parkerId: number

    /**
     * 
     * @type {ServerRequestsCreateParkerNoteRequest}
     * @memberof ParkerNoteApiCreateParkerNote
     */
    readonly serverRequestsCreateParkerNoteRequest?: ServerRequestsCreateParkerNoteRequest
}

/**
 * Request parameters for deleteParkerNote operation in ParkerNoteApi.
 * @export
 * @interface ParkerNoteApiDeleteParkerNoteRequest
 */
export interface ParkerNoteApiDeleteParkerNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiDeleteParkerNote
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiDeleteParkerNote
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiDeleteParkerNote
     */
    readonly noteId: number
}

/**
 * Request parameters for listParkerNotes operation in ParkerNoteApi.
 * @export
 * @interface ParkerNoteApiListParkerNotesRequest
 */
export interface ParkerNoteApiListParkerNotesRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiListParkerNotes
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiListParkerNotes
     */
    readonly parkerId: number
}

/**
 * Request parameters for updateParkerNote operation in ParkerNoteApi.
 * @export
 * @interface ParkerNoteApiUpdateParkerNoteRequest
 */
export interface ParkerNoteApiUpdateParkerNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiUpdateParkerNote
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiUpdateParkerNote
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof ParkerNoteApiUpdateParkerNote
     */
    readonly noteId: number

    /**
     * 
     * @type {ServerRequestsUpdateParkerNoteRequest}
     * @memberof ParkerNoteApiUpdateParkerNote
     */
    readonly serverRequestsUpdateParkerNoteRequest?: ServerRequestsUpdateParkerNoteRequest
}

/**
 * ParkerNoteApi - object-oriented interface
 * @export
 * @class ParkerNoteApi
 * @extends {BaseAPI}
 */
export class ParkerNoteApi extends BaseAPI {
    /**
     * 
     * @param {ParkerNoteApiCreateParkerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerNoteApi
     */
    public createParkerNote(requestParameters: ParkerNoteApiCreateParkerNoteRequest, options?: RawAxiosRequestConfig) {
        return ParkerNoteApiFp(this.configuration).createParkerNote(requestParameters.facilityId, requestParameters.parkerId, requestParameters.serverRequestsCreateParkerNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerNoteApiDeleteParkerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerNoteApi
     */
    public deleteParkerNote(requestParameters: ParkerNoteApiDeleteParkerNoteRequest, options?: RawAxiosRequestConfig) {
        return ParkerNoteApiFp(this.configuration).deleteParkerNote(requestParameters.facilityId, requestParameters.parkerId, requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerNoteApiListParkerNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerNoteApi
     */
    public listParkerNotes(requestParameters: ParkerNoteApiListParkerNotesRequest, options?: RawAxiosRequestConfig) {
        return ParkerNoteApiFp(this.configuration).listParkerNotes(requestParameters.facilityId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkerNoteApiUpdateParkerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkerNoteApi
     */
    public updateParkerNote(requestParameters: ParkerNoteApiUpdateParkerNoteRequest, options?: RawAxiosRequestConfig) {
        return ParkerNoteApiFp(this.configuration).updateParkerNote(requestParameters.facilityId, requestParameters.parkerId, requestParameters.noteId, requestParameters.serverRequestsUpdateParkerNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParkingValidationRequestApi - axios parameter creator
 * @export
 */
export const ParkingValidationRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveParkingValidationRequest: async (requestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('approveParkingValidationRequest', 'requestId', requestId)
            const localVarPath = `/parking-validation/{requestId}/approve`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} rateProgramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfRateProgramExists: async (rateProgramId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rateProgramId' is not null or undefined
            assertParamExists('checkIfRateProgramExists', 'rateProgramId', rateProgramId)
            const localVarPath = `/parking-validation/rate-program{rateProgramId}`
                .replace(`{${"rateProgramId"}}`, encodeURIComponent(String(rateProgramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeParkingValidationRequest: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('completeParkingValidationRequest', 'requestId', requestId)
            const localVarPath = `/parking-validation/{requestId}/complete`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parkingValidationRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedParkingValidationRequestById: async (parkingValidationRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parkingValidationRequestId' is not null or undefined
            assertParamExists('getApprovedParkingValidationRequestById', 'parkingValidationRequestId', parkingValidationRequestId)
            const localVarPath = `/parking-validation/by-id/{parkingValidationRequestId}`
                .replace(`{${"parkingValidationRequestId"}}`, encodeURIComponent(String(parkingValidationRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingParkingValidationRequests: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getPendingParkingValidationRequests', 'facilityId', facilityId)
            const localVarPath = `/parking-validation/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectParkingValidationRequest: async (requestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('rejectParkingValidationRequest', 'requestId', requestId)
            const localVarPath = `/parking-validation/{requestId}/reject`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsSubmitParkingValidationRequest} [serverRequestsSubmitParkingValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitParkingValidationRequest: async (serverRequestsSubmitParkingValidationRequest?: ServerRequestsSubmitParkingValidationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parking-validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsSubmitParkingValidationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParkingValidationRequestApi - functional programming interface
 * @export
 */
export const ParkingValidationRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParkingValidationRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveParkingValidationRequest(requestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkingValidationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveParkingValidationRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.approveParkingValidationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} rateProgramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfRateProgramExists(rateProgramId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsRateProgramByIdReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfRateProgramExists(rateProgramId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.checkIfRateProgramExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeParkingValidationRequest(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCompleteParkingValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeParkingValidationRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.completeParkingValidationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} parkingValidationRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovedParkingValidationRequestById(parkingValidationRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkingValidationByIdData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovedParkingValidationRequestById(parkingValidationRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.getApprovedParkingValidationRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingParkingValidationRequests(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetParkingValidationRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingParkingValidationRequests(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.getPendingParkingValidationRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectParkingValidationRequest(requestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkingValidationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectParkingValidationRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.rejectParkingValidationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsSubmitParkingValidationRequest} [serverRequestsSubmitParkingValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitParkingValidationRequest(serverRequestsSubmitParkingValidationRequest?: ServerRequestsSubmitParkingValidationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkingValidationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitParkingValidationRequest(serverRequestsSubmitParkingValidationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParkingValidationRequestApi.submitParkingValidationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParkingValidationRequestApi - factory interface
 * @export
 */
export const ParkingValidationRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParkingValidationRequestApiFp(configuration)
    return {
        /**
         * 
         * @param {ParkingValidationRequestApiApproveParkingValidationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveParkingValidationRequest(requestParameters: ParkingValidationRequestApiApproveParkingValidationRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkingValidationData> {
            return localVarFp.approveParkingValidationRequest(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkingValidationRequestApiCheckIfRateProgramExistsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfRateProgramExists(requestParameters: ParkingValidationRequestApiCheckIfRateProgramExistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsRateProgramByIdReponse> {
            return localVarFp.checkIfRateProgramExists(requestParameters.rateProgramId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkingValidationRequestApiCompleteParkingValidationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeParkingValidationRequest(requestParameters: ParkingValidationRequestApiCompleteParkingValidationRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCompleteParkingValidationResponse> {
            return localVarFp.completeParkingValidationRequest(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkingValidationRequestApiGetApprovedParkingValidationRequestByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedParkingValidationRequestById(requestParameters: ParkingValidationRequestApiGetApprovedParkingValidationRequestByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkingValidationByIdData> {
            return localVarFp.getApprovedParkingValidationRequestById(requestParameters.parkingValidationRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkingValidationRequestApiGetPendingParkingValidationRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingParkingValidationRequests(requestParameters: ParkingValidationRequestApiGetPendingParkingValidationRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetParkingValidationRequestsResponse> {
            return localVarFp.getPendingParkingValidationRequests(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkingValidationRequestApiRejectParkingValidationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectParkingValidationRequest(requestParameters: ParkingValidationRequestApiRejectParkingValidationRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkingValidationData> {
            return localVarFp.rejectParkingValidationRequest(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkingValidationRequestApiSubmitParkingValidationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitParkingValidationRequest(requestParameters: ParkingValidationRequestApiSubmitParkingValidationRequestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkingValidationData> {
            return localVarFp.submitParkingValidationRequest(requestParameters.serverRequestsSubmitParkingValidationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveParkingValidationRequest operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiApproveParkingValidationRequestRequest
 */
export interface ParkingValidationRequestApiApproveParkingValidationRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkingValidationRequestApiApproveParkingValidationRequest
     */
    readonly requestId: number
}

/**
 * Request parameters for checkIfRateProgramExists operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiCheckIfRateProgramExistsRequest
 */
export interface ParkingValidationRequestApiCheckIfRateProgramExistsRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkingValidationRequestApiCheckIfRateProgramExists
     */
    readonly rateProgramId: number
}

/**
 * Request parameters for completeParkingValidationRequest operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiCompleteParkingValidationRequestRequest
 */
export interface ParkingValidationRequestApiCompleteParkingValidationRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof ParkingValidationRequestApiCompleteParkingValidationRequest
     */
    readonly requestId: string
}

/**
 * Request parameters for getApprovedParkingValidationRequestById operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiGetApprovedParkingValidationRequestByIdRequest
 */
export interface ParkingValidationRequestApiGetApprovedParkingValidationRequestByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ParkingValidationRequestApiGetApprovedParkingValidationRequestById
     */
    readonly parkingValidationRequestId: string
}

/**
 * Request parameters for getPendingParkingValidationRequests operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiGetPendingParkingValidationRequestsRequest
 */
export interface ParkingValidationRequestApiGetPendingParkingValidationRequestsRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkingValidationRequestApiGetPendingParkingValidationRequests
     */
    readonly facilityId: number
}

/**
 * Request parameters for rejectParkingValidationRequest operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiRejectParkingValidationRequestRequest
 */
export interface ParkingValidationRequestApiRejectParkingValidationRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof ParkingValidationRequestApiRejectParkingValidationRequest
     */
    readonly requestId: number
}

/**
 * Request parameters for submitParkingValidationRequest operation in ParkingValidationRequestApi.
 * @export
 * @interface ParkingValidationRequestApiSubmitParkingValidationRequestRequest
 */
export interface ParkingValidationRequestApiSubmitParkingValidationRequestRequest {
    /**
     * 
     * @type {ServerRequestsSubmitParkingValidationRequest}
     * @memberof ParkingValidationRequestApiSubmitParkingValidationRequest
     */
    readonly serverRequestsSubmitParkingValidationRequest?: ServerRequestsSubmitParkingValidationRequest
}

/**
 * ParkingValidationRequestApi - object-oriented interface
 * @export
 * @class ParkingValidationRequestApi
 * @extends {BaseAPI}
 */
export class ParkingValidationRequestApi extends BaseAPI {
    /**
     * 
     * @param {ParkingValidationRequestApiApproveParkingValidationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public approveParkingValidationRequest(requestParameters: ParkingValidationRequestApiApproveParkingValidationRequestRequest, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).approveParkingValidationRequest(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkingValidationRequestApiCheckIfRateProgramExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public checkIfRateProgramExists(requestParameters: ParkingValidationRequestApiCheckIfRateProgramExistsRequest, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).checkIfRateProgramExists(requestParameters.rateProgramId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkingValidationRequestApiCompleteParkingValidationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public completeParkingValidationRequest(requestParameters: ParkingValidationRequestApiCompleteParkingValidationRequestRequest, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).completeParkingValidationRequest(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkingValidationRequestApiGetApprovedParkingValidationRequestByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public getApprovedParkingValidationRequestById(requestParameters: ParkingValidationRequestApiGetApprovedParkingValidationRequestByIdRequest, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).getApprovedParkingValidationRequestById(requestParameters.parkingValidationRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkingValidationRequestApiGetPendingParkingValidationRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public getPendingParkingValidationRequests(requestParameters: ParkingValidationRequestApiGetPendingParkingValidationRequestsRequest, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).getPendingParkingValidationRequests(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkingValidationRequestApiRejectParkingValidationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public rejectParkingValidationRequest(requestParameters: ParkingValidationRequestApiRejectParkingValidationRequestRequest, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).rejectParkingValidationRequest(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkingValidationRequestApiSubmitParkingValidationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingValidationRequestApi
     */
    public submitParkingValidationRequest(requestParameters: ParkingValidationRequestApiSubmitParkingValidationRequestRequest = {}, options?: RawAxiosRequestConfig) {
        return ParkingValidationRequestApiFp(this.configuration).submitParkingValidationRequest(requestParameters.serverRequestsSubmitParkingValidationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnerReservationApi - axios parameter creator
 * @export
 */
export const PartnerReservationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsPartnerReservationCreateRequest} [serverRequestsPartnerReservationCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerReservation: async (serverRequestsPartnerReservationCreateRequest?: ServerRequestsPartnerReservationCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsPartnerReservationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} [dateFromUtc] 
         * @param {string} [dateToUtc] 
         * @param {string} [plateNumber] 
         * @param {string} [email] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerReservations: async (locationId: string, dateFromUtc?: string, dateToUtc?: string, plateNumber?: string, email?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listPartnerReservations', 'locationId', locationId)
            const localVarPath = `/partner/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }

            if (dateFromUtc !== undefined) {
                localVarQueryParameter['DateFromUtc'] = (dateFromUtc as any instanceof Date) ?
                    (dateFromUtc as any).toISOString() :
                    dateFromUtc;
            }

            if (dateToUtc !== undefined) {
                localVarQueryParameter['DateToUtc'] = (dateToUtc as any instanceof Date) ?
                    (dateToUtc as any).toISOString() :
                    dateToUtc;
            }

            if (plateNumber !== undefined) {
                localVarQueryParameter['PlateNumber'] = plateNumber;
            }

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerReservationApi - functional programming interface
 * @export
 */
export const PartnerReservationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerReservationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsPartnerReservationCreateRequest} [serverRequestsPartnerReservationCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartnerReservation(serverRequestsPartnerReservationCreateRequest?: ServerRequestsPartnerReservationCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPartnerReservationCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartnerReservation(serverRequestsPartnerReservationCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerReservationApi.createPartnerReservation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} [dateFromUtc] 
         * @param {string} [dateToUtc] 
         * @param {string} [plateNumber] 
         * @param {string} [email] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartnerReservations(locationId: string, dateFromUtc?: string, dateToUtc?: string, plateNumber?: string, email?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPartnerReservationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartnerReservations(locationId, dateFromUtc, dateToUtc, plateNumber, email, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerReservationApi.listPartnerReservations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerReservationApi - factory interface
 * @export
 */
export const PartnerReservationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerReservationApiFp(configuration)
    return {
        /**
         * 
         * @param {PartnerReservationApiCreatePartnerReservationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerReservation(requestParameters: PartnerReservationApiCreatePartnerReservationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPartnerReservationCreateResponse> {
            return localVarFp.createPartnerReservation(requestParameters.serverRequestsPartnerReservationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PartnerReservationApiListPartnerReservationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerReservations(requestParameters: PartnerReservationApiListPartnerReservationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPartnerReservationListResponse> {
            return localVarFp.listPartnerReservations(requestParameters.locationId, requestParameters.dateFromUtc, requestParameters.dateToUtc, requestParameters.plateNumber, requestParameters.email, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPartnerReservation operation in PartnerReservationApi.
 * @export
 * @interface PartnerReservationApiCreatePartnerReservationRequest
 */
export interface PartnerReservationApiCreatePartnerReservationRequest {
    /**
     * 
     * @type {ServerRequestsPartnerReservationCreateRequest}
     * @memberof PartnerReservationApiCreatePartnerReservation
     */
    readonly serverRequestsPartnerReservationCreateRequest?: ServerRequestsPartnerReservationCreateRequest
}

/**
 * Request parameters for listPartnerReservations operation in PartnerReservationApi.
 * @export
 * @interface PartnerReservationApiListPartnerReservationsRequest
 */
export interface PartnerReservationApiListPartnerReservationsRequest {
    /**
     * 
     * @type {string}
     * @memberof PartnerReservationApiListPartnerReservations
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PartnerReservationApiListPartnerReservations
     */
    readonly dateFromUtc?: string

    /**
     * 
     * @type {string}
     * @memberof PartnerReservationApiListPartnerReservations
     */
    readonly dateToUtc?: string

    /**
     * 
     * @type {string}
     * @memberof PartnerReservationApiListPartnerReservations
     */
    readonly plateNumber?: string

    /**
     * 
     * @type {string}
     * @memberof PartnerReservationApiListPartnerReservations
     */
    readonly email?: string

    /**
     * 
     * @type {number}
     * @memberof PartnerReservationApiListPartnerReservations
     */
    readonly limit?: number
}

/**
 * PartnerReservationApi - object-oriented interface
 * @export
 * @class PartnerReservationApi
 * @extends {BaseAPI}
 */
export class PartnerReservationApi extends BaseAPI {
    /**
     * 
     * @param {PartnerReservationApiCreatePartnerReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerReservationApi
     */
    public createPartnerReservation(requestParameters: PartnerReservationApiCreatePartnerReservationRequest = {}, options?: RawAxiosRequestConfig) {
        return PartnerReservationApiFp(this.configuration).createPartnerReservation(requestParameters.serverRequestsPartnerReservationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PartnerReservationApiListPartnerReservationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerReservationApi
     */
    public listPartnerReservations(requestParameters: PartnerReservationApiListPartnerReservationsRequest, options?: RawAxiosRequestConfig) {
        return PartnerReservationApiFp(this.configuration).listPartnerReservations(requestParameters.locationId, requestParameters.dateFromUtc, requestParameters.dateToUtc, requestParameters.plateNumber, requestParameters.email, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnerReservationDocsApi - axios parameter creator
 * @export
 */
export const PartnerReservationDocsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        docsPartnerReservationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/docs/partner/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        docsPartnerReservationsOpenapiJsonGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/docs/partner/reservations/openapi.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerReservationDocsApi - functional programming interface
 * @export
 */
export const PartnerReservationDocsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerReservationDocsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async docsPartnerReservationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.docsPartnerReservationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerReservationDocsApi.docsPartnerReservationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async docsPartnerReservationsOpenapiJsonGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.docsPartnerReservationsOpenapiJsonGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerReservationDocsApi.docsPartnerReservationsOpenapiJsonGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerReservationDocsApi - factory interface
 * @export
 */
export const PartnerReservationDocsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerReservationDocsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        docsPartnerReservationsGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.docsPartnerReservationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        docsPartnerReservationsOpenapiJsonGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.docsPartnerReservationsOpenapiJsonGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerReservationDocsApi - object-oriented interface
 * @export
 * @class PartnerReservationDocsApi
 * @extends {BaseAPI}
 */
export class PartnerReservationDocsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerReservationDocsApi
     */
    public docsPartnerReservationsGet(options?: RawAxiosRequestConfig) {
        return PartnerReservationDocsApiFp(this.configuration).docsPartnerReservationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerReservationDocsApi
     */
    public docsPartnerReservationsOpenapiJsonGet(options?: RawAxiosRequestConfig) {
        return PartnerReservationDocsApiFp(this.configuration).docsPartnerReservationsOpenapiJsonGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlateScanApi - axios parameter creator
 * @export
 */
export const PlateScanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsPlateScanRequest} [serverRequestsPlateScanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanPlate: async (serverRequestsPlateScanRequest?: ServerRequestsPlateScanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/plate-scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsPlateScanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlateScanApi - functional programming interface
 * @export
 */
export const PlateScanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlateScanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsPlateScanRequest} [serverRequestsPlateScanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanPlate(serverRequestsPlateScanRequest?: ServerRequestsPlateScanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsPlateScanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanPlate(serverRequestsPlateScanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlateScanApi.scanPlate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlateScanApi - factory interface
 * @export
 */
export const PlateScanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlateScanApiFp(configuration)
    return {
        /**
         * 
         * @param {PlateScanApiScanPlateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanPlate(requestParameters: PlateScanApiScanPlateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsPlateScanResponse> {
            return localVarFp.scanPlate(requestParameters.serverRequestsPlateScanRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for scanPlate operation in PlateScanApi.
 * @export
 * @interface PlateScanApiScanPlateRequest
 */
export interface PlateScanApiScanPlateRequest {
    /**
     * 
     * @type {ServerRequestsPlateScanRequest}
     * @memberof PlateScanApiScanPlate
     */
    readonly serverRequestsPlateScanRequest?: ServerRequestsPlateScanRequest
}

/**
 * PlateScanApi - object-oriented interface
 * @export
 * @class PlateScanApi
 * @extends {BaseAPI}
 */
export class PlateScanApi extends BaseAPI {
    /**
     * 
     * @param {PlateScanApiScanPlateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlateScanApi
     */
    public scanPlate(requestParameters: PlateScanApiScanPlateRequest = {}, options?: RawAxiosRequestConfig) {
        return PlateScanApiFp(this.configuration).scanPlate(requestParameters.serverRequestsPlateScanRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerTransferRecurringReportScheduleRequest} [serverTransferRecurringReportScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAddRecurringReportPost: async (serverTransferRecurringReportScheduleRequest?: ServerTransferRecurringReportScheduleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/add-recurring-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferRecurringReportScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerTransferAddSavedReportRequest} [serverTransferAddSavedReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAddSavedReportPost: async (serverTransferAddSavedReportRequest?: ServerTransferAddSavedReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/add-saved-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferAddSavedReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAdhocReportsDownloadLinkGet: async (id?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/adhoc-reports/download-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [payoutFrom] 
         * @param {string} [payoutTo] 
         * @param {string} [paymentType] 
         * @param {string} [paymentStatus] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [quickDateMode] 
         * @param {string} [quickPayoutDateMode] 
         * @param {Array<number>} [operatorIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAdminRevenueGet: async (from?: string, to?: string, payoutFrom?: string, payoutTo?: string, paymentType?: string, paymentStatus?: string, name?: string, email?: string, quickDateMode?: string, quickPayoutDateMode?: string, operatorIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/admin-revenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (payoutFrom !== undefined) {
                localVarQueryParameter['PayoutFrom'] = (payoutFrom as any instanceof Date) ?
                    (payoutFrom as any).toISOString() :
                    payoutFrom;
            }

            if (payoutTo !== undefined) {
                localVarQueryParameter['PayoutTo'] = (payoutTo as any instanceof Date) ?
                    (payoutTo as any).toISOString() :
                    payoutTo;
            }

            if (paymentType !== undefined) {
                localVarQueryParameter['PaymentType'] = paymentType;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['PaymentStatus'] = paymentStatus;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (quickDateMode !== undefined) {
                localVarQueryParameter['QuickDateMode'] = quickDateMode;
            }

            if (quickPayoutDateMode !== undefined) {
                localVarQueryParameter['QuickPayoutDateMode'] = quickPayoutDateMode;
            }

            if (operatorIds) {
                localVarQueryParameter['OperatorIds'] = operatorIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [age] 
         * @param {number} [facilityId] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [cutoffMode] 
         * @param {string} [cutoffDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAgingGet: async (age?: string, facilityId?: number, name?: string, email?: string, cutoffMode?: string, cutoffDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/aging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (age !== undefined) {
                localVarQueryParameter['Age'] = age;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (cutoffMode !== undefined) {
                localVarQueryParameter['CutoffMode'] = cutoffMode;
            }

            if (cutoffDate !== undefined) {
                localVarQueryParameter['CutoffDate'] = (cutoffDate as any instanceof Date) ?
                    (cutoffDate as any).toISOString() :
                    cutoffDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsFacilityReportsIndexGet: async (facilityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/facility-reports-index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [payoutFrom] 
         * @param {string} [payoutTo] 
         * @param {string} [paymentType] 
         * @param {string} [paymentStatus] 
         * @param {number} [facilityId] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [quickDateMode] 
         * @param {string} [quickPayoutDateMode] 
         * @param {Array<number>} [facilityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsPaymentsGet: async (from?: string, to?: string, payoutFrom?: string, payoutTo?: string, paymentType?: string, paymentStatus?: string, facilityId?: number, name?: string, email?: string, quickDateMode?: string, quickPayoutDateMode?: string, facilityIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (payoutFrom !== undefined) {
                localVarQueryParameter['PayoutFrom'] = (payoutFrom as any instanceof Date) ?
                    (payoutFrom as any).toISOString() :
                    payoutFrom;
            }

            if (payoutTo !== undefined) {
                localVarQueryParameter['PayoutTo'] = (payoutTo as any instanceof Date) ?
                    (payoutTo as any).toISOString() :
                    payoutTo;
            }

            if (paymentType !== undefined) {
                localVarQueryParameter['PaymentType'] = paymentType;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['PaymentStatus'] = paymentStatus;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (quickDateMode !== undefined) {
                localVarQueryParameter['QuickDateMode'] = quickDateMode;
            }

            if (quickPayoutDateMode !== undefined) {
                localVarQueryParameter['QuickPayoutDateMode'] = quickPayoutDateMode;
            }

            if (facilityIds) {
                localVarQueryParameter['FacilityIds'] = facilityIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [operatorId] 
         * @param {string} [quickDateMode] 
         * @param {Array<number>} [facilityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsPayoutSummaryGet: async (from?: string, to?: string, operatorId?: number, quickDateMode?: string, facilityIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/payout-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (operatorId !== undefined) {
                localVarQueryParameter['OperatorId'] = operatorId;
            }

            if (quickDateMode !== undefined) {
                localVarQueryParameter['QuickDateMode'] = quickDateMode;
            }

            if (facilityIds) {
                localVarQueryParameter['FacilityIds'] = facilityIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [recurringReportScheduleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRecurringReportDelete: async (recurringReportScheduleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/recurring-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recurringReportScheduleId !== undefined) {
                localVarQueryParameter['recurringReportScheduleId'] = recurringReportScheduleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRecurringReportsDownloadLinkGet: async (id?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/recurring-reports/download-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRecurringReportsGet: async (facilityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/recurring-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [validationId] 
         * @param {number} [facilityId] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRedeemedValidationGet: async (from?: string, to?: string, validationId?: number, facilityId?: number, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/redeemed-validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (validationId !== undefined) {
                localVarQueryParameter['ValidationId'] = validationId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [savedReportId] 
         * @param {string} [newName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRenameSavedReportPost: async (savedReportId?: number, newName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/rename-saved-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (savedReportId !== undefined) {
                localVarQueryParameter['savedReportId'] = savedReportId;
            }

            if (newName !== undefined) {
                localVarQueryParameter['newName'] = newName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [savedReportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsSavedReportDelete: async (savedReportId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/saved-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (savedReportId !== undefined) {
                localVarQueryParameter['savedReportId'] = savedReportId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {DataEntitiesReportsReportType} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsSavedReportsGet: async (facilityId?: number, reportType?: DataEntitiesReportsReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/saved-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [planName] 
         * @param {string} [email] 
         * @param {string} [name] 
         * @param {string} [status] 
         * @param {number} [facilityId] 
         * @param {string} [quickDateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsSubscriptionsGet: async (from?: string, to?: string, planName?: string, email?: string, name?: string, status?: string, facilityId?: number, quickDateMode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (planName !== undefined) {
                localVarQueryParameter['PlanName'] = planName;
            }

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['FacilityId'] = facilityId;
            }

            if (quickDateMode !== undefined) {
                localVarQueryParameter['QuickDateMode'] = quickDateMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [recurringReportScheduleId] 
         * @param {ServerTransferRecurringReportScheduleRequest} [serverTransferRecurringReportScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsUpdateRecurringReportPost: async (recurringReportScheduleId?: number, serverTransferRecurringReportScheduleRequest?: ServerTransferRecurringReportScheduleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitor/reports/update-recurring-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recurringReportScheduleId !== undefined) {
                localVarQueryParameter['recurringReportScheduleId'] = recurringReportScheduleId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverTransferRecurringReportScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerTransferRecurringReportScheduleRequest} [serverTransferRecurringReportScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsAddRecurringReportPost(serverTransferRecurringReportScheduleRequest?: ServerTransferRecurringReportScheduleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferRecurringReportScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsAddRecurringReportPost(serverTransferRecurringReportScheduleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsAddRecurringReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerTransferAddSavedReportRequest} [serverTransferAddSavedReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsAddSavedReportPost(serverTransferAddSavedReportRequest?: ServerTransferAddSavedReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferSavedReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsAddSavedReportPost(serverTransferAddSavedReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsAddSavedReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsAdhocReportsDownloadLinkGet(id?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsAdhocReportsDownloadLinkGet(id, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsAdhocReportsDownloadLinkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [payoutFrom] 
         * @param {string} [payoutTo] 
         * @param {string} [paymentType] 
         * @param {string} [paymentStatus] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [quickDateMode] 
         * @param {string} [quickPayoutDateMode] 
         * @param {Array<number>} [operatorIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsAdminRevenueGet(from?: string, to?: string, payoutFrom?: string, payoutTo?: string, paymentType?: string, paymentStatus?: string, name?: string, email?: string, quickDateMode?: string, quickPayoutDateMode?: string, operatorIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerControllersGridResultAdminRevenueReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsAdminRevenueGet(from, to, payoutFrom, payoutTo, paymentType, paymentStatus, name, email, quickDateMode, quickPayoutDateMode, operatorIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsAdminRevenueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [age] 
         * @param {number} [facilityId] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [cutoffMode] 
         * @param {string} [cutoffDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsAgingGet(age?: string, facilityId?: number, name?: string, email?: string, cutoffMode?: string, cutoffDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerControllersGridResultAgingReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsAgingGet(age, facilityId, name, email, cutoffMode, cutoffDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsAgingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsFacilityReportsIndexGet(facilityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferFacilityReportsIndexResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsFacilityReportsIndexGet(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsFacilityReportsIndexGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [payoutFrom] 
         * @param {string} [payoutTo] 
         * @param {string} [paymentType] 
         * @param {string} [paymentStatus] 
         * @param {number} [facilityId] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [quickDateMode] 
         * @param {string} [quickPayoutDateMode] 
         * @param {Array<number>} [facilityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsPaymentsGet(from?: string, to?: string, payoutFrom?: string, payoutTo?: string, paymentType?: string, paymentStatus?: string, facilityId?: number, name?: string, email?: string, quickDateMode?: string, quickPayoutDateMode?: string, facilityIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerControllersGridResultPaymentReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsPaymentsGet(from, to, payoutFrom, payoutTo, paymentType, paymentStatus, facilityId, name, email, quickDateMode, quickPayoutDateMode, facilityIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsPaymentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [operatorId] 
         * @param {string} [quickDateMode] 
         * @param {Array<number>} [facilityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsPayoutSummaryGet(from?: string, to?: string, operatorId?: number, quickDateMode?: string, facilityIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerControllersGridResultPayoutSummaryReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsPayoutSummaryGet(from, to, operatorId, quickDateMode, facilityIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsPayoutSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [recurringReportScheduleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsRecurringReportDelete(recurringReportScheduleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsRecurringReportDelete(recurringReportScheduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsRecurringReportDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsRecurringReportsDownloadLinkGet(id?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsRecurringReportsDownloadLinkGet(id, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsRecurringReportsDownloadLinkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsRecurringReportsGet(facilityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferRecurringReportScheduleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsRecurringReportsGet(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsRecurringReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [validationId] 
         * @param {number} [facilityId] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsRedeemedValidationGet(from?: string, to?: string, validationId?: number, facilityId?: number, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerControllersGridResultRedeemedValidationReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsRedeemedValidationGet(from, to, validationId, facilityId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsRedeemedValidationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [savedReportId] 
         * @param {string} [newName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsRenameSavedReportPost(savedReportId?: number, newName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferSavedReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsRenameSavedReportPost(savedReportId, newName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsRenameSavedReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [savedReportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsSavedReportDelete(savedReportId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsSavedReportDelete(savedReportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsSavedReportDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {DataEntitiesReportsReportType} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsSavedReportsGet(facilityId?: number, reportType?: DataEntitiesReportsReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerTransferSavedReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsSavedReportsGet(facilityId, reportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsSavedReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [planName] 
         * @param {string} [email] 
         * @param {string} [name] 
         * @param {string} [status] 
         * @param {number} [facilityId] 
         * @param {string} [quickDateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsSubscriptionsGet(from?: string, to?: string, planName?: string, email?: string, name?: string, status?: string, facilityId?: number, quickDateMode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerControllersGridResultSubscriptionReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsSubscriptionsGet(from, to, planName, email, name, status, facilityId, quickDateMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsSubscriptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [recurringReportScheduleId] 
         * @param {ServerTransferRecurringReportScheduleRequest} [serverTransferRecurringReportScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorReportsUpdateRecurringReportPost(recurringReportScheduleId?: number, serverTransferRecurringReportScheduleRequest?: ServerTransferRecurringReportScheduleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerTransferRecurringReportScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorReportsUpdateRecurringReportPost(recurringReportScheduleId, serverTransferRecurringReportScheduleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.monitorReportsUpdateRecurringReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportsApiMonitorReportsAddRecurringReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAddRecurringReportPost(requestParameters: ReportsApiMonitorReportsAddRecurringReportPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferRecurringReportScheduleResponse> {
            return localVarFp.monitorReportsAddRecurringReportPost(requestParameters.serverTransferRecurringReportScheduleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsAddSavedReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAddSavedReportPost(requestParameters: ReportsApiMonitorReportsAddSavedReportPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferSavedReportResponse> {
            return localVarFp.monitorReportsAddSavedReportPost(requestParameters.serverTransferAddSavedReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsAdhocReportsDownloadLinkGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAdhocReportsDownloadLinkGet(requestParameters: ReportsApiMonitorReportsAdhocReportsDownloadLinkGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.monitorReportsAdhocReportsDownloadLinkGet(requestParameters.id, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsAdminRevenueGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAdminRevenueGet(requestParameters: ReportsApiMonitorReportsAdminRevenueGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerControllersGridResultAdminRevenueReport> {
            return localVarFp.monitorReportsAdminRevenueGet(requestParameters.from, requestParameters.to, requestParameters.payoutFrom, requestParameters.payoutTo, requestParameters.paymentType, requestParameters.paymentStatus, requestParameters.name, requestParameters.email, requestParameters.quickDateMode, requestParameters.quickPayoutDateMode, requestParameters.operatorIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsAgingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsAgingGet(requestParameters: ReportsApiMonitorReportsAgingGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerControllersGridResultAgingReport> {
            return localVarFp.monitorReportsAgingGet(requestParameters.age, requestParameters.facilityId, requestParameters.name, requestParameters.email, requestParameters.cutoffMode, requestParameters.cutoffDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsFacilityReportsIndexGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsFacilityReportsIndexGet(requestParameters: ReportsApiMonitorReportsFacilityReportsIndexGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferFacilityReportsIndexResponse> {
            return localVarFp.monitorReportsFacilityReportsIndexGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsPaymentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsPaymentsGet(requestParameters: ReportsApiMonitorReportsPaymentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerControllersGridResultPaymentReport> {
            return localVarFp.monitorReportsPaymentsGet(requestParameters.from, requestParameters.to, requestParameters.payoutFrom, requestParameters.payoutTo, requestParameters.paymentType, requestParameters.paymentStatus, requestParameters.facilityId, requestParameters.name, requestParameters.email, requestParameters.quickDateMode, requestParameters.quickPayoutDateMode, requestParameters.facilityIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsPayoutSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsPayoutSummaryGet(requestParameters: ReportsApiMonitorReportsPayoutSummaryGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerControllersGridResultPayoutSummaryReport> {
            return localVarFp.monitorReportsPayoutSummaryGet(requestParameters.from, requestParameters.to, requestParameters.operatorId, requestParameters.quickDateMode, requestParameters.facilityIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsRecurringReportDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRecurringReportDelete(requestParameters: ReportsApiMonitorReportsRecurringReportDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.monitorReportsRecurringReportDelete(requestParameters.recurringReportScheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsRecurringReportsDownloadLinkGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRecurringReportsDownloadLinkGet(requestParameters: ReportsApiMonitorReportsRecurringReportsDownloadLinkGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.monitorReportsRecurringReportsDownloadLinkGet(requestParameters.id, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsRecurringReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRecurringReportsGet(requestParameters: ReportsApiMonitorReportsRecurringReportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferRecurringReportScheduleResponse>> {
            return localVarFp.monitorReportsRecurringReportsGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsRedeemedValidationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRedeemedValidationGet(requestParameters: ReportsApiMonitorReportsRedeemedValidationGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerControllersGridResultRedeemedValidationReport> {
            return localVarFp.monitorReportsRedeemedValidationGet(requestParameters.from, requestParameters.to, requestParameters.validationId, requestParameters.facilityId, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsRenameSavedReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsRenameSavedReportPost(requestParameters: ReportsApiMonitorReportsRenameSavedReportPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferSavedReportResponse> {
            return localVarFp.monitorReportsRenameSavedReportPost(requestParameters.savedReportId, requestParameters.newName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsSavedReportDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsSavedReportDelete(requestParameters: ReportsApiMonitorReportsSavedReportDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.monitorReportsSavedReportDelete(requestParameters.savedReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsSavedReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsSavedReportsGet(requestParameters: ReportsApiMonitorReportsSavedReportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerTransferSavedReportResponse>> {
            return localVarFp.monitorReportsSavedReportsGet(requestParameters.facilityId, requestParameters.reportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsSubscriptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsSubscriptionsGet(requestParameters: ReportsApiMonitorReportsSubscriptionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerControllersGridResultSubscriptionReport> {
            return localVarFp.monitorReportsSubscriptionsGet(requestParameters.from, requestParameters.to, requestParameters.planName, requestParameters.email, requestParameters.name, requestParameters.status, requestParameters.facilityId, requestParameters.quickDateMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiMonitorReportsUpdateRecurringReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorReportsUpdateRecurringReportPost(requestParameters: ReportsApiMonitorReportsUpdateRecurringReportPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerTransferRecurringReportScheduleResponse> {
            return localVarFp.monitorReportsUpdateRecurringReportPost(requestParameters.recurringReportScheduleId, requestParameters.serverTransferRecurringReportScheduleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for monitorReportsAddRecurringReportPost operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsAddRecurringReportPostRequest
 */
export interface ReportsApiMonitorReportsAddRecurringReportPostRequest {
    /**
     * 
     * @type {ServerTransferRecurringReportScheduleRequest}
     * @memberof ReportsApiMonitorReportsAddRecurringReportPost
     */
    readonly serverTransferRecurringReportScheduleRequest?: ServerTransferRecurringReportScheduleRequest
}

/**
 * Request parameters for monitorReportsAddSavedReportPost operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsAddSavedReportPostRequest
 */
export interface ReportsApiMonitorReportsAddSavedReportPostRequest {
    /**
     * 
     * @type {ServerTransferAddSavedReportRequest}
     * @memberof ReportsApiMonitorReportsAddSavedReportPost
     */
    readonly serverTransferAddSavedReportRequest?: ServerTransferAddSavedReportRequest
}

/**
 * Request parameters for monitorReportsAdhocReportsDownloadLinkGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsAdhocReportsDownloadLinkGetRequest
 */
export interface ReportsApiMonitorReportsAdhocReportsDownloadLinkGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdhocReportsDownloadLinkGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdhocReportsDownloadLinkGet
     */
    readonly email?: string
}

/**
 * Request parameters for monitorReportsAdminRevenueGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsAdminRevenueGetRequest
 */
export interface ReportsApiMonitorReportsAdminRevenueGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly to?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly payoutFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly payoutTo?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly paymentType?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly paymentStatus?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly quickDateMode?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly quickPayoutDateMode?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof ReportsApiMonitorReportsAdminRevenueGet
     */
    readonly operatorIds?: Array<number>
}

/**
 * Request parameters for monitorReportsAgingGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsAgingGetRequest
 */
export interface ReportsApiMonitorReportsAgingGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAgingGet
     */
    readonly age?: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsAgingGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAgingGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAgingGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAgingGet
     */
    readonly cutoffMode?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsAgingGet
     */
    readonly cutoffDate?: string
}

/**
 * Request parameters for monitorReportsFacilityReportsIndexGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsFacilityReportsIndexGetRequest
 */
export interface ReportsApiMonitorReportsFacilityReportsIndexGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsFacilityReportsIndexGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for monitorReportsPaymentsGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsPaymentsGetRequest
 */
export interface ReportsApiMonitorReportsPaymentsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly to?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly payoutFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly payoutTo?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly paymentType?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly paymentStatus?: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly quickDateMode?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly quickPayoutDateMode?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof ReportsApiMonitorReportsPaymentsGet
     */
    readonly facilityIds?: Array<number>
}

/**
 * Request parameters for monitorReportsPayoutSummaryGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsPayoutSummaryGetRequest
 */
export interface ReportsApiMonitorReportsPayoutSummaryGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPayoutSummaryGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPayoutSummaryGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsPayoutSummaryGet
     */
    readonly operatorId?: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsPayoutSummaryGet
     */
    readonly quickDateMode?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof ReportsApiMonitorReportsPayoutSummaryGet
     */
    readonly facilityIds?: Array<number>
}

/**
 * Request parameters for monitorReportsRecurringReportDelete operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsRecurringReportDeleteRequest
 */
export interface ReportsApiMonitorReportsRecurringReportDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsRecurringReportDelete
     */
    readonly recurringReportScheduleId?: number
}

/**
 * Request parameters for monitorReportsRecurringReportsDownloadLinkGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsRecurringReportsDownloadLinkGetRequest
 */
export interface ReportsApiMonitorReportsRecurringReportsDownloadLinkGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsRecurringReportsDownloadLinkGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsRecurringReportsDownloadLinkGet
     */
    readonly email?: string
}

/**
 * Request parameters for monitorReportsRecurringReportsGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsRecurringReportsGetRequest
 */
export interface ReportsApiMonitorReportsRecurringReportsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsRecurringReportsGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for monitorReportsRedeemedValidationGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsRedeemedValidationGetRequest
 */
export interface ReportsApiMonitorReportsRedeemedValidationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsRedeemedValidationGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsRedeemedValidationGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsRedeemedValidationGet
     */
    readonly validationId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsRedeemedValidationGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsRedeemedValidationGet
     */
    readonly name?: string
}

/**
 * Request parameters for monitorReportsRenameSavedReportPost operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsRenameSavedReportPostRequest
 */
export interface ReportsApiMonitorReportsRenameSavedReportPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsRenameSavedReportPost
     */
    readonly savedReportId?: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsRenameSavedReportPost
     */
    readonly newName?: string
}

/**
 * Request parameters for monitorReportsSavedReportDelete operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsSavedReportDeleteRequest
 */
export interface ReportsApiMonitorReportsSavedReportDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsSavedReportDelete
     */
    readonly savedReportId?: number
}

/**
 * Request parameters for monitorReportsSavedReportsGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsSavedReportsGetRequest
 */
export interface ReportsApiMonitorReportsSavedReportsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsSavedReportsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {DataEntitiesReportsReportType}
     * @memberof ReportsApiMonitorReportsSavedReportsGet
     */
    readonly reportType?: DataEntitiesReportsReportType
}

/**
 * Request parameters for monitorReportsSubscriptionsGet operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsSubscriptionsGetRequest
 */
export interface ReportsApiMonitorReportsSubscriptionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly to?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly planName?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly status?: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiMonitorReportsSubscriptionsGet
     */
    readonly quickDateMode?: string
}

/**
 * Request parameters for monitorReportsUpdateRecurringReportPost operation in ReportsApi.
 * @export
 * @interface ReportsApiMonitorReportsUpdateRecurringReportPostRequest
 */
export interface ReportsApiMonitorReportsUpdateRecurringReportPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiMonitorReportsUpdateRecurringReportPost
     */
    readonly recurringReportScheduleId?: number

    /**
     * 
     * @type {ServerTransferRecurringReportScheduleRequest}
     * @memberof ReportsApiMonitorReportsUpdateRecurringReportPost
     */
    readonly serverTransferRecurringReportScheduleRequest?: ServerTransferRecurringReportScheduleRequest
}

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {ReportsApiMonitorReportsAddRecurringReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsAddRecurringReportPost(requestParameters: ReportsApiMonitorReportsAddRecurringReportPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsAddRecurringReportPost(requestParameters.serverTransferRecurringReportScheduleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsAddSavedReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsAddSavedReportPost(requestParameters: ReportsApiMonitorReportsAddSavedReportPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsAddSavedReportPost(requestParameters.serverTransferAddSavedReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsAdhocReportsDownloadLinkGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsAdhocReportsDownloadLinkGet(requestParameters: ReportsApiMonitorReportsAdhocReportsDownloadLinkGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsAdhocReportsDownloadLinkGet(requestParameters.id, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsAdminRevenueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsAdminRevenueGet(requestParameters: ReportsApiMonitorReportsAdminRevenueGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsAdminRevenueGet(requestParameters.from, requestParameters.to, requestParameters.payoutFrom, requestParameters.payoutTo, requestParameters.paymentType, requestParameters.paymentStatus, requestParameters.name, requestParameters.email, requestParameters.quickDateMode, requestParameters.quickPayoutDateMode, requestParameters.operatorIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsAgingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsAgingGet(requestParameters: ReportsApiMonitorReportsAgingGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsAgingGet(requestParameters.age, requestParameters.facilityId, requestParameters.name, requestParameters.email, requestParameters.cutoffMode, requestParameters.cutoffDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsFacilityReportsIndexGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsFacilityReportsIndexGet(requestParameters: ReportsApiMonitorReportsFacilityReportsIndexGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsFacilityReportsIndexGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsPaymentsGet(requestParameters: ReportsApiMonitorReportsPaymentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsPaymentsGet(requestParameters.from, requestParameters.to, requestParameters.payoutFrom, requestParameters.payoutTo, requestParameters.paymentType, requestParameters.paymentStatus, requestParameters.facilityId, requestParameters.name, requestParameters.email, requestParameters.quickDateMode, requestParameters.quickPayoutDateMode, requestParameters.facilityIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsPayoutSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsPayoutSummaryGet(requestParameters: ReportsApiMonitorReportsPayoutSummaryGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsPayoutSummaryGet(requestParameters.from, requestParameters.to, requestParameters.operatorId, requestParameters.quickDateMode, requestParameters.facilityIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsRecurringReportDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsRecurringReportDelete(requestParameters: ReportsApiMonitorReportsRecurringReportDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsRecurringReportDelete(requestParameters.recurringReportScheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsRecurringReportsDownloadLinkGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsRecurringReportsDownloadLinkGet(requestParameters: ReportsApiMonitorReportsRecurringReportsDownloadLinkGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsRecurringReportsDownloadLinkGet(requestParameters.id, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsRecurringReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsRecurringReportsGet(requestParameters: ReportsApiMonitorReportsRecurringReportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsRecurringReportsGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsRedeemedValidationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsRedeemedValidationGet(requestParameters: ReportsApiMonitorReportsRedeemedValidationGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsRedeemedValidationGet(requestParameters.from, requestParameters.to, requestParameters.validationId, requestParameters.facilityId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsRenameSavedReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsRenameSavedReportPost(requestParameters: ReportsApiMonitorReportsRenameSavedReportPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsRenameSavedReportPost(requestParameters.savedReportId, requestParameters.newName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsSavedReportDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsSavedReportDelete(requestParameters: ReportsApiMonitorReportsSavedReportDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsSavedReportDelete(requestParameters.savedReportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsSavedReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsSavedReportsGet(requestParameters: ReportsApiMonitorReportsSavedReportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsSavedReportsGet(requestParameters.facilityId, requestParameters.reportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsSubscriptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsSubscriptionsGet(requestParameters: ReportsApiMonitorReportsSubscriptionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsSubscriptionsGet(requestParameters.from, requestParameters.to, requestParameters.planName, requestParameters.email, requestParameters.name, requestParameters.status, requestParameters.facilityId, requestParameters.quickDateMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiMonitorReportsUpdateRecurringReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public monitorReportsUpdateRecurringReportPost(requestParameters: ReportsApiMonitorReportsUpdateRecurringReportPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).monitorReportsUpdateRecurringReportPost(requestParameters.recurringReportScheduleId, requestParameters.serverTransferRecurringReportScheduleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReservationApi - axios parameter creator
 * @export
 */
export const ReservationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerRequestsReservationEntryConfirmBody} [serverRequestsReservationEntryConfirmBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entryConfirmReservation: async (facilityId: number, serverRequestsReservationEntryConfirmBody?: ServerRequestsReservationEntryConfirmBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('entryConfirmReservation', 'facilityId', facilityId)
            const localVarPath = `/facility/{facilityId}/reservation/entry-confirm`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsReservationEntryConfirmBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {string} [timeZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entryConfirmedTodayCount: async (facilityId: number, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('entryConfirmedTodayCount', 'facilityId', facilityId)
            const localVarPath = `/facility/{facilityId}/reservation/entry-confirmed-today-count`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsReservationValidateRequest} [serverRequestsReservationValidateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateReservation: async (serverRequestsReservationValidateRequest?: ServerRequestsReservationValidateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsReservationValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReservationApi - functional programming interface
 * @export
 */
export const ReservationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReservationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerRequestsReservationEntryConfirmBody} [serverRequestsReservationEntryConfirmBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entryConfirmReservation(facilityId: number, serverRequestsReservationEntryConfirmBody?: ServerRequestsReservationEntryConfirmBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsReservationEntryConfirmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entryConfirmReservation(facilityId, serverRequestsReservationEntryConfirmBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationApi.entryConfirmReservation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {string} [timeZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entryConfirmedTodayCount(facilityId: number, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsReservationEntryConfirmedTodayCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entryConfirmedTodayCount(facilityId, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationApi.entryConfirmedTodayCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsReservationValidateRequest} [serverRequestsReservationValidateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateReservation(serverRequestsReservationValidateRequest?: ServerRequestsReservationValidateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsReservationValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateReservation(serverRequestsReservationValidateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationApi.validateReservation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReservationApi - factory interface
 * @export
 */
export const ReservationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReservationApiFp(configuration)
    return {
        /**
         * 
         * @param {ReservationApiEntryConfirmReservationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entryConfirmReservation(requestParameters: ReservationApiEntryConfirmReservationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsReservationEntryConfirmResponse> {
            return localVarFp.entryConfirmReservation(requestParameters.facilityId, requestParameters.serverRequestsReservationEntryConfirmBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReservationApiEntryConfirmedTodayCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entryConfirmedTodayCount(requestParameters: ReservationApiEntryConfirmedTodayCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsReservationEntryConfirmedTodayCountResponse> {
            return localVarFp.entryConfirmedTodayCount(requestParameters.facilityId, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReservationApiValidateReservationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateReservation(requestParameters: ReservationApiValidateReservationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsReservationValidateResponse> {
            return localVarFp.validateReservation(requestParameters.serverRequestsReservationValidateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for entryConfirmReservation operation in ReservationApi.
 * @export
 * @interface ReservationApiEntryConfirmReservationRequest
 */
export interface ReservationApiEntryConfirmReservationRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservationApiEntryConfirmReservation
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerRequestsReservationEntryConfirmBody}
     * @memberof ReservationApiEntryConfirmReservation
     */
    readonly serverRequestsReservationEntryConfirmBody?: ServerRequestsReservationEntryConfirmBody
}

/**
 * Request parameters for entryConfirmedTodayCount operation in ReservationApi.
 * @export
 * @interface ReservationApiEntryConfirmedTodayCountRequest
 */
export interface ReservationApiEntryConfirmedTodayCountRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservationApiEntryConfirmedTodayCount
     */
    readonly facilityId: number

    /**
     * 
     * @type {string}
     * @memberof ReservationApiEntryConfirmedTodayCount
     */
    readonly timeZone?: string
}

/**
 * Request parameters for validateReservation operation in ReservationApi.
 * @export
 * @interface ReservationApiValidateReservationRequest
 */
export interface ReservationApiValidateReservationRequest {
    /**
     * 
     * @type {ServerRequestsReservationValidateRequest}
     * @memberof ReservationApiValidateReservation
     */
    readonly serverRequestsReservationValidateRequest?: ServerRequestsReservationValidateRequest
}

/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
export class ReservationApi extends BaseAPI {
    /**
     * 
     * @param {ReservationApiEntryConfirmReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public entryConfirmReservation(requestParameters: ReservationApiEntryConfirmReservationRequest, options?: RawAxiosRequestConfig) {
        return ReservationApiFp(this.configuration).entryConfirmReservation(requestParameters.facilityId, requestParameters.serverRequestsReservationEntryConfirmBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReservationApiEntryConfirmedTodayCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public entryConfirmedTodayCount(requestParameters: ReservationApiEntryConfirmedTodayCountRequest, options?: RawAxiosRequestConfig) {
        return ReservationApiFp(this.configuration).entryConfirmedTodayCount(requestParameters.facilityId, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReservationApiValidateReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public validateReservation(requestParameters: ReservationApiValidateReservationRequest = {}, options?: RawAxiosRequestConfig) {
        return ReservationApiFp(this.configuration).validateReservation(requestParameters.serverRequestsReservationValidateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StaffApi - axios parameter creator
 * @export
 */
export const StaffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsCreateAdminStaffRequest} [serverRequestsCreateAdminStaffRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminStaff: async (serverRequestsCreateAdminStaffRequest?: ServerRequestsCreateAdminStaffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/staffs/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateAdminStaffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsCreateStaffRequest} [serverRequestsCreateStaffRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaff: async (serverRequestsCreateStaffRequest?: ServerRequestsCreateStaffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/staffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsCreateStaffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaff: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStaff', 'id', id)
            const localVarPath = `/staffs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStaff', 'id', id)
            const localVarPath = `/staffs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffImpersonated: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStaffImpersonated', 'id', id)
            const localVarPath = `/staffs/{id}/impersonate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isSuperAdmin] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaff: async (isSuperAdmin?: boolean, pageSize?: number, pageNumber?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/staffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isSuperAdmin !== undefined) {
                localVarQueryParameter['IsSuperAdmin'] = isSuperAdmin;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['Pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaffPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/staffs/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsPatchStaffRequest} [serverRequestsPatchStaffRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaff: async (id: number, serverRequestsPatchStaffRequest?: ServerRequestsPatchStaffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStaff', 'id', id)
            const localVarPath = `/staffs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsPatchStaffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaffApi - functional programming interface
 * @export
 */
export const StaffApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StaffApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsCreateAdminStaffRequest} [serverRequestsCreateAdminStaffRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminStaff(serverRequestsCreateAdminStaffRequest?: ServerRequestsCreateAdminStaffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminStaff(serverRequestsCreateAdminStaffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.createAdminStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsCreateStaffRequest} [serverRequestsCreateStaffRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStaff(serverRequestsCreateStaffRequest?: ServerRequestsCreateStaffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStaff(serverRequestsCreateStaffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.createStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStaff(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStaff(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.deleteStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaff(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaff(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.getStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaffImpersonated(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaffImpersonated(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.getStaffImpersonated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isSuperAdmin] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [pagination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaff(isSuperAdmin?: boolean, pageSize?: number, pageNumber?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaff(isSuperAdmin, pageSize, pageNumber, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.listStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaffPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffPermissionsCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaffPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.listStaffPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsPatchStaffRequest} [serverRequestsPatchStaffRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStaff(id: number, serverRequestsPatchStaffRequest?: ServerRequestsPatchStaffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetStaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStaff(id, serverRequestsPatchStaffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.updateStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StaffApi - factory interface
 * @export
 */
export const StaffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StaffApiFp(configuration)
    return {
        /**
         * 
         * @param {StaffApiCreateAdminStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminStaff(requestParameters: StaffApiCreateAdminStaffRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffResponse> {
            return localVarFp.createAdminStaff(requestParameters.serverRequestsCreateAdminStaffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffApiCreateStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaff(requestParameters: StaffApiCreateStaffRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffResponse> {
            return localVarFp.createStaff(requestParameters.serverRequestsCreateStaffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffApiDeleteStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaff(requestParameters: StaffApiDeleteStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStaff(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffApiGetStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff(requestParameters: StaffApiGetStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffResponse> {
            return localVarFp.getStaff(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffApiGetStaffImpersonatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffImpersonated(requestParameters: StaffApiGetStaffImpersonatedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffResponse> {
            return localVarFp.getStaffImpersonated(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffApiListStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaff(requestParameters: StaffApiListStaffRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffsResponse> {
            return localVarFp.listStaff(requestParameters.isSuperAdmin, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaffPermissions(options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffPermissionsCatalogResponse> {
            return localVarFp.listStaffPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffApiUpdateStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaff(requestParameters: StaffApiUpdateStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetStaffResponse> {
            return localVarFp.updateStaff(requestParameters.id, requestParameters.serverRequestsPatchStaffRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAdminStaff operation in StaffApi.
 * @export
 * @interface StaffApiCreateAdminStaffRequest
 */
export interface StaffApiCreateAdminStaffRequest {
    /**
     * 
     * @type {ServerRequestsCreateAdminStaffRequest}
     * @memberof StaffApiCreateAdminStaff
     */
    readonly serverRequestsCreateAdminStaffRequest?: ServerRequestsCreateAdminStaffRequest
}

/**
 * Request parameters for createStaff operation in StaffApi.
 * @export
 * @interface StaffApiCreateStaffRequest
 */
export interface StaffApiCreateStaffRequest {
    /**
     * 
     * @type {ServerRequestsCreateStaffRequest}
     * @memberof StaffApiCreateStaff
     */
    readonly serverRequestsCreateStaffRequest?: ServerRequestsCreateStaffRequest
}

/**
 * Request parameters for deleteStaff operation in StaffApi.
 * @export
 * @interface StaffApiDeleteStaffRequest
 */
export interface StaffApiDeleteStaffRequest {
    /**
     * 
     * @type {number}
     * @memberof StaffApiDeleteStaff
     */
    readonly id: number
}

/**
 * Request parameters for getStaff operation in StaffApi.
 * @export
 * @interface StaffApiGetStaffRequest
 */
export interface StaffApiGetStaffRequest {
    /**
     * 
     * @type {number}
     * @memberof StaffApiGetStaff
     */
    readonly id: number
}

/**
 * Request parameters for getStaffImpersonated operation in StaffApi.
 * @export
 * @interface StaffApiGetStaffImpersonatedRequest
 */
export interface StaffApiGetStaffImpersonatedRequest {
    /**
     * 
     * @type {number}
     * @memberof StaffApiGetStaffImpersonated
     */
    readonly id: number
}

/**
 * Request parameters for listStaff operation in StaffApi.
 * @export
 * @interface StaffApiListStaffRequest
 */
export interface StaffApiListStaffRequest {
    /**
     * 
     * @type {boolean}
     * @memberof StaffApiListStaff
     */
    readonly isSuperAdmin?: boolean

    /**
     * 
     * @type {number}
     * @memberof StaffApiListStaff
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof StaffApiListStaff
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof StaffApiListStaff
     */
    readonly pagination?: boolean
}

/**
 * Request parameters for updateStaff operation in StaffApi.
 * @export
 * @interface StaffApiUpdateStaffRequest
 */
export interface StaffApiUpdateStaffRequest {
    /**
     * 
     * @type {number}
     * @memberof StaffApiUpdateStaff
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsPatchStaffRequest}
     * @memberof StaffApiUpdateStaff
     */
    readonly serverRequestsPatchStaffRequest?: ServerRequestsPatchStaffRequest
}

/**
 * StaffApi - object-oriented interface
 * @export
 * @class StaffApi
 * @extends {BaseAPI}
 */
export class StaffApi extends BaseAPI {
    /**
     * 
     * @param {StaffApiCreateAdminStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public createAdminStaff(requestParameters: StaffApiCreateAdminStaffRequest = {}, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).createAdminStaff(requestParameters.serverRequestsCreateAdminStaffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffApiCreateStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public createStaff(requestParameters: StaffApiCreateStaffRequest = {}, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).createStaff(requestParameters.serverRequestsCreateStaffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffApiDeleteStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public deleteStaff(requestParameters: StaffApiDeleteStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).deleteStaff(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffApiGetStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public getStaff(requestParameters: StaffApiGetStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).getStaff(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffApiGetStaffImpersonatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public getStaffImpersonated(requestParameters: StaffApiGetStaffImpersonatedRequest, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).getStaffImpersonated(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffApiListStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public listStaff(requestParameters: StaffApiListStaffRequest = {}, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).listStaff(requestParameters.isSuperAdmin, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public listStaffPermissions(options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).listStaffPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffApiUpdateStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public updateStaff(requestParameters: StaffApiUpdateStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).updateStaff(requestParameters.id, requestParameters.serverRequestsPatchStaffRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeWebhookApi - axios parameter creator
 * @export
 */
export const StripeWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripev2WebhookPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripev2/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeWebhookApi - functional programming interface
 * @export
 */
export const StripeWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripev2WebhookPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripev2WebhookPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeWebhookApi.stripev2WebhookPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StripeWebhookApi - factory interface
 * @export
 */
export const StripeWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripev2WebhookPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stripev2WebhookPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeWebhookApi - object-oriented interface
 * @export
 * @class StripeWebhookApi
 * @extends {BaseAPI}
 */
export class StripeWebhookApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeWebhookApi
     */
    public stripev2WebhookPost(options?: RawAxiosRequestConfig) {
        return StripeWebhookApiFp(this.configuration).stripev2WebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsChangeOptInFeeRequest} [serverRequestsChangeOptInFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOptInFee: async (serverRequestsChangeOptInFeeRequest?: ServerRequestsChangeOptInFeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/change-opt-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsChangeOptInFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerAccessCode: async (subscriptionId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getParkerAccessCode', 'subscriptionId', subscriptionId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerAccessCode', 'parkerId', parkerId)
            const localVarPath = `/subscription/{subscriptionId}/{parkerId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsGetParkerOptInFeesRequest} [serverRequestsGetParkerOptInFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOptedInFees: async (serverRequestsGetParkerOptInFeesRequest?: ServerRequestsGetParkerOptInFeesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/opted-in-fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsGetParkerOptInFeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionAccessCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription/access-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionIdCostProjectionGet: async (subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('subscriptionIdCostProjectionGet', 'subscriptionId', subscriptionId)
            const localVarPath = `/{subscriptionId}/cost-projection`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsChangeOptInFeeRequest} [serverRequestsChangeOptInFeeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeOptInFee(serverRequestsChangeOptInFeeRequest?: ServerRequestsChangeOptInFeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkerOptInFee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeOptInFee(serverRequestsChangeOptInFeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.changeOptInFee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerAccessCode(subscriptionId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerAccessCode(subscriptionId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getParkerAccessCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsGetParkerOptInFeesRequest} [serverRequestsGetParkerOptInFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerOptedInFees(serverRequestsGetParkerOptInFeesRequest?: ServerRequestsGetParkerOptInFeesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetParkerOptInFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerOptedInFees(serverRequestsGetParkerOptInFeesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getParkerOptedInFees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionAccessCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionAccessCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getSubscriptionAccessCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionIdCostProjectionGet(subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCostProjectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionIdCostProjectionGet(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.subscriptionIdCostProjectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionApiChangeOptInFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOptInFee(requestParameters: SubscriptionApiChangeOptInFeeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkerOptInFee> {
            return localVarFp.changeOptInFee(requestParameters.serverRequestsChangeOptInFeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionApiGetParkerAccessCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerAccessCode(requestParameters: SubscriptionApiGetParkerAccessCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getParkerAccessCode(requestParameters.subscriptionId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionApiGetParkerOptedInFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerOptedInFees(requestParameters: SubscriptionApiGetParkerOptedInFeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetParkerOptInFeeResponse> {
            return localVarFp.getParkerOptedInFees(requestParameters.serverRequestsGetParkerOptInFeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionAccessCodes(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getSubscriptionAccessCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionApiSubscriptionIdCostProjectionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionIdCostProjectionGet(requestParameters: SubscriptionApiSubscriptionIdCostProjectionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCostProjectionResponse> {
            return localVarFp.subscriptionIdCostProjectionGet(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for changeOptInFee operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiChangeOptInFeeRequest
 */
export interface SubscriptionApiChangeOptInFeeRequest {
    /**
     * 
     * @type {ServerRequestsChangeOptInFeeRequest}
     * @memberof SubscriptionApiChangeOptInFee
     */
    readonly serverRequestsChangeOptInFeeRequest?: ServerRequestsChangeOptInFeeRequest
}

/**
 * Request parameters for getParkerAccessCode operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiGetParkerAccessCodeRequest
 */
export interface SubscriptionApiGetParkerAccessCodeRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiGetParkerAccessCode
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiGetParkerAccessCode
     */
    readonly parkerId: number
}

/**
 * Request parameters for getParkerOptedInFees operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiGetParkerOptedInFeesRequest
 */
export interface SubscriptionApiGetParkerOptedInFeesRequest {
    /**
     * 
     * @type {ServerRequestsGetParkerOptInFeesRequest}
     * @memberof SubscriptionApiGetParkerOptedInFees
     */
    readonly serverRequestsGetParkerOptInFeesRequest?: ServerRequestsGetParkerOptInFeesRequest
}

/**
 * Request parameters for subscriptionIdCostProjectionGet operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiSubscriptionIdCostProjectionGetRequest
 */
export interface SubscriptionApiSubscriptionIdCostProjectionGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiSubscriptionIdCostProjectionGet
     */
    readonly subscriptionId: number
}

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionApiChangeOptInFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public changeOptInFee(requestParameters: SubscriptionApiChangeOptInFeeRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).changeOptInFee(requestParameters.serverRequestsChangeOptInFeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionApiGetParkerAccessCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getParkerAccessCode(requestParameters: SubscriptionApiGetParkerAccessCodeRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getParkerAccessCode(requestParameters.subscriptionId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionApiGetParkerOptedInFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getParkerOptedInFees(requestParameters: SubscriptionApiGetParkerOptedInFeesRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getParkerOptedInFees(requestParameters.serverRequestsGetParkerOptInFeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getSubscriptionAccessCodes(options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getSubscriptionAccessCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionApiSubscriptionIdCostProjectionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public subscriptionIdCostProjectionGet(requestParameters: SubscriptionApiSubscriptionIdCostProjectionGetRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).subscriptionIdCostProjectionGet(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionGroupsApi - axios parameter creator
 * @export
 */
export const SubscriptionGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsSubscriptionGroupAddRequest} [serverRequestsSubscriptionGroupAddRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup: async (serverRequestsSubscriptionGroupAddRequest?: ServerRequestsSubscriptionGroupAddRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsSubscriptionGroupAddRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsParkerGroupChangeRequest} [serverRequestsParkerGroupChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeParkerGroup: async (serverRequestsParkerGroupChangeRequest?: ServerRequestsParkerGroupChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription-groups/parker-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsParkerGroupChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (subscriptionGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionGroupId' is not null or undefined
            assertParamExists('deleteGroup', 'subscriptionGroupId', subscriptionGroupId)
            const localVarPath = `/subscription-groups/{subscriptionGroupId}`
                .replace(`{${"subscriptionGroupId"}}`, encodeURIComponent(String(subscriptionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getGroups', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscription-groups/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkersByGroup: async (subscriptionGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionGroupId' is not null or undefined
            assertParamExists('getParkersByGroup', 'subscriptionGroupId', subscriptionGroupId)
            const localVarPath = `/subscription-groups/parkers/{subscriptionGroupId}`
                .replace(`{${"subscriptionGroupId"}}`, encodeURIComponent(String(subscriptionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (subscriptionGroupId: number, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionGroupId' is not null or undefined
            assertParamExists('updateGroup', 'subscriptionGroupId', subscriptionGroupId)
            const localVarPath = `/subscription-groups/{subscriptionGroupId}`
                .replace(`{${"subscriptionGroupId"}}`, encodeURIComponent(String(subscriptionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionGroupsApi - functional programming interface
 * @export
 */
export const SubscriptionGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsSubscriptionGroupAddRequest} [serverRequestsSubscriptionGroupAddRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGroup(serverRequestsSubscriptionGroupAddRequest?: ServerRequestsSubscriptionGroupAddRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsSubscriptionGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGroup(serverRequestsSubscriptionGroupAddRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionGroupsApi.addGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsParkerGroupChangeRequest} [serverRequestsParkerGroupChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeParkerGroup(serverRequestsParkerGroupChangeRequest?: ServerRequestsParkerGroupChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkerGroupChangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeParkerGroup(serverRequestsParkerGroupChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionGroupsApi.changeParkerGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(subscriptionGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsSubscriptionGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(subscriptionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionGroupsApi.deleteGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsSubscriptionGroupsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionGroupsApi.getGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkersByGroup(subscriptionGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsParkersByGroupListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkersByGroup(subscriptionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionGroupsApi.getParkersByGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionGroupId 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(subscriptionGroupId: number, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsSubscriptionGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroup(subscriptionGroupId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionGroupsApi.updateGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionGroupsApi - factory interface
 * @export
 */
export const SubscriptionGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionGroupsApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionGroupsApiAddGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup(requestParameters: SubscriptionGroupsApiAddGroupRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsSubscriptionGroupsResponse> {
            return localVarFp.addGroup(requestParameters.serverRequestsSubscriptionGroupAddRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionGroupsApiChangeParkerGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeParkerGroup(requestParameters: SubscriptionGroupsApiChangeParkerGroupRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkerGroupChangeResponse> {
            return localVarFp.changeParkerGroup(requestParameters.serverRequestsParkerGroupChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionGroupsApiDeleteGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(requestParameters: SubscriptionGroupsApiDeleteGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsSubscriptionGroupsResponse> {
            return localVarFp.deleteGroup(requestParameters.subscriptionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionGroupsApiGetGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(requestParameters: SubscriptionGroupsApiGetGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsSubscriptionGroupsListResponse> {
            return localVarFp.getGroups(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionGroupsApiGetParkersByGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkersByGroup(requestParameters: SubscriptionGroupsApiGetParkersByGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsParkersByGroupListResponse> {
            return localVarFp.getParkersByGroup(requestParameters.subscriptionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionGroupsApiUpdateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(requestParameters: SubscriptionGroupsApiUpdateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsSubscriptionGroupsResponse> {
            return localVarFp.updateGroup(requestParameters.subscriptionGroupId, requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addGroup operation in SubscriptionGroupsApi.
 * @export
 * @interface SubscriptionGroupsApiAddGroupRequest
 */
export interface SubscriptionGroupsApiAddGroupRequest {
    /**
     * 
     * @type {ServerRequestsSubscriptionGroupAddRequest}
     * @memberof SubscriptionGroupsApiAddGroup
     */
    readonly serverRequestsSubscriptionGroupAddRequest?: ServerRequestsSubscriptionGroupAddRequest
}

/**
 * Request parameters for changeParkerGroup operation in SubscriptionGroupsApi.
 * @export
 * @interface SubscriptionGroupsApiChangeParkerGroupRequest
 */
export interface SubscriptionGroupsApiChangeParkerGroupRequest {
    /**
     * 
     * @type {ServerRequestsParkerGroupChangeRequest}
     * @memberof SubscriptionGroupsApiChangeParkerGroup
     */
    readonly serverRequestsParkerGroupChangeRequest?: ServerRequestsParkerGroupChangeRequest
}

/**
 * Request parameters for deleteGroup operation in SubscriptionGroupsApi.
 * @export
 * @interface SubscriptionGroupsApiDeleteGroupRequest
 */
export interface SubscriptionGroupsApiDeleteGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionGroupsApiDeleteGroup
     */
    readonly subscriptionGroupId: number
}

/**
 * Request parameters for getGroups operation in SubscriptionGroupsApi.
 * @export
 * @interface SubscriptionGroupsApiGetGroupsRequest
 */
export interface SubscriptionGroupsApiGetGroupsRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionGroupsApiGetGroups
     */
    readonly subscriptionId: number
}

/**
 * Request parameters for getParkersByGroup operation in SubscriptionGroupsApi.
 * @export
 * @interface SubscriptionGroupsApiGetParkersByGroupRequest
 */
export interface SubscriptionGroupsApiGetParkersByGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionGroupsApiGetParkersByGroup
     */
    readonly subscriptionGroupId: number
}

/**
 * Request parameters for updateGroup operation in SubscriptionGroupsApi.
 * @export
 * @interface SubscriptionGroupsApiUpdateGroupRequest
 */
export interface SubscriptionGroupsApiUpdateGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionGroupsApiUpdateGroup
     */
    readonly subscriptionGroupId: number

    /**
     * 
     * @type {string}
     * @memberof SubscriptionGroupsApiUpdateGroup
     */
    readonly name?: string
}

/**
 * SubscriptionGroupsApi - object-oriented interface
 * @export
 * @class SubscriptionGroupsApi
 * @extends {BaseAPI}
 */
export class SubscriptionGroupsApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionGroupsApiAddGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionGroupsApi
     */
    public addGroup(requestParameters: SubscriptionGroupsApiAddGroupRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionGroupsApiFp(this.configuration).addGroup(requestParameters.serverRequestsSubscriptionGroupAddRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionGroupsApiChangeParkerGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionGroupsApi
     */
    public changeParkerGroup(requestParameters: SubscriptionGroupsApiChangeParkerGroupRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionGroupsApiFp(this.configuration).changeParkerGroup(requestParameters.serverRequestsParkerGroupChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionGroupsApiDeleteGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionGroupsApi
     */
    public deleteGroup(requestParameters: SubscriptionGroupsApiDeleteGroupRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionGroupsApiFp(this.configuration).deleteGroup(requestParameters.subscriptionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionGroupsApiGetGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionGroupsApi
     */
    public getGroups(requestParameters: SubscriptionGroupsApiGetGroupsRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionGroupsApiFp(this.configuration).getGroups(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionGroupsApiGetParkersByGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionGroupsApi
     */
    public getParkersByGroup(requestParameters: SubscriptionGroupsApiGetParkersByGroupRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionGroupsApiFp(this.configuration).getParkersByGroup(requestParameters.subscriptionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionGroupsApiUpdateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionGroupsApi
     */
    public updateGroup(requestParameters: SubscriptionGroupsApiUpdateGroupRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionGroupsApiFp(this.configuration).updateGroup(requestParameters.subscriptionGroupId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionStaffApi - axios parameter creator
 * @export
 */
export const SubscriptionStaffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerAccessCodeStaff: async (subscriptionId: number, parkerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getParkerAccessCodeStaff', 'subscriptionId', subscriptionId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getParkerAccessCodeStaff', 'parkerId', parkerId)
            const localVarPath = `/subscriptionstaff/{subscriptionId}/{parkerId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRenewalFailureDetail: async (subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getRenewalFailureDetail', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscriptionstaff/renewal-failure/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionStaffApi - functional programming interface
 * @export
 */
export const SubscriptionStaffApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionStaffApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {number} parkerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkerAccessCodeStaff(subscriptionId: number, parkerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkerAccessCodeStaff(subscriptionId, parkerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionStaffApi.getParkerAccessCodeStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRenewalFailureDetail(subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetSubBillingFailedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRenewalFailureDetail(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionStaffApi.getRenewalFailureDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionStaffApi - factory interface
 * @export
 */
export const SubscriptionStaffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionStaffApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionStaffApiGetParkerAccessCodeStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkerAccessCodeStaff(requestParameters: SubscriptionStaffApiGetParkerAccessCodeStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getParkerAccessCodeStaff(requestParameters.subscriptionId, requestParameters.parkerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionStaffApiGetRenewalFailureDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRenewalFailureDetail(requestParameters: SubscriptionStaffApiGetRenewalFailureDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetSubBillingFailedResponse> {
            return localVarFp.getRenewalFailureDetail(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getParkerAccessCodeStaff operation in SubscriptionStaffApi.
 * @export
 * @interface SubscriptionStaffApiGetParkerAccessCodeStaffRequest
 */
export interface SubscriptionStaffApiGetParkerAccessCodeStaffRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionStaffApiGetParkerAccessCodeStaff
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {number}
     * @memberof SubscriptionStaffApiGetParkerAccessCodeStaff
     */
    readonly parkerId: number
}

/**
 * Request parameters for getRenewalFailureDetail operation in SubscriptionStaffApi.
 * @export
 * @interface SubscriptionStaffApiGetRenewalFailureDetailRequest
 */
export interface SubscriptionStaffApiGetRenewalFailureDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionStaffApiGetRenewalFailureDetail
     */
    readonly subscriptionId: number
}

/**
 * SubscriptionStaffApi - object-oriented interface
 * @export
 * @class SubscriptionStaffApi
 * @extends {BaseAPI}
 */
export class SubscriptionStaffApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionStaffApiGetParkerAccessCodeStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionStaffApi
     */
    public getParkerAccessCodeStaff(requestParameters: SubscriptionStaffApiGetParkerAccessCodeStaffRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionStaffApiFp(this.configuration).getParkerAccessCodeStaff(requestParameters.subscriptionId, requestParameters.parkerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionStaffApiGetRenewalFailureDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionStaffApi
     */
    public getRenewalFailureDetail(requestParameters: SubscriptionStaffApiGetRenewalFailureDetailRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionStaffApiFp(this.configuration).getRenewalFailureDetail(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TutorialProgressApi - axios parameter creator
 * @export
 */
export const TutorialProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tutorialProgressCompletedStaffIdGet: async (staffId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('tutorialProgressCompletedStaffIdGet', 'staffId', staffId)
            const localVarPath = `/tutorial-progress/completed/{staffId}`
                .replace(`{${"staffId"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ServerRequestsSaveTutorialProgressRequest} [serverRequestsSaveTutorialProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tutorialProgressPost: async (serverRequestsSaveTutorialProgressRequest?: ServerRequestsSaveTutorialProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tutorial-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsSaveTutorialProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TutorialProgressApi - functional programming interface
 * @export
 */
export const TutorialProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TutorialProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tutorialProgressCompletedStaffIdGet(staffId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetCompletedTutorialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tutorialProgressCompletedStaffIdGet(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TutorialProgressApi.tutorialProgressCompletedStaffIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ServerRequestsSaveTutorialProgressRequest} [serverRequestsSaveTutorialProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tutorialProgressPost(serverRequestsSaveTutorialProgressRequest?: ServerRequestsSaveTutorialProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsSaveTutorialProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tutorialProgressPost(serverRequestsSaveTutorialProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TutorialProgressApi.tutorialProgressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TutorialProgressApi - factory interface
 * @export
 */
export const TutorialProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TutorialProgressApiFp(configuration)
    return {
        /**
         * 
         * @param {TutorialProgressApiTutorialProgressCompletedStaffIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tutorialProgressCompletedStaffIdGet(requestParameters: TutorialProgressApiTutorialProgressCompletedStaffIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetCompletedTutorialResponse> {
            return localVarFp.tutorialProgressCompletedStaffIdGet(requestParameters.staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TutorialProgressApiTutorialProgressPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tutorialProgressPost(requestParameters: TutorialProgressApiTutorialProgressPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsSaveTutorialProgressResponse> {
            return localVarFp.tutorialProgressPost(requestParameters.serverRequestsSaveTutorialProgressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for tutorialProgressCompletedStaffIdGet operation in TutorialProgressApi.
 * @export
 * @interface TutorialProgressApiTutorialProgressCompletedStaffIdGetRequest
 */
export interface TutorialProgressApiTutorialProgressCompletedStaffIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TutorialProgressApiTutorialProgressCompletedStaffIdGet
     */
    readonly staffId: number
}

/**
 * Request parameters for tutorialProgressPost operation in TutorialProgressApi.
 * @export
 * @interface TutorialProgressApiTutorialProgressPostRequest
 */
export interface TutorialProgressApiTutorialProgressPostRequest {
    /**
     * 
     * @type {ServerRequestsSaveTutorialProgressRequest}
     * @memberof TutorialProgressApiTutorialProgressPost
     */
    readonly serverRequestsSaveTutorialProgressRequest?: ServerRequestsSaveTutorialProgressRequest
}

/**
 * TutorialProgressApi - object-oriented interface
 * @export
 * @class TutorialProgressApi
 * @extends {BaseAPI}
 */
export class TutorialProgressApi extends BaseAPI {
    /**
     * 
     * @param {TutorialProgressApiTutorialProgressCompletedStaffIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TutorialProgressApi
     */
    public tutorialProgressCompletedStaffIdGet(requestParameters: TutorialProgressApiTutorialProgressCompletedStaffIdGetRequest, options?: RawAxiosRequestConfig) {
        return TutorialProgressApiFp(this.configuration).tutorialProgressCompletedStaffIdGet(requestParameters.staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TutorialProgressApiTutorialProgressPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TutorialProgressApi
     */
    public tutorialProgressPost(requestParameters: TutorialProgressApiTutorialProgressPostRequest = {}, options?: RawAxiosRequestConfig) {
        return TutorialProgressApiFp(this.configuration).tutorialProgressPost(requestParameters.serverRequestsSaveTutorialProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsageBillingApi - axios parameter creator
 * @export
 */
export const UsageBillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGetUsageReceiptDownload: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('connectGetUsageReceiptDownload', 'orderId', orderId)
            const localVarPath = `/connect/finance/order/{orderId}/usage-receipt`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {string} description 
         * @param {number} [amount] 
         * @param {File} [receipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsageCharge: async (subscriptionId: number, description: string, amount?: number, receipt?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('createUsageCharge', 'subscriptionId', subscriptionId)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('createUsageCharge', 'description', description)
            const localVarPath = `/usage-billing/subscriptions/{subscriptionId}/charge`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (amount !== undefined) { 
                localVarFormParams.append('Amount', amount as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('Description', description as any);
            }
    
            if (receipt !== undefined) { 
                localVarFormParams.append('Receipt', receipt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageBillingPage: async (subscriptionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getUsageBillingPage', 'subscriptionId', subscriptionId)
            const localVarPath = `/usage-billing/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageReceiptDownload: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getUsageReceiptDownload', 'orderId', orderId)
            const localVarPath = `/usage-billing/orders/{orderId}/receipt`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGetUsageReceiptDownload: async (facilityId: number, parkerId: number, orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('monitorGetUsageReceiptDownload', 'facilityId', facilityId)
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('monitorGetUsageReceiptDownload', 'parkerId', parkerId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('monitorGetUsageReceiptDownload', 'orderId', orderId)
            const localVarPath = `/monitor/facility/{facilityId}/parker/{parkerId}/order/{orderId}/usage-receipt`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsageBillingApi - functional programming interface
 * @export
 */
export const UsageBillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsageBillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectGetUsageReceiptDownload(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUsageReceiptDownloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectGetUsageReceiptDownload(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsageBillingApi.connectGetUsageReceiptDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {string} description 
         * @param {number} [amount] 
         * @param {File} [receipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsageCharge(subscriptionId: number, description: string, amount?: number, receipt?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsCreateUsageChargeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsageCharge(subscriptionId, description, amount, receipt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsageBillingApi.createUsageCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageBillingPage(subscriptionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUsageBillingPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageBillingPage(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsageBillingApi.getUsageBillingPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageReceiptDownload(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUsageReceiptDownloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageReceiptDownload(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsageBillingApi.getUsageReceiptDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {number} parkerId 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monitorGetUsageReceiptDownload(facilityId: number, parkerId: number, orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsUsageReceiptDownloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monitorGetUsageReceiptDownload(facilityId, parkerId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsageBillingApi.monitorGetUsageReceiptDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsageBillingApi - factory interface
 * @export
 */
export const UsageBillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsageBillingApiFp(configuration)
    return {
        /**
         * 
         * @param {UsageBillingApiConnectGetUsageReceiptDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGetUsageReceiptDownload(requestParameters: UsageBillingApiConnectGetUsageReceiptDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUsageReceiptDownloadDto> {
            return localVarFp.connectGetUsageReceiptDownload(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsageBillingApiCreateUsageChargeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsageCharge(requestParameters: UsageBillingApiCreateUsageChargeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsCreateUsageChargeResponse> {
            return localVarFp.createUsageCharge(requestParameters.subscriptionId, requestParameters.description, requestParameters.amount, requestParameters.receipt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsageBillingApiGetUsageBillingPageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageBillingPage(requestParameters: UsageBillingApiGetUsageBillingPageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUsageBillingPageDto> {
            return localVarFp.getUsageBillingPage(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsageBillingApiGetUsageReceiptDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageReceiptDownload(requestParameters: UsageBillingApiGetUsageReceiptDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUsageReceiptDownloadDto> {
            return localVarFp.getUsageReceiptDownload(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsageBillingApiMonitorGetUsageReceiptDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorGetUsageReceiptDownload(requestParameters: UsageBillingApiMonitorGetUsageReceiptDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsUsageReceiptDownloadDto> {
            return localVarFp.monitorGetUsageReceiptDownload(requestParameters.facilityId, requestParameters.parkerId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for connectGetUsageReceiptDownload operation in UsageBillingApi.
 * @export
 * @interface UsageBillingApiConnectGetUsageReceiptDownloadRequest
 */
export interface UsageBillingApiConnectGetUsageReceiptDownloadRequest {
    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiConnectGetUsageReceiptDownload
     */
    readonly orderId: number
}

/**
 * Request parameters for createUsageCharge operation in UsageBillingApi.
 * @export
 * @interface UsageBillingApiCreateUsageChargeRequest
 */
export interface UsageBillingApiCreateUsageChargeRequest {
    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiCreateUsageCharge
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {string}
     * @memberof UsageBillingApiCreateUsageCharge
     */
    readonly description: string

    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiCreateUsageCharge
     */
    readonly amount?: number

    /**
     * 
     * @type {File}
     * @memberof UsageBillingApiCreateUsageCharge
     */
    readonly receipt?: File
}

/**
 * Request parameters for getUsageBillingPage operation in UsageBillingApi.
 * @export
 * @interface UsageBillingApiGetUsageBillingPageRequest
 */
export interface UsageBillingApiGetUsageBillingPageRequest {
    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiGetUsageBillingPage
     */
    readonly subscriptionId: number
}

/**
 * Request parameters for getUsageReceiptDownload operation in UsageBillingApi.
 * @export
 * @interface UsageBillingApiGetUsageReceiptDownloadRequest
 */
export interface UsageBillingApiGetUsageReceiptDownloadRequest {
    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiGetUsageReceiptDownload
     */
    readonly orderId: number
}

/**
 * Request parameters for monitorGetUsageReceiptDownload operation in UsageBillingApi.
 * @export
 * @interface UsageBillingApiMonitorGetUsageReceiptDownloadRequest
 */
export interface UsageBillingApiMonitorGetUsageReceiptDownloadRequest {
    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiMonitorGetUsageReceiptDownload
     */
    readonly facilityId: number

    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiMonitorGetUsageReceiptDownload
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof UsageBillingApiMonitorGetUsageReceiptDownload
     */
    readonly orderId: number
}

/**
 * UsageBillingApi - object-oriented interface
 * @export
 * @class UsageBillingApi
 * @extends {BaseAPI}
 */
export class UsageBillingApi extends BaseAPI {
    /**
     * 
     * @param {UsageBillingApiConnectGetUsageReceiptDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageBillingApi
     */
    public connectGetUsageReceiptDownload(requestParameters: UsageBillingApiConnectGetUsageReceiptDownloadRequest, options?: RawAxiosRequestConfig) {
        return UsageBillingApiFp(this.configuration).connectGetUsageReceiptDownload(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsageBillingApiCreateUsageChargeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageBillingApi
     */
    public createUsageCharge(requestParameters: UsageBillingApiCreateUsageChargeRequest, options?: RawAxiosRequestConfig) {
        return UsageBillingApiFp(this.configuration).createUsageCharge(requestParameters.subscriptionId, requestParameters.description, requestParameters.amount, requestParameters.receipt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsageBillingApiGetUsageBillingPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageBillingApi
     */
    public getUsageBillingPage(requestParameters: UsageBillingApiGetUsageBillingPageRequest, options?: RawAxiosRequestConfig) {
        return UsageBillingApiFp(this.configuration).getUsageBillingPage(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsageBillingApiGetUsageReceiptDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageBillingApi
     */
    public getUsageReceiptDownload(requestParameters: UsageBillingApiGetUsageReceiptDownloadRequest, options?: RawAxiosRequestConfig) {
        return UsageBillingApiFp(this.configuration).getUsageReceiptDownload(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsageBillingApiMonitorGetUsageReceiptDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageBillingApi
     */
    public monitorGetUsageReceiptDownload(requestParameters: UsageBillingApiMonitorGetUsageReceiptDownloadRequest, options?: RawAxiosRequestConfig) {
        return UsageBillingApiFp(this.configuration).monitorGetUsageReceiptDownload(requestParameters.facilityId, requestParameters.parkerId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WaitlistApi - axios parameter creator
 * @export
 */
export const WaitlistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ServerRequestsAddToWaitlistRequest} [serverRequestsAddToWaitlistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToWaitlist: async (serverRequestsAddToWaitlistRequest?: ServerRequestsAddToWaitlistRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/waitlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsAddToWaitlistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParkerFromWaitlist: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteParkerFromWaitlist', 'id', id)
            const localVarPath = `/waitlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityWaitlistToggle: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getFacilityWaitlistToggle', 'facilityId', facilityId)
            const localVarPath = `/waitlist/{facilityId}/toggle`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitlist: async (facilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('getWaitlist', 'facilityId', facilityId)
            const localVarPath = `/waitlist/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} waitlistEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitlistById: async (waitlistEntryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waitlistEntryId' is not null or undefined
            assertParamExists('getWaitlistById', 'waitlistEntryId', waitlistEntryId)
            const localVarPath = `/waitlist/by-id/{waitlistEntryId}`
                .replace(`{${"waitlistEntryId"}}`, encodeURIComponent(String(waitlistEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parkerId 
         * @param {number} [subscriptionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitlistByParkerId: async (parkerId: number, subscriptionId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parkerId' is not null or undefined
            assertParamExists('getWaitlistByParkerId', 'parkerId', parkerId)
            const localVarPath = `/waitlist/by-parker-id/{parkerId}`
                .replace(`{${"parkerId"}}`, encodeURIComponent(String(parkerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (subscriptionId !== undefined) {
                localVarQueryParameter['subscriptionId'] = subscriptionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsInviteParkerToClaimSpotRequest} [serverRequestsInviteParkerToClaimSpotRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteParkerToClaimSpot: async (id: number, serverRequestsInviteParkerToClaimSpotRequest?: ServerRequestsInviteParkerToClaimSpotRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('inviteParkerToClaimSpot', 'id', id)
            const localVarPath = `/waitlist/invite-parker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsInviteParkerToClaimSpotRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerRequestsPatchFacilityWaitlistToggleRequest} [serverRequestsPatchFacilityWaitlistToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFacilityWaitlistToggle: async (facilityId: number, serverRequestsPatchFacilityWaitlistToggleRequest?: ServerRequestsPatchFacilityWaitlistToggleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('patchFacilityWaitlistToggle', 'facilityId', facilityId)
            const localVarPath = `/waitlist/toggle/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsPatchFacilityWaitlistToggleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsReorderWaitlistRequest} [serverRequestsReorderWaitlistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWaitlist: async (id: number, serverRequestsReorderWaitlistRequest?: ServerRequestsReorderWaitlistRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reorderWaitlist', 'id', id)
            const localVarPath = `/waitlist/reorder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverRequestsReorderWaitlistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWailitEntryAsAccepted: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setWailitEntryAsAccepted', 'id', id)
            const localVarPath = `/waitlist/set-as-accepted/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaitlistApi - functional programming interface
 * @export
 */
export const WaitlistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaitlistApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ServerRequestsAddToWaitlistRequest} [serverRequestsAddToWaitlistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToWaitlist(serverRequestsAddToWaitlistRequest?: ServerRequestsAddToWaitlistRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsWaitlistData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToWaitlist(serverRequestsAddToWaitlistRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.addToWaitlist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParkerFromWaitlist(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsDeleteParkerFromWaitlistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParkerFromWaitlist(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.deleteParkerFromWaitlist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilityWaitlistToggle(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFacilityWaitlistToggleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilityWaitlistToggle(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.getFacilityWaitlistToggle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitlist(facilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetWaitlistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitlist(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.getWaitlist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} waitlistEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitlistById(waitlistEntryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetWaitlistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitlistById(waitlistEntryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.getWaitlistById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parkerId 
         * @param {number} [subscriptionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitlistByParkerId(parkerId: number, subscriptionId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetWaitlistByParkerIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitlistByParkerId(parkerId, subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.getWaitlistByParkerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsInviteParkerToClaimSpotRequest} [serverRequestsInviteParkerToClaimSpotRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteParkerToClaimSpot(id: number, serverRequestsInviteParkerToClaimSpotRequest?: ServerRequestsInviteParkerToClaimSpotRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsWaitlistData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteParkerToClaimSpot(id, serverRequestsInviteParkerToClaimSpotRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.inviteParkerToClaimSpot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} facilityId 
         * @param {ServerRequestsPatchFacilityWaitlistToggleRequest} [serverRequestsPatchFacilityWaitlistToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchFacilityWaitlistToggle(facilityId: number, serverRequestsPatchFacilityWaitlistToggleRequest?: ServerRequestsPatchFacilityWaitlistToggleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetFacilityWaitlistToggleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchFacilityWaitlistToggle(facilityId, serverRequestsPatchFacilityWaitlistToggleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.patchFacilityWaitlistToggle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ServerRequestsReorderWaitlistRequest} [serverRequestsReorderWaitlistRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderWaitlist(id: number, serverRequestsReorderWaitlistRequest?: ServerRequestsReorderWaitlistRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsGetWaitlistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderWaitlist(id, serverRequestsReorderWaitlistRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.reorderWaitlist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWailitEntryAsAccepted(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerRequestsWaitlistData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWailitEntryAsAccepted(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitlistApi.setWailitEntryAsAccepted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WaitlistApi - factory interface
 * @export
 */
export const WaitlistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaitlistApiFp(configuration)
    return {
        /**
         * 
         * @param {WaitlistApiAddToWaitlistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToWaitlist(requestParameters: WaitlistApiAddToWaitlistRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsWaitlistData> {
            return localVarFp.addToWaitlist(requestParameters.serverRequestsAddToWaitlistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiDeleteParkerFromWaitlistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParkerFromWaitlist(requestParameters: WaitlistApiDeleteParkerFromWaitlistRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsDeleteParkerFromWaitlistResponse> {
            return localVarFp.deleteParkerFromWaitlist(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiGetFacilityWaitlistToggleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityWaitlistToggle(requestParameters: WaitlistApiGetFacilityWaitlistToggleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFacilityWaitlistToggleResponse> {
            return localVarFp.getFacilityWaitlistToggle(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiGetWaitlistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitlist(requestParameters: WaitlistApiGetWaitlistRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetWaitlistResponse> {
            return localVarFp.getWaitlist(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiGetWaitlistByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitlistById(requestParameters: WaitlistApiGetWaitlistByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetWaitlistResponse> {
            return localVarFp.getWaitlistById(requestParameters.waitlistEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiGetWaitlistByParkerIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitlistByParkerId(requestParameters: WaitlistApiGetWaitlistByParkerIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetWaitlistByParkerIdResponse> {
            return localVarFp.getWaitlistByParkerId(requestParameters.parkerId, requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiInviteParkerToClaimSpotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteParkerToClaimSpot(requestParameters: WaitlistApiInviteParkerToClaimSpotRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsWaitlistData> {
            return localVarFp.inviteParkerToClaimSpot(requestParameters.id, requestParameters.serverRequestsInviteParkerToClaimSpotRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiPatchFacilityWaitlistToggleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFacilityWaitlistToggle(requestParameters: WaitlistApiPatchFacilityWaitlistToggleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetFacilityWaitlistToggleResponse> {
            return localVarFp.patchFacilityWaitlistToggle(requestParameters.facilityId, requestParameters.serverRequestsPatchFacilityWaitlistToggleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiReorderWaitlistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWaitlist(requestParameters: WaitlistApiReorderWaitlistRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsGetWaitlistResponse> {
            return localVarFp.reorderWaitlist(requestParameters.id, requestParameters.serverRequestsReorderWaitlistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WaitlistApiSetWailitEntryAsAcceptedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWailitEntryAsAccepted(requestParameters: WaitlistApiSetWailitEntryAsAcceptedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServerRequestsWaitlistData> {
            return localVarFp.setWailitEntryAsAccepted(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addToWaitlist operation in WaitlistApi.
 * @export
 * @interface WaitlistApiAddToWaitlistRequest
 */
export interface WaitlistApiAddToWaitlistRequest {
    /**
     * 
     * @type {ServerRequestsAddToWaitlistRequest}
     * @memberof WaitlistApiAddToWaitlist
     */
    readonly serverRequestsAddToWaitlistRequest?: ServerRequestsAddToWaitlistRequest
}

/**
 * Request parameters for deleteParkerFromWaitlist operation in WaitlistApi.
 * @export
 * @interface WaitlistApiDeleteParkerFromWaitlistRequest
 */
export interface WaitlistApiDeleteParkerFromWaitlistRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiDeleteParkerFromWaitlist
     */
    readonly id: number
}

/**
 * Request parameters for getFacilityWaitlistToggle operation in WaitlistApi.
 * @export
 * @interface WaitlistApiGetFacilityWaitlistToggleRequest
 */
export interface WaitlistApiGetFacilityWaitlistToggleRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiGetFacilityWaitlistToggle
     */
    readonly facilityId: number
}

/**
 * Request parameters for getWaitlist operation in WaitlistApi.
 * @export
 * @interface WaitlistApiGetWaitlistRequest
 */
export interface WaitlistApiGetWaitlistRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiGetWaitlist
     */
    readonly facilityId: number
}

/**
 * Request parameters for getWaitlistById operation in WaitlistApi.
 * @export
 * @interface WaitlistApiGetWaitlistByIdRequest
 */
export interface WaitlistApiGetWaitlistByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiGetWaitlistById
     */
    readonly waitlistEntryId: number
}

/**
 * Request parameters for getWaitlistByParkerId operation in WaitlistApi.
 * @export
 * @interface WaitlistApiGetWaitlistByParkerIdRequest
 */
export interface WaitlistApiGetWaitlistByParkerIdRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiGetWaitlistByParkerId
     */
    readonly parkerId: number

    /**
     * 
     * @type {number}
     * @memberof WaitlistApiGetWaitlistByParkerId
     */
    readonly subscriptionId?: number
}

/**
 * Request parameters for inviteParkerToClaimSpot operation in WaitlistApi.
 * @export
 * @interface WaitlistApiInviteParkerToClaimSpotRequest
 */
export interface WaitlistApiInviteParkerToClaimSpotRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiInviteParkerToClaimSpot
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsInviteParkerToClaimSpotRequest}
     * @memberof WaitlistApiInviteParkerToClaimSpot
     */
    readonly serverRequestsInviteParkerToClaimSpotRequest?: ServerRequestsInviteParkerToClaimSpotRequest
}

/**
 * Request parameters for patchFacilityWaitlistToggle operation in WaitlistApi.
 * @export
 * @interface WaitlistApiPatchFacilityWaitlistToggleRequest
 */
export interface WaitlistApiPatchFacilityWaitlistToggleRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiPatchFacilityWaitlistToggle
     */
    readonly facilityId: number

    /**
     * 
     * @type {ServerRequestsPatchFacilityWaitlistToggleRequest}
     * @memberof WaitlistApiPatchFacilityWaitlistToggle
     */
    readonly serverRequestsPatchFacilityWaitlistToggleRequest?: ServerRequestsPatchFacilityWaitlistToggleRequest
}

/**
 * Request parameters for reorderWaitlist operation in WaitlistApi.
 * @export
 * @interface WaitlistApiReorderWaitlistRequest
 */
export interface WaitlistApiReorderWaitlistRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiReorderWaitlist
     */
    readonly id: number

    /**
     * 
     * @type {ServerRequestsReorderWaitlistRequest}
     * @memberof WaitlistApiReorderWaitlist
     */
    readonly serverRequestsReorderWaitlistRequest?: ServerRequestsReorderWaitlistRequest
}

/**
 * Request parameters for setWailitEntryAsAccepted operation in WaitlistApi.
 * @export
 * @interface WaitlistApiSetWailitEntryAsAcceptedRequest
 */
export interface WaitlistApiSetWailitEntryAsAcceptedRequest {
    /**
     * 
     * @type {number}
     * @memberof WaitlistApiSetWailitEntryAsAccepted
     */
    readonly id: number
}

/**
 * WaitlistApi - object-oriented interface
 * @export
 * @class WaitlistApi
 * @extends {BaseAPI}
 */
export class WaitlistApi extends BaseAPI {
    /**
     * 
     * @param {WaitlistApiAddToWaitlistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public addToWaitlist(requestParameters: WaitlistApiAddToWaitlistRequest = {}, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).addToWaitlist(requestParameters.serverRequestsAddToWaitlistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiDeleteParkerFromWaitlistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public deleteParkerFromWaitlist(requestParameters: WaitlistApiDeleteParkerFromWaitlistRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).deleteParkerFromWaitlist(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiGetFacilityWaitlistToggleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public getFacilityWaitlistToggle(requestParameters: WaitlistApiGetFacilityWaitlistToggleRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).getFacilityWaitlistToggle(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiGetWaitlistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public getWaitlist(requestParameters: WaitlistApiGetWaitlistRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).getWaitlist(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiGetWaitlistByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public getWaitlistById(requestParameters: WaitlistApiGetWaitlistByIdRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).getWaitlistById(requestParameters.waitlistEntryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiGetWaitlistByParkerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public getWaitlistByParkerId(requestParameters: WaitlistApiGetWaitlistByParkerIdRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).getWaitlistByParkerId(requestParameters.parkerId, requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiInviteParkerToClaimSpotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public inviteParkerToClaimSpot(requestParameters: WaitlistApiInviteParkerToClaimSpotRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).inviteParkerToClaimSpot(requestParameters.id, requestParameters.serverRequestsInviteParkerToClaimSpotRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiPatchFacilityWaitlistToggleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public patchFacilityWaitlistToggle(requestParameters: WaitlistApiPatchFacilityWaitlistToggleRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).patchFacilityWaitlistToggle(requestParameters.facilityId, requestParameters.serverRequestsPatchFacilityWaitlistToggleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiReorderWaitlistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public reorderWaitlist(requestParameters: WaitlistApiReorderWaitlistRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).reorderWaitlist(requestParameters.id, requestParameters.serverRequestsReorderWaitlistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WaitlistApiSetWailitEntryAsAcceptedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitlistApi
     */
    public setWailitEntryAsAccepted(requestParameters: WaitlistApiSetWailitEntryAsAcceptedRequest, options?: RawAxiosRequestConfig) {
        return WaitlistApiFp(this.configuration).setWailitEntryAsAccepted(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



